webpackJsonp([23],{

/***/ "+3lO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("abPz");
var global = __webpack_require__("YjQv");
var hide = __webpack_require__("aLzV");
var Iterators = __webpack_require__("yYxz");
var TO_STRING_TAG = __webpack_require__("hgbu")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+6Bu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "+Ds/":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "+MS5":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"check\" ><title>Operation Icons Copy 6</title><path d=\"M34.538 8L38 11.518 17.808 32 8 22.033l3.462-3.518 6.346 6.45z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "check");

/***/ }),

/***/ "+MZ2":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "+SdG":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("a/OS")('keys');
var uid = __webpack_require__("GmwO");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "+VX5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "+iDZ":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("YjQv").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "+jwL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "+zJ9":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("GmwO")('meta');
var isObject = __webpack_require__("8ANE");
var has = __webpack_require__("x//u");
var setDesc = __webpack_require__("GCs6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("zyKz")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "/7Pz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("YK8K");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var NavBar = function (_React$Component) {
    (0, _inherits3['default'])(NavBar, _React$Component);

    function NavBar() {
        (0, _classCallCheck3['default'])(this, NavBar);
        return (0, _possibleConstructorReturn3['default'])(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).apply(this, arguments));
    }

    (0, _createClass3['default'])(NavBar, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                mode = _a.mode,
                iconName = _a.iconName,
                leftContent = _a.leftContent,
                rightContent = _a.rightContent,
                onLeftClick = _a.onLeftClick,
                restProps = __rest(_a, ["prefixCls", "className", "children", "mode", "iconName", "leftContent", "rightContent", "onLeftClick"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, className), (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + mode, true), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, restProps, { className: wrapCls }),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-left', role: 'button', onClick: onLeftClick },
                    iconName && _react2['default'].createElement(
                        'span',
                        { className: prefixCls + '-left-icon', 'aria-hidden': 'true' },
                        _react2['default'].createElement(_index2['default'], { type: iconName })
                    ),
                    _react2['default'].createElement(
                        'span',
                        { className: prefixCls + '-left-content' },
                        leftContent
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-title' },
                    children
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-right' },
                    rightContent
                )
            );
        }
    }]);
    return NavBar;
}(_react2['default'].Component);

exports['default'] = NavBar;

NavBar.defaultProps = {
    prefixCls: 'am-navbar',
    mode: 'dark',
    iconName: 'left',
    onLeftClick: function onLeftClick() {}
};
module.exports = exports['default'];

/***/ }),

/***/ "/7dr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/OXf":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("TJq6");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "/aCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _language$morequeryte;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = (_language$morequeryte = {
  language: 'en',
  morequerytext1: 'More Inquiries',
  morequerytext12: '查询其他客票',
  morequerytext2: '没有找到要退改的机票（测试环境非人脸）',
  reminder1: 'Notes',
  reminder2: 'Notes：',
  writeText1: 'Please enter the correct document number.',
  writeText2: 'For more ticket inquiries, please visit the mini-program or China Southern Airlines App.',
  writeText_3: '您好，为保障行程信息安全，需进行实名认证后方可对身份证关联客票进行退改操作，请确认是否继续。',
  writeText3: 'Hello, to ensure the security of your travel information, facial recognition verification is required before refund or change operations can be performed on tickets linked to your ID card. Please confirm whether to proceed.',
  writeText4: 'Hello, to prevent financial risks, facial recognition is required for further inquiries. Please update to the latest version of the APP to proceed. Thank you.',
  inputText: 'Please enter your information.',
  labeltext1: 'ID number：',
  labeltext2: 'The surname：',
  labeltext3: 'The name：',
  labeltext4: 'The surname',
  labeltext5: 'The name',
  writeTip2: 'Please enter the ID number',
  writeTip3: 'Please enter your surname.',
  writeTip312: '乘机人的姓',
  writeTip322: '乘机人的名',
  writeTip4: 'Please enter your given name.',
  writeTip4qw: 'name contains special characters',
  writeTip466: 'Search',
  writeTip5: 'As your name contains special characters, please reselect and confirm your name information.',
  writeTip6: 'Length cannot exceed 20 characters.',
  wxFaceCheck: 'WeChat real-name authentication',
  inpTip1: 'Please fill in your information to complete real-name verification.',
  inpTip2: 'Please enter your surname/given name.',
  idNum: 'ID No.',
  openFaceCheck: '开启人脸识别',
  tip1: "Friendly reminder: If your name contains '·', please check the 'Name contains special characters' option. The system will add '·' between your surname and given name for verification; otherwise, verification will fail.",
  tip2: '1、The range of flights eligible for free changes in case of flight delays/cancellations is subject to actual conditions.',
  tip3: '2、The change calculation result is only the service fee; actual changes may require payment of a fare difference.',
  tip4: "3、The above refund and change instructions are for reference only. Please refer to China Southern Airlines' actual regulations.",
  tip5: "The above refund and change instructions are for reference only. Please refer to China Southern Airlines' actual regulations.",
  lookAgin: 'View Again',
  realName: 'Real-Name Verification',
  calculateR: 'Refund Calculation',
  calculateC: 'Change Calculation',
  refunMen: 'Refund Segments',
  leg: 'Leg',
  detailsR: 'Refundable Amount Details',
  amount: 'Ticket Fare',
  tax: 'Refundable Taxes and Fees',
  insurPremium: 'Insurance Fee',
  noinsurPremium: 'Non-Refundable Insurance Fee',
  handlingFee: 'Refund handling fee',
  coupon: 'discount coupon',
  refundableAmount: 'Refundable Amount',
  confirm: 'OK',
  applicableLeg: 'Applicable Segments',
  rules: 'Rules',
  CostDisplay: 'Fee Display',
  dateNow: 'Calculated based on current time',
  cFee: 'Change handling fee',
  tipRefun: 'When changing your ticket, you may need to pay a fare difference depending on the new flight and cabin class you select.',
  clickTip: 'Click the bottom button to view detailed fees.',
  receivedR: 'Refunded',
  receivedU: 'Used',
  receivedC: 'Changed',
  unavailable: 'Unavailable',
  seleLeg: 'Select Change',
  refundLeg: 'Refund Segments',
  rulesFC: 'Rules for refund and change',
  rulesdetailed: 'Detailed Rules',
  choose: 'Select',
  chooseMore: 'More Options',
  name: 'Name',
  ticketNo: 'Ticket No.',
  taxes: 'Taxes',
  otherTicketses: 'Other Ticket Refund and Change Calculations',
  ticketnoInp: 'Please enter the ticket number or document number.',
  ticketNoID: 'Ticket No. / ID No.',
  passengerName: "Please enter the passenger's name",
  inpTip3: 'Please enter the actual operating flight number (e.g., CZ605).',
  flightNo: 'Flight number',
  flightDate: 'flight date',
  tip6: '1、Currently, only e-tickets for domestic flights operated by China Southern Airlines (starting with 784) are supported.；',
  tip7: '2、Team tickets, mileage redemption tickets, government procurement tickets, courtesy tickets, etc., are not currently supported.',
  tip8: '3、If your ticket cannot be queried for refund or change fees, it may be outside our current service coverage. We apologize for any inconvenience! You may contact the original ticketing service provider or China Southern Airlines customer service at 95539 for assistance.',
  nextStep: 'Next',
  openCard: 'Card Issuance Document',
  cardNo: 'ID number',
  cardNoBin: 'bank card BIN',
  checkMessage: '请核对填写公务卡开卡信息',
  titel1: 'Seat Selection & Check-In',
  titel2: 'Airport Transfer',
  titel3: 'Valet Parking',
  titel4: 'VIP Lounge',
  titel5: 'Extra Luggage',
  titel6: 'Pre-Sale of Multiple Seats for One Person',
  paySuccess: 'Payment completed',
  changeNo: 'Change order No.:',
  titelTip: 'Friendly reminder: The system is processing your change request. For specific progress, please check the order details. If you have other questions, please call 95539.',
  goback: 'Return to Refundable & Alterable',
  details1: 'View Order Details',
  PleaseEnter: 'Please enter',
  cardholder: 'Cardholder',
  carddetails: 'Bank card information under your name (UnionPay only)',
  placeChoose: "Please select (the refund will be credited to the cardholder's account)",
  placeChoose123: 'Please select the ',
  placeHoder: 'Please select (please enter a 16-19-digit bank card number)',
  certification: 'Verification',
  failure: 'The verification of the account for refund has failed.',
  failureCardNo: 'The bank card information you provided is incorrect.',
  checkAgin: 'Please check it carefully!',
  Understood: 'Understood',
  successCer: 'Refund Account Verification Successful',
  cardNum: 'Card No.',
  cardNum2: 'Card Nunber',
  adult: 'Adult',
  child: 'Child',
  body: 'Infant',
  army: 'disabled servicemen',
  police: "disabled people's policemen",
  mileage: 'Mileage',
  mileageJ: '积分',
  ticketFee: 'Fare',
  mileageValue: '抵扣金额',
  refundInsurance: 'Refundable premium',
  airportTaxFee: 'Airport tax',
  fuelFee: 'Fuel surcharge difference',
  fuelFee123: 'Fuel surcharge',
  otherFee: 'Other Taxes',
  HandlingFee: 'Handling fees',
  costTotal: 'Fare difference',
  airportTaxFeedif: 'Airport tax difference',
  missfee: 'No-Show Fee',
  extensionfee: 'Extension Fee',
  qtPrice: 'Other Taxes',
  difference: 'Tax Difference',
  changeCost: 'Change fees',
  refundCost: 'Recoverable amount',
  mileageF: 'Refundable Miles',
  pendingReview: 'To be reviewed',
  Issued: 'Issued',
  Reserved: 'Scheduled',
  unreserved: 'Not Scheduled',
  ProcessingFailed: 'failed to process',
  InvoiceTitle: 'Invoice title:',
  TaxpayerIdentNum: '纳税人识别号:',
  phonenum: '收票人手机号:',
  email: 'Recipient‘s email:',
  Sunday: '(Sunday)',
  Monday: '(Monday)',
  Tuesday: '(Tuesday)',
  Wednesday: '(Wednesday)',
  Thursday: '(Thursday)',
  Friday: '(Friday)',
  Saturday: '(Saturday)',
  dateWorm: '(Incorrect Date)',
  Sunday1: 'Sun.',
  Monday1: 'Mon.',
  Tuesday1: 'Tues.',
  Wednesday1: 'Wed.',
  Thursday1: 'Thur.',
  Friday1: 'Fri.',
  Saturday1: 'Sat.',
  dateWorm1: 'Incorrect Date',
  one: '1st',
  two: '2nd',
  three: '3rd',
  four: '4th',
  five: '5th',
  six: '6th',
  seven: '7th',
  the: 'The',
  voyageleg: 'Segment',
  cabin: 'cabin',
  share: 'Share',
  highspeed: 'High-speed rail ',
  bullet_train: '动车 ',
  Intercity_railway: '城际铁路 ',
  afterChange: 'After Change',
  oldTitle: 'Original Flight',
  ni: 'ID No.',
  ni2: 'ID No.',
  pp: 'Passport No.',
  othersId: 'Other documents：',
  booklet: 'Household Register：',
  certificate: 'Birth Certificate：',
  Officer_Cert: 'Military Officer ID：',
  Police_Cert: 'Police Officer ID：',
  Taiwan_Cert: 'Taiwan Compatriot Permit：',
  home_Cert: 'Home Visit Permit：',
  Taiwan_permit: 'Taiwan Resident Residence Permit：',
  hk_mac: 'Hong Kong and Macau Resident Residence Permit：',
  Passport: 'Passport：',
  others: 'Other：',
  ForeignersId: 'Permanent Residence Permit for Foreigners：',
  Seafarer_Cert: "Seafarer's Certificate：",
  Exit_Permit: 'Exit-Entry Permit for Foreigners：',
  others2: 'Other Documents：',
  Passport2: 'Passport',
  e_passport: 'Electronic Passport',
  household_register: 'Household Register',
  mp_Cert: '军人及武警证件',
  passId: '通行证',
  others3: 'Other Documents',
  ForeignersID: 'Permanent Residence Permit for Foreigners',
  seaman_book: "Seafarer's Certificate",
  china_issued: '外交部签发的驻华外交人员证',
  Officer_ID: 'Military Officer ID',
  hkmtId: '港澳台居民居住证',
  others4: 'Other Documents',
  hkmaId: '港澳通行证',
  twId: '大陆居民来往台湾通行证',
  Sergeant_Cert: '士官证',
  certificate2: '出生医学证明',
  student_ID: 'Student ID',
  noNewTicketNo: '(No New Ticket Number Assigned Yet)',
  NewTicketNum: 'New ticket number',
  ticketNum: 'Ticket No.：',
  PassengerInfo: 'Passenger information',
  TermsOfUse: 'Instructions for use',
  tipcoup1: 'As your change service fee requires manual calculation, the coupon deduction amount will be determined based on the coupon usage conditions and manual calculation results. For detailed calculation rules, please refer to the coupon usage conditions.',
  tipcoup2: 'As your refund service fee requires manual calculation, the coupon deduction amount will be determined based on the coupon usage conditions and manual calculation results. For detailed calculation rules, please refer to the coupon usage conditions.',
  Contact: 'Contact information',
  Contact123: 'Please enter the contact person',
  name2: 'Name：',
  name2123: 'Document Number：',
  Contact_phone: 'Mobile：',
  bank_card: 'Bank Card',
  addNewCard: 'Add New Card',
  Seat_number: 'Seat Number',
  operation: 'Handling',
  ChangeSeats: 'Reselect Seat',
  SeatsTip1: 'Reserving a seat for you on the aircraft...',
  SeatsTip2: 'Seat reservation failed!',
  SeatsC: 'Seat Selection',
  SeatsTip3: 'The system has assigned you the following seat:',
  SeatsTip4: 'Seat reservation successful!',
  refundTip1: '自身原因无法成行，同意扣除退票手续费',
  refundTip2: '航空公司原因无法成行，申请全额退票',
  tipP1: 'Due to busy business, please submit your request first to enter the review stage.',
  tipP2: '审核通过后，变更费用将在订单详情中进行显示',
  tipP3: 'Hello, foreign currency tickets are currently not supported on the mini-program, H5, or APP. Please visit the official website to proceed. Thank you.',
  tipP4: function tipP4(a, b) {
    return a + ' to be deducted for this change ' + b + ' Km. If the transaction fails, the system will refund the ' + a + ' in full';
  },
  tipP5: 'Your ticket was not issued through our app. Changes or refunds must be handled through the original booking channel.',
  changeNo2: 'Change order No.：',
  cancelNo: 'Itinerary cancellation order number：',
  refundNo: 'Refund Number：',
  changeFee: 'Change fees：',
  refundFee: 'Amount to Refund：',
  loading1: '正在加载...',
  newChangeNo: 'New Change Number：',
  doorFee: '专车应退金额',
  tipT1: 'Note: High-speed rail products are refunded to the original payment method by default.',
  titelE1: 'E-Invoice Issuance',
  titelE2: 'Additional product',
  titelE3: 'View refund details',
  titelE4: '*Note: If the refund fails, you can go to the details page and re-initiate the refund.',
  Zhang: 'Sheet(s)',
  flie1: 'Attachment uploaded successfully.',
  flie2: 'Submitted!',
  flie3: 'Attachment upload failed. Please upload again.',
  flie4: 'Pull down to refresh',
  flie5: 'Refreshing',
  flie6: 'Loaded successfully',
  flie7: "Your ticket was not purchased through China Southern Airlines' official channels. The refundable amount has been returned to the original payment account. The actual refund amount is subject to the original ticketing channel's refund policy. For details, please contact the original ticketing channel.",
  flie8: 'Green Flight - On Demand Dining',
  choosed: 'Selected',
  unit: 'Portion(s)',
  gift: 'Gift',
  Einvoice: 'E-invoice',
  resubmit: 'Resubmit',
  Cancel: 'Cancel',
  pay: 'Pay',
  complete: 'Complete',
  modify: '修改退票原因',
  modifyRefun: '退票原因',
  chooseRefun: '请选择退票原因',
  submit: 'Submit ',
  good: '好的',
  UnderReview: 'Reviewing',
  notApproved: 'Disapproved',
  Canceled: 'Cancelled',
  Canceled123: '可取消',
  progress1: 'Your change request has been cancelled. If you have any doubts, ',
  progress2: 'please contact our online customer service for consultation or the original ticketing location for processing.',
  progress3: 'Unpaid',
  progress4: '支付中',
  progress5: 'Payment failed',
  progress6: 'Automatically processing',
  progress7: 'Change failed',
  progress8: 'We apologize, your change request failed to process. Please contact China Southern Airlines',
  progress9: ' customer service at 95539 for assistance.',
  progress0: 'Successfully',
  progress10: 'Manually processing',
  progress11: 'Submit the order again',
  progressTip1: 'Change abandoned',
  progressTip2: 'Notified by phone',
  progressTip3: 'Wait for processing',
  progressTip4: 'Handling',
  progressTip5: 'Processing failed',
  progressTip6: 'Change Failed: We apologize, your change request failed to process.',
  progressTip7: 'Disapproved',
  progressTip8: 'Refund being processed',
  progressTip9: 'Refund completed',
  progressTip0: 'Abnormal refund',
  progressTip10: 'Wait for processing',
  progressT1: 'Refund Processing',
  progressT2: 'Refund completed',
  progressT3: 'Closed',
  progressT4: 'Your refund request has been closed. If you have any questions,',
  progressT5: 'please contact China Southern Customer service at 95539',
  progressT6: 'Itinerary cancellation failed',
  progressT7: 'please contact the online customer service for consultation and processing.',
  progressT8: 'Itinerary cancelled successfully',
  progressT9: 'Handling',
  progressT91: 'Refundable & Alterable',
  progressT92: 'Refunded/changed',
  progressT0: 'Your refund request has been canceled. If you have any questions,',
  progressT10: 'Change review',
  progressT11: 'Handling the change',
  progressTips1: 'Handled',
  progressTips2: 'Please contact our online customer service for consultation or the original ticketing location for processing.',
  progressTips3: 'Unpaid  Please complete payment as soon as possible.',
  progressTips4: 'Please complete the payment before the deadline.',
  progressTips5: 'Payment failed  Please make payment again.',
  progressTips6: 'Payment failed，Please complete the payment before the deadline.',
  progressTips7: 'Processing is expected to take 2 minutes. Please wait patiently.',
  progressTips8: 'To be handled',
  progressTips9: 'Please wait',
  progressTips0: 'To be confirmed by phone',
  progressTips10: "China Southern's customer service center will call the contact person later, please make sure your phone stays connected.",
  progressTips11: 'the contact person did not answer the phone or replied that no change is required. If you have any questions, please contact our online customer service for consultation.',
  progressTips12: 'The customer service has notified the contact person by phone. The contact person needs to confirm again when they return. If further handling is required, please contact the online customer service for consultation and processing.',
  progresswTip1: 'Refund review',
  progresswTip2: 'Accepted by bank',
  progresswTip3: 'Refund Acceptance',
  progresswTip4: 'Refund received',
  progresswTip5: 'Voucher Credited',
  progresswTip6: 'Refund Processing',
  progresswTip7: 'If you have any objection to the audit result, please update the attachment as required and submit again for review.',
  progresswTip8: 'Please contact the original issuing channel for processing',
  progresswTip9: function progresswTip9(a) {
    return 'The refund is expected to arrive in your bank account before ' + a;
  },
  progresswTip10: 'The refund is expected to arrive in 3 working days after being accepted by the bank ',
  progresswTip11: "call the bank's customer service center if you do not receive it after the due date",
  progresskl1: '若未查询到代金券到账，请联系南航客服95539。',
  progresskl2: "The card number verification failed during refunding, please click <span style='color: rgba(0, 138, 203, 1)' >[Verify again]</span> below",
  progresskl3: 'The review is expected to take 1-5 business days. Please wait patiently.',
  progresskl4: 'View progress',
  progresskl5: 'Mileage refund exception. Please contact online customer service or the original ticketing channel for assistance.',
  progresskl544: '里程退款失败',
  refundMoth: 'Refund method',
  inpIdCard: 'Enter bank card number (UnionPay only)',
  choosePerson: 'Select the cardholder',
  inpMessage: "Enter the cardholder's name",
  inpMessage2: "Enter the cardholder's ID number",
  inpIdCard2: 'Enter the bank card number',
  cardtip: "The cardholder must match the passenger's document number and name to proceed. If the ID card name contains special characters, such as '.', please enter them as they are; otherwise, real-name verification will fail.",
  refundMoth1: 'province',
  refundMoth2: 'Enter the province where the bank card account is opened',
  refundMoth3: 'Enter the exact province where the opening bank is located，For example: Guangdong Province',
  refundMoth4: 'City',
  refundMoth4567: 'The address to open the account',
  refundMoth5: 'Enter the city where the bank card account is opened',
  refundMoth6: 'Enter the exact city where the opening bank is located，For example: Guangzhou',
  refundMoth7: 'Enter the address of the opening bank',
  refundMoth8: 'Enter the exact address of the opening bank to make sure the refund can be received，For example: Guangzhou XXXX sub branch',
  refundMoth9: 'Bank-registered mobile number',
  refundMoth0: 'Enter the mobile number registered with the bank',
  refundMoth11: 'Enter verification code',
  checkCode: 'Get Verification Code',
  refundMoth12: 'I Understand',
  refundMoth13: 'Hello, your ticket cannot be handled automatically , the application will be transferred to the original ticket issuing channel for processing, please confirm whether to submit.',
  refundMoth14: 'Enter the mobile number',
  refundMoth15: 'Facial Recognition Prompt',
  refundMoth16: "Hello, to ensure the security of your funds, express refund requires facial recognition to verify the cardholder's identity. Please confirm whether to proceed.",
  refundMoth17: 'Go to Verify',
  refundMoth1765: '信息校验失败',
  refundMoth18: 'Hello, to prevent financial risks, express refund requires facial recognition. Please update to the latest version of the APP to proceed. Thank you.',
  refundMoth19: 'Hello, in order to ensure the safety of your funds, face recognition verification is required for speed refund. Please go to the official APP of China Southern Airlines or wechat mini program for refund operation, thank you.',
  refundMoth20: 'The verification of the account for refund has failed. The bank card information you provided is incorrect. Please check it carefully!',
  refundMoth21: 'The system is processing your refund request. Please wait! \n If submission fails, please try again later.',
  refundMoth22: 'Hello, your ticket cannot be handled automatically , the application will be transferred to the original ticket issuing channel for processing, please confirm whether to submit.',
  refundMoth23: '3、机票款将以代金券形式退至您的南航账户。',
  refundMoth24: '3.机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励及额外里程奖励。',
  refundMoth25: function refundMoth25(a) {
    return '3\u3001\u673A\u7968\u6B3E\u5C06\u4EE5\u4EE3\u91D1\u5238\u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u989D\u5916\u83B7\u5F97\u4E00\u5B9A\u989D\u5EA6' + a + '\u5956\u52B1\u3002';
  },
  refundMoth26: '3、机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励。',
  refundMoth27: 'Hello! If you refund your ticket, your rights and interests of China Southern Airlines Beijing Daxing unlimited package ticket will become invalid.',
  refundMoth28: 'Cancel refund',
  refundMoth29: 'Hello! High-speed rail products cannot be refunded at this time. If you have any questions, please contact China Southern Airlines customer service at 95539.',
  refundMoth30: 'Continue Refunding Flight Ticket',
  refundMoth31: 'After refund, any auction adjustment fees (if applicable) will be automatically refunded.',
  refundMoth32: 'Proceed with refund',
  refundMoth33: 'Dear passenger, if you have companions, please check the box for the passenger on the refund application page and submit your identification documents together.',
  refundMoth34: function refundMoth34(a) {
    return 'Hello, the valid date of the ticket is ' + a + ' . Please submit the application for change or refund within the valid date of the ticket. Thank you.';
  },
  refundMoth35: 'Submit again',
  refundMoth36: 'Please select a refund method.',
  refundMoth37: "Your ticket was not purchased through China Southern Airlines' official channels. The refundable amount has been returned to the original payment account. The actual refund amount is subject to the original ticketing channel's refund policy. For details, please contact the original ticketing channel.",
  refundMoth38: 'You have not yet registered a China Southern Airlines account. This refund method is currently unavailable. Would you like to register now?',
  refundMoth39: 'Remind Me Later',
  refundMoth40: 'Register Now',
  refundMoth41: "Refund to China Southern Airlines account is only supported for the passenger's own account. Please confirm if this is your own operation.",
  refundMoth42: 'Other Refund Methods',
  refundMoth43: "<span style='color: #03bffd;'>Voucher：</span><span>China Southern Airlines Account<strong>Voucher</strong>Can be fully deducted when purchasing tickets, selecting seats, luggage allowance, VIP lounge, etc., for yourself or others through China Southern Airlines' official channels. It can also be split and used multiple times. Valid for 2 years from the date of refund.<strong>Non withdrawable</strong>。</span><br/>",
  refundMoth44: function refundMoth44(a, b, c) {
    return '<span style="color:#0096d5;">\u673A\u7968\u4F18\u60E0\u5238\uFF1A</span><span>\u673A\u7968\u4F18\u60E0\u5238\u53EF\u5728\u5357\u822A\u5B98\u65B9\u6E20\u9053\u8D2D\u4E70\u673A\u7968\u65F6\u90E8\u5206\u62B5\u6263\uFF0C\u4E0D\u53EF\u62C6\u5206\u591A\u6B21\u4F7F\u7528\uFF0C\u4EC5\u9650\uFF08\u4F1A\u5458\u53F7\uFF1A' + a + '\uFF09\u672C\u4EBA\u4F7F\u7528\uFF0C<strong>\u4E0D\u53EF\u63D0\u73B0\uFF0C\u4E0D\u9000\u4E0D\u8865</strong>\u3002' + (!b && c ? ' 具体使用说明如下：' : '') + '</span><br/>';
  },
  refundMoth45: function refundMoth45(a) {
    return '<span style="color:#0096d5;">\u4F7F\u7528\u65E5\u671F\uFF1A</span><span>' + a + '</span><br/>';
  },
  refundMoth46: function refundMoth46(a) {
    return '<span style="color:#0096d5;">\u9002\u7528\u4E1A\u52A1\uFF1A</span><span>' + a + '</span><br/>';
  },
  refundMoth47: function refundMoth47(a) {
    return '<span style="color:#0096d5;">\u4EF7\u683C\u9650\u5236\uFF1A</span><span>\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1\u4E0D\u4F4E\u4E8E' + a + '\u5143\uFF08\u542B\uFF09\u53EF\u4EE5\u4F7F\u7528</span><br/>';
  },
  refundMoth48: 'Flight Date：',
  refundMoth49: 'The departure dates of all flights in the order must fall within the following range:',
  refundMoth50: 'No restrictions',
  refundMoth51: 'Excluded Flight Dates:',
  refundMoth52: 'Coupons cannot be used for flights on the following dates:',
  refundMoth53: 'China Southern Airlines Account',
  refundMoth54: function refundMoth54(a, b) {
    return '<span style="color:#0096d5;">\u53EF\u7528\u7684\u822A\u7EBF\uFF1A</span><span style="word-wrap: break-word;">' + a + '</span><br/>\n        <span style="color:#0096d5;word-wrap: break-word;">\u822A\u73ED\u53F7\uFF1A</span><span style="word-wrap: break-word;">' + b + '</span><br/>';
  },
  refundMoth55: function refundMoth55(a, b) {
    return '<span style="color:#0096d5;">\u9002\u7528\u8231\u4F4D\uFF1A</span><span>' + a + '</span><br/>\n            <span style="color:#0096d5;">\u53EF\u7528\u7684\u652F\u4ED8\u65B9\u5F0F\uFF1A </span><span>\u4EC5\u9650' + b + '</span><br/>\n            <span style="color:#0096d5;">\u5907\u6CE8\uFF1A</span><span>\u90E8\u5206\u7279\u6B8A\u4EA7\u54C1\u4E0D\u80FD\u4F7F\u7528\u4F18\u60E0\u5238</span><br/>';
  },
  refundMoth56: '应退机票款将以<strong>代金券</strong>形式退至您的南航账户，并获得一定奖励。',
  refundMoth57: function refundMoth57(a, b, c, d) {
    return a + '\u5143\u673A\u7968\u6B3E\u5C06\u4EE5<strong>\u4EE3\u91D1\u5238</strong>\n                  \u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u53EF\u83B7\u5F97' + b + '\u989D\u5916\n                  ' + (c === 'Y' ? '积分' : '里程') + '\u53CA\n                  ' + d + '\u5143\u673A\u7968\u4F18\u60E0\u5238\u5956\u52B1\u3002';
  },
  refundMoth58: '应退机票款将以<strong>代金券</strong>形式退至您的南航账户。',
  refundMoth59: function refundMoth59(a, b, c) {
    return a + '\u5143\u673A\u7968\u6B3E\u5C06\u4EE5<strong>\u4EE3\u91D1\u5238</strong>\n                  \u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u53EF\u83B7\u5F97' + b + '\u989D\u5916\n                  ' + (c === 'Y' ? '积分' : '里程') + '\u5956\u52B1\u3002';
  },
  refundMoth60: function refundMoth60(a, b) {
    return a + '\u5143\u673A\u7968\u6B3E\u5C06\u4EE5<strong>\u4EE3\u91D1\u5238</strong>\n                  \u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u83B7\u5F97' + b + '\n                  \u5143\u673A\u7968\u4F18\u60E0\u5238\u3002';
  },
  refundMoth61: 'Attachment upload failed',
  refundMoth62: 'Note: Additional products are refunded to the original payment method by default.',
  refundMoth63: 'This ticket was purchased through the Guanaitong channel. Part of the amount will be refunded to the Guanaitong account balance. The actual refund amount is subject to the credited amount.',
  refundMoth64: 'Additional Products Selected for Refund',
  refundMoth65: 'Itinerary cancelled',
  refundMoth66: 'Refund',
  refundMoth84: 'flight leg for refund',
  refundMoth67: 'Please provide the bank card number.',
  refundMoth68: "Please provide the cardholder's name.",
  refundMoth69: 'To ensure financial safety, according to relevant laws and regulations, the ticket fare will be only refunded to the original payment card and it can only be done once. In the event of repeated refunding via multiple channels or other arbitrage attempts, China Southern and the ticket issuer will hold the relevant person responsible.',
  refundMoth71: 'To ensure financial safety, according to relevant laws and regulations, the ticket fare will be only refunded to the passenger himself/herself and it can only be done once. In the event of repeated refunding via multiple channels or other arbitrage attempts, China Southern and the ticket issuer will hold the relevant person responsible.',
  refundMoth72: 'I have read and agree to the',
  refundMoth73: ' «Privacy Notice» ',
  refundMoth74: ' «General Conditions of Carriage for Passenger & Baggage» ',
  refundMoth75: '《International Conditions of Carriage》',
  refundMoth76: 'Refund to Original Payment Method',
  refundMoth77: 'Estimated to arrive in 3 working days',
  refundMoth78: 'Refund to bank card',
  refundMoth79: 'Real-time receipt',
  refundMoth80: 'Refund to China Southern Airlines Account',
  refundMoth81: 'Real-time receipt',
  refundMoth82: 'Extra Mileage and Coupon Rewards',
  refundMoth83: 'Extra Mileage Reward',
  refCupon1: 'Segment Selection',
  refCupon2: 'No restrictions',
  refCupon3: 'quick refund',
  refCupon4: 'Refund to Original Channel',
  refCupon5: function refCupon5(a, b) {
    return '\u4EAB\u53D7\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1\u514D\u8D39\uFF0C\u6700\u9AD8\u53EF\u62B5' + a + b;
  },
  refCupon6: function refCupon6(a, b, c) {
    return '\u4EAB\u53D7\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1' + Number(a) / 10 + '\u6298\uFF0C\u6700\u9AD8\u53EF\u62B5' + b + c;
  },
  refCupon7: function refCupon7(a, b, c) {
    return '\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1\u6EE1' + a + b / (Number(c) / 100) + '\uFF08\u542B\uFF09\u53EF\u4F7F\u7528';
  },
  refCupon8: '仅会员本人',
  refCupon9: '额外优惠券奖励',
  refCupon0: '仅会员本人及其受让人',
  refCupon11: '退票费券',
  refCupon12: '多品类券',
  refCupon13: '不满足航线限制',
  refCupon14: '不可与已选优惠券叠加使用',
  refCupon15: '机票',
  refCupon16: '选座',
  refCupon17: '行李',
  refCupon18: 'Meal',
  refCupon19: '休息室',
  refCupon20: '中转住宿',
  refCuponDoor: '接送机专车',
  refCupon21: 'PLUS会员',
  refCupon22: '免费变更',
  refCupon23: '候补升舱',
  refCupon24: '登机口升舱',
  refCupon25: 'Multiple Seats for One Person',
  refCupon26: '现场逾重行李',
  refCupon27: '套票',
  refCupon28: '机场贵宾服务',
  refCupon29: '现场升舱',
  refCupon30: '机票兑换K位',
  refCupon31: '优惠券不适用于该航段',
  refCupon32: '仅限实名认证会员使用',
  refCupon33: 'confirm',
  refCupon3354: 'return',
  refCupon34: '不可用原因',
  refCupon35: '使用期限：',
  refCupon36: '% off',
  refCupon37: '次',
  refCupon38: '使用说明',
  refCupon39: '优惠券号',
  refCupon40: '最高抵用',
  refCupon41: '价格限制',
  refCupon42: '适用业务',
  refCupon43: '航班时刻',
  refCupon44: '订单所选退票航段的航班时刻需在以下范围内：',
  refCupon45: '不限',
  refCupon46: '订单内所有航班的出发日期必须在以下日期范围内：',
  refCupon47: '不限实名认证会员',
  refCupon48: '限制实名认证会员使用',
  refCupon49: '适用航线',
  refCupon50: '可使用的退款方式',
  refCupon51: '退票时限',
  refCupon52: function refCupon52(a) {
    return '\u4EC5\u9650\u539F\u822A\u73ED\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u4F7F\u7528';
  },
  refCupon53: function refCupon53(a) {
    return '\u4EC5\u9650\u539F\u822A\u73ED\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u4F7F\u7528';
  },
  refCupon54: function refCupon54(a) {
    return '\u4EC5\u9650' + a + '\u8231\u4F4D\u5BA2\u7968\u4F7F\u7528';
  },
  refCupon55: function refCupon55(a) {
    return '\u4EC5\u9650\u4ED8\u6B3E\u6E20\u9053\u4E3A' + a + '\u7684\u5BA2\u7968\u4F7F\u7528';
  },
  refCupon56: function refCupon56(a) {
    return '\u4EC5' + a + '\u6E20\u9053\u4F7F\u7528';
  },
  refCupon57: '舱位限制',
  refCupon58: '支付方式',
  refCupon59: '使用渠道',
  refCupon60: '退票场景',
  selectDate1: 'Continue',
  selectDate2: 'Reselect',
  selectDate22: '升舱',
  selectDate3: function selectDate3(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u5DF2\u8D85\u51FA\u9650\u5236\uFF0C\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF08\u53EF\u80FD\u9700\u652F\u4ED8\u8D39\u7528\uFF09\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u70B9\u51FB\u3010\u91CD\u65B0\u9009\u62E9\u3011\uFF0C\u53EF\u91CD\u65B0\u9009\u62E9\u65E5\u671F\u3002';
  },
  selectDate33: function selectDate33(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u7B26\u5408\u975E\u81EA\u613F\u53D8\u66F4\u65E5\u671F\u8303\u56F4\uFF0C\u5C06\u6309\u975E\u81EA\u613F\u53D8\u66F4\u5904\u7406\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u975E\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u5982\u9700\u5347\u8231\u8BF7\u70B9\u51FB\u3010\u5347\u8231\u3011\uFF08\u5B58\u5728\u5347\u8231\u8D39\u7528\uFF09';
  },
  selectDate4: '温馨提示：因儿童或婴儿旅客不支持购买“加赠”产品，如继续办理将为所有乘客选择普通客票产品；如需将携带儿童或婴儿的旅客客票变更为“加赠”产品，请联系南航客服95539办理。',
  selectDate5: 'Departure date',
  selectDate51212: '您已选择',
  selectDate5121: '（组合）',
  selectDate512: '为您推荐',
  selectDate6: 'Sun.',
  selectDate7: 'Mon.',
  selectDate8: 'Tues.',
  selectDate9: 'Wed.',
  selectDate0: 'Thur.',
  selectDate11: 'Fri.',
  selectDate12: 'Sat.',
  selectDate13: '年',
  selectDate14: '月',
  selectDate15: 'today',
  selectDate16: function selectDate16(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u5DF2\u8D85\u51FA\u9650\u5236\uFF0C\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF08\u53EF\u80FD\u9700\u652F\u4ED8\u8D39\u7528\uFF09\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u70B9\u51FB\u3010\u91CD\u65B0\u9009\u62E9\u3011\uFF0C\u53EF\u91CD\u65B0\u9009\u62E9\u65E5\u671F\u3002';
  },
  ticketChanges1: 'Week',
  ticketChanges2: 'All Dates',
  ticketChanges3: 'Refund and Change Rules',
  ticketChanges4: "Disabled People's Police",
  ticketChanges5: 'Disabled Military Personnel',
  ticketChanges6: function ticketChanges6(a) {
    return '\u4EE5\u4E0B\u4E3A' + a + '\u9000\u6539\u8BF4\u660E\u6807\u6CE8,\u4EC5\u4F9B\u53C2\u8003,\u8BF7\u4EE5\u5B9E\u9645\u60C5\u51B5\u4E3A\u51C6';
  },
  ticketChanges7: 'Free baggage allowance',
  ticketChanges8: 'Rules for Refund and Change of New Flights',
  ticketChanges9: 'Change fees',
  ticketChanges9123: 'Explanation of Change Fees',
  ticketChanges0: 'Change Fee/Time',
  ticketChanges022: 'Instructions',
  ticketChanges11: 'Change time',
  ticketChanges12: 'More than 24 hours before departure',
  ticketChanges13: 'Within 24 hours before departure',
  ticketChanges14: 'Detailed Explanation of Changes',
  ticketChanges15: 'Explanation of Refund Fee',
  ticketChanges16: 'Refund time',
  ticketChanges17: 'original ticket redemption miles',
  ticketChanges18: '50% of the original ticket redemption miles',
  ticketChanges19: 'Detailed Explanation of Refund',
  ticketChanges20: 'Additional notes',
  ticketChanges21: '<span>\n                        \u5BA2\u7968\u53D8\u66F4\u540E\u9000\u7968,\u6240\u6536\u7684\u53D8\u66F4\u624B\u7EED\u8D39\u4E0D\u9000,\u5BA2\u7968\u8BA2\u5EA7\u8231\u4F4D\u66F4\u6539\u540E\u5982\n                      </span>\n                      <span>\n                        \u53C8\u53D1\u751F\u9000\u7968,\u7968\u4EF7\u5DEE\u90E8\u5206\u6309\u53D8\u66F4\u540E\u65B0\u7968\u4EF7\u8BA2\u5EA7\u8231\u4F4D\u624B\u7EED\u8D39\u6807\u51C6\u529E\n                      </span>\n                      <span>\n                        \u7406,\u539F\u7968\u4EF7\u6309\u53D8\u66F4\u524D\u8BA2\u5EA7\u8231\u4F4D\u9000\u7968\u624B\u7EED\u8D39\u6807\u51C6\u529E\u7406\uFF0C\u5408\u8BA1\u6536\u53D6\u9000\n                      </span>\n                      <span>\u7968\u8D39\uFF0C\u4E14\u539F\u7968\u53D8\u66F4\u624B\u7EED\u8D39\u4E0D\u9000\u3002</span>',
  ticketChanges22: '<span>\n                        If a ticket is refunded after a change, the change fee already collected is non-refundable.\n                        If a refund is requested after changing the booking class, the fare difference portion will be refunded according to the rules of the new booking class, \n                        while the original fare portion will be refunded according to the rules of the original booking class. The refund fee will be calculated accordingly.\n                        </span>\n                        <span>\n                        If both a change fee and a fare difference for an upgrade apply, both the change fee and the fare difference will be charged.\n                        </span>',
  ticketChanges23: 'If a ticket is refunded after a change, the change fee already collected is non-refundable.',
  ticketChanges24: 'Sold out',
  ticketChanges25: 'Remaining seats inadequate',
  ticketChanges2589: 'Remaining seats inadequate',
  ticketChanges2512: 'Remaining tickets',
  ticketChanges26: 'Economy Class',
  ticketChanges27: 'Sky Pearl Economy Class',
  ticketChanges28: 'Business Class',
  ticketChanges281: 'First Class',
  ticketChanges29: 'Full fare',
  ticketChanges2943: 'Front seats offer wider spacing',
  ticketChanges294333: '退改条件及行李额',
  ticketChanges2935: 'Access to CZ VIP Lounge & Priority Airport Services',
  ticketChanges30: 'Discount on upgrade change fee',
  ticketChanges31: '额外获得',
  ticketChanges32: 'Free baggage allowance',
  ticketChanges33: 'Selected Flight',
  ticketChanges34: 'The',
  ticketChanges35: 'Segment',
  ticketChanges35j: 'Starting',
  ticketChanges35jf: 'Segments',
  ticketChanges36: 'Handling fee + fare difference',
  ticketChanges37: 'Fare difference',
  ticketChanges38: 'transfer：',
  ticketChanges39: 'Stay about',
  ticketChanges40: 'Meal included',
  ticketChanges41: 'No meals',
  ticketChanges42: 'stop over：',
  ticketChanges42a: 'Arrived the next day',
  ticketChanges43: function ticketChanges43(a) {
    return '\u8BE5\u822A\u73ED\u4E3A\n            ' + a + '\n            \u627F\u8FD0\u7684\u5357\u822A\u4EE3\u7801\u5171\u4EAB\u822A\u73ED\uFF0C\u767B\u673A\u524D\u8BF7\u5230\n            ' + a + '\n            \u503C\u673A\u67DC\u53F0\u529E\u7406\u503C\u673A\u3002';
  },
  ticketChanges46: 'Actual Carrier',
  ticketChanges47: 'Hide',
  ticketChanges48: 'Expand',
  ticketChanges49: 'Flight details',
  ticketChanges50: function ticketChanges50(a) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0A\u4E00\u822A\u73ED\u4E0D\u8DB3' + a / 60000 + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges5aa: function ticketChanges5aa(a) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + a / 60000 + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges51: function ticketChanges51(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u4E0E\u4E0A\u4E00\u822A\u73ED\u8854\u63A5\u65F6\u95F4\u4E0D\u8DB3' + (a === true ? b : c) + '\u5206\u949F\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges53: function ticketChanges53(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === 0 ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges54: function ticketChanges54(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === true ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges55: function ticketChanges55(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === 0 ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges56: function ticketChanges56(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === true ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges57: function ticketChanges57(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u5DF2\u8D85\u51FA\u9650\u5236\uFF0C\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF08\u53EF\u80FD\u9700\u652F\u4ED8\u8D39\u7528\uFF09\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u70B9\u51FB\u3010\u91CD\u65B0\u9009\u62E9\u3011\uFF0C\u53EF\u91CD\u65B0\u9009\u62E9\u65E5\u671F\u3002';
  },
  ticketChanges58: function ticketChanges58(a, b) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u81F3' + b + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges59: function ticketChanges59(a, b) {
    return '\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u81F3' + b + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges60: function ticketChanges60(a, b) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u81F3\u8D77\u98DE\u540E' + b + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges61: function ticketChanges61(a) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u4E4B\u540E';
  },
  ticketChanges62: function ticketChanges62(a) {
    return '\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u4E4B\u5916';
  },
  ticketChanges63: function ticketChanges63(a) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u4E4B\u524D';
  },
  ticketChanges64: function ticketChanges64(a) {
    return '\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges65: 'Online change to flights departing in the next 60 minutes is not allowed.',
  ticketChanges66: 'This flight is approaching departure time. Please contact our online customer service for consultation or confirm with the check-in counter that you can still check in before making a reservation. Any costs incurred due to missed flights will be borne by you.',
  ticketChanges67: 'Agree and Continue',
  ticketChanges68: 'If you change your flight to Beijing Capital International Airport, your privileges of unlimited package ticket with China Southern at Beijing Daxing International Airport will be invalid.',
  ticketChanges69: 'If you change to a code-share flight, your privileges of unlimited package ticket with China Southern at Beijing Daxing International Airport will be invalid.',
  ticketChanges70: 'Change cancellation',
  ticketChanges71: 'Continue change',
  ticketChanges71a: function ticketChanges71a(a, b) {
    return '\u6CE8\uFF1A\u59CB\u53D1\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + a + '\uFF0C\u5230\u8FBE\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + b + '\uFF0C\u8BF7\u52A1\u5FC5\u786E\u8BA4';
  },
  ticketChanges71s: function ticketChanges71s(a) {
    return '\u6CE8\uFF1A\u59CB\u53D1\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + a + '\uFF0C\u8BF7\u52A1\u5FC5\u786E\u8BA4';
  },
  ticketChanges71d: function ticketChanges71d(a) {
    return '\u6CE8\uFF1A\u5230\u8FBE\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + a + '\uFF0C\u8BF7\u52A1\u5FC5\u786E\u8BA4';
  },
  ticketChanges72: 'Origins of some flights changed to',
  ticketChanges73: 'Destinations of some flights changed to',
  ticketChanges74: 'Note the difference.',
  ticketChanges75: 'change',
  updateDetail0: 'Order No：',
  updateDetail1: 'Change order：',
  updateDetail2: 'Refund order：',
  updateDetail3: 'Ticket No:',
  updateDetail4: 'Fare (excluding taxes)',
  updateDetail5: 'Total Price : ',
  updateDetail6: 'Total Change Fee: ',
  updateDetail7: 'Amount to Refund : ',
  updateDetail8: 'Itinerary cancelled successfully',
  updateDetail9: 'Itinerary cancellation failed',
  updateDetail10: 'Submitted but not confirmed',
  updateDetail11: 'Confirmed pending refund',
  updateDetail12: 'Refunded',
  updateDetail13: 'Cancelled',
  updateDetail14: 'Adjusted',
  updateDetail15: 'Refunded',
  updateDetail16: 'Closed',
  updateDetail17: 'Accepted',
  updateDetail18: 'Handling',
  updateDetail19: 'Processing Failed',
  updateDetail21: 'Processing Successful',
  updateDetail22: 'Reviewing',
  updateDetail23: 'Disapproved',
  updateDetail24: 'Unpaid',
  updateDetail25: 'Payment failed',
  updateDetail26: 'Refund being processed',
  updateDetail27: 'Automatically processing',
  updateDetail28: 'Change failed',
  updateDetail29: 'Abnormal refund',
  updateDetail30: 'To be manually processed',
  updateDetail31: 'Manually processing',
  updateDetail32: 'To be confirmed by phone',
  updateDetail33: 'resubmit',
  updateDetail34: 'Change abandoned',
  updateDetail35: 'Notified by phone',
  updateDetail36: 'Changed successfully',
  updateDetail37: 'Refund completed',
  updateDetail38: 'Status error',
  updateDetail39: 'Hello, foreign currency tickets are currently not supported on the mini-program, H5, or APP. Please visit the official website to proceed. Thank you.',
  updateDetail40: function updateDetail40(a, b) {
    return '\u672C\u6B21\u53D8\u66F4\u9700\u6263\u51CF' + a + b + '\u516C\u91CC\uFF0C\u5982\u4EA4\u6613\u5931\u8D25\u7CFB\u7EDF\u5C06\u5168\u989D\u9000\u8FD8' + a + '\u3002';
  },
  updateDetail4122: 'Remarks',
  updateDetail41: 'Voluntary changes may incur a service fee and fare difference. In case of flight delay or cancellation, one free change is allowed under applicable regulations.',
  updateDetail42: 'When a ticket contains multiple usage rules, the strictest rule for the changed segment will apply. Change fees are charged per segment at the highest standard and per occurrence.',
  updateDetail43: "Ticket changes must be made within the ticket's validity period.",
  updateDetail44: 'If the change fee is pending review, the actual change fee will be as stated in the SMS after review.',
  updateDetail45: 'Voluntary refunds may incur a service fee. In case of flight delay or cancellation, unused segments can be refunded without a service fee under applicable regulations.',
  updateDetail46: 'When a ticket contains multiple usage rules, the strictest rule for the entire journey will apply. If the ticket has been partially used, the refund will deduct the applicable fare and taxes for the used segments, along with any refund service fee and no-show fee (if applicable).',
  updateDetail47: 'If the refund fee is pending review, the actual refund fee will be as stated in the SMS after review. Once submitted, the refund request cannot be canceled.',
  updateDetail48: 'All unused refundable segments must be refunded together.',
  updateDetail49: 'Children aged 2-11 and infants occupying a seat are charged the same fees as adults for changes/refunds. Infants under 2 not occupying a seat are not charged for changes/refunds.',
  updateDetail50: "The above rules are for reference only. For other matters, please refer to China Southern Airlines' actual regulations. If you have any questions, please contact 95539.",
  updateDetail51: 'The itinerary has been cancelled',
  updateDetail52: 'Ticket No.',
  updateDetail53: 'For fees and more rules,',
  updateDetail54: "please see 'Refund and Change Rules'",
  updateDetail55: 'ID No.',
  updateDetail56: 'Change',
  updateDetail57: 'Refund',
  updateDetail5723: 'Handling fees：',
  updateDetail58: 'Pay',
  updateDetail59: 'Search by Ticket No. / ID No. / Name',
  updateDetail60: 'Incorrect ticket number, document number, or name.',
  updateDetail61: 'Re-Login',
  updateDetail63: 'Refunded/ Changed',
  updateDetail62: 'Currently, you do not have any tickets eligible for refund or change.',
  updateDetail64: '抱歉！暂无法找到您可退改的客票。建议您先完成',
  updateDetail65: '您现在暂无可退改订单/客票',
  updateDetail66: 'No flights match your search.',
  updateDetail67: 'No eligible tickets/orders found yet.',
  updateDetail68: 'Click',
  updateDetail69: ' to inquire about more tickets.',
  updateDetail70: 'Flight Time',
  updateDetail71: 'Passenger Type',
  updateDetail72: 'This function has been disabled and cannot be accessed.',
  updateDetail73: 'Please enter mispurchase ticket information',
  updateDetail74: 'Please enter new ticket information',
  updateDetail75: 'Please select the mispurchase ticket purchase scenario',
  updateDetail76: 'Please enter the ticket number!',
  updateDetail77: 'Please enter the correct ticket number!',
  updateDetail78: 'Click to select a ticket or enter a ticket number',
  updateDetail79: '出发',
  updateDetail80: 'No search results available at the moment',
  updateDetail81: 'Querying...',
  updateDetail82: 'Mispurchase ticket',
  updateDetail83: 'Click to select a ticket or enter a new ticket number',
  updateDetail84: 'New ticket',
  updateDetail85: 'Mispurchase scenario',
  updateDetail86: 'Submit Request',
  updateDetail87: 'Refund/change',
  updateDetail88: 'Change Progress',
  updateDetail89: '取消行程进度',
  updateDetail90: 'Refund Progress',

  gender: 'Gender',
  nationality: 'Nationality',
  tipError: function tipError(a, b) {
    return '\u65C5\u5BA2' + a + '\u7684' + b + '\u683C\u5F0F\u9519\u8BEF';
  },
  certiIssuing: 'Document Issuing Authority',
  supplement: function supplement(a) {
    return '\u8BF7\u8865\u5145\u65C5\u5BA2' + a + '\u7684\u4FE1\u606F';
  },
  suppleMessage: function suppleMessage(a, b) {
    return '\u8BF7\u8865\u5145\u65C5\u5BA2' + a + '\u7684' + b;
  },
  passenger: 'Passenger',
  save: 'Save',
  SuppPsginfo: 'Supplement Passenger Information',
  male: 'Male',
  female: 'Female',
  selectDetailInfo: 'Please select details.',
  prePsgMessage: 'Please confirm that the name entered matches the travel document.',
  mandatory: 'Required',
  dateBirth: 'Date of Birth',
  country: 'Country/Region',
  documentType: 'Document Type',
  Required: 'mandatory',
  validityPeriod: 'Document Expiry Date',
  additionalTip: '购买产品数量不可超过成人数量',
  additionalTip2: '该宝贝不能购买更多哦',
  additionalTip3: '选择休息室',
  checked: 'Selected',
  checked123: '/人起',
  recommends: 'Recommended Services for You',
  orderTotal: '订单总额',
  details: '明细',
  addPsgTip: 'Hello, this change requires supplementary passenger information.',
  replenish: 'Go to Supplement',
  replenish123: 'Please enter civil servant information',
  verifyTip: 'Verification failed. Please try again later or contact online customer service for assistance.',
  verifyTip2: 'The entered civil servant name does not match the change passenger. Please re-enter.',
  verifyTip3: 'The entered bank card BIN number has an incorrect digit count. Please re-enter.',
  verifyTip4: 'This change requires a deduction of XX miles. If the transaction fails, the system will fully refund the miles.',
  verifyTip5: 'After a voluntary change, any auction adjustment fees (if applicable) will be automatically refunded.',
  verifyTip6: 'After an involuntary change, the refundability of auction adjustment fees (if applicable) will be linked to the status of the new ticket.',
  chooseFood: '请选择是否机上用餐',
  yes: 'YES',
  no: 'NO',
  no123: 'Reward',
  foodSelect: function foodSelect(a) {
    return '\u52FE\u9009\u201C\u5426\u201D\uFF0C\u53D6\u6D88\u673A\u4E0A\u7528\u9910\uFF0C\u83B7\u53D6' + a + '\u5956\u52B1';
  },
  greenFlight: 'Green Flight',
  benefits: 'Equity benefits',
  civilMsg: 'Please enter civil servant information',
  foodPsg: 'Please select passengers who dine on flight',
  greenPsg: 'Please select green flight passengers',
  selectAll: 'Select All',
  submitChange: 'Submit Change request',
  inputPsgName: '请输入联系人姓名',
  telephone: 'Mobile',
  telephone123: '请输入联系手机',
  VerificationCode: 'Verification Code',
  rcRuleTip5: 'a fee may apply ',
  rcRuleTip6: 'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is a voluntary refund; ',
  rcRuleTip1: 'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is a voluntary refund; a fee may apply according to the rules.',
  rcRuleTip2: 'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is an involuntary refund; no fee is charged.',
  rcRuleTip3: 'This is a voluntary refund. A refund fee may apply according to the fare rules.',
  rcRuleTip4: 'This is an involuntary refund. No refund fee will be charged.',
  rfInstruction: 'Refund and Change Instructions',
  unused: 'Fully Unused',
  partiallyUsed: 'Partially Used',
  noChange: 'Non-Changeable',
  noRefund: 'Non-Refundable',
  referenceTip: 'The above instructions are for reference only. Please refer to actual conditions.',
  officialCard: "refers to the first 6 digits of the official card number; for example, the BIN for ICBC's official card is 628288.",
  bankCardNo: 'Bank card BIN',
  inpuitCardholder: "Please enter the cardholder's name.",
  reCode2: 'Referral Code (Optional)',
  inputRecode: 'Please enter the employee referral code.',
  reCode1: 'Referral Code',
  segPsg: '/Leg/person',
  people: '/person',
  people123: 'person',
  fillInfo: 'Select the change information',
  gotoRc: 'Proceed to Refund and Change',
  queryTip3: '当前您没有已取消行程的订单',
  queryTip4: '当前您没有可办理取消行程的机票。',
  queryTip5: '未找到相关客票/订单信息',
  ticketN: 'Ticket No.：',
  ticketN123: 'Passenger',
  ticketNow: '当前',
  totalPrice: '总价：',
  totalChangeFee: '总变更费：',
  muTip: '该客票暂不支持自助取消行程，请联系东航客服95530处理。',
  caTip: '该客票暂不支持自助取消行程，请联系国航客服95583处理。',
  huTip: '该客票暂不支持自助取消行程，请联系海航客服95339处理。',
  psgTicNo: 'Ticket No.：',
  cancellationTip: '取消行程费用及更多规则，请查询“取消行程说明”',
  cancellationInt: '取消行程说明',
  reCertification: '重新认证',
  faceFail: '对不起，未通过实名认证',
  fail: 'Failed',
  faceSuccess: '恭喜您，通过实名认证',
  success: 'Successful',
  weekDay: 'Mon.,Tues.,Wed.,Thur.,Fri.,Sat.,Sun.',
  discountRecom: '优惠推荐',
  csair: 'China Southern Airlines',
  changeDes: 'Change Rules',
  refundDes: 'Refund Rules',
  close: 'Close',
  tikcetPrice: 'Ticket Fare: ',
  refundhfee: 'Current Refund Fee / Penalty: ',
  changehfee: 'Current Change Fee / Penalty: ',
  irefundRule: 'The ticket meets the conditions for involuntary changes/refunds. Fees will be calculated according to the involuntary change/refund rules.',
  calTip1: 'Calculated based on the current time and as a voluntary refund.',
  calTip2: 'Calculated based on the current time and as a voluntary change.',
  immeRefund: 'Refund Now',
  changeSeg: '变更航程',
  cancelTip1: '若您的航程后续仍需出行，但出行时间待定，可取消行程，待出行时间确认后，对客票进行变更操作，变更手续费按当前取消行程时间计算。',
  cancelTip2: '取消行程后，将无法再乘坐本航班，且无法恢复。',
  costCal: 'Fee Calculation',
  percentage: 'Percentage Calculation',
  numerical: 'Numerical Calculation',
  process: 'Application Process',
  viewDe: 'View details',
  free: 'free',
  onlyTax: '仅退税费',
  front: 'before',
  timeNode: 'Time Frame',
  noTimeLimit: '不限制时间',
  couponTip8: '变更费券',
  couponTip10: '不满足价格限制',
  couponTip12: '与已选优惠券的支付方式不可同时使用',
  pSeat: '国内优选座位',
  speedyBoarding: '快速登机',
  couponInfo1: '因所选择机票变更手续费为0，无需使用优惠券',
  couponInfo5: '仅限会员本人使用',
  couponInfo6: '航班日期不符合条件',
  couponInfo9: '订单所选原航班的航班时刻需在以下范围内：',
  couponInfo11: '最高抵用',
  couponInfo12: '价格限制',
  couponInfo14: '用于变更时，可用于以下变更后舱位',
  couponInfo15: '当日变更',
  couponInfo16: '仅航班当天允许使用',
  couponInfo17: '可用的支付方式',
  couponInfo18: '变更时限',
  couponInfo22: '客票预定后',
  applicationDate: '适用日期',
  to: '至',
  except: '除外',
  outinHours: '小时之外',
  networkFail1: 'Your network seems unstable.',
  networkFail2: 'The server is busy. Please try again later.',
  discounted: '降价客票',
  discountedTip1: '请输入旧客票信息',
  discountedTip2: '请输入新客票信息',
  discountedTip6: '新旧客票号不能相同，请重新输入',
  oldTic: '旧客票',
  newTic: '新客票',
  login: '登录',
  idTikcetNo: '证件号或者票号',
  surnamePsg: '乘机人的姓氏',
  namePsg: '乘机人的名字',
  kindTip1: '1.请使用乘机人的姓名、证件号或者票号进行查询。',
  kindTip2: '2.变更适用于南航国内客票，以及航班不正常情况下的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip3: '3.退票适用于南航国内客票，以及南航官网、APP、微信小程序、微信公众号、客服渠道购买的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip4: '4.对于以上暂未支持自助退改的客票，请联系南航客服95539办理退改。',
  kindTip5: "Please use the passenger's name, ID number or ticket number, e.g.7840000000000 for inquiry",
  queryRc: '查询退改记录',
  confirmMsg: '请确认您的信息',
  invoice2: '纳税人识别号:',
  invoice3: '公司地址:',
  invoice4: '公司电话:',
  invoice5: '公司开户行:',
  invoice6: '公司账号:',
  invoice7: 'Recipient‘s mobile:',
  invoice9: '退票旅客:',
  invoice10: '请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收',
  invoiceApoint: '提交发票预约信息',
  inputInvoice: '请输入您的电子发票信息',
  invoiceCont: 'Invoice content: Refund handling fee',
  invoiceType: 'Invoice type:',
  invoiceMsg1: '个人',
  invoiceMsg2: '企业',
  invoiceMsg3: '非企业性单位',
  invoiceMsg4: '选择发票抬头',
  invoiceMsg5: '请输入公司名称',
  invoiceMsg6: '请输入纳税人识别号',
  optional: 'optional',
  invoiceMsg7: '请输入联系人邮箱',
  invoiceMsg8: '请输入联系人手机',
  invoiceTip1: '为同行人开具:',
  invoiceTip2: '1.请您确认填写信息是否正确，邮箱请填写真实地址，否则将无法收到电子发票邮件！',
  invoiceTip3: '2.税总（2017）16号文件规定，2017年7月起，企业必须提供税号才能开票，否则不能作为报销凭据。',
  view: '查看',
  companyName: '公司名称',
  TaxCode: '纳税人识别码',
  companyAddress: '公司地址',
  companyPhone: '公司电话',
  openBank: '公司开户行',
  companyAccount: '公司账号',
  voiceTitle: '我的发票抬头',
  default: '默认',
  taxId: '税号:',
  addPsg: '添加同行人',
  selectDate: 'Change Flight Date',
  additional1: 'Please select the ancillary product(s) you wish to cancel.',
  additional2: '提交退票申请后，机票包含的',
  additional3: '将跟随机票一起作废，请谨慎操作。',
  trainTip1: function trainTip1(a) {
    return '\u6B64\u4E3A\u7A7A\u94C1\u8054\u8FD0\u8BA2\u5355\uFF0C\u65C5\u5BA2' + a + '\u4F7F\u7528\u4E86\u706B\u8F66\u7968\u4F18\u60E0\u5238\uFF0C\u673A\u7968\u4E0E\u706B\u8F66\u7968\u9700\u4E00\u8D77\u9000\u8BA2\uFF0C\u8C22\u8C22';
  },
  trainTip2: '此为空铁联运订单，机票与火车票需一起退订，谢谢',
  selectResaon: '请选择退票原因！',
  notCancel: '暂不取消',
  notCancel123: '确认取消',
  domestic: 'Domestic',
  international: 'International',
  additional5: 'After the refund is completed, note how the limit is returned. If there is no return, you may log in to the Employee Travel zone to request the return limit.',
  firstJn: '第一程',
  firstJn12321: 'to',
  asd0: 'Voluntary refund',
  asd1: '个人原因',
  asd2: 'Involuntary refund',
  asd3: 'Flight Delay',
  asd4: 'Flight Cancellation',
  asd5: '航班超售',
  asd6: '航班变动',
  asd7: 'Other',

  inputTip1: 'The server is busy. Please try again later.',
  inputTip2: 'Please enter the contact person',
  inputTip3: 'Please enter the Mobile Number',
  inputTip4: '联系手机:',
  trainPrice: '高铁票价',
  trainHandFee: '高铁手续费',
  fareCost: 'Fare',
  fuelTaxTotal: 'Fuel surcharge difference',
  airportTaxTotal: 'Airport tax difference',
  premium: 'Refundable Insurance Fee',
  airportTax: 'Airport tax',
  fuelCost: 'Fuel surcharge',
  counterFee: 'Handling fee',
  refundCoupon: 'Refund coupon',
  totalTax: 'Refundable Taxes and Fees',
  ticketPrice: 'Fare',
  deductionMileage: 'Deduction mileage',
  mileageCharge: 'Mileage charge',
  discontedFee: 'Commission Charge Discount',
  retainUpgrades: '退票挽留升舱',
  mileageTxt: 'Please log in the member mileage account to check the actual mileage',
  actualMileage: 'Refunded Miles',
  expiredMileage: 'Expired Miles',
  delayMileage: 'Extended Miles',
  actualExpired: 'Actual Expired Miles',
  reSubmitTip1: '提交退票申请后，机票包含的',
  reSubmitTip2: '将跟随机票一起作废，请谨慎操作。',
  reSubmitTip3: '1.The above mileage expiration information is for reference only.',
  reSubmitTip4: ' 2.The award miles refunded for involuntary ticket refunds will be extended for 6 months based on the original validity period',
  reSubmitTip5: ' 3.If the refunded miles have already expired, they will be considered invalid. Please refer to the actual credited amount.',
  reSubmitTip6: 'This is an involuntary refund. No refund fee will be charged.',
  reSubmitTip7: 'This is a voluntary refund. A refund fee may apply according to the fare rules.',
  reSubmitTip8: 'The final refund amount is subject to review. You will be notified via SMS after the review is approved. This is an involuntary refund; no fee is charged.',
  reSubmitTip9: "Due to high volume, your refund request is expected to be processed within 7 days. Fees will be calculated according to your ticket's conditions. The final refund amount is subject to review.",
  reSubmitTip10: '因疫情防控需要，请密切关注南航官网发布的特殊退改政策公告。需要办理特殊退改的客票，请联系原购票单位或者南航客服95539办理。',
  caRules: 'calculation rule',
  couponQuantity: '优惠券数量',
  couponperiod: '优惠券有效期',
  period: '有效期',
  mileageperiod: '里程有效期',
  aa: 'Sheet(s)',
  coValue: '优惠券面值',
  mileageLimit: '里程额度',
  limit: '额度',
  coCode: '优惠券券码',
  giveCou: '赠送优惠券',
  giveMileage: 'Free Mileage',
  feeInfo: 'Fee Information',
  addSvc: '附加服务',
  guaranteeSvc: '保障服务',
  trainFee: '应退高铁金额',
  expiredInfo: 'expiration information',
  expiredInfo123: '费用总计',
  voucher: 'Voucher',
  refundMileage: 'Refundable Miles',
  seletedCoupon: '已选优惠券',
  csairAccount: ' 南航账户',
  couponUseTip1: "Can be fully deducted when purchasing tickets, selecting seats, luggage allowance, VIP lounge, etc., for yourself or others through China Southern Airlines' official channels. It can also be split and used multiple times. Valid for 2 years from the date of refund.",
  couponUseTip2: '不可提现。',
  couponUseTip3: function couponUseTip3(a, b) {
    return '\u53EF\u5728\u5357\u822A\u5B98\u65B9\u6E20\u9053\u8D2D\u4E70\u673A\u7968\u65F6\u90E8\u5206\u62B5\u6263\uFF0C\u4E0D\u53EF\u62C6\u5206\u591A\u6B21\u4F7F\u7528\uFF0C\u4EC5\u9650\n                  ' + a + '\uFF08\u5361\u53F7\uFF1A' + b + '\n                  \uFF09\u672C\u4EBA\u4F7F\u7528\uFF0C\n                  <strong>\u4E0D\u53EF\u63D0\u73B0\uFF0C\u4E0D\u9000\u4E0D\u8865</strong>\n                  \uFF0C\u4F7F\u7528\u89C4\u5219\u4EE5\u5B9E\u9645\u5230\u8D26\u67E5\u8BE2\u7ED3\u679C\u4E3A\u51C6\u3002';
  },
  actualTrans: '实际承运',
  transportation1: '该航班为',
  transportation2: '承运的南航代码共享航班，登机前请到',
  transportation3: '值机柜台办理值机。',
  transportation4: '按住滑块,拖动完成拼图',
  transportation5: '请登录退改客票的购票人或乘机人帐号进行操作',
  tips: 'prompt',
  memberShip1: '诚邀非会员:',
  memberShip2: '申请加入南航会员明珠俱乐部,尊享会员权益',
  skip: '跳过',
  memberShip3: '单个文件名不超过150字',
  memberShip4: 'Fill in the information',
  memberShip5: 'As your refund service fee requires manual calculation, the coupon deduction amount will be determined based on the coupon usage conditions and manual calculation results. For detailed calculation rules, please refer to the coupon usage conditions.',
  memberShip6: 'Please enter the Pearl member password',
  memberShip7: '由于银联系统对于姓名包含特殊符号暂时没有统一标准，认证失败可尝试取消特殊符号选项再试一次。',
  reInput: 're-enter.',
  feedback: 'I want feedback',
  manualService: '在线人工客服',
  onliveService: 'Online Support',
  automatic1: 'Loading automatically...',
  automatic2: 'Automatically processing...',
  additional: 'Additional product',
  addproducts: '增加产品',
  adjustment: '竞拍调整',
  copy: '1Portion(s)',
  trainTicket: '火车票',
  excessBaggage: 'Overheavy luggage',
  paidSeat: 'Paid seat selection',
  interval: '间',
  late: '晚',
  Processing1: 'Processing for you...',
  Processing2: "Your change request has been submitted. Please check the details or complete the payment later in the 'Processing' or 'Refunded/Changed' list. If you cannot find the relevant change request, please resubmit the change. Thank you.",
  Processing3: "Your refund request has been submitted. Please check later in the 'Processing' or 'Refunded/Changed' section. If you cannot find your refund request, please click the 'Refund' button again to apply for a ticket refund. Thank you.",
  progress: '进度条',
  veriTip1: 'Please enter the employee referral code.',
  veriTip2: 'The verification code entered is incorrect. Please re-enter it',
  veriTip3: 'Please confirm that you are the person who will be taking the flight or have obtained the permission of the person who will be taking the flight to cancel the check-in. If not, you may be held legally responsible.<br/> Note: You will not be able to board the plane after successfully canceling the check-in.',
  checkTip1: 'Note: You will not be able to board the flight after successfully canceling your check-in.',
  checkTip2: 'Are you sure you want to cancel the check-in that has been completed?',
  seMethod: '选择“退款至南航账户”',
  rewardTip2: '享受额外权益奖励。',
  rewardTip3: '元机票优惠券',
  modify22: '前往修改',
  giveUp: 'Abandon',
  sureT: 'Refundable',
  sureTs: 'Refunded Miles',
  deleFile: 'Confirm to delete file',
  deleteS: 'The file has been deleted. You can upload it again',
  uploadF: 'Attachment upload',
  File: 'Attachment',
  zhengm: '请上传相关证明文件',
  as1: 'Special refund application',
  as2: 'If you need to apply for special refund or change due to epidemic prevention or other diseases, please select the reason and upload relevant certification materials according to the guidelines or contact the original issuing unit for handling.',
  as3: 'Dear passenger, if you have companions, please check the box for the passenger on the refund application page and submit your identification documents together.',
  as4: 'Epidemic prevention',
  as5: 'Application for special refund about medical reasons.',
  as6: 'Information',
  as7: 'Please upload the text version of the information picture',
  as8: 'Identity certificate',
  as9: 'Continue adding',
  as0: 'Documentation of the epidemic',
  as11: 'Medical institution payment invoice or hospitalization deposit certificate',
  as12: 'Please upload both sides of your ID card',
  as13: 'Please confirm that you are the person who will be taking the flight or have obtained the permission of the person who will be taking the flight to cancel the check-in. If not, you may be held legally responsible.<br/> Note: You will not be able to board the plane after successfully canceling the check-in.',
  as14: 'Note: You will not be able to board the flight after successfully canceling your check-in.',
  as15: 'Select Flights',
  load11: 'Loading',
  loginFail: '登录失效',
  timeOut: '网络超时',
  yichang: 'Network connection error',
  title: 'Notes',
  title_delay: 'Flight Delay/Cancellation',
  title_explain: '退改说明',
  title_Confirm_error: 'Submission Failed',
  applicationSubmission: 'Submit request',
  back: 'Back',
  okBtn: 'OK',
  cancel: 'Cancel',
  goon: '继续',
  myOrder: 'My Orders',
  goonRefund: 'Continue Refund',
  goonChange: 'Continue Change',
  quitChange: 'Abandon Change',
  allsubmit: 'Submit Together',
  ressubmit: 'Resubmit'
}, _defineProperty(_language$morequeryte, 'yes', '是'), _defineProperty(_language$morequeryte, 'no', '否'), _defineProperty(_language$morequeryte, 'keepsubmit', 'Continue Submission'), _defineProperty(_language$morequeryte, 'orderStatusChange', 'Hello! The status of the current change request has been updated and can no longer be processed for payment.'), _defineProperty(_language$morequeryte, 'cardBin', '银行卡Bin'), _defineProperty(_language$morequeryte, 'cardBinMsg', '是指公务卡卡号的前6位;</br>例如:工行的公务卡卡Bin是628288</br>'), _defineProperty(_language$morequeryte, 'updateDetail', {
  title: 'Notes',
  content: '您好！需先进行实名认证，您可以在移动端按以下任一方式认证：</br></br>1、南航APP首页—我—在线实名认证；</br>2、南航官网首页—服务大厅—在线实名验证；',
  noticket: '您好！根据您输入的信息，未找到可退改的客票，请重新输入。',
  cancelOrder: 'Hello! Are you sure you want to cancel this change request? ',
  cancelOrderOk: '取消变更成功！',
  cancelOrderFailed: '抱歉！暂时无法取消变更。请稍后重试或联系南航客服95539。',
  costCalculation: '费用计算',
  huChangeTip: '本渠道仅支持该客票办理自愿变更，若想办理航班不正常改签，请前往海航官网或者APP进行办理，如有疑问请联系在线客服或海航客服95339'
}), _defineProperty(_language$morequeryte, 'endorsedApply', {
  addPsgSuccess: '添加同行人成功',
  OneAdult: '您好！该旅客已进行过航班改期，后续将以改期的航班时间进行变更。',
  ManyAdult: '您好！该旅客已进行过航班改期，本次变更仅限航班时间相同的旅客，航班时间不同的旅客们需分别申请变更。',
  flightDelayOrCancel: "<p>1.国内客票可免费变更航班日期前后7天内（含航班当天）的航班。</p><p style='margin: 0.2rem 0;'>2.国际客票可免费变更航班日期前7天、后14天（含航班当天）的航班。</p><p>3.头等舱、公务舱、明珠经济舱、经济舱全价票可选航班日期不受此限制。</p>",
  needSelectPsg: {
    content: '您好！添加同行人需先选择乘机人。'
  },
  pleaseSelectChangeFlightAndPsg: 'Please select the flight segment and passenger(s) you wish to change first!',
  pleaseSelectRefundFlightAndPsg: 'Please select the flight segment and passenger(s) you wish to refund first!',
  pleaseSelectChangeFlight: 'Please select the flight segment you wish to change first!',
  pleaseSelectRefundFlight: 'Please select the flight segment you wish to refund first!',
  pleaseSelectTrainFlight: '您好！若需单独退订高铁产品，可通过 “我的订单” - “假期” - “高铁订单” 操作退款',
  pleaseSelectPsg: '请您先勾选乘机人！',
  pleaseSelectHtlight: '您好！若需单独退订酒店产品，可通过“我的订单-酒店”操作退款',
  selectedPsgMustHasAdult: 'Hello! Separate changes for children are not currently supported. If you have any questions, please contact China Southern Airlines customer service at 95539 for assistance.',
  selectedPsgbady: '您好！暂不支持单独婴儿自助变更。如有疑问，请联系南航客服95539处理。',
  selectedFlightError: function selectedFlightError(text) {
    return '\u60A8\u597D\uFF01' + text + '\u7684\u822A\u73ED\u9700\u8981\u52FE\u9009\u540E\u65B9\u53EF\u8FDB\u884C\u4E00\u4E0B\u6B65\u64CD\u4F5C\uFF0C\u8BF7\u786E\u5B9A\u662F\u5426\u52FE\u9009\u8BE5\u884C\u6BB5\uFF1F';
  },

  selectedFlightSuccess: 'Selection successful. Please select the flight date for the next segment!!',
  onlySelectOneAdultInTAOrder: '您好，此类型客票仅允许选择一个成人乘机人进行退票操作！',
  cancelCheckIn: 'Check-in cancellation',
  selectMutiplePerson: '该产品同一订单的乘机人需同时退改，请勾选所有乘机人。'
}), _defineProperty(_language$morequeryte, 'selectDateObj', {
  selectedFlightDateBefore: 'Hello! The selected date cannot be earlier than the previous flight date. Please select a new date.',
  selectedFlightDateAfter: 'Hello! The selected date cannot be later than the subsequent flight date. Please select a new date.',
  selectedFlightDateBeyondWQT: 'This date does not qualify for discounted change fees. Please confirm if you still wish to change the date.',
  selectedFlightDateSeasonTicket: '本期双城旅行产品旅行截止日期为2023年1月5日。您选择变更后的航班日期，后续产品保障不足90日。是否继续？',
  selectedFlightDateExceeds: '抱歉! 中转运价客票要求航班衔接时间不得大于24小时, 请重新选择',
  selectMuFlightDate: '您好！新航班日期在原航班日期前3天，后3天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。'
}), _defineProperty(_language$morequeryte, 'ticketChanges', {
  optionalFlight: '您好！当天除您已订的航班外，无其它可选航班，建议您重新选择日期，如有疑问，请联系在线客服咨询或原出票地办理。',
  electionFlight: '您有一段航班是处于重选状态，请选择完毕再进行其它航班重选！',
  checkpending: '本次变更的费用需要人工审核，在您选择完新航班并提交申请后，客服稍后短信通知您审核结果及变更费用。',
  changeCabin_1: '您好，该航班的明珠经济舱剩余座位不足或售罄，是否变更至经济舱？',
  changeCabin_2: '您好，该航班无明珠经济舱，是否变更至经济舱？',
  compareCabin: function compareCabin(text) {
    return '\u60A8\u6240\u9009\u8231\u4F4D\u4E3A\u964D\u8231\u53D8\u66F4\uFF0C\u5DF2\u5151\u6362' + text + '\u4E0D\u9000\u8FD8\u3002';
  }
}), _defineProperty(_language$morequeryte, 'addPersonMessage', {
  afterSaleChangeConfirm_ok: {
    title: '提交成功',
    content: ''
  },
  afterSaleChangeConfirm_error: "非常抱歉的通知您, 您的改签申请提交失败。 原因可能是您所选航班座位已售空， 或同时改签人数过多造成系统改签出错。你可以拔打<a href='tel://95539 '> <u>95539</u></a>人工服务垂询。",
  afterSaleChangeConfirm_fail: {
    title: '提示',
    content: ''
  }
}), _defineProperty(_language$morequeryte, 'applySubmit', {
  inputContactInfo: {
    content: '请输入并保存联系人信息'
  },
  inputRightContactInfo: 'Hello! Please enter a valid mobile number.',
  verificationCode: '请输入六位验证码！',
  afterSaleChangeReqPayOK_error: '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或拨打南航客服95539处理。',
  afterSaleRefundApp_error: '尊敬的旅客，您好！退票申请中遇到问题，请重新提交或联系南航客服95539处理。',
  checkTips_fzy: "<strong style='color:#262626;'>We will finish reviewing the refund as soon as possible and notify you by SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.<br/>2. This is an involuntary refund. No refund fee will be charged.</div>",
  bingtui_zy: "<strong style='color:#262626;'>We will finish reviewing the refund as soon as possible and notify you by SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.<br/>2、您将提交病退申请，若您的材料符合要求，将为您免费办理退票；若您的材料不符合要求，系统将按自愿退票规则进行办理，自愿退票手续费可通过服务大厅“退改计算器”模块查看或联系客服咨询。</div>",
  checkTips_zy: "<strong style='color:#262626;'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.</div>",
  checkTips_zy_lessFare: function checkTips_zy_lessFare(contentProps) {
    if (contentProps.isDomestic) {
      return '<strong style=\'color:#262626;\'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div>\n            <div class="lessFare_tips_area">\n              <div class="lessFare_tipsT">\n                <span>Recoverable amount</span>\n                <span>' + (contentProps.curr + contentProps.totalCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Fare</span>\n                <span>' + (contentProps.curr + contentProps.ticketCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Airport tax</span>\n                <span>' + (contentProps.curr + contentProps.airTaxCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Fuel surcharge</span>\n                <span>' + (contentProps.curr + contentProps.ryTaxCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Handling fees</span>\n                <span>' + (contentProps.curr + '-' + contentProps.totalCharge) + '</span>\n              </div>\n            </div>\n          </div><div style=\'margin-top: 10px; text-align:left; color:#262626\'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.</div>';
    } else {
      return '<strong style=\'color:#262626;\'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div>\n            <div class="lessFare_tips_area">\n              <div class="lessFare_tipsT">\n                <span>Recoverable amount</span>\n                <span>' + (contentProps.curr + contentProps.totalCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Fare</span>\n                <span>' + (contentProps.curr + contentProps.ticketCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Refundable Taxes and Fees</span>\n                <span>' + (contentProps.curr + contentProps.totalTaxCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>Handling fees</span>\n                <span>' + (contentProps.curr + '-' + contentProps.totalCharge) + '</span>\n              </div>\n            </div>\n          </div><div style=\'margin-top: 10px; text-align:left; color:#262626\'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.</div>';
    }
  },
  checkTips_pengdingzy: "<strong style='color:#262626;'>Hello, we will complete the refund review as soon as possible and notify you via SMS.</strong><div style='margin-top: 10px; text-align:left; color:#262626'>Friendly reminder:<br/><span>1. Once you submit your refund request, your original seat reservation will be cancelled, and the ticket will no longer be valid. The final refund amount is subject to review.</span><br/>2. This is a voluntary refund, and corresponding refund fees may apply according to the refund and change rules.<br/><span style='color:#e5004a'>3. The actual refund fee will be manually reviewed according to the ticket usage rules. After the manual review is completed, the refund will be processed directly.</span> As the refund fee may be relatively high, if you are unaware of the calculation rules for the refund fee, it is recommended to contact the original ticketing channel or China Southern Airlines customer service for consultation before submitting.</div>",
  yddqTip: "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，实际退还金额将以审核结果为准；<br/>2、本次因疫情原因申请的退票需要人工审核。如符合疫情文件，退票将按非自愿退票，免收退票手续费；如不符合疫情文件，退票将按自愿退票，按照客票使用条件可能产生相应退票手续费。</div>",
  quotaTip: "<span style='color:#e5004a'>额度将在退票后几分钟内到账（若超出额度数不予退回），若未到账，可通过员工旅行-返回额度申请</span>",
  contact_important: 'Please complete the contact information.',
  error_certno: '请输入证件号',
  error_certnoF: '请输入正确的证件号',
  error_name: '请输入持卡人',
  no_verification: '请输入验证码！',
  get_verification: '请获取验证码！',
  error_verification: '您输入的验证码有误，请重新输入。',
  overtime_verification: '您输入的验证码已超时，请重新获取。',
  eleven_phone: '请输入11位国内手机号。 ',
  isCheckedRead: 'Please read and agree to the Service Agreement',
  artificial: 'Hello! This change requires manual review. Our customer service will notify you of the review result and any change fees via SMS shortly.',
  error_cardNo: '抱歉，您输入的银行卡信息有误，请重新输入。',
  no_bankcard: '请输入16-19位银行卡号',
  error_referral: '推荐码格式不正确！',
  changeCabin: '尊敬的旅客，您选择新航班的明珠经济舱已售罄，系统将自动为您安排同航班经济舱座位。<br/>变更成功后，您可前往南航机场柜台领取明珠经济舱体验券。<br/>请确认是否继续提交？',
  happyFlying: '您好！按照南航套票产品规则：机票一旦出票，不得变更、不得签转。',
  repeat: '文件名重复，无法上传，请更名后上传',
  selectedError: '附件上传格式为Word（.doc/.docx/.DOC/.DOCX）、Excel（.xls/.xlsx/.XLS/.XLSX）、PDF（.pdf/.PDF）、文本文件(.txt/.TXT) 或JPG(.jpg/.JPG)、PNG(.png/.PNG)格式，每个附件大小不能超20M',
  muFileError: "附件上传格式为'JPG', 'PNG', 'DOC', 'JPEG', 'DOCX'，所有附件大小不能超2M。",
  fileSize: '您好，您所提交的附件内容为空，请核对后提交，谢谢。',
  fileTip: 'Please upload the following attachments as needed based on the actual situation:1. Explanation of circumstances 2.Front and back images of ID card or other official identity documents 3. Official proof of travel disruption 4.Official proof of destination activity postponement or cancellation 5.Screenshot of abnormal health code or nucleic acid test result 6.Other official proof of inability to travel due to pandemic-related reasons.',
  fileTipIll: 'Please upload the medical payment invoice or hospitalization deposit proof issued by a medical institution recognized by China Southern Airlines.',
  fileTipProof: '请根据实际情况，按需上传如下附件：<br/>1.本人手持购票证件（姓名页）和抗原检测阳性结果合照，要求本人人脸、姓名页证件和抗原阳性结果须同框。<br/>2.学校放假计划调整证明文件和学生证(封面和姓名页)图片。<br/>3.其他疫情原因导致无法出行的官方证明材料。',
  noRefundMode: '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
  thanksPerson: 'Thank you for your support and cooperation!',
  contactInfo: 'Reminder: Please carefully verify the flight details, passenger name, ID information, and contact number to avoid any issues during your journey.',
  transferInfo: '您的客票调整至中转航班后，如已预定附加服务可能无法保障，具体以现场核销为准, ',
  pleaseCheckIsFood: '请您先勾选是否机上用餐',
  fileSuppleTip: 'You have selected the refund due to illness, but have not uploaded your identification or relevant medical supporting documents. Please provide the required materials before submitting.'
}), _defineProperty(_language$morequeryte, 'feeQuery', {
  selectFlight: '请选择想要退票或变更的航段! ',
  refundrules: '您好！根据退改规则，所有未使用航段必须同时申退。',
  canotChange: '您选择的航段不可变更，请重新选择',
  modification: '抱歉，您选择的航段不可变更'
}), _defineProperty(_language$morequeryte, 'loginFeeQuery', {
  inputTicketNoOrId: '请输入票号或者证件号！',
  inputName: '请输入旅客姓名！',
  inputTicketNo: '请输入航班号！',
  inputFlightDate: '请选择航班日期！'
}), _defineProperty(_language$morequeryte, 'refundChangeCompute', {}), _defineProperty(_language$morequeryte, 'detailsMessage', {
  inputContactPersonName: '联系人信息很重要，请补充完整',
  inputRightContactPersonName: '请输入正确的联系人姓名',
  inputContactPersonPhone: '联系人信息很重要，请补充完整',
  inputRightContactPersonPhone: '您输入的联系手机不正确，请重新输入'
}), _defineProperty(_language$morequeryte, 'realNameVerify', {
  descTitle: '退款账户认证说明',
  descContent: '您提交的退票我们将把退款退回您（婴儿请提供携带成人的银行账户）本人的银行账户，请填写有效银联卡并完成认证，退款将在0-20个工作日退回到您提供的银行账户，具体时间以各家银行为准。',
  createRefundTa_error: "<div>很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者拔打<a style='display: inline-block;' href='tel:95539 '> <u>95539</u></a>人工服务垂询。</div>"
}), _defineProperty(_language$morequeryte, 'ReformProcess', {}), _defineProperty(_language$morequeryte, 'subInfomation', {
  payOverTime: {
    title: '支付超时'
  }
}), _defineProperty(_language$morequeryte, 'ElectronicInvoice', {
  noCompanyName: '请输入公司名称',
  noTaxpayerIdCode: '请输入纳税人识别码',
  noEmail: '请输入收票人邮箱',
  noPhone: '请输入收票人电话',
  erroeEmail: '邮箱输入有误，请重新输入',
  errorTaxpayerIdCode: '纳税人识别号不符合规则',
  errorPhone: '请正确输入收票人电话',
  tip: '点击“提交”后将为勾选的乘机人自动填充同样的发票信息并一并提交，请慎重勾选！'
}), _defineProperty(_language$morequeryte, 'changeMember', {
  checkMember: '您还没有勾选要入会的乘机人，请先勾选要入会的乘机人'
}), _defineProperty(_language$morequeryte, 'rateTip', {
  rateTip: '请选择评分！',
  rateSuccess: '感谢您的反馈！'
}), _defineProperty(_language$morequeryte, 'mileageMsg', {
  title: function title(text) {
    return text + ' calculation rule';
  },
  info: function info(text) {
    return 'Calculation formula:<br/>Actual Expired ' + text + '=Expired ' + text + ' - Extended ' + text + '<br/>Refunded ' + text + '=Refundable ' + text + ' - Actual Expired ' + text;
  },

  btn: '知道了'
}), _defineProperty(_language$morequeryte, 'cancelPage', {
  CancellationTip: "<p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem; margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem' ><strong style='font-size:0.26rem;color:#009cd9'> 提前了解 </strong><br/> 请在取消行程前留意客票的退改政策，部分客票可能存在不允许变更或退票的规则</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem ;margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 无法恢复</strong><br/>取消航班行程后，将无法再乘坐本航班，且无法恢复。</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem;margin:0.1rem 0;text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 后续出行</strong><br/>在确定好新的行程后，您可在机票退改模块点击“变更”按钮，预订新的航班。</p>"
}), _defineProperty(_language$morequeryte, 'tchan', 'Ticket change'), _defineProperty(_language$morequeryte, 'trefun', 'Refund Request'), _defineProperty(_language$morequeryte, 'tchanges', 'Change Request'), _defineProperty(_language$morequeryte, 'cancelt', '取消行程申请'), _defineProperty(_language$morequeryte, 'tcu', '退改/升舱'), _defineProperty(_language$morequeryte, 'gongwu', '公务员信息认证'), _defineProperty(_language$morequeryte, 'payresun', 'Payment Result'), _defineProperty(_language$morequeryte, 'yasd', '退款账户认证'), _defineProperty(_language$morequeryte, 'refundName', 'Details of refund '), _defineProperty(_language$morequeryte, 'changeName', 'Details of change'), _defineProperty(_language$morequeryte, 'refundSeat', '取消行程详情'), _defineProperty(_language$morequeryte, 'serveC', '餐食服务'), _defineProperty(_language$morequeryte, 'contact', 'Call '), _defineProperty(_language$morequeryte, 'refundSubmitTip1', 'The system is processing your refund request. Please wait!'), _defineProperty(_language$morequeryte, 'refundSubmitTip2', 'If submission fails, please try again later.'), _defineProperty(_language$morequeryte, 'sumitKnow', 'I Understand'), _defineProperty(_language$morequeryte, 'sumitSure', 'Confirm Submission'), _defineProperty(_language$morequeryte, 'moreThink', 'Let me think'), _defineProperty(_language$morequeryte, 'ticInfo', 'Ticket Info'), _defineProperty(_language$morequeryte, 'lessPrice', function lessPrice(refundMoney) {
  return 'Pursuant to the ticket refund policy, the refundable amount for this ticket is low (' + refundMoney + '). Please confirm whether you wish to proceed with the refund submission.';
}), _language$morequeryte);

/***/ }),

/***/ "/dMe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "0/jl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("YjQv");
var has = __webpack_require__("x//u");
var DESCRIPTORS = __webpack_require__("qs+f");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var META = __webpack_require__("+zJ9").KEY;
var $fails = __webpack_require__("zyKz");
var shared = __webpack_require__("a/OS");
var setToStringTag = __webpack_require__("LhDF");
var uid = __webpack_require__("GmwO");
var wks = __webpack_require__("hgbu");
var wksExt = __webpack_require__("4DQ7");
var wksDefine = __webpack_require__("Ntt2");
var enumKeys = __webpack_require__("6rdy");
var isArray = __webpack_require__("NU0k");
var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var toObject = __webpack_require__("wXdB");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var createDesc = __webpack_require__("YTz9");
var _create = __webpack_require__("NZ8V");
var gOPNExt = __webpack_require__("6tLb");
var $GOPD = __webpack_require__("rjjF");
var $GOPS = __webpack_require__("THEY");
var $DP = __webpack_require__("GCs6");
var $keys = __webpack_require__("pEGt");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("2m2c").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("bSeU").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("c8Kh")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("aLzV")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "01WB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("O5te");

/***/ }),

/***/ "0Lvz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var defined = __webpack_require__("+MZ2");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0PNg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA9pJREFUWEfFl19oW2UUwH/n3tRVu8GwSbaCk9WtoiCbOpG1t5sVKm4v+mKHDoQkuj9V1BehzOmTG6P4pAzbbZAEhCGrLz5NsWDdmnaIU1d8GHZzxQndkhSVrVpNco98d0lJ/940svU+3JfvnO/8vnPOd875hAo+bWsLTGycalLXbsJlpwqbBZqAVUX1GwqjolzA4rRYhdH6S7WjMjCQ99te/ATGI1vXB7BfU2GnQCNQ56MzqXBFlNN5Ch83JM+NLSa/IMBEdPs6VwoRlK6i0ZvAZUS+Bf3eVeuKaOG62VzFXmOJ2wjyOKpPAhuAlcAkQreldrI+cebqfCDzAqQjbWtFc59gsR2oAUYUPSQBayT4R8Nl6esrzLeZdnTY2dXjGzTvbhLkXWATkMPljErNy+HkwLXZenMAJiLOM67wEfAQ8CuqXVOT+vm6vuG//cJVvn61o/nu2jp5HpFu4H7goqW8WZ9MfVUuNwPAO7nkvvaMCyPqSlc4OfjFUgzPlk1HWneIpd2o542LqjVPl3tiGsCLuVuIY9FujOfVam9InM0sZFz3bqnJ5msfMOvBwNQvcvx8biHZ8ei2UEDcfg/Cpd+y7FgpJ6YBMjHnPRQTt2uqss/v5NlYa7uqa9yLiNUVjA/2L+YpzxOix4C1CIdC8dT7nq75eVdN7J+Ae1DdHUoOfern9nTEOSrC694tgKPhROoNP51MpOVFRE4Cf+W18Ii5omKKTLYxdwR4G7gwddNtriThMtGWYyB7bxnV46HE0D4/AC8xV1rDwGaUD4JjNe9I9tWtD7sF+5TAekWj4cTQZ34bmfVqAIxeOtrygiAJhTHLLuySTMx5DsW45RIB2RU6Mfjz7QTI7Gl9kLyeAjYi7JZMxOlB2I/IieCNhs6FisxsqGo94BWrVeM9qO5B6ZV01BkSaEboDMVTvZWc/v+EwNONOftRehSGJRN1zF0Pulg71iTOfnknAK5Htz1r4ZoClzUAU8AKVX0snBz68U4ApCMtj4rID8A/1QOUcudWIegNJVOdlcLPBqgqBNmoc0DhcLGaHQwmUqaWVPTNCEG1SfjnK8335tR+yVgMrODk6p7B3yuyPicJq7yGlRqbLTfnGlZbiEyHu4vCU8bAv9jfLNY5yyHmFKJqS3E64hwR4S0vB5UPw8nUgUq8MqcUV92MYs53KFs8o8L5UDz1hB/AvM3IKFXTjovzw8EiwOFSf18MYt52XFJY6kBikmmi7jfzNqB+8r5Rvx6y6EBiNlnqSObn7vL1ikYyo7CsQ2mJeFnH8hLEsj5Mpj2xnE+zGQm0XI/Tcojb+Tz/D+9zigfSioK7AAAAAElFTkSuQmCC"

/***/ }),

/***/ "0aDT":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("tyYZ"),
    assignMergeValue = __webpack_require__("K+tY"),
    baseFor = __webpack_require__("k8CY"),
    baseMergeDeep = __webpack_require__("ymMP"),
    isObject = __webpack_require__("fAzg"),
    keysIn = __webpack_require__("nWat"),
    safeGet = __webpack_require__("CglM");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "12Os":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "1KgM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("h2Na");

__webpack_require__("gLkT");

/***/ }),

/***/ "1RnF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("aLzV");


/***/ }),

/***/ "24Tv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2H8H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = Popup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css__ = __webpack_require__("h2Na");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_icon_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon__ = __webpack_require__("YK8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__csair_emp_helpers__ = __webpack_require__("mekh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Btn__ = __webpack_require__("yU3I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less__ = __webpack_require__("jFhi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_axiosMiddleware__ = __webpack_require__("aJUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__ = __webpack_require__("Sf+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Utils__ = __webpack_require__("oFuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_cn__ = __webpack_require__("GxNa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_en__ = __webpack_require__("/aCt");




var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * 弹窗
 * @param { title, imgICon, text, onClose, btn, imgWidth, textStyle, contertStyle}
 *  title String 弹窗名称
 *  imgICon 图片
 *  imgStyle 图片宽度 默认2.5rem
 *  textStyle 内容自定义样式
 *  text String 中间段落
 *  btn Array 按钮
 *    btn-item Object {name:'',callBack:fun}
 */














// 预约受理后缀标题
var fastRefundSufTitle = '选择机票退票预约受理业务。';
/**
 * 获取预约受理提示语，如果匹配得上，将再最后面补充 选择机票退票预约受理业务
 * @param {String} msg
 */
// function getFastRefundMsg(msg) {
//   // 是否需要修改文案，true = 是
//   let needMod = false;
//   if (msg) {
//     if (
//       msg.includes('企业订座客票暂不支持自助处理') ||
//       msg.includes(
//         '客票非直销渠道直接购买，一次只允许退一个成人旅客，退其他成人旅客请分开提交'
//       ) ||
//       msg.includes('客票状态不符') ||
//       msg.includes('请勾选所有可退航段') ||
//       msg.includes('为线下渠道出票，暂不支持自助处理')
//     ) {
//       needMod = true;
//     } else if (msg.includes('退票')) {
//       if (
//         msg.includes('同行人客票在不同渠道购买，请分开提交退票申请') ||
//         msg.includes('系统操作权限') ||
//         msg.includes('客票状态不一致，可分别提交') ||
//         msg.includes(
//           '所有未使用航段必须全退，目前您未使用的航段存在状态不符情况无法提交'
//         ) ||
//         (msg.includes('自助') &&
//           (msg.includes('无法') || msg.includes('不支持'))) ||
//         msg.includes('不支持单独') ||
//         msg.includes('选择以下任一方式')
//       ) {
//         needMod = true;
//       }
//     }
//   }
//   if (needMod) {
//     if (msg.includes('3、联系南航客服95539'))
//       return msg.replace('。', `；<br/>4、${fastRefundSufTitle}`);
//     else if (msg.includes('2、联系南航客服95539'))
//       return msg.replace('。', `；<br/>3、${fastRefundSufTitle}`);
//     else return msg.replace('。', `或者${fastRefundSufTitle}`);
//   }
//   return msg || '';
// }

var popupQueue = [];

function handleClickCallPhone(phone) {
  return function () {
    Object(__WEBPACK_IMPORTED_MODULE_5__csair_emp_helpers__["C" /* isCsairApp */])() ? Object(__WEBPACK_IMPORTED_MODULE_5__csair_emp_helpers__["d" /* appTell */])(phone) : window.location.href = 'tel://' + phone;
  };
}

function getURLParams(url) {
  var reg = /(\w+)=(\w+)/g;
  var params = {};
  url.replace(reg, function (_, key, value) {
    params[key] = value;
  });
  return params;
}

function handleClickToService(txt, title) {
  var type = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('scopeType');
  var tiNo = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('allTicketNo');
  var allName = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('allName');
  var changeTap = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('changeTap');
  var pageButtonName = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('pageButtonName');
  window.$sensors.sensors.track('popup_click', {
    page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash),
    // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
    popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
    popup_type: '功能弹窗',
    tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : '',
    popup_title: title,
    popup_content: txt,
    click_type: '我要反馈',
    channel_id: window.location.href ? getURLParams(window.location.href).channel : '',
    ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
    target_url: 'https://icc.csair.com/mCustService/#/demands?channel=PC/APP&' + (type ? 'type=' + type + '&' : '') + (tiNo ? 'ticketNo=' + tiNo : '') + '&prompt=' + txt + '&' + (allName ? 'name=' + allName : '')
  });

  return function () {
    // window.location.href = `https://icc.csair.com/mCustService/#/demands?channel=PC/APP&t${
    //   type ? `type=${type}&` : ''
    // }${tiNo ? `ticketNo=${tiNo}` : ''}&prompt=${txt}&${allName ? `name=${allName}` : ''}`;
    //测试
    window.location.href = 'https://icc.csair.com/mCustService/#/demands?channel=PC/APP&' + (type ? 'type=' + type + '&' : '') + (tiNo ? 'ticketNo=' + tiNo : '') + '&prompt=' + txt + '&' + (allName ? 'name=' + allName : '');
  };
}

function handleClickToArit(txt, title) {
  var type = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('scopeType');
  var tiNo = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('allTicketNo');
  var reCalc = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('reCalc');
  var pageButtonName = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('pageButtonName');
  var changeTap = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('changeTap');
  window.$sensors.sensors.track('popup_click', {
    page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash),
    // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
    popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
    popup_type: '功能弹窗',
    popup_title: title,
    popup_content: txt,
    click_type: '在线人工客服',
    ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
    channel_id: window.location.href ? getURLParams(window.location.href).channel : '',
    tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : '',
    target_url: ''
  });

  return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
    var res;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_9__store_axiosMiddleware__["a" /* client */].createHttp('post', '/EMP/customerServiceTickets', {
              data: {
                ticketNo: tiNo.replace(',', ';'),
                typeCode: type,
                speech: txt,
                reCalc: reCalc === '1' ? true : false
              }
            });

          case 2:
            res = _context.sent;

            if (res) {
              window.$sensors.sensors.track('popup_click', {
                page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash),
                // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
                popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
                popup_type: '功能弹窗',
                popup_title: title,
                popup_content: txt,
                click_type: '在线人工客服',
                ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
                channel_id: window.location.href ? getURLParams(window.location.href).channel : '',
                tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : '',
                target_url: 'https://icc.csair.com/mCustService/#/?channel=touch_02&query=dxxzrg&value1=' + res.data.url
              });
              window.location.href = 'https://icc.csair.com/mCustService/#/?channel=touch_02&query=dxxzrg&value1=' + res.data.url;
            }

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}

function handleClickToIng(txt, title) {
  var urlA = '';
  if (Object(__WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__["d" /* webEntry */])() === 0) {
    urlA = __WEBPACK_IMPORTED_MODULE_7_Url__["default"].online_service_app_url;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__["d" /* webEntry */])() === 1) {
    urlA = __WEBPACK_IMPORTED_MODULE_7_Url__["default"].online_service_web_url;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__["d" /* webEntry */])() === 2) {
    urlA = __WEBPACK_IMPORTED_MODULE_7_Url__["default"].online_service_wx_url;
  }
  var pageButtonName = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('pageButtonName');
  var tiNo = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('allTicketNo');
  var changeTap = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('changeTap');

  window.$sensors.sensors.track('popup_click', {
    page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash),
    // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
    popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
    popup_type: '功能弹窗',
    popup_title: title,
    popup_content: txt,
    click_type: '在线客服',
    channel_id: window.location.href ? getURLParams(window.location.href).channel : '',

    tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(window.location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : '',
    ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
    target_url: urlA
  });
  return function () {
    if (Object(__WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__["d" /* webEntry */])() === 0) {
      window.location.href = __WEBPACK_IMPORTED_MODULE_7_Url__["default"].online_service_app_url;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__["d" /* webEntry */])() === 1) {
      window.location.href = __WEBPACK_IMPORTED_MODULE_7_Url__["default"].online_service_web_url;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_10_utilsRecommendCode__["d" /* webEntry */])() === 2) {
      window.location.href = __WEBPACK_IMPORTED_MODULE_7_Url__["default"].online_service_wx_url;
    }
  };
}
function TicPopUp(_ref2) {
  var title = _ref2.title,
      imgICon = _ref2.imgICon,
      text = _ref2.text,
      onClose = _ref2.onClose,
      btn = _ref2.btn,
      imgWidth = _ref2.imgWidth,
      textStyle = _ref2.textStyle,
      _ref2$needTel = _ref2.needTel,
      needTel = _ref2$needTel === undefined ? true : _ref2$needTel,
      contertStyle = _ref2.contertStyle;

  var tel = /(4008895539|95539)/.exec(text);
  var lang = __WEBPACK_IMPORTED_MODULE_12_cn__["a" /* default */];
  // let isEN = window.sessionStorage.getItem('language') == "en";
  var isEN = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('language') == 'en';

  if (isEN) {
    lang = __WEBPACK_IMPORTED_MODULE_13_en__["a" /* default */];
  }
  if (window.sessionStorage.getItem('persist:emp')) {
    lang = JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App).lang;
  }
  var ser = text.includes('我要反馈');
  var ati = text.includes('在线人工客服');
  var igs = text.includes('【在线客服】');

  var bt = [];
  if (tel && needTel) {
    bt.push({
      text: _jsx('a', {
        href: 'javascript:void(0)',
        onClick: handleClickCallPhone(tel[0]),
        style: { color: 'rgba(38, 38, 38, 0.6)' }
      }, void 0, lang.contact, tel[0]),
      callback: function callback() {}
    });
  }
  // GN: [ID1556600][2024-10-16]
  if (ser) {
    if (btn.length !== 0 && btn[0] && btn[0].text.includes(lang.selectDate1)) {
      btn[1] = {
        text: _jsx('a', {
          href: 'javascript:void(0)',
          onClick: handleClickToService(text, title),
          style: { color: 'rgb(0, 138, 203)' },
          id: 'iBlack',
          'aria-hidden': 'true'
        }, void 0, '\u6211\u8981\u53CD\u9988'),
        callback: function callback() {}
      };
      bt.push.apply(bt, _toConsumableArray(btn));
    } else {
      bt.push({
        text: lang.refCupon3354,
        callback: function callback() {
          return onClose(lang.refCupon3354);
        },
        style: { color: 'rgba(38, 38, 38, 0.6)' }
      }, {
        text: _jsx('a', {
          href: 'javascript:void(0)',
          onClick: handleClickToService(text, title),
          style: { color: 'rgb(0, 138, 203)' },
          id: 'iBlack',
          'aria-hidden': 'true'
        }, void 0, '\u6211\u8981\u53CD\u9988'),
        callback: function callback() {}
      });
    }
  }

  if (ati) {
    if (btn.length !== 0 && btn[0] && btn[0].text.includes(lang.selectDate1)) {
      btn[1] = {
        text: _jsx('a', {
          href: 'javascript:void(0)',
          onClick: handleClickToArit(text, title),
          style: { color: 'rgb(0, 138, 203)' },
          id: 'lineBlack',
          'aria-hidden': 'true'
        }, void 0, '\u5728\u7EBF\u4EBA\u5DE5\u5BA2\u670D'),
        callback: function callback() {}
      };
      bt.push.apply(bt, _toConsumableArray(btn));
    } else {
      bt.push({
        text: lang.refCupon3354,
        callback: function callback() {
          return onClose(lang.refCupon3354);
        },
        style: { color: 'rgba(38, 38, 38, 0.6)' }
      }, {
        text: _jsx('a', {
          href: 'javascript:void(0)',
          onClick: handleClickToArit(text),
          style: { color: 'rgb(0, 138, 203)' },
          id: 'lineBlack',
          'aria-hidden': 'true'
        }, void 0, '\u5728\u7EBF\u4EBA\u5DE5\u5BA2\u670D'),
        callback: function callback() {}
      });
    }
  }

  if (igs) {
    bt.push({
      text: '返回',
      callback: function callback() {
        return onClose('返回');
      },
      style: { color: 'rgba(38, 38, 38, 0.6)' }
    }, {
      text: _jsx('a', {
        href: 'javascript:void(0)',
        onClick: handleClickToIng(text, title),
        style: { color: 'rgb(0, 138, 203)' },
        id: 'lineBlack',
        'aria-hidden': 'true'
      }, void 0, '\u5728\u7EBF\u5BA2\u670D'),
      callback: function callback() {}
    });
  }

  if (!(ser || ati || igs)) {
    btn.length !== 0 ? bt.push.apply(bt, _toConsumableArray(btn)) : bt.push({ text: lang.confirm, callback: function callback() {
        return onClose(lang.confirm);
      } });
  }

  return _jsx('div', {
    className: 'popUP_main'
  }, void 0, _jsx('div', {
    id: 'pCt',
    className: 'popUP_Content',
    role: 'dialog',
    tabIndex: '-1',
    'aria-modal': 'true',
    style: contertStyle
  }, void 0, _jsx('div', {
    className: 'popUP_close_div'
  }, void 0, _jsx('span', {
    className: 'popUP_close',
    onClick: function onClick() {
      return onClose();
    },
    'aria-label': '\u5173\u95ED',
    role: 'button'
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_icon___default.a, {
    type: 'cross',
    style: {}
  }))), title && _jsx('p', {
    className: 'popUP_title'
  }, void 0, title), _jsx('div', {
    className: 'popUP_scrollDiv'
  }, void 0, imgICon && _jsx('div', {
    className: 'popUP_centerImgDiv',
    style: { width: imgWidth }
  }, void 0, _jsx('img', {
    className: 'popUP_centerImg',
    src: imgICon,
    alt: ''
  })), text && _jsx('p', {
    className: 'popUP_tip',
    style: textStyle,
    dangerouslySetInnerHTML: { __html: text }
  })), _jsx('div', {
    className: 'popUP_btn'
  }, void 0, bt.map(function (item, i) {
    if (item.style) {
      delete item.style.background;
      delete item.style.color;
    }
    return item !== '' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      Object.assign({
        key: i
      }, item.style ? { style: item.style } : {}, {
        className: 'popUP_submit ' + (bt.length > 1 ? 'hw' : ''),
        role: 'button',
        onClick: item.callback,
        'aria-labelledby': i === 0 ? 'blackB' : 'iBlack lineBlack blackB2'
      }),
      _jsx('p', {
        style: {
          borderLeft: bt.length > 1 ? '1px solid #ccc' : 'none',
          width: '100%',
          color: item.text === lang.close || item.text === lang.Cancel ? 'rgba(38, 38, 38, 0.6)' : 'rgba(0, 138, 203, 1)'
        }
      }, void 0, _jsx('span', {
        id: i === 0 ? 'blackB' : 'blackB2',
        'aria-hidden': 'true'
      }, void 0, item.text))
    );
  }))));
}

TicPopUp.defaultProps = {
  onClose: function onClose() {},
  title: '',
  imgICon: '',
  imgWidth: '2.5rem',
  text: '',
  btn: [],
  textStyle: {},
  contertStyle: {}
};

/**
 * 弹框
 * @param { title, text, onClose, imgICon, actions, imgWidth, textStyle,contertStyle }
 * desc
 * onClose fn
 * actions array (item => { text: '', onPress: fn })
 */
function Popup() {
  var title = arguments.length <= 0 ? undefined : arguments[0];
  var content = arguments.length <= 1 ? undefined : arguments[1];
  var _onClose = (arguments.length <= 2 ? undefined : arguments[2]) || function () {};
  var imgICon = arguments.length <= 3 ? undefined : arguments[3];
  var actions = (arguments.length <= 4 ? undefined : arguments[4]) || [];
  var imgWidth = arguments.length <= 5 ? undefined : arguments[5];
  var textStyle = arguments.length <= 6 ? undefined : arguments[6];
  var needTel = arguments.length <= 7 ? undefined : arguments[7];
  var contertStyle = arguments.length <= 8 ? undefined : arguments[8];

  if (!title && !content) {
    return {
      close: function close() {}
    };
  }

  var div = document.createElement('div');
  document.body.appendChild(div);

  var timeoutEvn = null;
  function keydownFun(e) {
    var dom = document.getElementById('pCt');
    var focusableElements = dom.getElementsByTagName('*');
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var isTabPressed = e.key === 'Tab' || e.shiftKey && e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  function close(text) {
    var pageButtonName = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('pageButtonName');
    var tiNo = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('allTicketNo');
    var changeTap = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('changeTap');

    // JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).updateDetail).selectStyle==="1"
    window.$sensors.sensors.track('popup_click', {
      page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash),
      popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
      popup_type: '功能弹窗',
      popup_title: title,
      popup_content: content,
      click_type: text,
      channel_id: window.location.href ? getURLParams(window.location.href).channel : '',

      ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
      target_url: '',
      tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : ''
    });
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  var footer = actions.map(function (button) {
    var orginPress = button.onPress || function () {};
    var pageButtonName = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('pageButtonName');
    var changeTap = Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["session"])('changeTap');

    button.callback = function () {
      var res = orginPress();
      if (res && res.then) {
        window.$sensors.sensors.track('popup_click', {
          page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash),
          popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
          popup_type: '功能弹窗',
          popup_title: title,
          popup_content: content,
          click_type: button.text,
          target_url: '',
          channel_id: window.location.href ? getURLParams(window.location.href).channel : '',
          tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : ''
        });
        res.then(function () {
          window.$sensors.sensors.track('popup_click', {
            page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash),
            // popup_area: getPageName(location.hash) + pageButtonName ? pageButtonName : '',
            popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
            popup_type: '功能弹窗',
            popup_title: title,
            popup_content: content,
            click_type: button.text,
            target_url: '',
            channel_id: window.location.href ? getURLParams(window.location.href).channel : '',
            tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : ''
          });
          close(button.text);
        });
      } else {
        window.$sensors.sensors.track('popup_click', {
          page_name: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash),
          popup_area: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) + (pageButtonName ? pageButtonName : ''),
          popup_type: '功能弹窗',
          popup_title: title,
          popup_content: content,
          click_type: button.text,
          target_url: '',
          channel_id: window.location.href ? getURLParams(window.location.href).channel : '',
          tab_type: Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改列表页' ? changeTap ? changeTap : '可退改' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-退改说明页' ? changeTap ? changeTap : '退票说明' : Object(__WEBPACK_IMPORTED_MODULE_11_Utils__["getPageName"])(location.hash) === '机票退改-取消行程列表页' ? changeTap ? changeTap : '可取消' : ''
        });
        close(button.text);
      }
    };
    return button;
  });

  __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(_jsx(TicPopUp, {
    title: title,
    imgICon: imgICon,
    imgWidth: imgWidth,
    textStyle: textStyle,
    onClose: function onClose(text) {
      _onClose();
      close(text);
    },
    text: content,
    btn: footer,
    needTel: needTel,
    contertStyle: contertStyle
  }), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('pCt').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(function () {
    focus();
    trapFocus();
  }, 200);
  popupQueue.push({
    close: close
  });

  return popupQueue[popupQueue.length - 1];
}

Popup.clear = function () {
  if (popupQueue && popupQueue.length) {
    popupQueue.forEach(function (progess) {
      progess.close();
    });
    popupQueue = [];
  }
};

/***/ }),

/***/ "2m2c":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("DvwR");
var hiddenKeys = __webpack_require__("B5V0").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("jbrW");
__webpack_require__("lkEk");
__webpack_require__("2H8H");
__webpack_require__("7rGq");
__webpack_require__("m5tV");
__webpack_require__("3dT7");
__webpack_require__("AjmZ");
__webpack_require__("oFuF");
__webpack_require__("a1o4");
__webpack_require__("8oYa");
__webpack_require__("yU3I");
__webpack_require__("hdgR");
__webpack_require__("OTY+");
module.exports = __webpack_require__("EjGm");


/***/ }),

/***/ "31Lb":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("cz0U");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "3IRH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(206);

/***/ }),

/***/ "3dT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__("r9K6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_flight_png__ = __webpack_require__("H7xP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_flight_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_flight_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flight2_png__ = __webpack_require__("wNex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flight2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_flight2_png__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = _jsx('div', {
  className: 'flight_img'
});

var _ref2 = _jsx('div', {
  className: 'left_cont'
}, void 0, _jsx('div', {
  className: 'left_line'
}), _jsx('span', {
  className: 'sc'
}));

var _ref3 = _jsx('div', {
  className: 'line'
}, void 0, _jsx('div', {
  className: 'line_left_'
}), _jsx('div', {
  className: 'line_left_'
}));

var _ref4 = _jsx('span', {
  className: 'nextC'
});

var _ref5 = _jsx('span', {
  className: 'nextCF'
});

var RefundNav = function (_PureComponent) {
  _inherits(RefundNav, _PureComponent);

  function RefundNav() {
    _classCallCheck(this, RefundNav);

    return _possibleConstructorReturn(this, (RefundNav.__proto__ || Object.getPrototypeOf(RefundNav)).apply(this, arguments));
  }

  _createClass(RefundNav, [{
    key: 'render',
    value: function render() {
      var lang = this.props.lang;

      return _jsx('div', {
        style: {
          width: '100%',
          overflow: 'hidden',
          minHeight: '0.9rem',
          marginTop: '-2px',
          paddingTop: '20px',
          textAlign: "center"
        }
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: 'navBarHeight',
          className: 'ref_navbar_nav ' + (this.props.navStyle || 'nav1'),
          style: { float: 'left' }
        },
        _jsx('div', {
          className: 'ref_RefundNavbar_tips'
        }, void 0, this.props.navStyle !== 'nav3' ? _ref : null, _jsx('div', {
          className: 'left'
        }, void 0, _ref2, _jsx('span', {
          className: 'ref_navbar_tips1',
          style: { color: '#008ACB' }
        }, void 0, lang.fillInfo)), _ref3, _jsx('div', {
          className: 'line'
        }, void 0, _jsx('div', {
          className: this.props.navStyle !== 'nav3' ? 'line_right' : 'line_left_'
        }), _jsx('div', {
          className: this.props.navStyle !== 'nav3' ? 'line_right' : 'line_left_'
        })), _jsx('div', {
          className: 'right'
        }, void 0, _jsx('div', {
          className: 'right_cont'
        }, void 0, _jsx('div', {
          className: this.props.navStyle !== 'nav3' ? 'right_line' : 'right_line_'
        }), this.props.navStyle !== 'nav3' ? _ref4 : _ref5), _jsx('span', {
          className: 'ref_navbar_tips3',
          style: this.props.navStyle !== 'nav3' ? { color: '#262626' } : { color: '#008ACB' }
        }, void 0, lang.updateDetail86)))
      ));
    }
  }]);

  return RefundNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

RefundNav.PropTypes = {
  navStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  airplaneICon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lang: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["default"] = (RefundNav);

/***/ }),

/***/ "3fMt":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("SWGL");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "3ggi":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('asyncIterator');


/***/ }),

/***/ "43O/":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 64 64\" id=\"exclamation-circle\" ><title>Share Icons Copy 3</title><path d=\"M59.58 40.889L41.193 9.11C39.135 5.382 35.723 3 31.387 3c-3.11 0-6.521 2.382-8.58 6.111L4.42 40.89c-2.788 4.635-3.126 8.81-1.225 12.22C5.015 56.208 7.572 58 13 58h36.773c5.428 0 9.21-1.792 11.031-4.889 1.9-3.41 1.564-7.584-1.225-12.222zm-2.452 11c-.635 1.695-3.802 2.444-7.354 2.444H13c-3.591 0-5.493-.75-6.129-2.444-1.712-2.41-1.375-5.262 0-8.556l18.386-31.777c2.116-3.168 4.394-4.89 6.13-4.89 2.96 0 5.238 1.722 7.354 4.89l18.386 31.777c1.374 3.294 1.713 6.146 0 8.556zm-25.74-33c-.405 0-1.227.836-1.227 2.444v15.89c0 1.608.822 2.444 1.226 2.444 1.628 0 2.452-.836 2.452-2.445V21.333c0-1.608-.824-2.444-2.452-2.444zm0 23.222c-.405 0-1.227.788-1.227 1.222v2.445c0 .434.822 1.222 1.226 1.222 1.628 0 2.452-.788 2.452-1.222v-2.445c0-.434-.824-1.222-2.452-1.222z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "exclamation-circle");

/***/ }),

/***/ "455d":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("81VC");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "49fU":
/***/ (function(module, exports) {

module.exports = vendor_library;

/***/ }),

/***/ "4DQ7":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("hgbu");


/***/ }),

/***/ "4T41":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),

/***/ "4ajQ":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("qs+f"), 'Object', { defineProperty: __webpack_require__("GCs6").f });


/***/ }),

/***/ "4dmN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c8Kh");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var hide = __webpack_require__("aLzV");
var Iterators = __webpack_require__("yYxz");
var $iterCreate = __webpack_require__("I7B8");
var setToStringTag = __webpack_require__("LhDF");
var getPrototypeOf = __webpack_require__("VD8v");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "56Hq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("y1vT");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Steps = function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps(props) {
    _classCallCheck(this, Steps);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.calcStepOffsetWidth = function () {
      var domNode = _reactDom2["default"].findDOMNode(_this);
      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }
        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
          // Reduce shake bug
          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
            return;
          }
          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
        });
      }
    };

    _this.state = {
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = (0, _lodash2["default"])(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.calcTimeout) {
      clearTimeout(this.calcTimeout);
    }
    if (this.calcStepOffsetWidth.cancel) {
      this.calcStepOffsetWidth.cancel();
    }
  };

  Steps.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var props = this.props;

    var prefixCls = props.prefixCls,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        className = props.className,
        children = props.children,
        direction = props.direction,
        labelPlacement = props.labelPlacement,
        iconPrefix = props.iconPrefix,
        status = props.status,
        size = props.size,
        current = props.current,
        progressDot = props.progressDot,
        restProps = _objectWithoutProperties(props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot']);

    var filteredChildren = _react2["default"].Children.toArray(children).filter(function (c) {
      return !!c;
    });
    var lastIndex = filteredChildren.length - 1;
    var reLayouted = this.state.lastStepOffsetWidth > 0;
    var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
    var classString = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, prefixCls + '-' + size, size), _defineProperty(_classNames, prefixCls + '-' + direction, true), _defineProperty(_classNames, prefixCls + '-label-' + adjustedlabelPlacement, direction === 'horizontal'), _defineProperty(_classNames, prefixCls + '-hidden', !reLayouted), _defineProperty(_classNames, prefixCls + '-dot', !!progressDot), _defineProperty(_classNames, className, className), _classNames));

    return _react2["default"].createElement(
      'div',
      _extends({ className: classString, style: style }, restProps),
      _react2["default"].Children.map(filteredChildren, function (ele, idx) {
        if (!ele) {
          return null;
        }
        var itemWidth = direction === 'vertical' || idx === lastIndex || !reLayouted ? null : 100 / lastIndex + '%';
        var adjustMarginRight = direction === 'vertical' || idx === lastIndex ? null : -Math.round(_this2.state.lastStepOffsetWidth / lastIndex + 1);
        var np = {
          stepNumber: (idx + 1).toString(),
          itemWidth: itemWidth,
          adjustMarginRight: adjustMarginRight,
          prefixCls: prefixCls,
          iconPrefix: iconPrefix,
          wrapperStyle: style,
          progressDot: progressDot
        };

        // fix tail color
        if (status === 'error' && idx === current - 1) {
          np.className = props.prefixCls + '-next-error';
        }

        if (!ele.props.status) {
          if (idx === current) {
            np.status = status;
          } else if (idx < current) {
            np.status = 'finish';
          } else {
            np.status = 'wait';
          }
        }
        return _react2["default"].cloneElement(ele, np);
      }, this)
    );
  };

  return Steps;
}(_react2["default"].Component);

exports["default"] = Steps;


Steps.propTypes = {
  prefixCls: _propTypes2["default"].string,
  iconPrefix: _propTypes2["default"].string,
  direction: _propTypes2["default"].string,
  labelPlacement: _propTypes2["default"].string,
  children: _propTypes2["default"].any,
  status: _propTypes2["default"].string,
  size: _propTypes2["default"].string,
  progressDot: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].func])
};

Steps.defaultProps = {
  prefixCls: 'rc-steps',
  iconPrefix: 'rc',
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  current: 0,
  status: 'process',
  size: '',
  progressDot: false
};
module.exports = exports['default'];

/***/ }),

/***/ "59gI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "5I/1":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("uDOi");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("tYO1"), __esModule: true };

/***/ }),

/***/ "5eVA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6+fr":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "63og":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "69qq":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "6fbY":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 72 72\" id=\"fail\" ><title>&#x5931;&#x8D25;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path d=\"M22 22l28.304 28.304M22 50.304L50.304 22\" stroke=\"#FFF\" stroke-width=\"2\"/></g></symbol>";
module.exports = sprite.add(image, "fail");

/***/ }),

/***/ "6oX/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
var ActivityIndicator = function (_React$Component) {
    (0, _inherits3['default'])(ActivityIndicator, _React$Component);

    function ActivityIndicator() {
        (0, _classCallCheck3['default'])(this, ActivityIndicator);
        return (0, _possibleConstructorReturn3['default'])(this, (ActivityIndicator.__proto__ || Object.getPrototypeOf(ActivityIndicator)).apply(this, arguments));
    }

    (0, _createClass3['default'])(ActivityIndicator, [{
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                animating = _props.animating,
                toast = _props.toast,
                size = _props.size,
                text = _props.text;

            var wrapClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-toast', !!toast), _classNames));
            var spinnerClass = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-spinner', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-spinner-lg', !!toast || size === 'large'), _classNames2));
            if (animating) {
                if (toast) {
                    return _react2['default'].createElement(
                        'div',
                        { className: wrapClass },
                        text ? _react2['default'].createElement(
                            'div',
                            { className: prefixCls + '-content' },
                            _react2['default'].createElement('span', { className: spinnerClass, 'aria-hidden': 'true' }),
                            _react2['default'].createElement(
                                'span',
                                { className: prefixCls + '-toast' },
                                text
                            )
                        ) : _react2['default'].createElement(
                            'div',
                            { className: prefixCls + '-content' },
                            _react2['default'].createElement('span', { className: spinnerClass, 'aria-label': 'Loading' })
                        )
                    );
                } else {
                    return text ? _react2['default'].createElement(
                        'div',
                        { className: wrapClass },
                        _react2['default'].createElement('span', { className: spinnerClass, 'aria-hidden': 'true' }),
                        _react2['default'].createElement(
                            'span',
                            { className: prefixCls + '-tip' },
                            text
                        )
                    ) : _react2['default'].createElement(
                        'div',
                        { className: wrapClass },
                        _react2['default'].createElement('span', { className: spinnerClass, 'aria-label': 'loading' })
                    );
                }
            } else {
                return null;
            }
        }
    }]);
    return ActivityIndicator;
}(_react2['default'].Component);

exports['default'] = ActivityIndicator;

ActivityIndicator.defaultProps = {
    prefixCls: 'am-activity-indicator',
    animating: true,
    size: 'small',
    panelColor: 'rgba(34,34,34,0.6)',
    toast: false
};
module.exports = exports['default'];

/***/ }),

/***/ "6rdy":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "6tLb":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("ksFB");
var gOPN = __webpack_require__("2m2c").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "74g+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7OyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProgressBar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__("fMlP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_x_cloud_png__ = __webpack_require__("gCui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_x_cloud_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_x_cloud_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_x_sun_png__ = __webpack_require__("N1YQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_x_sun_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_x_sun_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_x_plane_png__ = __webpack_require__("ko9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_x_plane_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_x_plane_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_x_cloud_1_png__ = __webpack_require__("hVCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_x_cloud_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_x_cloud_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_x_cloud_2_png__ = __webpack_require__("GqR8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_x_cloud_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_x_cloud_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_x_cloud_3_png__ = __webpack_require__("74g+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_x_cloud_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_x_cloud_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_TicPopUp__ = __webpack_require__("2H8H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_cn__ = __webpack_require__("GxNa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_en__ = __webpack_require__("/aCt");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var progressQueue = [];

var _ref2 = _jsx('div', {}, void 0, _jsx('img', {
  className: 'progress-bar-sun',
  src: __WEBPACK_IMPORTED_MODULE_4__assets_x_sun_png___default.a,
  alt: ''
}), _jsx('div', {
  className: 'progress-bar-sm-cloud'
}, void 0, _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_6__assets_x_cloud_1_png___default.a,
  alt: ''
}), _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_7__assets_x_cloud_2_png___default.a,
  alt: ''
}), _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8__assets_x_cloud_3_png___default.a,
  alt: ''
})), _jsx('img', {
  className: 'progress-bar-plane',
  src: __WEBPACK_IMPORTED_MODULE_5__assets_x_plane_png___default.a,
  alt: ''
}), _jsx('div', {
  className: 'progress-bar-cloud'
}, void 0, _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_3__assets_x_cloud_png___default.a,
  alt: ''
})));

var ProgressBarComponent = function (_Component) {
  _inherits(ProgressBarComponent, _Component);

  function ProgressBarComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProgressBarComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProgressBarComponent.__proto__ || Object.getPrototypeOf(ProgressBarComponent)).call.apply(_ref, [this].concat(args))), _this), _this.rateTimeout = null, _this.prev = Date.now(), _this.randomTimeout = null, _this.state = {
      value: 0,
      status: ''
    }, _this.start = function () {
      clearTimeout(_this.rateTimeout);
      clearTimeout(_this.randomTimeout);
      _this.setState({ value: 0, status: '' }, function () {
        _this.randomRate();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // 进度计时器


  // 随机取进度计时


  _createClass(ProgressBarComponent, [{
    key: 'setCurRate',


    // 设置当前进度
    value: function setCurRate(value, callback) {
      var _this2 = this;

      clearTimeout(this.rateTimeout);
      var timeOver = this.props.timeOver;

      var ms = Math.ceil(100 / Number(timeOver) / 1000);
      this.rateTimeout = setTimeout(function () {
        var oldValue = _this2.state.value;
        if (oldValue === value) {
          callback && callback();
          return;
        }
        _this2.setState({ value: oldValue + ms }, function () {
          _this2.setCurRate(value, callback);
        });
      }, 10);
    }
    // 随机时间更新进度

  }, {
    key: 'randomRate',
    value: function randomRate() {
      var _this3 = this;

      clearTimeout(this.randomTimeout);
      var timeOver = this.props.timeOver;

      var max = 99;
      var value = this.state.value;

      if (value > max) return;
      var ms = Math.ceil(max / Number(timeOver));
      this.randomTimeout = setTimeout(function () {
        value += ms;
        if (value >= max) value = max;
        _this3.setCurRate(value, function () {
          _this3.randomRate();
        });
      }, 1000 /* Math.round(ms + ms * Math.random()) * 1000 */);
    }

    // 设置当前进度

  }, {
    key: 'setCurRate111',
    value: function setCurRate111(value, callback) {
      var _this4 = this;

      clearTimeout(this.rateTimeout);
      var curr = Date.now();
      var spac = value === 100 ? 40 : 80;
      var ms = Math.max(0, spac - (curr - this.prev));
      this.rateTimeout = setTimeout(function () {
        var oldValue = _this4.state.value;
        if (oldValue === value) {
          callback && callback();
          return;
        }
        _this4.setState({ value: oldValue + 1 }, function () {
          _this4.setCurRate(value, callback);
        });
      }, ms);
      this.prev = curr + ms;
    }

    // 随机时间更新进度

  }, {
    key: 'randomRate111',
    value: function randomRate111() {
      var _this5 = this;

      clearTimeout(this.randomTimeout);
      var max = 99;
      var value = this.state.value;

      if (value > max) return;
      var ms = Math.ceil(value / 10);
      this.randomTimeout = setTimeout(function () {
        value += Math.round(1 + (10 - ms + 1) * Math.random());
        if (value >= max) value = max;
        _this5.setCurRate(value, function () {
          _this5.randomRate();
        });
      }, 1000 /* Math.round(ms + ms * Math.random()) * 1000 */);
    }

    // 开始

  }, {
    key: 'success',
    value: function success(callback) {
      var _this6 = this;

      clearTimeout(this.rateTimeout);
      clearTimeout(this.randomTimeout);
      this.setCurRate(100, function () {
        setTimeout(function () {
          _this6.setState({ status: 'success' }, function () {
            setTimeout(function () {
              callback && callback();
            }, 1000);
          });
        }, 600);
      });
    }
  }, {
    key: 'fail',
    value: function fail(callback) {
      clearTimeout(this.rateTimeout);
      clearTimeout(this.randomTimeout);
      this.setState({ status: 'fail' }, function () {
        setTimeout(function () {
          callback && callback();
        }, 1000);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.state.value;

      var layerStyle = {
        width: value + '%'
      };
      return _jsx('div', {
        className: 'progress-bar-container'
      }, void 0, _ref2, _jsx('div', {
        className: 'progress'
      }, void 0, _jsx('div', {
        className: 'bar'
      }, void 0, _jsx('div', {
        style: layerStyle
      })), _jsx('b', {}, void 0, value, '%')), _jsx('b', {
        className: 'label'
      }, void 0, this.props.message));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.start();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.rateTimeout);
      clearTimeout(this.randomTimeout);
    }
  }]);

  return ProgressBarComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ProgressBarComponent.defaultProps = {
  message: '正在为您处理...',
  timeOver: '15'
};


function ProgressBar(message, operateType, timeOver) {
  var lang = __WEBPACK_IMPORTED_MODULE_10_cn__["a" /* default */];
  var isEN = window.sessionStorage.getItem('language') == 'en';
  if (isEN) {
    lang = __WEBPACK_IMPORTED_MODULE_11_en__["a" /* default */];
  }
  if (window.sessionStorage.getItem('persist:emp')) {
    lang = JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App).lang;
  }
  var div = document.createElement('div');
  var s = null;
  document.body.appendChild(div);
  var destroy = function destroy() {
    if (!div) return;
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(div);
    document.body.removeChild(div);
    compoent = null;
    div = null;
  };

  var compoent = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressBarComponent, Object.assign({}, message ? { message: message } : { message: lang.Processing1 }, { timeOver: timeOver })), div);

  var success = function success(finished) {
    compoent && compoent.success(function () {
      destroy();
      finished && finished();
    });
  };
  var fail = function fail(finished) {
    compoent && compoent.fail(function () {
      destroy();
      finished && finished();
    });
  };
  var overtime = function overtime() {
    var isAIComming = window.sessionStorage.getItem('isAIComming');
    var isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
    var enterUrl = window.sessionStorage.getItem('enterUrl') ? window.sessionStorage.getItem('enterUrl') : "https://emp.csair.com/" + 'ticketRefund/#/ticket/updateDetail?' + (isAIComming ? 'channel=AI&from=assistant' : isAICommingFT ? 'channel=AI' : '');
    var tip = operateType === 'B' ? lang.Processing2 : lang.Processing3;
    s = setTimeout(function () {
      destroy();
      if (progressQueue.length > 0) {
        window.sessionStorage.setItem('进度条', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_9_TicPopUp__["default"])(lang.reminder1, tip, function () {
          window.sessionStorage.removeItem('进度条');
          window.location.href = enterUrl;
          window.location.reload();
        }, '', [{
          text: lang.refCupon33,
          onPress: function onPress() {
            window.sessionStorage.removeItem('进度条');
            window.location.href = enterUrl;
            window.location.reload();
          }
        }], '3.85rem');
      }
      clearTimeout(s);
    }, Number(timeOver) * 1000);
  };
  overtime();
  progressQueue.push({
    destroy: destroy,
    success: success,
    fail: fail
  });
  return progressQueue[progressQueue.length - 1];
}

ProgressBar.clear = function () {
  if (progressQueue && progressQueue.length) {
    progressQueue.forEach(function (progess) {
      progess.destroy();
    });
    progressQueue = [];
  }
};

/***/ }),

/***/ "7dw9":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"up\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><title>background</title><path fill=\"none\" d=\"M-1-1h46v46H-1z\"/><g><title>Layer 1</title><defs><path id=\"up_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"up_b\"><use xlink:href=\"#up_a\"/></clipPath><g clip-path=\"url(#up_b)\"><defs><path id=\"up_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"up_d\"><use xlink:href=\"#up_c\"/></clipPath></g><path d=\"M23.417 14.229L11.184 26.462l2.121 2.12 10.12-10.117 10.117 10.118 2.121-2.121L23.43 14.229l-.006.006z\"/></g></symbol>";
module.exports = sprite.add(image, "up");

/***/ }),

/***/ "7rGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = PopUpLoad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_activity_indicator_style_css__ = __webpack_require__("uZMl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_activity_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_activity_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_activity_indicator__ = __webpack_require__("6oX/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_activity_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_activity_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_loadingHardly_gif__ = __webpack_require__("eGYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_loadingHardly_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_loadingHardly_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_autoCheck_gif__ = __webpack_require__("bBQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_autoCheck_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_autoCheck_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__("KL7P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);



var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * load弹窗
 *  props
 *    visible bool 是否显示
 *    title String 弹窗名称
 *      btn-item Object {name:'',callBack:fun}
 */







var popUpLoadQueue = [];

var _ref2 = _jsx('div', {
  className: 'popUpLoad_main'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_activity_indicator___default.a, {}));

function PopUpLoadComponent(_ref) {
  var type = _ref.type,
      onClose = _ref.onClose,
      lang = _ref.lang;

  return _jsx('div', {
    className: 'popUpLoad',
    style: type === 'act' ? { background: '#000', opacity: '.1' } : { background: '#f7fbff' }
  }, void 0, type === 'act' ? _ref2 : _jsx('img', {
    alt: '',
    style: type === 'load' ? { width: '2.5rem', marginBottom: '0.15rem' } : { width: '2.3rem', marginBottom: '0.15rem' },
    src: type === 'load' ? __WEBPACK_IMPORTED_MODULE_4__assets_loadingHardly_gif___default.a : __WEBPACK_IMPORTED_MODULE_5__assets_autoCheck_gif___default.a
  }), _jsx('div', {
    id: 'loadAria'
  }, void 0, type === 'load' ? lang.automatic1 : lang.automatic2));
}

function PopUpLoad() {
  var type = (arguments.length <= 0 ? undefined : arguments[0]) || 'act';
  var lang = (arguments.length <= 1 ? undefined : arguments[1]) || {};

  var timeoutEvn = null;
  var div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(_jsx(PopUpLoadComponent, {
    type: type,
    lang: lang,
    onClose: function onClose() {
      close();
    }
  }), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('loadAria').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  popUpLoadQueue.push({
    close: close
  });

  timeoutEvn = setTimeout(function () {
    focus();
  }, 200);
  return popUpLoadQueue[popUpLoadQueue.length - 1];
}

PopUpLoad.clear = function () {
  if (popUpLoadQueue && popUpLoadQueue.length) {
    popUpLoadQueue.forEach(function (progess) {
      progess.close();
    });
    popUpLoadQueue = [];
  }
};

/***/ }),

/***/ "81VC":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("axIB");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "8ANE":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8aSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// CONCATENATED MODULE: ./node_modules/rc-animate/es/ChildrenUtils.js


function toArrayChildren(children) {
  var ret = [];
  reactfrom_dll_reference_vendor_library_default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./node_modules/css-animation/es/index.js + 1 modules
var es = __webpack_require__("Mqyb");

// CONCATENATED MODULE: ./node_modules/rc-animate/es/util.js
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ var es_util = (util);
// CONCATENATED MODULE: ./node_modules/rc-animate/es/AnimateChild.js











var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild_AnimateChild = function (_React$Component) {
  inherits_default()(AnimateChild, _React$Component);

  function AnimateChild() {
    classCallCheck_default()(this, AnimateChild);

    return possibleConstructorReturn_default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  createClass_default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (es_util.isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (es_util.isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (es_util.isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = react_domfrom_dll_reference_vendor_library_default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : typeof_default()(transitionName)) === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((es["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(es["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(reactfrom_dll_reference_vendor_library_default.a.Component);

AnimateChild_AnimateChild.propTypes = {
  children: prop_typesfrom_dll_reference_vendor_library_default.a.any
};
/* harmony default export */ var es_AnimateChild = (AnimateChild_AnimateChild);
// CONCATENATED MODULE: ./node_modules/rc-animate/es/Animate.js










var defaultKey = 'rc_animate_' + Date.now();


function getChildrenFromProps(props) {
  var children = props.children;
  if (reactfrom_dll_reference_vendor_library_default.a.isValidElement(children)) {
    if (!children.key) {
      return reactfrom_dll_reference_vendor_library_default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate_Animate = function (_React$Component) {
  inherits_default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    classCallCheck_default()(this, Animate);

    var _this = possibleConstructorReturn_default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    Animate__initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: toArrayChildren(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  createClass_default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = toArrayChildren(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? toArrayChildren(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && findChildInChildrenByKey(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = reactfrom_dll_reference_vendor_library_default.a.cloneElement(nextChild || currentChild, defineProperty_default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !findChildInChildrenByKey(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = mergeChildren(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && findChildInChildrenByKey(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = findShownChildInChildrenByKey(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && findChildInChildrenByKey(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = findShownChildInChildrenByKey(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return findShownChildInChildrenByKey(currentChildren, key, showProp);
      }
      return findChildInChildrenByKey(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return reactfrom_dll_reference_vendor_library_default.a.createElement(
            es_AnimateChild,
            {
              key: child.key,
              ref: function ref(node) {
                return _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = extends_default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return reactfrom_dll_reference_vendor_library_default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(reactfrom_dll_reference_vendor_library_default.a.Component);

Animate_Animate.isAnimate = true;
Animate_Animate.propTypes = {
  component: prop_typesfrom_dll_reference_vendor_library_default.a.any,
  componentProps: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  animation: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  transitionName: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.string, prop_typesfrom_dll_reference_vendor_library_default.a.object]),
  transitionEnter: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  transitionAppear: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  exclusive: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  transitionLeave: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  onEnd: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onEnter: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onLeave: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onAppear: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  showProp: prop_typesfrom_dll_reference_vendor_library_default.a.string
};
Animate_Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var Animate__initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = toArrayChildren(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else {
      if (type === 'appear') {
        if (es_util.allowAppearCallback(props)) {
          props.onAppear(key);
          props.onEnd(key, true);
        }
      } else {
        if (es_util.allowEnterCallback(props)) {
          props.onEnter(key);
          props.onEnd(key, true);
        }
      }
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = toArrayChildren(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (es_util.allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!isSameChildren(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ var es_Animate = __webpack_exports__["a"] = (Animate_Animate);

/***/ }),

/***/ "8oYa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// const cms_url = process.env.REACT_APP_CMS;
var upp_url = "https://uppc.csair.com/";
var app_url = "https://emp.csair.com/";
var login_url = "https://m.csair.com/";
var readname_url = "https://m.csair.com/personal/#/certification?t=forward&redirect=http%3A%2F%2Femp.csair.com%2FticketRefund%2F%23%2Fticket%2FupdateDetail%3Fidentification%3DY%26realName%3Dtrue%26";
var msky_url = "https://mskypearl.csair.com/msky/#/register";
var luckyDraw_url = "https://emp.csair.com/" + 'luckyDraw';
var djpapp_url = "https://m.csair.com/kr/newboardingpass/#/healthCodeAuth";
var djph5_url = "https://m.csair.com/touch/com.csair.mbp.index/index.html#com.csair.mbp.checkin_new/seatCheck";
var jsj_url = "https://car.csair.com/transfer?WT.mc_id=FX1808080001-fwdt";
var dkbc_url = "http://car.csair.com/csair-fbt";
var vip_url = "https://m.csair.com/extra_web/payLounge/#";
var ewxl_url = "https://m.csair.com/extra_web/extraLuggage/#/extraLuggage/";
var yrdz_url = "https://m.csair.com/extra_web/extraFlightList/#/flightList?type=multipleSeat";

var personal_order_url = "https://m.csair.com/order_center/#/";
var order_center_url = "https://m.csair.com/order_center/#/";
// const common_query_more_url =
//   process.env.REACT_APP_APP + 'common/#/query/general/more';
// const common_query_easy_url =
//   process.env.REACT_APP_APP + 'common/#/query/general/easy';
// const common_query_qrcode_url =
//   process.env.REACT_APP_APP + 'common/#/query/qrCode';
var online_service_app_url = "https://icc.csair.com/mCustService/#/?channel=app&active=机票退改";
var online_service_web_url = "https://icc.csair.com/mCustService/#/?channel=touch&active=机票退改";
var online_service_wx_url = "https://icc.csair.com/mCustService/#/?channel=wxopen&active=机票退改";

var common_facequery_more_url = "https://emp.csair.com/" + 'ticketRefund/#/ticket/facemoreQurey';
var common_query_more_url = "https://emp.csair.com/" + 'msite/#/auth/query/login/more';
var common_query_easy_url = "https://emp.csair.com/" + 'msite/#/auth/query/login/easy';
var common_query_qrcode_url = "https://emp.csair.com/" + 'msite/#/auth/query/qrCode';

var msiteDeatils = "https://emp.csair.com/" + 'msite/#/details';
var msiteChangeSubmit = "https://emp.csair.com/" + 'msite/#/changeApply';
var addPsgsInfo_url = "https://emp.csair.com/" + 'msite/#/add/info';
var addPsgsPnrInfo_url = "https://emp.csair.com/" + 'msite/#/add/PnrPsgInfo';

var openWallet = "https://m.csair.com/personal_new/conciseWallet/#/";

if (false) {
  luckyDraw_url = process.env.REACT_APP_APP_HOST + 'luckyDraw';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  addPsgsInfo_url: addPsgsInfo_url,
  addPsgsPnrInfo_url: addPsgsPnrInfo_url,
  msiteChangeSubmit: msiteChangeSubmit,
  msiteDeatils: msiteDeatils,
  common_facequery_more_url: common_facequery_more_url,
  common_query_more_url: common_query_more_url,
  common_query_easy_url: common_query_easy_url,
  common_query_qrcode_url: common_query_qrcode_url,
  app_config_url: '/public/config.json',
  cms_url: '/EMP/getAds',
  openWallet: openWallet,
  msky_url: msky_url,
  upp_url: upp_url,
  app_url: app_url,
  login_url: login_url,
  readname_url: readname_url,
  luckyDraw_url: luckyDraw_url,
  // 接送机
  jsj_url: jsj_url,
  // 登机牌
  djpapp_url: djpapp_url,
  djph5_url: djph5_url,
  // 代客泊车
  dkbc_url: dkbc_url,
  // 贵宾休息室
  vip_url: vip_url,
  // 额外行李
  ewxl_url: ewxl_url,
  // 一人多座
  yrdz_url: yrdz_url,
  //SO跳转机票订单
  personal_order_url: personal_order_url,
  // 我的订单中心
  order_center_url: order_center_url,
  // 在线客服
  online_service_app_url: online_service_app_url,
  online_service_web_url: online_service_web_url,
  online_service_wx_url: online_service_wx_url,
  // 查询配置开关
  getConfig: '/EMP/isPropertiesTrue',
  //通用开关接口
  commonSystemSwitch: '/EMP/memberSystemSwitch',
  // 查询当前用户是否登录
  getUserStatus: '/EMP/loginStatus',
  // 查询可退改状态的客票，(根据客票号之类的搜索)
  getTicektList: '/EMP/queryOrderTickets',
  // 更多客票查询
  getMoreTicektList: '/EMP/moreQuery',
  // 扫描登机牌查询
  getWXTicektList: '/EMP/wxopenQuery',
  // ss
  getSsTicektList: '/EMP/involLoginQuery', // 废弃
  // 简易登录查询
  getEasyTicektList: '/EMP/easyLoginQuery',
  // 查询处理中、已退改状态客票
  getIntreatmentBack: '/EMP/getIntreatmentBack',
  // 校验（退票校验，变更校验）变更
  checkOrderTicket: '/EMP/checkOrderTicket',
  checkOrderTicketTPWL: '/EMP/checkOrderTicketTPWL',
  // 变更、退票航段校验
  checkTicketFlight: '/EMP/checkTicketFlight',
  checkTicketFlightTPWL: '/EMP/checkTicketFlightTPWL',
  // 检测航班日期
  checkFlightDate: '/EMP/checkFlightDate',
  // 提交非自愿变更申请
  afterSaleChangeReqPayOK: '/EMP/afterSaleChangeReqPayOK',
  // 缺失项校验提交变更申请
  afterSaleChangeConfirm: '/EMP/afterSaleChangeConfirm',
  // 提交自愿变更申请
  afterSaleVolChangeReqPayOK: '/EMP/afterSaleVolChangeReqPayOK',
  // 提交退票申请
  afterSaleRefundApp: '/EMP/afterSaleRefundApp',
  // 退票提交验证码校验
  checkVerificationCode: '/EMP/checkVerificationCode',
  // 获取变更详情
  afterSaleChangeReqDetail: '/EMP/afterSaleChangeReqDetail',
  // 获取退票详情
  afterGetRefundOrderDetail: '/EMP/afterGetRefundOrderDetail',
  // 获取退票费
  afterSaleRefundFee: '/EMP/afterSaleRefundFee',
  // 创建TA单
  createRefundTa: '/EMP/createRefundTa',
  //创建挽留TJ单
  submitFastRefundMultiple: '/EMP/submitFastRefundMultiple',
  // 身份验证
  identityPayAuthInfo: '/EMP/identityPayAuthInfo',
  // 退改费用查询
  queryRefundChangeFee: '/EMP/queryRefundChangeFee',
  // 退票手续费
  queryRefundFee: '/EMP/queryRefundFee',
  // 变更手续费
  queryChangeFee: '/EMP/queryChangeFee',
  // 2018.03.16 该需求暂定 行程单回收通知
  // strokeNotice: '/EMP/checkedReceipt'
  // 取消值机
  cancelCheckIn: '/EMP/cancelCheckIn',
  // 查询新航班
  changeReqNewFlightDetail: '/EMP/afterSaleChangeReqNewFlightDetail',
  // 取消变更单
  cancleChangePayIn: '/EMP/cancleChangePayIn',
  // 取消OO变更单
  cancleChangeOOPayIn: '/EMP/cancleChangeOOPayIn',
  // 去支付
  volunteerChangePay: '/EMP/volunteerChangePay',
  // 支付成功后的回调接口
  // volunteerChangePaymentCallBack: '/EMP/ChangePaymentCallBack',
  // 推荐升舱
  queryChangeCost: '/EMP/queryChangeCost',
  // 银行卡
  searchAuthInfo: '/EMP/searchAuthInfo',
  // 简易登录
  easyLoginQuery: '/EMP/easyLoginQuery',
  // 退票，变更获取联系人和电话
  getNameAndPhone: '/EMP/getNameAndPhone',
  // 获取验证码
  getVerificationCode: '/EMP/getVerificationCode',
  // 获取是否展示退款方式
  getRefundMode: '/EMP/getRefundMode',
  //获取电子发票信息
  getSvcPcInvoiceInfoByIdAndType: '/EMP/getSvcPcInvoiceInfoByIdAndType',
  //新增电子发票信息
  saveSvcPcInvoiceDto: '/EMP/saveSvcPcInvoiceDto',
  //生成电子发票
  createInvoice: '/EMP/createInvoice',
  //获取电子发票是否展示
  showEiEntrance: '/EMP/showEiEntrance',
  //退票详情页电子发票详情
  getPrintableTickets: '/EMP/getPrintableTickets',
  // upp
  uppPay: upp_url + 'upp_cashier/upp-web/dist/pages/h5/orderPay.html',
  // 获取X产品
  queryRefundExtendDetail: '/EMP/queryRefundExtendDetail',
  // upp 支付成功回调地址
  // payCallBackUrl: `${app_url}msite/#/common/payResult/msite?`, // `${app_url}ticketRefund/#/ticket/pay`,
  payCallBackUrl: app_url + 'ticketRefund/#/ticket/pay',
  // 简易登录
  easyLogin: app_url + 'ticketRefund/#/ticket/easyLogin',
  pageInfoDto: {
    historyUrl: app_url + 'ticketRefund/#/ticket/updateDetail',
    homeUrl: app_url + 'ticketRefund/#/ticket/updateDetail',
    overTimeUrl: app_url + 'ticketRefund/#/ticket/updateDetail',
    reOrderUrl: app_url + 'ticketRefund/#/ticket/updateDetail'
  },
  // 退改计算器列表页面
  queryCalculatorTickets: '/EMP/queryCalculatorTickets',
  // 退改计算器免登
  getLoginSessionTemp: '/EMP/getLoginSessionTemp',
  // 检测抽奖入口
  checkLuckDrawEntry: '/EMP/marketingActivities/checkLuckDrawEntry',
  // 获取退改规则
  getOriginFlightUseCondition: '/EMP/getOriginFlightUseCondition',
  // 支付里程
  exchangePayMileage: '/EMP/exchangePayMileage',
  // 里程验证
  checkSvcFfpMemberPwd: '/EMP/checkSvcFfpMemberPwd',
  // 人脸识别校验
  faceRecognition: '/EMP/faceRecognition',
  // 获取变更优惠券
  getCoupons: '/EMP/touchSearchBGQ',
  // 预定选座
  reserveNewSeat: '/EMP/reservedNewFlightDetail',
  reserveNewSeatUrl: ( false ? 'http://mtest.csair.com:7071/' : "https://m.csair.com/") + 'touch/com.csair.mbp.index/index.html#com.csair.mbp.prechooseseat/seatChooseLogin',
  // 快速受理
  fastRefundUrl: "https://emp.csair.com/" + 'msite/#/fastRefund/submit',
  fastChange: "https://emp.csair.com/" + 'msite/#/fastChange/submit',
  busy: "https://emp.csair.com/" + 'msite/#/common/selectOperate',
  autoFastRefund: '/EMP/autoFastRefund',
  createE2ERefund: '/EMP/createE2ERefund',
  verifyPnrPassengerBirthday: '/EMP/verifyPnrPassengerBirthday',
  getUserInfo: '/EMP/userinfo',
  touchConfirmIntVol: '/EMP/touchConfirmIntVol',
  checkPnrDocs: '/EMP/checkPnrDocs',
  createE2EChange: '/EMP/createE2EChange',
  createMuChange: '/EMP/createChangeByMU', //东航创单
  xProductUrl: "https://mtrip.csair.com/" + 'waptuan/login/tuanorder/TuanOrderAction.shtml?mhd=getOrderList',
  getPassageMemberLevel: '/EMP/marketingActivities/getPassageMemberLevel',
  createNpsQnrDetail: '/EMP/marketingActivities/createNpsQnrDetail',
  getRefundWalletInfo: '/EMP/getRefundWalletInfo',
  createGPChange: '/EMP/createGPChange',
  touchRefundSearchBGQ: '/EMP/touchRefundSearchBGQ',
  getScheme: '/EMP/getWechatAppLink',
  getFlightRules: '/EMP/getDomesticFlightRules',
  // 获取保险
  getInsurancecChange: '/EMP/insurancecChange',
  getProductShopList: '/EMP/loungeChange',
  uploadRefundFile: '/EMP/uploadRefundFile',
  searchRefundAttachment: '/EMP/searchRefundAttachment', // 散客、团体
  uploadRCattachment: '/EMP/uploadRCattachment',
  updateFileList: '/EMP/updateFileList',
  searchNpsUrl: '/EMP/searchNpsUrl',
  greenFlightServe: '/EMP/greenFlight',
  isGreenSwitchOn: '/EMP/isGreenSwitchOn',
  memberSystemSwitch: '/EMP/memberSystemSwitch', //获取里程字段开关
  getMenuList: '/EMP/getMenuList', //获取错构服务列表
  getTips: '/EMP/getTips', //错购提示语
  getAdInfo: '/EMP/getAdInfo', //列表广告
  getPackageDate: '/EMP/getPackageDate', //套票自愿变更校验
  encrypFlights: '/EMP/getAnthCode', //防航班信息篡改，加密航班信息
  memberAllSwitch: '/EMP/memberBatchSystemSwitch', //统一开关集合
  customerUrlSwitchOn: ' /EMP/customerUrlSwitchOn', //诉求单及客服开关集合
  getWrongPurchaseTicket: '/EMP/queryOrderTicketCuoGou', //错构列表
  getAreaCodeList: '/EMP/getAreaCodeList',
  getMilageFlightRules: '/EMP/modelCommissionConfig',
  resetSubmitReason: '/EMP/changeRefundStatusNtoS',
  createXSOOrder: '/EMP/createXSOOrder', //X资源创单
  queryUppPayResult: '/EMP/queryUppPayResult',
  customerServiceTickets: '/EMP/customerServiceTickets',
  downloadFile: '/EMP/downloadFile', //附件下载
  HuFlightProtectionCheck: '/EMP/HuFlightProtectionCheck', //海航非自愿航班保护
  getWxAuthResult: '/EMP//getWxAuthResult' //查询实名认证结果接口
});

/***/ }),

/***/ "8tDh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/addval_icon.5e1953a2.jpg";

/***/ }),

/***/ "97gm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("+jwL");
var isBuffer = __webpack_require__("Sk4Y");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "9MLQ":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("QISU");

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),

/***/ "9MbE":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("8ANE");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "AFOY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("CZee");
var $Object = __webpack_require__("iANj").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "Ae6m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("CCtP");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "AjmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__("5eVA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_flight_png__ = __webpack_require__("H7xP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_flight_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_flight_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flight2_png__ = __webpack_require__("wNex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flight2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_flight2_png__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Created by Administrator on 2017/5/4.
 */
// 导航插件






var _ref = _jsx('div', {
  className: 'lineLeft_cont'
}, void 0, _jsx('span', {
  className: 'line'
}), _jsx('span', {
  className: 'sc'
}));

var _ref2 = _jsx('div', {
  className: 'line_'
});

var _ref3 = _jsx('div', {
  className: 'line_'
});

var _ref4 = _jsx('div', {
  className: 'line'
});

var _ref5 = _jsx('div', {
  className: 'line_f'
});

var _ref6 = _jsx('div', {
  className: 'line'
});

var _ref7 = _jsx('div', {
  className: '_line_'
});

var _ref8 = _jsx('div', {
  className: 'line_'
});

var _ref9 = _jsx('span', {
  className: 'nextC'
});

var _ref10 = _jsx('span', {
  className: 'next'
});

var _ref11 = _jsx('div', {
  className: 'line_'
});

var _ref12 = _jsx('div', {
  className: 'line'
});

var _ref13 = _jsx('div', {
  className: 'line_'
});

var _ref14 = _jsx('div', {
  className: 'line'
});

var _ref15 = _jsx('span', {
  className: 'line'
});

var _ref16 = _jsx('span', {
  className: 'line_'
});

var _ref17 = _jsx('span', {
  className: 'line'
});

var _ref18 = _jsx('span', {
  className: 'nextCF'
});

var _ref19 = _jsx('span', {
  className: 'nextC'
});

var Nav = function (_PureComponent) {
  _inherits(Nav, _PureComponent);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
  }

  _createClass(Nav, [{
    key: 'render',
    value: function render() {
      var lang = this.props.lang;

      return _jsx('div', {
        className: 'navBox',
        style: { marginTop: '-2px' }
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: 'navBarHeight',
          className: 'navbar_nav ' + this.props.navStyle,
          style: { float: 'left' }
        },
        _jsx('div', {
          className: 'navbar_line'
        }, void 0, this.props.navStyle !== 'nav3' && _jsx('img', {
          style: this.props.navStyle == 'nav2' ? { left: '70%' } : { left: '30%' },
          alt: '',
          src: __WEBPACK_IMPORTED_MODULE_4__assets_flight2_png___default.a
        }), _jsx('div', {
          className: 'navbar_lineLeft'
        }, void 0, _ref, _jsx('span', {
          className: 'navbar_tips1'
        }, void 0, ' ', lang.fillInfo)), _jsx('div', {
          className: 'lefts'
        }, void 0, _ref2, this.props.navStyle !== 'nav1' ? _ref3 : _ref4), _jsx('div', {
          className: 'navbar_lineCenter'
        }, void 0, _jsx('div', {
          className: 'lineCenter_cont'
        }, void 0, this.props.navStyle !== 'nav1' ? _ref5 : _ref6, this.props.navStyle !== 'nav1' ? _ref7 : _ref8, this.props.navStyle == 'nav1' ? _ref9 : _ref10), _jsx('span', {
          className: 'navbar_tips2',
          style: this.props.navStyle !== 'nav1' ? { color: 'rgba(0, 138, 203, 1)' } : { color: 'rgba(38, 38, 38, 0.6)' }
        }, void 0, ' ', lang.as15)), _jsx('div', {
          className: 'rights'
        }, void 0, this.props.navStyle !== 'nav1' ? _ref11 : _ref12, this.props.navStyle == 'nav3' ? _ref13 : _ref14), _jsx('div', {
          className: 'navbar_lineRight'
        }, void 0, _jsx('div', {
          className: 'lineRight_cont'
        }, void 0, _ref15, this.props.navStyle == 'nav3' ? _ref16 : _ref17, this.props.navStyle == 'nav3' ? _ref18 : _ref19), _jsx('span', {
          className: 'navbar_tips3',
          style: this.props.navStyle == 'nav3' ? { color: 'rgba(0, 138, 203, 1)' } : { color: 'rgba(38, 38, 38, 0.6)' }
        }, void 0, ' ', lang.updateDetail86)))
      ));
    }
  }]);

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Nav.PropTypes = {
  navStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].string,
  lang: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["default"] = (Nav);

/***/ }),

/***/ "Aq0r":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "B5V0":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "BNrO":
/***/ (function(module, exports) {

(function(host) {

  var properties = {
    browser: [
      [/msie ([\.\_\d]+)/, "ie"],
      [/trident\/.*?rv:([\.\_\d]+)/, "ie"],
      [/firefox\/([\.\_\d]+)/, "firefox"],
      [/chrome\/([\.\_\d]+)/, "chrome"],
      [/version\/([\.\_\d]+).*?safari/, "safari"],
      [/mobile safari ([\.\_\d]+)/, "safari"],
      [/android.*?version\/([\.\_\d]+).*?safari/, "com.android.browser"],
      [/crios\/([\.\_\d]+).*?safari/, "chrome"],
      [/opera/, "opera"],
      [/opera\/([\.\_\d]+)/, "opera"],
      [/opera ([\.\_\d]+)/, "opera"],
      [/opera mini.*?version\/([\.\_\d]+)/, "opera.mini"],
      [/opios\/([a-z\.\_\d]+)/, "opera"],
      [/blackberry/, "blackberry"],
      [/blackberry.*?version\/([\.\_\d]+)/, "blackberry"],
      [/bb\d+.*?version\/([\.\_\d]+)/, "blackberry"],
      [/rim.*?version\/([\.\_\d]+)/, "blackberry"],
      [/iceweasel\/([\.\_\d]+)/, "iceweasel"],
      [/edge\/([\.\d]+)/, "edge"]
    ],
    os: [
      [/linux ()([a-z\.\_\d]+)/, "linux"],
      [/mac os x/, "macos"],
      [/mac os x.*?([\.\_\d]+)/, "macos"],
      [/os ([\.\_\d]+) like mac os/, "ios"],
      [/openbsd ()([a-z\.\_\d]+)/, "openbsd"],
      [/android/, "android"],
      [/android ([a-z\.\_\d]+);/, "android"],
      [/mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/, "firefoxos"],
      [/windows\s*(?:nt)?\s*([\.\_\d]+)/, "windows"],
      [/windows phone.*?([\.\_\d]+)/, "windows.phone"],
      [/windows mobile/, "windows.mobile"],
      [/blackberry/, "blackberryos"],
      [/bb\d+/, "blackberryos"],
      [/rim.*?os\s*([\.\_\d]+)/, "blackberryos"]
    ],
    device: [
      [/ipad/, "ipad"],
      [/iphone/, "iphone"],
      [/lumia/, "lumia"],
      [/htc/, "htc"],
      [/nexus/, "nexus"],
      [/galaxy nexus/, "galaxy.nexus"],
      [/nokia/, "nokia"],
      [/ gt\-/, "galaxy"],
      [/ sm\-/, "galaxy"],
      [/xbox/, "xbox"],
      [/(?:bb\d+)|(?:blackberry)|(?: rim )/, "blackberry"]
    ]
  };

  var UNKNOWN = "Unknown";

  var propertyNames = Object.keys(properties);

  function Sniffr() {
    var self = this;

    propertyNames.forEach(function(propertyName) {
      self[propertyName] = {
        name: UNKNOWN,
        version: [],
        versionString: UNKNOWN
      };
    });
  }

  function determineProperty(self, propertyName, userAgent) {
    properties[propertyName].forEach(function(propertyMatcher) {
      var propertyRegex = propertyMatcher[0];
      var propertyValue = propertyMatcher[1];

      var match = userAgent.match(propertyRegex);

      if (match) {
        self[propertyName].name = propertyValue;

        if (match[2]) {
          self[propertyName].versionString = match[2];
          self[propertyName].version = [];
        } else if (match[1]) {
          self[propertyName].versionString = match[1].replace(/_/g, ".");
          self[propertyName].version = parseVersion(match[1]);
        } else {
          self[propertyName].versionString = UNKNOWN;
          self[propertyName].version = [];
        }
      }
    });
  }

  function parseVersion(versionString) {
    return versionString.split(/[\._]/).map(function(versionPart) {
      return parseInt(versionPart);
    });
  }

  Sniffr.prototype.sniff = function(userAgentString) {
    var self = this;
    var userAgent = (userAgentString || navigator.userAgent || "").toLowerCase();

    propertyNames.forEach(function(propertyName) {
      determineProperty(self, propertyName, userAgent);
    });
  };


  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Sniffr;
  } else {
    host.Sniffr = new Sniffr();
    host.Sniffr.sniff(navigator.userAgent);
  }
})(this);


/***/ }),

/***/ "BQO6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tz60");
__webpack_require__("+3lO");
module.exports = __webpack_require__("4DQ7").f('iterator');


/***/ }),

/***/ "BiZS":
/***/ (function(module, exports, __webpack_require__) {

var Sprite = __webpack_require__("RLiO");
var globalSprite = new Sprite();

if (document.body) {
  globalSprite.elem = globalSprite.render(document.body);
} else {
  document.addEventListener('DOMContentLoaded', function () {
    globalSprite.elem = globalSprite.render(document.body);
  }, false);
}

module.exports = globalSprite;


/***/ }),

/***/ "Bp4u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__("Z09J");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _CheckboxItem = __webpack_require__("tVq+");

var _CheckboxItem2 = _interopRequireDefault(_CheckboxItem);

var _AgreeItem = __webpack_require__("JYxR");

var _AgreeItem2 = _interopRequireDefault(_AgreeItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Checkbox2['default'].CheckboxItem = _CheckboxItem2['default'];
_Checkbox2['default'].AgreeItem = _AgreeItem2['default'];
exports['default'] = _Checkbox2['default'];
module.exports = exports['default'];

/***/ }),

/***/ "BzqH":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("nclR");
module.exports = __webpack_require__("iANj").Object.setPrototypeOf;


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("rKx+"), __esModule: true };

/***/ }),

/***/ "CCtP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("nSP+");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "CGvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rc-collapse/es/PanelContent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelContent_PanelContent = function (_Component) {
  _inherits(PanelContent, _Component);

  function PanelContent() {
    _classCallCheck(this, PanelContent);

    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
  }

  _createClass(PanelContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.isActive || nextProps.isActive;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      this._isActived = this._isActived || this.props.isActive;
      if (!this._isActived) {
        return null;
      }
      var _props = this.props,
          prefixCls = _props.prefixCls,
          isActive = _props.isActive,
          children = _props.children,
          destroyInactivePanel = _props.destroyInactivePanel;

      var contentCls = classnames_default()((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
      var child = !isActive && destroyInactivePanel ? null : reactfrom_dll_reference_vendor_library_default.a.createElement(
        'div',
        { className: prefixCls + '-content-box' },
        children
      );
      return reactfrom_dll_reference_vendor_library_default.a.createElement(
        'div',
        {
          className: contentCls,
          role: 'tabpanel'
        },
        child
      );
    }
  }]);

  return PanelContent;
}(reactfrom_dll_reference_vendor_library["Component"]);

PanelContent_PanelContent.propTypes = {
  prefixCls: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  isActive: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  children: prop_typesfrom_dll_reference_vendor_library_default.a.any,
  destroyInactivePanel: prop_typesfrom_dll_reference_vendor_library_default.a.bool
};

/* harmony default export */ var es_PanelContent = (PanelContent_PanelContent);
// EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules
var Animate = __webpack_require__("8aSS");

// CONCATENATED MODULE: ./node_modules/rc-collapse/es/Panel.js
var Panel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Panel__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Panel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Panel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Panel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Panel_CollapsePanel = function (_Component) {
  Panel__inherits(CollapsePanel, _Component);

  function CollapsePanel() {
    Panel__classCallCheck(this, CollapsePanel);

    return Panel__possibleConstructorReturn(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
  }

  Panel__createClass(CollapsePanel, [{
    key: 'handleItemClick',
    value: function handleItemClick() {
      if (this.props.onItemClick) {
        this.props.onItemClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          style = _props.style,
          prefixCls = _props.prefixCls,
          header = _props.header,
          headerClass = _props.headerClass,
          children = _props.children,
          isActive = _props.isActive,
          showArrow = _props.showArrow,
          destroyInactivePanel = _props.destroyInactivePanel,
          disabled = _props.disabled;

      var headerCls = classnames_default()(prefixCls + '-header', Panel__defineProperty({}, headerClass, headerClass));
      var itemCls = classnames_default()((_classNames2 = {}, Panel__defineProperty(_classNames2, prefixCls + '-item', true), Panel__defineProperty(_classNames2, prefixCls + '-item-active', isActive), Panel__defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
      return reactfrom_dll_reference_vendor_library_default.a.createElement(
        'div',
        { className: itemCls, style: style, id: id, role: 'tablist' },
        reactfrom_dll_reference_vendor_library_default.a.createElement(
          'div',
          {
            className: headerCls,
            onClick: this.handleItemClick.bind(this),
            role: 'tab',
            'aria-expanded': isActive
          },
          showArrow && reactfrom_dll_reference_vendor_library_default.a.createElement('i', { className: 'arrow' }),
          header
        ),
        reactfrom_dll_reference_vendor_library_default.a.createElement(
          Animate["a" /* default */],
          {
            showProp: 'isActive',
            exclusive: true,
            component: '',
            animation: this.props.openAnimation
          },
          reactfrom_dll_reference_vendor_library_default.a.createElement(
            es_PanelContent,
            {
              prefixCls: prefixCls,
              isActive: isActive,
              destroyInactivePanel: destroyInactivePanel
            },
            children
          )
        )
      );
    }
  }]);

  return CollapsePanel;
}(reactfrom_dll_reference_vendor_library["Component"]);

Panel_CollapsePanel.propTypes = {
  className: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.string, prop_typesfrom_dll_reference_vendor_library_default.a.object]),
  id: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  children: prop_typesfrom_dll_reference_vendor_library_default.a.any,
  openAnimation: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  prefixCls: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  header: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.string, prop_typesfrom_dll_reference_vendor_library_default.a.number, prop_typesfrom_dll_reference_vendor_library_default.a.node]),
  headerClass: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  showArrow: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  isActive: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  onItemClick: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  style: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  destroyInactivePanel: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  disabled: prop_typesfrom_dll_reference_vendor_library_default.a.bool
};

Panel_CollapsePanel.defaultProps = {
  showArrow: true,
  isActive: false,
  destroyInactivePanel: false,
  onItemClick: function onItemClick() {},

  headerClass: ''
};

/* harmony default export */ var Panel = (Panel_CollapsePanel);
// EXTERNAL MODULE: ./node_modules/css-animation/es/index.js + 1 modules
var es = __webpack_require__("Mqyb");

// CONCATENATED MODULE: ./node_modules/rc-collapse/es/openAnimationFactory.js


function animate(node, show, transitionName, done) {
  var height = void 0;
  return Object(es["a" /* default */])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = node.offsetHeight + 'px';
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = (show ? height : 0) + 'px';
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, prefixCls + '-anim', done);
    },
    leave: function leave(node, done) {
      return animate(node, false, prefixCls + '-anim', done);
    }
  };
}

/* harmony default export */ var openAnimationFactory = (animation);
// CONCATENATED MODULE: ./node_modules/rc-collapse/es/Collapse.js
var Collapse__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Collapse__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Collapse__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Collapse__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Collapse__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function toArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }
  return currentActiveKey;
}

var Collapse_Collapse = function (_Component) {
  Collapse__inherits(Collapse, _Component);

  function Collapse(props) {
    Collapse__classCallCheck(this, Collapse);

    var _this = Collapse__possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    var _this$props = _this.props,
        activeKey = _this$props.activeKey,
        defaultActiveKey = _this$props.defaultActiveKey;

    var currentActiveKey = defaultActiveKey;
    if ('activeKey' in _this.props) {
      currentActiveKey = activeKey;
    }

    _this.state = {
      openAnimation: _this.props.openAnimation || openAnimationFactory(_this.props.prefixCls),
      activeKey: toArray(currentActiveKey)
    };
    return _this;
  }

  Collapse__createClass(Collapse, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: toArray(nextProps.activeKey)
        });
      }
      if ('openAnimation' in nextProps) {
        this.setState({
          openAnimation: nextProps.openAnimation
        });
      }
    }
  }, {
    key: 'onClickItem',
    value: function onClickItem(key) {
      var activeKey = this.state.activeKey;
      if (this.props.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = [].concat(_toConsumableArray(activeKey));
        var index = activeKey.indexOf(key);
        var isActive = index > -1;
        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }
      this.setActiveKey(activeKey);
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var activeKey = this.state.activeKey;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          accordion = _props.accordion,
          destroyInactivePanel = _props.destroyInactivePanel;

      var newChildren = [];

      reactfrom_dll_reference_vendor_library["Children"].forEach(this.props.children, function (child, index) {
        if (!child) return;
        // If there is no key provide, use the panel order as default key
        var key = child.key || String(index);
        var _child$props = child.props,
            header = _child$props.header,
            headerClass = _child$props.headerClass,
            disabled = _child$props.disabled;

        var isActive = false;
        if (accordion) {
          isActive = activeKey[0] === key;
        } else {
          isActive = activeKey.indexOf(key) > -1;
        }

        var props = {
          key: key,
          header: header,
          headerClass: headerClass,
          isActive: isActive,
          prefixCls: prefixCls,
          destroyInactivePanel: destroyInactivePanel,
          openAnimation: _this2.state.openAnimation,
          children: child.props.children,
          onItemClick: disabled ? null : function () {
            return _this2.onClickItem(key);
          }
        };

        newChildren.push(reactfrom_dll_reference_vendor_library_default.a.cloneElement(child, props));
      });

      return newChildren;
    }
  }, {
    key: 'setActiveKey',
    value: function setActiveKey(activeKey) {
      if (!('activeKey' in this.props)) {
        this.setState({ activeKey: activeKey });
      }
      this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          className = _props2.className,
          style = _props2.style;

      var collapseClassName = classnames_default()((_classNames = {}, Collapse__defineProperty(_classNames, prefixCls, true), Collapse__defineProperty(_classNames, className, !!className), _classNames));
      return reactfrom_dll_reference_vendor_library_default.a.createElement(
        'div',
        { className: collapseClassName, style: style },
        this.getItems()
      );
    }
  }]);

  return Collapse;
}(reactfrom_dll_reference_vendor_library["Component"]);

Collapse_Collapse.propTypes = {
  children: prop_typesfrom_dll_reference_vendor_library_default.a.any,
  prefixCls: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  activeKey: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.string, prop_typesfrom_dll_reference_vendor_library_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_library_default.a.string)]),
  defaultActiveKey: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.string, prop_typesfrom_dll_reference_vendor_library_default.a.arrayOf(prop_typesfrom_dll_reference_vendor_library_default.a.string)]),
  openAnimation: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  onChange: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  accordion: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  className: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  style: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  destroyInactivePanel: prop_typesfrom_dll_reference_vendor_library_default.a.bool
};

Collapse_Collapse.defaultProps = {
  prefixCls: 'rc-collapse',
  onChange: function onChange() {},

  accordion: false,
  destroyInactivePanel: false
};

Collapse_Collapse.Panel = Panel;

/* harmony default export */ var es_Collapse = (Collapse_Collapse);
// CONCATENATED MODULE: ./node_modules/rc-collapse/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return es_Panel; });


/* harmony default export */ var rc_collapse_es = __webpack_exports__["default"] = (es_Collapse);
var es_Panel = es_Collapse.Panel;

/***/ }),

/***/ "CIhR":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 -2 59.75 60.25\" id=\"loading\" ><path fill=\"#ccc\" d=\"M29.691-.527c-15.648 0-28.333 12.685-28.333 28.333s12.685 28.333 28.333 28.333c15.648 0 28.333-12.685 28.333-28.333S45.339-.527 29.691-.527zm.184 53.75c-14.037 0-25.417-11.379-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.379 25.417 25.417-11.38 25.416-25.417 25.416z\"/><path fill=\"none\" stroke=\"#108ee9\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M56.587 29.766c.369-7.438-1.658-14.699-6.393-19.552\"/></symbol>";
module.exports = sprite.add(image, "loading");

/***/ }),

/***/ "CIox":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(244);

/***/ }),

/***/ "CZee":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("NZ8V") });


/***/ }),

/***/ "CglM":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "D2L8":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"cross-circle\" ><g fill-rule=\"evenodd\"><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z\"/><path d=\"M24.34 22.219l-7.775-7.774a1.499 1.499 0 1 0-2.121 2.121l7.774 7.774-7.774 7.775a1.499 1.499 0 1 0 2.12 2.12l7.775-7.773 7.775 7.774a1.499 1.499 0 1 0 2.121-2.121L26.46 24.34l7.774-7.774a1.499 1.499 0 1 0-2.121-2.121l-7.775 7.774z\"/></g></symbol>";
module.exports = sprite.add(image, "cross-circle");

/***/ }),

/***/ "D6oK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRefund */
/* unused harmony export isChange */
/* unused harmony export getStatusMsgLink */
/* harmony export (immutable) */ __webpack_exports__["a"] = loadStatusCodeMsg;
/* unused harmony export loadXhrScript */
/* unused harmony export requestMergeCode */
/* unused harmony export getStatusCodeMsg */
/* unused harmony export getStatusCodeFiled */
/* harmony export (immutable) */ __webpack_exports__["b"] = setResponseMsg3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__ = __webpack_require__("mekh");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var statusCodeMsg = {};
function getLangAndSwitch() {
    var language = window.sessionStorage.getItem('language');
    var isEN = language == "en";
    var isGDop = isEN ? false : window.sessionStorage.getItem('csSwitch') == 'Y';
    var isOPgd = isEN ? false : window.sessionStorage.getItem('atSwitch') == 'Y';
    var isOPzn = isEN ? false : window.sessionStorage.getItem('igSwitch') == 'Y';
    var pageInfo = {
        _lang: language ? language : "cn",
        language: language ? language : "cn"
    };
    return {
        pageInfo: pageInfo,
        isGDop: isGDop,
        isOPgd: isOPgd,
        isOPzn: isOPzn
    };
}
function isRefund() {
    return (/\b(refundTicket)\b/.test(window.location.href)
    );
}

function isChange() {
    return (/\b(ticketChange)\b/.test(window.location.href)
    );
}

/**
 * 获取相应的地址
 */
function getStatusMsgLink(code, opt) {
    var objLS = getLangAndSwitch();
    function name(ext) {
        var extFile = !ext ? code + '.json' : code + '.' + ext + '.json';
        return window.location.origin + '/public/apiStatusCodeMsg/' + objLS.pageInfo._lang + '/' + extFile;
    }

    var arr = [name()];
    if (opt && Array.isArray(opt[code])) {
        opt[code].forEach(function (ext) {
            arr.push(name(ext));
        });
        return arr;
    }

    if (isRefund()) arr.push(name('refund'));
    if (isChange()) arr.push(name('change'));
    // if (typecr) {
    //     if (typecr = 'refundTicket') {
    //         arr.push(name('refund'));
    //     }
    //     if (typecr = 'ticketChange') {
    //         arr.push(name('change'));
    //     }
    // }
    if (window.location.href.indexOf('cancelLation') !== -1) arr.push(name('tpwl'));

    return arr;
}

/**
 * 加载API静态状态码提示信息
 * @param {array} api 接口
 * @param {object} opt 自定义后缀
 */
function loadStatusCodeMsg(api, opt) {
    if (Array.isArray(api)) {
        api.forEach(function (_api) {
            var apiArr = getStatusMsgLink(_api, opt);
            // xhrProcessController(
            //   apiArr.map(function (address) {
            //     return function () {
            //       return loadXhrScript(address, true);
            //     };
            //   }),
            //   _api
            // );
            requestMergeCode(_api, apiArr);
        });
    }
}

function loadXhrScript(url) {
    var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return window.$.ajax({
        url: url,
        method: 'GET',
        async: async
        // dataType: 'jsonp',
        // jsonp: 'callback',
        // jsonpCallback: 'callback',
    });
}

function requestMergeCode(apiKey, apiArr) {
    var _window$$$when;

    (_window$$$when = window.$.when).call.apply(_window$$$when, [null].concat(_toConsumableArray(apiArr.map(function (api) {
        return loadXhrScript(api, true);
    })))).done(function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _arr = apiArr.length > 1 ? args.map(function (item) {
            return item[0];
        }) : [args[0]];
        _arr.forEach(function (data) {
            if (!statusCodeMsg[apiKey]) {
                statusCodeMsg[apiKey] = data;
            } else {
                statusCodeMsg[apiKey] = Object.assign({}, statusCodeMsg[apiKey], data);
            }
        });
    });
}

/**
 * 匹配状态码提示语
 * @param {string} [code='']
 * @param {*} [invalidArgs=[]]
 * @param {*} [reqConfig={}] ajax 请求配置
 * @return {string}
 */
// [1132022614001639015] [2024-10-11]
// [1132022614001601056] [2024-09-04]
function getStatusCodeMsg() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var invalidArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var reqConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var defaultMsg = arguments[3];

    var objLS = getLangAndSwitch();
    var _url = reqConfig.url ? reqConfig.url : this.url;
    if (!_url) return '';
    // _url = new URL('http://' + _url);
    var urls = _url.split('/');
    var api = urls[urls.length - 1] || urls[urls.length - 2];
    api = api.split('?')[0];
    if (!statusCodeMsg[api] || !statusCodeMsg[api][code]) {
        return defaultMsg ? defaultMsg : '';
    }
    var msg = statusCodeMsg[api][code].indexOf("function") !== -1 ? statusCodeMsg[api][code].indexOf("znkf,GDop") !== -1 ? new Function('return ' + statusCodeMsg[api][code])()(objLS.isOPzn, objLS.isGDop) : new Function('return ' + statusCodeMsg[api][code])()(objLS.isOPgd) : statusCodeMsg[api][code];
    var _invalidArgs = Array.isArray(invalidArgs) ? [].concat(_toConsumableArray(invalidArgs)) : [];
    return msg.replace(/(\${invalidArg})/g, function () {
        return _invalidArgs.shift();
    }).replace(/CHD/g, '');
}

/**
 * 兼容后台接口读取规则invalidCode、invalidArgs
 * @param {object} response 后台接口返参
 * @return {}
 */
function getStatusCodeFiled(response) {
    var _response = Array.isArray(response) ? response[0] : response;
    if (!_response) {
        return {
            invalidCode: '',
            invalidArgs: []
        };
    }

    return {
        invalidCode: _response.errorInfo ? _response.errorInfo.invalidCode : _response.error ? _response.error.errorCode : _response.invalidCode,
        invalidArgs: _response.errorInfo ? _response.errorInfo.invalidArgs : _response.error ? _response.error.invalidArgs : _response.invalidArgs
    };
}

function setResponseMsg3(response, reqConfig) {
    if (!response || Array.isArray(response) && !response.length) return response;

    var statusCode = getStatusCodeFiled(response);
    var msg = getStatusCodeMsg(statusCode.invalidCode, statusCode.invalidArgs, reqConfig);
    var result = Array.isArray(response) ? response[0] : response;

    function finProAndSetMsg(obj) {
        var objLS = getLangAndSwitch();
        var propertyChainList = ['checkMsg', 'warning', 'error.errorMsg', 'errorInfo.errorMsg', 'errorInfo.description', 'refundModeRes.error.errorMsg', 'showMsg', 'responseMessage', 'message'];
        for (var k = 0; k < propertyChainList.length; k++) {
            var isBreak = false;
            var subPropertyList = propertyChainList[k].split('.');
            var copyObj = null;
            var Num_of_copies = 0;
            for (var j = 0; j < subPropertyList.length; j++) {
                if (copyObj) {
                    if (!copyObj[subPropertyList[j]]) {
                        copyObj = null;
                        Num_of_copies = 0;
                        break;
                    }
                    if (copyObj[subPropertyList[j]] instanceof Object) {
                        Num_of_copies += 1;
                        copyObj = copyObj[subPropertyList[j]];
                    }
                }
                if (copyObj) {
                    if (typeof copyObj[subPropertyList[j]] === 'string' && j == subPropertyList.length - 1 && subPropertyList.length - 1 == Num_of_copies) {
                        isBreak = true;
                        break;
                    }
                }
                if (copyObj === null) {
                    if (!obj[subPropertyList[j]]) {
                        copyObj = null;
                        Num_of_copies = 0;
                        break;
                    }
                    if (obj[subPropertyList[j]] instanceof Object) {
                        Num_of_copies += 1;
                        copyObj = obj[subPropertyList[j]];
                    }
                }
                if (typeof obj[subPropertyList[j]] === 'string' && j == subPropertyList.length - 1 && subPropertyList.length - 1 == Num_of_copies) {
                    isBreak = true;
                    break;
                }
            }
            if (isBreak) {
                var _ret = function () {
                    var copyObject = null;
                    subPropertyList.forEach(function (item) {
                        if (copyObject == null) {
                            if (obj[item]) {
                                copyObject = obj[item];
                            }
                        } else {
                            if (copyObject[item] && copyObject[item] instanceof Object) {
                                copyObject = copyObject[item];
                            }
                            if (typeof copyObject[item] == 'string') {
                                copyObject[item] = msg ? Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["J" /* transformStatusCodeMsg */])(msg, objLS.pageInfo.language) : Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["J" /* transformStatusCodeMsg */])(copyObject[item], objLS.pageInfo.language);
                            }
                        }
                    });
                    if (subPropertyList.length === 1) {
                        obj[subPropertyList[0]] = msg ? Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["J" /* transformStatusCodeMsg */])(msg, objLS.pageInfo.language) : Object(__WEBPACK_IMPORTED_MODULE_0__csair_emp_helpers__["J" /* transformStatusCodeMsg */])(obj[subPropertyList[0]], objLS.pageInfo.language);
                    }
                    return 'break';
                }();

                if (_ret === 'break') break;
            }
        }
    }
    finProAndSetMsg(result);
    if (Array.isArray(response)) return [result];

    return result;
}

/***/ }),

/***/ "DON5":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 43 38\" id=\"koubei-o\" ><path d=\"M37.75.227H5.25C2.125.227.66 2.652.66 4.542v8.03c0 9.346 5.751 17.213 13.64 20.35a.732.732 0 0 1 .325.246c.145.207.128.409.128.409l.001 2.033s.241.743.667 1.167c.254.254.899.545 1.201.577.929.099 2.059.226 4.716-.125a25.097 25.097 0 0 0 13.111-5.918c6.157-5.345 8.549-12.549 8.549-18.738V4.625c0-1.89-1.206-4.398-5.248-4.398zm3.287 13.045c0 5.58-2.277 11.784-7.87 16.603-3.366 2.896-7.511 4.831-11.917 5.417-2.413.317-3.347.186-4.191.096-.275-.029-.496-.076-.392-1.013.104-1.958-.194-2.156-.325-2.342-.076-.1-.261-.287-.378-.332C8.797 28.874 2.577 21.698 2.577 13.272V5.203c0-1.703.335-3.06 3.173-3.06h31.292c3.671 0 3.995 1.174 3.995 2.878v8.251z\"/><path d=\"M32.531 19.444c-.336 0-.62.171-.809.42l-.01-.007-.002-.001a11.61 11.61 0 0 1-9.682 5.196c-6.419 0-11.623-5.204-11.623-11.623h-.038a1.027 1.027 0 0 0-1.023-.995c-.556 0-1.003.443-1.023.995h-.007l.001.029-.001.007.002.012c.026 7.552 6.154 13.667 13.713 13.667 4.757 0 8.945-2.423 11.406-6.101 0 0 .127-.368.127-.57a1.031 1.031 0 0 0-1.031-1.029z\"/><ellipse cx=\"35.456\" cy=\"12.506\" rx=\"1.95\" ry=\"1.918\"/></symbol>";
module.exports = sprite.add(image, "koubei-o");

/***/ }),

/***/ "Dd8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "DndO":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("TJq6");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(165);

/***/ }),

/***/ "DvwR":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("x//u");
var toIObject = __webpack_require__("ksFB");
var arrayIndexOf = __webpack_require__("PbQV")(false);
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "Dysy":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "E32k":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("PHYd");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "Eif7":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("JyN8");
module.exports = __webpack_require__("iANj").Object.assign;


/***/ }),

/***/ "EjGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 应用提示文档

/* harmony default export */ __webpack_exports__["default"] = ({
  title: '温馨提示',
  title_delay: '航班延误/取消',
  title_explain: '退改说明',
  title_Confirm_error: '提交失败',
  applicationSubmission: '申请提交',
  back: '返回',
  okBtn: '确定',
  cancel: '取消',
  goon: '继续',
  myOrder: '我的订单',
  goonRefund: '继续退票',
  goonChange: '继续变更',
  quitChange: '放弃变更',
  submit: '提交',
  allsubmit: '一起提交',
  ressubmit: '重新提交',
  keepsubmit: '继续提交',
  orderStatusChange: '您好！当前变更单的状态已改变，不可再进行支付',
  cardBin: '银行卡Bin',
  cardBinMsg: '是指公务卡卡号的前6位;</br>例如:工行的公务卡卡Bin是628288</br>',
  updateDetail: {
    title: '温馨提示',
    content: '您好！需先进行实名认证，您可以在移动端按以下任一方式认证：</br></br>1、南航APP首页—我—在线实名认证；</br>2、南航官网首页—服务大厅—在线实名验证；',
    noticket: '您好！根据您输入的信息，未找到可退改的客票，请重新输入。',
    cancelOrder: '您好！您确定要取消该变更单吗? ',
    cancelOrderOk: '取消变更成功！',
    cancelOrderFailed: '抱歉！暂时无法取消变更。请稍后重试或联系南航客服95539。',
    // '您好！您的客票状态不符，无法提交退票。您可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。', // GN: [ID1556600][2024-10-16]
    costCalculation: '费用计算',
    huChangeTip: '本渠道仅支持该客票办理自愿变更，若想办理航班不正常改签，请前往海航官网或者APP进行办理，如有疑问请联系在线客服或海航客服95339'
  },
  // EndorsedApply页面
  endorsedApply: {
    addPsgSuccess: '添加同行人成功',
    OneAdult: '您好！该旅客已进行过航班改期，后续将以改期的航班时间进行变更。',
    ManyAdult: '您好！该旅客已进行过航班改期，本次变更仅限航班时间相同的旅客，航班时间不同的旅客们需分别申请变更。',
    flightDelayOrCancel: '<p>1.国内客票可免费变更航班日期前后7天内（含航班当天）的航班。</p><p style="margin: 0.2rem 0;">2.国际客票可免费变更航班日期前7天、后14天（含航班当天）的航班。</p><p>3.头等舱、公务舱、明珠经济舱、经济舱全价票可选航班日期不受此限制。</p>',
    needSelectPsg: {
      content: '您好！添加同行人需先选择乘机人。'
    },
    pleaseSelectChangeFlightAndPsg: '请您先勾选所需变更的航段和乘机人！',
    pleaseSelectRefundFlightAndPsg: '请您先勾选所需退票的航段和乘机人！',
    pleaseSelectChangeFlight: '请您先勾选所需变更的航段！',
    pleaseSelectRefundFlight: '请您先勾选所需退票的航段！',
    pleaseSelectTrainFlight: '您好！若需单独退订高铁产品，可通过 “我的订单” - “假期” - “高铁订单” 操作退款',
    pleaseSelectPsg: '请您先勾选乘机人！',
    pleaseSelectHtlight: '您好！若需单独退订酒店产品，可通过“我的订单-酒店”操作退款',
    selectedPsgMustHasAdult: '您好！暂不支持单独儿童变更。如有疑问，请联系南航客服95539处理。',
    // GN: [ID1556600][2024-10-16]
    // '您好！暂不支持单独儿童变更。如有疑问，可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    selectedPsgbady: '您好！暂不支持单独婴儿自助变更。如有疑问，请联系南航客服95539处理。',
    // GN: [ID1556600][2024-10-16]
    // '您好！暂不支持单独婴儿自助变更，如有疑问，可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    selectedFlightError: function selectedFlightError(text) {
      return '\u60A8\u597D\uFF01' + text + '\u7684\u822A\u73ED\u9700\u8981\u52FE\u9009\u540E\u65B9\u53EF\u8FDB\u884C\u4E00\u4E0B\u6B65\u64CD\u4F5C\uFF0C\u8BF7\u786E\u5B9A\u662F\u5426\u52FE\u9009\u8BE5\u884C\u6BB5\uFF1F';
    },

    selectedFlightSuccess: '选择成功，请再选择下一段航班日期!',
    onlySelectOneAdultInTAOrder: '您好，此类型客票仅允许选择一个成人乘机人进行退票操作！',
    cancelCheckIn: '取消值机',
    selectMutiplePerson: '该产品同一订单的乘机人需同时退改，请勾选所有乘机人。'
  },
  // selectDate页面
  selectDate: {
    selectedFlightDateBefore: '您好！您选日期不能在前一个航班日期之前，请重新选择日期。',
    selectedFlightDateAfter: '您好！您选日期不能在后一个航班日期之后，请重新选择日期。',
    selectedFlightDateBeyondWQT: '该日期无法享受优惠变更手续费的权益，请确认是否更改日期。',
    selectedFlightDateSeasonTicket: '本期双城旅行产品旅行截止日期为2023年1月5日。您选择变更后的航班日期，后续产品保障不足90日。是否继续？',
    selectedFlightDateExceeds: '抱歉! 中转运价客票要求航班衔接时间不得大于24小时, 请重新选择',
    selectMuFlightDate: '您好！新航班日期在原航班日期前3天，后3天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。'
  },
  // 选择新航班
  ticketChanges: {
    optionalFlight: '您好！当天除您已订的航班外，无其它可选航班，建议您重新选择日期，如有疑问，请联系在线客服咨询或原出票地办理。',
    electionFlight: '您有一段航班是处于重选状态，请选择完毕再进行其它航班重选！',
    checkpending: '本次变更的费用需要人工审核，在您选择完新航班并提交申请后，客服稍后短信通知您审核结果及变更费用。',
    changeCabin_1: '您好，该航班的明珠经济舱剩余座位不足或售罄，是否变更至经济舱？',
    changeCabin_2: '您好，该航班无明珠经济舱，是否变更至经济舱？',
    compareCabin: function compareCabin(text) {
      return '\u60A8\u6240\u9009\u8231\u4F4D\u4E3A\u964D\u8231\u53D8\u66F4\uFF0C\u5DF2\u5151\u6362' + text + '\u4E0D\u9000\u8FD8\u3002';
    }
  },
  // addPersonMessage页面
  addPersonMessage: {
    // addPersonMessage页面，请求afterSaleChangeConfirm接口成功的提示信息
    afterSaleChangeConfirm_ok: {
      title: '提交成功',
      content: ''
    },
    // addPersonMessage页面，请求afterSaleChangeConfirm接口出错的提示信息
    afterSaleChangeConfirm_error: "非常抱歉的通知您, 您的改签申请提交失败。 原因可能是您所选航班座位已售空， 或同时改签人数过多造成系统改签出错。你可以拔打<a href='tel://95539 '> <u>95539</u></a>人工服务垂询。",
    // GN: [ID1556600][2024-10-16]
    // '非常抱歉的通知您,您的改签申请提交失败。原因可能是您所选航班座位已售空，或同时改签人数过多造成系统改签出错。你可以可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    // addPersonMessage页面，请求afterSaleChangeConfirm接口出错的提示信息
    afterSaleChangeConfirm_fail: {
      title: '提示',
      content: ''
    }
  },
  // ApplySubmit页面
  applySubmit: {
    // ApplySubmit页面，提示用户输入联系人信息
    inputContactInfo: {
      content: '请输入并保存联系人信息'
    },
    // ApplySubmit页面，提示用户输入正确的联系人信息
    inputRightContactInfo: '您好！请输入正确的手机号',
    verificationCode: '请输入六位验证码！',
    // ApplySubmit页面，请求afterSaleChangeReqPayOK接口出错的提示信息
    afterSaleChangeReqPayOK_error: '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或拨打南航客服95539处理。',
    // GN: [ID1556600][2024-10-16]
    // '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    // ApplySubmit页面，请求afterSaleChangeReqPayOK接口出错的提示信息
    afterSaleRefundApp_error: '尊敬的旅客，您好！退票申请中遇到问题，请重新提交或联系南航客服95539处理。',
    // 提示语优化暂时使用
    checkTips_fzy: '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消且无法恢复，实际退还金额将以审核结果为准；<br/>2、此次为非自愿退票，免收退票手续费。</div>',
    bingtui_zy: '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消且无法恢复，实际退还金额将以审核结果为准；<br/>2、您将提交病退申请，若您的材料符合要求，将为您免费办理退票；若您的材料不符合要求，系统将按自愿退票规则进行办理，自愿退票手续费可通过服务大厅“退改计算器”模块查看或联系客服咨询。</div>',
    checkTips_zy: '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消且无法恢复，实际退还金额将以审核结果为准；<br/>2、此次为自愿退票，按照客票使用条件可能产生相应退票手续费。</div>',
    yddqTip: '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消，实际退还金额将以审核结果为准；<br/>2、本次因疫情原因申请的退票需要人工审核。如符合疫情文件，退票将按非自愿退票，免收退票手续费；如不符合疫情文件，退票将按自愿退票，按照客票使用条件可能产生相应退票手续费。</div>',
    quotaTip: '<span style="color:#e5004a">额度将在退票后几分钟内到账（若超出额度数不予退回），若未到账，可通过员工旅行-返回额度申请</span>',
    // contact_important: '联系人信息很重要，请补充完整。',
    contact_important: '请补充联系人信息',
    error_certno: '请输入证件号',
    error_certnoF: '请输入正确的证件号',
    error_name: '请输入持卡人',
    no_verification: '请输入验证码！',
    get_verification: '请获取验证码！',
    error_verification: '您输入的验证码有误，请重新输入。',
    overtime_verification: '您输入的验证码已超时，请重新获取。',
    eleven_phone: '请输入11位国内手机号。 ',
    isCheckedRead: '您好！请阅读并同意《隐私政策》。',
    artificial: '您好！本次变更需人工审核，客服稍后短信通知您审核结果及变更费用。',
    error_cardNo: '抱歉，您输入的银行卡信息有误，请重新输入。',
    no_bankcard: '请输入16-19位银行卡号',
    error_referral: '推荐码格式不正确！',
    changeCabin: '尊敬的旅客，您选择新航班的明珠经济舱已售罄，系统将自动为您安排同航班经济舱座位。<br/>变更成功后，您可前往南航机场柜台领取明珠经济舱体验券。<br/>请确认是否继续提交？',
    happyFlying: '您好！按照南航套票产品规则：机票一旦出票，不得变更、不得签转。',
    repeat: '文件名重复，无法上传，请更名后上传',
    selectedError: '附件上传格式为Word（.doc/.docx/.DOC/.DOCX）、Excel（.xls/.xlsx/.XLS/.XLSX）、PDF（.pdf/.PDF）、文本文件(.txt/.TXT) 或JPG(.jpg/.JPG)、PNG(.png/.PNG)格式，每个附件大小不能超20M',
    muFileError: '附件上传格式为"JPG", "PNG", "DOC", "JPEG", "DOCX"，所有附件大小不能超2M。',
    fileSize: '您好，您所提交的附件内容为空，请核对后提交，谢谢。',
    fileTip: '请根据实际情况，按需上传如下附件：1.情况说明 2.身份证正反面图片或其他身份证明官方材料 3.出行受阻官方证明材料 4.目的地活动延期或取消官方证明材料 5.健康码或核酸检测异常截图6.其他疫情原因导致无法出行的官方证明材料。',
    fileTipIll: '请上传南航认可医疗机构开具的医疗缴费发票或住院押金证明。',
    fileTipProof: '请根据实际情况，按需上传如下附件：<br/>1.本人手持购票证件（姓名页）和抗原检测阳性结果合照，要求本人人脸、姓名页证件和抗原阳性结果须同框。<br/>2.学校放假计划调整证明文件和学生证(封面和姓名页)图片。<br/>3.其他疫情原因导致无法出行的官方证明材料。',
    noRefundMode: '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
    thanksPerson: '谢谢您的支持与配合！',
    contactInfo: '温馨提示：请您认真核对航班信息、乘机人姓名及证件信息、联系电话等，以免影响乘机。',
    transferInfo: '您的客票调整至中转航班后，如已预定附加服务可能无法保障，具体以现场核销为准,',
    pleaseCheckIsFood: '请您先勾选是否机上用餐'
  },
  // feeQuery 页面
  feeQuery: {
    selectFlight: '请选择想要退票或变更的航段! ',
    refundrules: '您好！根据退改规则，所有未使用航段必须同时申退。',
    canotChange: '您选择的航段不可变更，请重新选择',
    modification: '抱歉，您选择的航段不可变更'
  },
  // loginFeeQuery 页面
  loginFeeQuery: {
    inputTicketNoOrId: '请输入票号或者证件号！',
    inputName: '请输入旅客姓名！',
    inputTicketNo: '请输入航班号！',
    inputFlightDate: '请选择航班日期！'
  },
  // 退改计算器
  refundChangeCompute: {},
  // DetailsMessage 页面
  detailsMessage: {
    // detailsMessage 页面， 请输入联系人姓名提示
    inputContactPersonName: '联系人信息很重要，请补充完整',
    // detailsMessage 页面， 请输入正确的联系人姓名提示
    inputRightContactPersonName: '请输入正确的联系人姓名',
    // detailsMessage 页面， 请输入联系人手机提示
    inputContactPersonPhone: '联系人信息很重要，请补充完整',
    // detailsMessage 页面， 您输入的联系手机不正确，请重新输入提示
    inputRightContactPersonPhone: '您输入的联系手机不正确，请重新输入'
  },
  // RealNameVerify退款账户认证页面
  realNameVerify: {
    descTitle: '退款账户认证说明',
    descContent: '您提交的退票我们将把退款退回您（婴儿请提供携带成人的银行账户）本人的银行账户，请填写有效银联卡并完成认证，退款将在0-20个工作日退回到您提供的银行账户，具体时间以各家银行为准。',
    createRefundTa_error: '<div>很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者拔打<a style="display: inline-block;" href=\'tel:95539 \'> <u>95539</u></a>人工服务垂询。</div>'
    // '很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
  },
  // ReformProcess 页面
  ReformProcess: {},
  // SubInfomation页面
  subInfomation: {
    payOverTime: {
      title: '支付超时'
    }
  },
  ElectronicInvoice: {
    noCompanyName: '请输入公司名称',
    noTaxpayerIdCode: '请输入纳税人识别码',
    noEmail: '请输入收票人邮箱',
    noPhone: '请输入收票人电话',
    erroeEmail: '邮箱输入有误，请重新输入',
    errorTaxpayerIdCode: '纳税人识别号不符合规则',
    errorPhone: '请正确输入收票人电话',
    tip: '点击“提交”后将为勾选的乘机人自动填充同样的发票信息并一并提交，请慎重勾选！'
  },
  changeMember: {
    checkMember: '您还没有勾选要入会的乘机人，请先勾选要入会的乘机人'
  },
  rateTip: {
    rateTip: '请选择评分！',
    rateSuccess: '感谢您的反馈！'
  },

  mileageMsg: {
    title: function title(text) {
      return text + '\u8BA1\u7B97\u89C4\u5219';
    },
    info: function info(text) {
      return '\u8BA1\u7B97\u516C\u5F0F:<br/>\u5B9E\u9645\u8FC7\u671F' + text + '=\u8FC7\u671F' + text + ' - \u5EF6\u671F' + text + '<br/>\u5B9E\u9000' + text + '=\u5E94\u9000' + text + ' - \u5B9E\u9645\u8FC7\u671F' + text;
    },

    btn: '知道了'
  },
  cancelPage: {
    CancellationTip: '<p style="background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem; margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem" ><strong style="font-size:0.26rem;color:#009cd9"> 提前了解 </strong><br/> 请在取消行程前留意客票的退改政策，部分客票可能存在不允许变更或退票的规则</p><p style="background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem ;margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem"><strong style="font-size:0.26rem;color:#009cd9"> 无法恢复</strong><br/>取消航班行程后，将无法再乘坐本航班，且无法恢复。</p><p style="background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem;margin:0.1rem 0;text-align:left;color:#262626; font-size:0.2rem"><strong style="font-size:0.26rem;color:#009cd9"> 后续出行</strong><br/>在确定好新的行程后，您可在机票退改模块点击“变更”按钮，预订新的航班。</p>'
  }

});

/***/ }),

/***/ "Ex0j":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAICAYAAACPp21mAAAAAXNSR0IArs4c6QAAAL1JREFUOE/N0iEOwkAQBdA/W9mz1a7pmlXVCAQWR1B1CCzJiB4ACzgcEtEDgCFZsSFhYUgTmiAa0iak7eif+S+TIfQ8zLxRSuVa62OXauoS/keWmZ8ASiKae+8La+29zd4hoPKBvQDsRWTqnDtlWfb4BR4SWrtKAGul1FJrXV27ccYArWEHEVlEUbRtAo8JWoEvRJSHEFZpmt6+T0vMXP9Mm5/uK3MGMInjeJckia9KxwoFEV1FpAghzIwx7g0A8kwJ5Rf6SwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "F3T6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("nCfu");
var utils = __webpack_require__("97gm");
var InterceptorManager = __webpack_require__("qP46");
var dispatchRequest = __webpack_require__("fhTm");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "FKWp":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "Fq9N":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "Fxj9":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "G4fZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("h2Na");

__webpack_require__("/7dr");

/***/ }),

/***/ "GCs6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var toPrimitive = __webpack_require__("9MbE");
var dP = Object.defineProperty;

exports.f = __webpack_require__("qs+f") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "GhAV":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("W6Rd");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "GiK3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(2);

/***/ }),

/***/ "GmwO":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "GqR8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAMAAAACYceEAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAARnQU1BAACxjwv8YQUAAAABc1JHQgCuzhzpAAABPlBMVEUAAADLy8vLy8vLy8vMzMzMzMzU1NTLy8vMzMza2trOzs7Ly8vMzMzMzMzKysrLy8vLy8vLy8vExMTMzMzLy8vMzMz////Ly8u/v7/Ly8vLy8vMzMzMzMzMzMzNzc3MzMzMzMzLy8vLy8vMzMzMzMzLy8vLy8vMzMzMzMzNzc3MzMzLy8vKysrKysrMzMzNzc3MzMzOzs7MzMzLy8vLy8vMzMzMzMzMzMzMzMzIyMjIyMjLy8vLy8vGxsbMzMzMzMzLy8v2+v/MzMz1+f/Pz8/u8PTr7fDy9vzS0tPg4eTf4OLo6u3a29zv8fXh4+X0+P7u8vbW19ja293e3+Hq7O/y9PrV1tfs8PTU1dbr7fHx9fnZ2tzw9PjNzc7r7/LX2Nrx8/fY2drt7/PT1NXNzc3y9vrk5ujR0tLp6+7x9fvxMOp+AAAAQXRSTlMA85n599cG/vwHFYDUyljGd3YN9vSJAe4IgeBR9aAkNwXbe3jZZ+8jfi5B/UkdpR9WL5Hq31DT7OIcDtGVEqfc0MQ1r30AAAEJSURBVCjPfdFnV8IwGAXggtW07OHCreDeinvmtlD2cG8F9///A7YlkYTj8X5LnnNz3pNXUf7L1jZJb6z+AWsEdrrmejrhaAcV6+keCIT6ggNkyDvGJYIGtXObA4s6zCSIrCO0ms+dX1xa1yWMjLdERZVKKWBy0BXtzZDFuEHClQCastAMen2O+FHvKNEz+B3Z38Vz+cGQS93uc+ub9qg1qWQS3aXlFQ+K0gymxj8kioIoRYT5PyzgSpQKprjoHtwJkkVqgtMo8oKUgWku8+TxpV0xwcZ24sWr1bqvlYBFzPxK7ACfX9/vmY+6vcTIkpZsL9AXZuuJH+4pymy/sFs9eqrGT45DMXb+AU3nVK1E54uvAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Gsca":
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ "GxNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _language$morequeryte;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = (_language$morequeryte = {
  language: 'cn',
  morequerytext1: '更多查询',
  morequerytext12: '查询其他客票',
  morequerytext2: '没有找到要退改的机票（测试环境非人脸）',
  reminder1: '温馨提示',
  reminder2: '温馨提示：',
  writeText1: '请输入正确的证件号',
  writeText2: '请前往小程序或南航App进行更多客票查询',
  writeText_3: '您好，为保障行程信息安全，需进行实名认证后方可对身份证关联客票进行退改操作，请确认是否继续。',
  writeText3: '您好，为保障行程信息安全，需进行人脸识别认证后方可对身份证关联客票进行退改操作，请确认是否继续。',
  writeText4: '您好，为防范金融风险，更多查询需进行人脸识别，请更新最新版APP进行操作，谢谢',
  photoTip: '请先更新APP最新版本后再使用上传文件功能。',
  inputText: '请输入您的信息',
  labeltext1: '证件号码：',
  labeltext2: '姓：',
  labeltext3: '名：',
  labeltext4: '姓',
  labeltext5: '名',
  writeTip2: '请输入证件号',
  writeTip3: '请输入姓',
  writeTip312: '乘机人的姓',
  writeTip322: '乘机人的名',
  writeTip4: '请输入名字',
  writeTip4qw: '姓名包含特殊字符',
  writeTip466: '查询',
  writeTip5: '由于姓名包含特殊字符，请再次选择并确认您的姓名信息',
  writeTip6: '长度不能超过20个字符',
  wxFaceCheck: '微信实名认证',
  inpTip1: '请填写信息，以完成实名认证',
  inpTip2: '请输入姓/名',
  idNum: '身份证',
  openFaceCheck: '开启人脸识别',
  tip1: '温馨提示：若您的姓名包含“·”，请勾选“姓名包含特殊字符”选项，系统将在姓和名之间添加“·”作为您的实际姓名进行认证，否则会认证失败。',
  tip2: '1、航班延误/取消时,允许免费改期的航班范围以实际为准',
  tip3: '2、变更计算结果仅为手续费,实际变更时可能需支付票价差额',
  tip4: '3、以上退改说明仅供参考,请以南航实际规定为准',
  tip5: '以上退改说明仅供参考，请以南航实际规定为准',
  lookAgin: '再看看',
  realName: '实名认证',
  calculateR: '退票计算',
  calculateC: '变更计算',
  refunMen: '退票航段',
  leg: '航段',
  detailsR: '可退金额明细',
  amount: '票面价',
  tax: '可退税费',
  insurPremium: '保险费',
  noinsurPremium: '不可退保险费',
  handlingFee: '退票手续费',
  coupon: '优惠券',
  refundableAmount: '可退金额',
  confirm: '确定',
  applicableLeg: '适用航段',
  rules: '规则',
  CostDisplay: '费用展示',
  dateNow: '按当前时间计算',
  cFee: '变更手续费',
  tipRefun: '客票变更时根据您实际选择的新航班及舱位，可能需补充支付票价差额',
  clickTip: '点击底部 按钮 可获取详细费用',
  receivedR: '已退票',
  receivedU: '已使用',
  receivedC: '已变更',
  unavailable: '不可用',
  seleLeg: '选择变更',
  refundLeg: '退票航段',
  rulesFC: '退改规则',
  rulesdetailed: '详细规则',
  choose: '选择',
  chooseMore: '更多选择',
  name: '姓名',
  ticketNo: '票号',
  taxes: '税费',
  otherTicketses: '其他客票退改计算',
  ticketnoInp: '请输入票号或者证件号',
  ticketNoID: '票号 / 证件号',
  passengerName: '请输入旅客姓名',
  inpTip3: '请输入实际承运航班号（如CZ605）',
  flightNo: '航班号',
  flightDate: '航班日期',
  tip6: '1、暂仅支持南航实际承运国内航班的电子客票(784开头)；',
  tip7: '2、团队、里程兑换、政府采购、礼遇等客票类型暂不支持；',
  tip8: '3、如您的客票无法查询退改手续费，可能是我们的服务范围暂未覆盖，敬请谅解！您可联系原出票服务商或南航客服95539咨询！',
  nextStep: '下一步',
  openCard: '开卡证件',
  cardNo: '证件号码',
  cardNoBin: '银行卡Bin',
  checkMessage: '请核对填写公务卡开卡信息',
  titel1: '选座&办登机牌',
  titel2: '接送机',
  titel3: '代客泊车',
  titel4: '贵宾休息室',
  titel5: '额外行李',
  titel6: '一人多座预售',
  paySuccess: '支付成功',
  changeNo: '变更单号:',
  titelTip: '温馨提示:系统正在处理您的变更申请,具体进度可点击查看订单详情;如有其它疑问,欢迎致电联系95539 !',
  goback: '返回可退改',
  details1: '查看订单详情',
  PleaseEnter: '请输入',
  cardholder: '持卡人',
  carddetails: '名下的银行卡信息（仅限银联）',
  placeChoose: '请选择(退款将退至该卡持卡人账户)',
  placeChoose123: '请选择',
  placeHoder: '请输入16-19位银行卡号',
  certification: '认证',
  failure: '退款账户认证失败',
  failureCardNo: '您提供的银行卡信息有误',
  checkAgin: '请详细核对',
  Understood: '知道了',
  successCer: '退款账户认证成功',
  cardNum: '卡号',
  cardNum2: '卡号',
  adult: '成人',
  child: '儿童',
  body: '婴儿',
  army: '军残',
  police: '警残',
  mileage: '里程',
  mileageJ: '积分',
  ticketFee: '票价',
  mileageValue: '抵扣金额',
  refundInsurance: '可退保险费',
  airportTaxFee: '机场税',
  fuelFee: '燃油费差',
  fuelFee123: '燃油费',
  otherFee: '其他税费',
  HandlingFee: '手续费',
  costTotal: '票价差额',
  airportTaxFeedif: '机场税差',
  missfee: '误机费',
  extensionfee: '延期费',
  qtPrice: '其它税差',
  difference: '税差',
  changeCost: '变更费用',
  refundCost: '应退金额',
  mileageF: '应退里程',
  pendingReview: '待审核',
  Issued: '已开具',
  Reserved: '已预约',
  unreserved: '未预约',
  ProcessingFailed: '处理失败',
  InvoiceTitle: '发票抬头:',
  TaxpayerIdentNum: '纳税人识别号:',
  phonenum: '收票人手机号:',
  email: '收票人邮箱:',
  Sunday: '(周日)',
  Monday: '(周一)',
  Tuesday: '(周二)',
  Wednesday: '(周三)',
  Thursday: '(周四)',
  Friday: '(周五)',
  Saturday: '(周六)',
  dateWorm: '(日期不对)',
  Sunday1: '周日',
  Monday1: '周一',
  Tuesday1: '周二',
  Wednesday1: '周三',
  Thursday1: '周四',
  Friday1: '周五',
  Saturday1: '周六',
  dateWorm1: '日期不对',
  one: '一',
  two: '二',
  three: '三',
  four: '四',
  five: '五',
  six: '六',
  seven: '七',
  the: '第',
  voyageleg: '航程',
  cabin: '舱',
  share: '共享',
  highspeed: '高铁 ',
  bullet_train: '动车 ',
  Intercity_railway: '城际铁路 ',
  afterChange: '变更后',
  oldTitle: '原航班',
  ni: '身份证',
  ni2: '身份证',
  pp: '护照号：',
  othersId: '其他证件：',
  booklet: '户口簿：',
  certificate: '出生证明：',
  Officer_Cert: '军官证：',
  Police_Cert: '警官证：',
  Taiwan_Cert: '台胞证：',
  home_Cert: '回乡证：',
  Taiwan_permit: '台湾居民居住证：',
  hk_mac: '港澳居民居住证：',
  Passport: '护照：',
  others: '其它：',
  ForeignersId: '外国人永久居留证：',
  Seafarer_Cert: '海员证：',
  Exit_Permit: '外国人出入境证：',
  others2: '其它证件：',
  Passport2: '护照',
  e_passport: '电子护照',
  household_register: '户口簿',
  mp_Cert: '军人及武警证件',
  passId: '通行证',
  others3: '其它证件',
  ForeignersID: '外国人永久居留证',
  seaman_book: '海员证',
  china_issued: '外交部签发的驻华外交人员证',
  Officer_ID: '军官证',
  hkmtId: '港澳台居民居住证',
  others4: '其他证件',
  hkmaId: '港澳通行证',
  twId: '大陆居民来往台湾通行证',
  Sergeant_Cert: '士官证',
  certificate2: '出生医学证明',
  student_ID: '学生证',
  noNewTicketNo: '(当前无新票号)',
  NewTicketNum: '新票号',
  ticketNum: '票    号：',
  PassengerInfo: '乘机人信息',
  TermsOfUse: '使用条件',
  tipcoup1: '因您的变更手续费需人工计算，优惠券抵扣金额将根据优惠券使用条件和人工计算结果得出，详细计算规则请查看优惠券使用条件。',
  tipcoup2: '因您的退票手续费需人工计算，优惠券抵扣金额将根据优惠券使用条件和人工计算结果得出，详细计算规则请查看优惠券使用条件。',
  Contact: '联系人',
  Contact123: '请输入联系人',
  name2: '姓名：',
  name2123: '证件号：',
  Contact_phone: '联系手机：',
  bank_card: '银行卡',
  addNewCard: '添加新卡',
  Seat_number: '座位号',
  operation: '操作',
  ChangeSeats: '改选座位',
  SeatsTip1: '正在为您预留机上座位...',
  SeatsTip2: '预留座位失败！',
  SeatsC: '选座',
  SeatsTip3: '系统已为您分配如下座位：',
  SeatsTip4: '预留座位成功！',
  refundTip1: '自身原因无法成行，同意扣除退票手续费',
  refundTip2: '航空公司原因无法成行，申请全额退票',
  tipP1: '由于业务繁忙，请您先提交进入审核阶段',
  tipP2: '审核通过后，变更费用将在订单详情中进行显示',
  tipP3: '您好，外币客票暂不支持小程序端/H5/APP处理，请前往官网办理，谢谢。',
  tipP4: function tipP4(a, b) {
    return '\u672C\u6B21\u53D8\u66F4\u9700\u6263\u51CF' + a + b + '\u516C\u91CC\uFF0C\u5982\u4EA4\u6613\u5931\u8D25\u7CFB\u7EDF\u5C06\u5168\u989D\u9000\u8FD8' + a;
  },
  tipP5: '您好，该客票非当前渠道购买，请返回原出票渠道进行相关操作。',
  changeNo2: '变更单号：',
  cancelNo: '取消行程单号：',
  refundNo: '退款单号：',
  changeFee: '变更费用：',
  refundFee: '应退金额：',
  refundFeeT: '机票应退金额：',
  loading1: '正在加载...',
  newChangeNo: '新变更单号：',
  doorFee: '专车应退金额',
  tipT1: '注：高铁产品默认原路径退款',
  titelE1: '电子发票开具',
  titelE2: '附加产品',
  titelE3: '查看退款详情',
  titelE4: '*注：如退款失败，可进入详情页，重新发起退款',
  Zhang: '张',
  flie1: '附件上传成功',
  flie2: '提交成功!',
  flie3: '上传附件失败，请重新上传。',
  flie4: '下拉刷新',
  flie5: '刷新中',
  flie6: '加载成功',
  flie7: '您的客票非南航官方渠道购买，应退票款已原流水退回至购票账户，具体到账金额以原购票渠道退款为准，详情请咨询原出票渠道。',
  flie8: '绿色飞行-按需用餐',
  choosed: '已选',
  unit: '份',
  gift: '赠送',
  Einvoice: '电子发票',
  resubmit: '重新提交',
  Cancel: '取消',
  pay: '支付',
  complete: '返回',
  modify: '修改退票原因',
  modifyRefun: '退票原因',
  chooseRefun: '请选择退票原因',
  submit: '提交',
  sumitKnow: '我已知晓',
  sumitSure: '确认提交',
  moreThink: '我再想想',
  UnderReview: '审核中',
  notApproved: '审核未通过',
  Canceled: '已取消',
  Canceled123: '可取消',
  progress1: '您的变更申请已取消，如有疑问，',
  progress2: '请联系在线客服咨询或原出票地办理',
  progress3: '待支付',
  progress4: '支付中',
  progress5: '支付失败',
  progress6: '自动处理中',
  progress7: '变更失败',
  progress8: '非常抱歉，您的变更申请处理失败，请联系南航',
  progress9: '客服95539处理。',
  progress0: '变更成功',
  progress10: '人工处理',
  progress11: '重新提单',
  progressTip1: '放弃变更',
  progressTip2: '已经电话通知',
  progressTip3: '等待处理',
  progressTip4: '变更处理中',
  progressTip5: '处理失败',
  progressTip6: '变更失败 非常抱歉，您的变更申请处理失败',
  progressTip7: '审核未通过',
  progressTip8: '退款处理中',
  progressTip9: '退款成功',
  progressTip0: '退款异常',
  progressTip10: '等待处理',
  progressT1: '退票处理中',
  progressT2: '退款成功',
  progressT3: '已关闭',
  progressT4: '您的退票申请已关闭，如有疑问，',
  progressT5: '请联系南航客服95539。',
  progressT6: '取消行程失败',
  progressT7: '请联系在线客服咨询办理。',
  progressT8: '取消行程成功',
  progressT9: '处理中',
  progressT91: '可退改',
  progressT92: '已退改',
  progressT0: '您的退票申请已取消，如有疑问，',
  progressT10: '变更审核',
  progressT11: '变更处理',
  progressTips1: '处理完成',
  progressTips2: '请联系在线客服咨询或原出票地办理',
  progressTips3: '待支付  请尽快支付',
  progressTips4: '请在支付时限前完成支付',
  progressTips5: '支付失败  请重新支付',
  progressTips6: '支付失败，请在支付时限前完成支付',
  progressTips7: '预计需要2分钟完成处理，请耐心等待。',
  progressTips8: '待处理',
  progressTips9: '请耐心等待',
  progressTips0: '待电话确认',
  progressTips10: '南航客服稍后电话给联系人，请保持手机畅通',
  progressTips11: '联系人未接电话或回复不需变更，如有疑问，请联系在线客服咨询。',
  progressTips12: '客服已经电话通知到联系人，联系人回复需再确认。后续如需处理，请联系在线客服咨询办理。',
  progresswTip1: '退款审核',
  progresswTip2: '银行受理',
  progresswTip3: '退款受理',
  progresswTip4: '银行卡到账',
  progresswTip5: '代金券到账',
  progresswTip6: '退票处理',
  progresswTip7: '审核未通过，如对审核结果有异议，请按要求更新附件重新提交审核。',
  progresswTip8: '请联系原出票渠道处理。',
  progresswTip9: function progresswTip9(a) {
    return '\u9884\u8BA1' + a + '\u524D\u9000\u6B3E\u81F3\u94F6\u884C';
  },
  progresswTip10: '银行受理成功后预计3个工作日到账。',
  progresswTip11: '若逾期未查询到退款到账，请致电银行客服。',
  progresskl1: '若未查询到代金券到账，请联系南航客服95539。',
  progresskl2: "退款时卡号验证不通过，请点击下方的 <span style='color: rgba(0, 138, 203, 1)' >[添加新卡]</span>",
  progresskl3: '预计1-5个工作日完成审核，请耐心等待。',
  progresskl4: '查看进度',
  progresskl5: '里程退分异常，请联系在线客服或原出票渠道处理。',
  progresskl544: '里程退款失败',
  refundMoth: '退款方式',
  inpIdCard: '请输入银行卡信息(仅限银联)',
  choosePerson: '请选择持卡人',
  inpMessage: '请输入持卡人身份证姓名',
  inpMessage2: '请输入持卡人身份证号',
  inpIdCard2: '请输入银行卡号',
  cardtip: '持卡人必须与乘机人证件号、姓名保持一致方可办理。如身份证姓名中含有特殊字符，如“.”等，请照实输入，否则无法通过实名认证。',
  refundMoth1: '省',
  refundMoth2: '请输入银行卡开户所在省',
  refundMoth3: '请输入准确的开户行所在省份，如：广东省',
  refundMoth4: '城市',
  refundMoth4567: '开户地址',
  refundMoth5: '请输入银行卡开户所在市',
  refundMoth6: '请输入准确的开户行所在市区，如：广州市',
  refundMoth7: '请输入银行卡开户地址',
  refundMoth8: '请输入准确的开户行地址，以免影响退款，如：广州市XXXX支行',
  refundMoth9: '银行预留手机',
  refundMoth0: '请输入银行预留手机',
  refundMoth11: '输入验证码',
  checkCode: '获取验证码',
  refundMoth12: '我已知晓',
  refundMoth13: '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
  refundMoth14: '请输入手机号',
  refundMoth15: '人脸识别提示',
  refundMoth16: '您好，为保障您的资金安全，极速退款需进行人脸识别，验证持卡人身份，请确认是否继续。',
  refundMoth17: '去认证',
  refundMoth1765: '信息校验失败',
  refundMoth18: '您好，为防范金融风险，极速退款需进行人脸识别，请更新最新版APP进行操作，谢谢',
  refundMoth19: '您好，为保障您的资金安全，极速退款需进行人脸识别验证，请前往南航官方APP或微信小程序进行退票操作，谢谢。',
  refundMoth20: '退款账户认证失败，您提供的银行卡信息有误，请详细核对！',
  refundMoth21: '系统正在处理您的退票请求，请稍等！\n 如提交失败，请稍后尝试重新提交。',
  refundMoth22: '您好，您的客票暂无法自助办理，退改申请将流转至原出票渠道进行处理，请确认是否提交。',
  refundMoth23: '3、机票款将以代金券形式退至您的南航账户。',
  refundMoth24: '3.机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励及额外里程奖励。',
  refundMoth25: function refundMoth25(a) {
    return '3\u3001\u673A\u7968\u6B3E\u5C06\u4EE5\u4EE3\u91D1\u5238\u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u989D\u5916\u83B7\u5F97\u4E00\u5B9A\u989D\u5EA6' + a + '\u5956\u52B1\u3002';
  },
  refundMoth26: '3、机票款将以代金券形式退至您的南航账户，并额外获得一定面额机票优惠券奖励。',
  refundMoth27: '您好！如您退票，您的南航北京大兴无限次套票奖励机票权益将失效作废。',
  refundMoth28: '取消退票',
  refundMoth29: '您好！高铁产品暂无法退订。如有疑问，请联系南航客服95539。',
  refundMoth30: '继续退票',
  refundMoth31: '退款后，竞拍调整费用（如有）将自动退款。',
  refundMoth32: '继续退票',
  refundMoth33: '尊敬的旅客，如您有同行人，请在退票申请页选择乘机人处勾选，并一同提交身份证明材料。',
  refundMoth34: function refundMoth34(a) {
    return '\u60A8\u597D\uFF0C\u5BA2\u7968\u6709\u6548\u671F\u622A\u6B62\u81F3' + a + '\uFF0C\u8BF7\u5728\u5BA2\u7968\u6709\u6548\u671F\u5185\u63D0\u4EA4\u53D8\u66F4\u6216\u9000\u7968\u7533\u8BF7\uFF0C\u8C22\u8C22\u3002';
  },
  refundMoth35: '继续提交',
  refundMoth36: '请选择退款方式',
  refundMoth37: '您的客票非南航官方渠道购买，应退票款将原流水退回至购票账户，具体到账金额以原购票渠道退款为准，提交退票后退款信息详情请咨询原出票渠道。',
  refundMoth38: '您尚未开通南航账户，暂无法选择该种退款方式，是否现在开通？',
  refundMoth39: '以后再说',
  refundMoth40: '现在开通',
  refundMoth41: '退款至南航账户，仅支持退款至乘机人本人南航账户，请确认是否本人操作？',
  refundMoth42: '其它退款方式',
  refundMoth43: "<span style='color: #03bffd;'>代金券：</span><span>南航账户<strong>代金券</strong>可在南航官方渠道为本人或他人购买机票、选座、行李额、贵宾休息室等产品时全额抵扣，也可以拆分多次使用，有效期自退票之日起2年有效，<strong>不可提现</strong>。</span><br/>",
  refundMoth44: function refundMoth44(a, b, c) {
    return '<span style="color:#0096d5;">\u673A\u7968\u4F18\u60E0\u5238\uFF1A</span><span>\u673A\u7968\u4F18\u60E0\u5238\u53EF\u5728\u5357\u822A\u5B98\u65B9\u6E20\u9053\u8D2D\u4E70\u673A\u7968\u65F6\u90E8\u5206\u62B5\u6263\uFF0C\u4E0D\u53EF\u62C6\u5206\u591A\u6B21\u4F7F\u7528\uFF0C\u4EC5\u9650\uFF08\u4F1A\u5458\u53F7\uFF1A' + a + '\uFF09\u672C\u4EBA\u4F7F\u7528\uFF0C<strong>\u4E0D\u53EF\u63D0\u73B0\uFF0C\u4E0D\u9000\u4E0D\u8865</strong>\u3002' + (!b && c ? ' 具体使用说明如下：' : '') + '</span><br/>';
  },
  refundMoth45: function refundMoth45(a) {
    return '<span style="color:#0096d5;">\u4F7F\u7528\u65E5\u671F\uFF1A</span><span>' + a + '</span><br/>';
  },
  refundMoth46: function refundMoth46(a) {
    return '<span style="color:#0096d5;">\u9002\u7528\u4E1A\u52A1\uFF1A</span><span>' + a + '</span><br/>';
  },
  refundMoth47: function refundMoth47(a) {
    return '<span style="color:#0096d5;">\u4EF7\u683C\u9650\u5236\uFF1A</span><span>\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1\u4E0D\u4F4E\u4E8E' + a + '\u5143\uFF08\u542B\uFF09\u53EF\u4EE5\u4F7F\u7528</span><br/>';
  },
  refundMoth48: '航班日期：',
  refundMoth49: '订单内所有航班的出发日期必须在以下日期范围内：',
  refundMoth50: '无限制',
  refundMoth51: '航班除外日期：',
  refundMoth52: '优惠券不能用于以下日期的航班：',
  refundMoth53: '南航账户',
  refundMoth54: function refundMoth54(a, b) {
    return '<span style="color:#0096d5;">\u53EF\u7528\u7684\u822A\u7EBF\uFF1A</span><span style="word-wrap: break-word;">' + a + '</span><br/>\n        <span style="color:#0096d5;word-wrap: break-word;">\u822A\u73ED\u53F7\uFF1A</span><span style="word-wrap: break-word;">' + b + '</span><br/>';
  },
  refundMoth55: function refundMoth55(a, b) {
    return '<span style="color:#0096d5;">\u9002\u7528\u8231\u4F4D\uFF1A</span><span>' + a + '</span><br/>\n              <span style="color:#0096d5;">\u53EF\u7528\u7684\u652F\u4ED8\u65B9\u5F0F\uFF1A </span><span>\u4EC5\u9650' + b + '</span><br/>\n              <span style="color:#0096d5;">\u5907\u6CE8\uFF1A</span><span>\u90E8\u5206\u7279\u6B8A\u4EA7\u54C1\u4E0D\u80FD\u4F7F\u7528\u4F18\u60E0\u5238</span><br/>';
  },
  refundMoth56: '应退机票款将以<strong>代金券</strong>形式退至您的南航账户，并获得一定奖励。',
  refundMoth57: function refundMoth57(a, b, c, d) {
    return a + '\u5143\u673A\u7968\u6B3E\u5C06\u4EE5<strong>\u4EE3\u91D1\u5238</strong>\n                    \u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u53EF\u83B7\u5F97' + b + '\u989D\u5916\n                    ' + (c === 'Y' ? '积分' : '里程') + '\u53CA\n                    ' + d + '\u5143\u673A\u7968\u4F18\u60E0\u5238\u5956\u52B1\u3002';
  },
  refundMoth58: '应退机票款将以<strong>代金券</strong>形式退至您的南航账户。',
  refundMoth59: function refundMoth59(a, b, c) {
    return a + '\u5143\u673A\u7968\u6B3E\u5C06\u4EE5<strong>\u4EE3\u91D1\u5238</strong>\u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u53EF\u83B7\u5F97' + b + '\u989D\u5916' + (c === 'Y' ? '积分' : '里程') + '\u5956\u52B1\u3002';
  },
  refundMoth60: function refundMoth60(a, b) {
    return a + '\u5143\u673A\u7968\u6B3E\u5C06\u4EE5<strong>\u4EE3\u91D1\u5238</strong>\n                    \u5F62\u5F0F\u9000\u81F3\u60A8\u7684\u5357\u822A\u8D26\u6237\uFF0C\u5E76\u83B7\u5F97' + b + '\n                    \u5143\u673A\u7968\u4F18\u60E0\u5238\u3002';
  },
  refundMoth61: '附件上传失败',
  refundMoth62: '注：附加产品默认从原路径退款',
  refundMoth63: '该票来自关爱通渠道，部分金额将会退回关爱通账户额度，退款金额以实际到账为准。',
  refundMoth64: '已选择退款的附加产品',
  refundMoth65: '取消行程',
  refundMoth66: '退票',
  refundMoth67: '请补充银行卡号',
  refundMoth68: '请补充持卡人',
  refundMoth69: '为保证资金安全，根据相关法律法规，退票款仅限退回原支付卡，退款仅限一次，如涉及多渠道重复退款等套利行为，南航与出票单位将追究相关责任。',
  refundMoth71: '为保证资金安全，根据相关法律法规，退票款仅限退回乘机人本人，退款仅限一次，如涉及多渠道重复退款等套利行为，南航与出票单位将追究相关责任。',
  refundMoth72: '已阅读并同意',
  refundMoth73: '《隐私通知》',
  refundMoth74: '《旅客、行李运输总条件》',
  refundMoth75: '《国际运输总条件》',
  refundMoth76: '原路径退款',
  refundMoth77: '预计3个工作日内到账',
  refundMoth78: '退款到银行卡',
  refundMoth79: '实时到账',
  refundMoth80: '退款至南航账户',
  refundMoth81: '实时到账',
  refundMoth82: '额外里程及优惠券奖励',
  refundMoth83: '额外里程奖励',
  refCupon1: '航段选择',
  refCupon2: '不限制',
  refCupon3: '极速退款',
  refCupon4: '原渠道退款',
  refCupon5: function refCupon5(a, b) {
    return '\u4EAB\u53D7\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1\u514D\u8D39\uFF0C\u6700\u9AD8\u53EF\u62B5' + a + b;
  },
  refCupon6: function refCupon6(a, b, c) {
    return '\u4EAB\u53D7\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1' + Number(a) / 10 + '\u6298\uFF0C\u6700\u9AD8\u53EF\u62B5' + b + c;
  },
  refCupon7: function refCupon7(a, b, c) {
    return '\u5355\u6B21\u4EA7\u54C1/\u670D\u52A1\u6EE1' + a + b / (Number(c) / 100) + '\uFF08\u542B\uFF09\u53EF\u4F7F\u7528';
  },
  refCupon8: '仅会员本人',
  refCupon9: '额外优惠券奖励',
  refCupon0: '仅会员本人及其受让人',
  refCupon11: '退票费券',
  refCupon12: '多品类券',
  refCupon13: '不满足航线限制',
  refCupon14: '不可与已选优惠券叠加使用',
  refCupon15: '机票',
  refCupon16: '选座',
  refCupon17: '行李',
  refCupon18: '餐食',
  refCupon19: '休息室',
  refCuponDoor: '接送机专车',
  refCupon20: '中转住宿',
  refCupon21: 'PLUS会员',
  refCupon22: '免费变更',
  refCupon23: '候补升舱',
  refCupon24: '登机口升舱',
  refCupon25: '一人多座',
  refCupon26: '现场逾重行李',
  refCupon27: '套票',
  refCupon28: '机场贵宾服务',
  refCupon29: '现场升舱',
  refCupon30: '机票兑换K位',
  refCupon31: '优惠券不适用于该航段',
  refCupon32: '仅限实名认证会员使用',
  refCupon33: '确认',
  refCupon3354: '返回',
  refCupon34: '不可用原因',
  refCupon35: '使用期限：',
  refCupon36: '折',
  refCupon37: '次',
  refCupon38: '使用说明',
  refCupon39: '优惠券号',
  refCupon40: '最高抵用',
  refCupon41: '价格限制',
  refCupon42: '适用业务',
  refCupon43: '航班时刻',
  refCupon44: '订单所选退票航段的航班时刻需在以下范围内：',
  refCupon45: '不限',
  refCupon46: '订单内所有航班的出发日期必须在以下日期范围内：',
  refCupon47: '不限实名认证会员',
  refCupon48: '限制实名认证会员使用',
  refCupon49: '适用航线',
  refCupon50: '可使用的退款方式',
  refCupon51: '退票时限',
  refCupon52: function refCupon52(a) {
    return '\u4EC5\u9650\u539F\u822A\u73ED\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u4F7F\u7528';
  },
  refCupon53: function refCupon53(a) {
    return '\u4EC5\u9650\u539F\u822A\u73ED\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u4F7F\u7528';
  },
  refCupon54: function refCupon54(a) {
    return '\u4EC5\u9650' + a + '\u8231\u4F4D\u5BA2\u7968\u4F7F\u7528';
  },
  refCupon55: function refCupon55(a) {
    return '\u4EC5\u9650\u4ED8\u6B3E\u6E20\u9053\u4E3A' + a + '\u7684\u5BA2\u7968\u4F7F\u7528';
  },
  refCupon56: function refCupon56(a) {
    return '\u4EC5' + a + '\u6E20\u9053\u4F7F\u7528';
  },
  refCupon57: '舱位限制',
  refCupon58: '支付方式',
  refCupon59: '使用渠道',
  refCupon60: '退票场景',
  selectDate1: '继续',
  selectDate2: '重新选择',
  selectDate22: '升舱',
  selectDate3: function selectDate3(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u5DF2\u8D85\u51FA\u9650\u5236\uFF0C\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF08\u53EF\u80FD\u9700\u652F\u4ED8\u8D39\u7528\uFF09\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u70B9\u51FB\u3010\u91CD\u65B0\u9009\u62E9\u3011\uFF0C\u53EF\u91CD\u65B0\u9009\u62E9\u65E5\u671F\u3002';
  },
  selectDate33: function selectDate33(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u7B26\u5408\u975E\u81EA\u613F\u53D8\u66F4\u65E5\u671F\u8303\u56F4\uFF0C\u5C06\u6309\u975E\u81EA\u613F\u53D8\u66F4\u5904\u7406\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u975E\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u5982\u9700\u5347\u8231\u8BF7\u70B9\u51FB\u3010\u5347\u8231\u3011\uFF08\u5B58\u5728\u5347\u8231\u8D39\u7528\uFF09';
  },
  selectDate4: '温馨提示：因儿童或婴儿旅客不支持购买“加赠”产品，如继续办理将为所有乘客选择普通客票产品；如需将携带儿童或婴儿的旅客客票变更为“加赠”产品，请联系南航客服95539办理。',
  selectDate5: '出发日期',
  selectDate51212: '您已选择',
  selectDate5121: '（组合）',
  selectDate512: '为您推荐',
  selectDate6: '日',
  selectDate7: '一',
  selectDate8: '二',
  selectDate9: '三',
  selectDate0: '四',
  selectDate11: '五',
  selectDate12: '六',
  selectDate13: '年',
  selectDate14: '月',
  selectDate15: '今天',
  selectDate16: function selectDate16(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u5DF2\u8D85\u51FA\u9650\u5236\uFF0C\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF08\u53EF\u80FD\u9700\u652F\u4ED8\u8D39\u7528\uFF09\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u70B9\u51FB\u3010\u91CD\u65B0\u9009\u62E9\u3011\uFF0C\u53EF\u91CD\u65B0\u9009\u62E9\u65E5\u671F\u3002';
  },
  ticketChanges1: '周',
  ticketChanges2: '全部日期',
  ticketChanges3: '退改说明',
  ticketChanges4: '伤残人民警察',
  ticketChanges5: '残疾军人',
  ticketChanges6: function ticketChanges6(a) {
    return '\u4EE5\u4E0B\u4E3A' + a + '\u9000\u6539\u8BF4\u660E\u6807\u6CE8,\u4EC5\u4F9B\u53C2\u8003,\u8BF7\u4EE5\u5B9E\u9645\u60C5\u51B5\u4E3A\u51C6';
  },
  ticketChanges7: '免费托运行李额',
  ticketChanges8: '新航班退改规则',
  ticketChanges9: '变更费',
  ticketChanges9123: '变更费说明',
  ticketChanges0: '变更费/次',
  ticketChanges022: '说明',
  ticketChanges11: '变更时间',
  ticketChanges12: '起飞前24小时之前',
  ticketChanges13: '起飞前24小时之后',
  ticketChanges14: '变更详细说明',
  ticketChanges15: '退票费说明',
  ticketChanges16: '退票时间',
  ticketChanges17: '原客票兑换里程的',
  ticketChanges18: '原客票兑换里程的50%',
  ticketChanges19: '退票详细说明',
  ticketChanges20: '补充说明',
  ticketChanges21: '<span>\u5BA2\u7968\u53D8\u66F4\u540E\u9000\u7968\uFF0C\u6240\u6536\u7684\u53D8\u66F4\u624B\u7EED\u8D39\u4E0D\u9000\uFF0C\u5BA2\u7968\u8BA2\u5EA7\u8231\u4F4D\u66F4\u6539\u540E\u5982\u53C8\u53D1\u751F\u9000\u7968\uFF0C\u7968\u4EF7\u5DEE\u90E8\u5206\u6309\u53D8\u66F4\u540E\u65B0\u7968\u4EF7\u8BA2\u5EA7\u8231\u4F4D\u624B\u7EED\u8D39\u6807\u51C6\u529E\u7406\uFF0C\u539F\u7968\u4EF7\u6309\u53D8\u66F4\u524D\u8BA2\u5EA7\u8231\u4F4D\u9000\u7968\u624B\u7EED\u8D39\u6807\u51C6\u529E\u7406\uFF0C\u5408\u8BA1\u6536\u53D6\u9000\u7968\u8D39\uFF0C\u4E14\u539F\u7968\u53D8\u66F4\u624B\u7EED\u8D39\u4E0D\u9000\u3002</span>',
  ticketChanges22: '<span>\u5BA2\u7968\u53D8\u66F4\u540E\u9000\u7968\uFF0C\u6240\u6536\u7684\u53D8\u66F4\u624B\u7EED\u8D39\u4E0D\u9000\uFF0C\u5BA2\u7968\u8BA2\u5EA7\u8231\u4F4D\u66F4\u6539\u540E\u5982\u53C8\u53D1\u751F\u9000\u7968\uFF0C\u7968\u4EF7\u5DEE\u90E8\u5206\u6309\u53D8\u66F4\u540E\u65B0\u7968\u4EF7\u8BA2\u5EA7\u8231\u4F4D\u624B\u7EED\u8D39\u6807\u51C6\u529E\u7406\uFF0C\u5176\u4ED6\u6309\u53D8\u66F4\u524D\u8BA2\u5EA7\u8231\u4F4D\u9000\u7968\u624B\u7EED\u8D39\u6807\u51C6\u529E\u7406\uFF0C\u5408\u7406\u6536\u53D6\u9000\u7968\u8D39\u3002</span><span>\u6539\u671F\u8D39\u4E0E\u5347\u8231\u8D39\u540C\u65F6\u53D1\u751F\u65F6,\u5219\u9700\u540C\u65F6\u6536\u53D6\u6539\u671F\u8D39\u548C\u5347\u8231\u5DEE\u989D\u3002</span>',
  ticketChanges23: '客票变更后退票，所收的变更手续费不退',
  ticketChanges24: '售罄',
  ticketChanges25: '余票不足',
  ticketChanges2589: '余位不足',
  ticketChanges2512: '余票',
  ticketChanges26: '经济舱',
  ticketChanges27: '明珠经济舱',
  ticketChanges28: '公务舱',
  ticketChanges281: '头等舱',
  ticketChanges29: '全价',
  ticketChanges2943: '座位靠前 间距更宽',
  ticketChanges294333: '退改条件及行李额',
  ticketChanges2935: '享南航贵宾室 优先机场服务',
  ticketChanges30: '升舱变更费优惠',
  ticketChanges31: '额外获得',
  ticketChanges32: '免费行李',
  ticketChanges33: '已选航班',
  ticketChanges34: '第',
  ticketChanges35: '程',
  ticketChanges35j: '起',
  ticketChanges35jf: '段',
  ticketChanges36: '手续费 + 票价差',
  ticketChanges37: '票价差',
  ticketChanges38: '中转：',
  ticketChanges39: '停留约',
  ticketChanges40: '有餐食',
  ticketChanges41: '无餐食',
  ticketChanges42: '经停：',
  ticketChanges42a: '次日达',
  ticketChanges43: function ticketChanges43(a) {
    return '\u8BE5\u822A\u73ED\u4E3A\n            ' + a + '\n            \u627F\u8FD0\u7684\u5357\u822A\u4EE3\u7801\u5171\u4EAB\u822A\u73ED\uFF0C\u767B\u673A\u524D\u8BF7\u5230\n            ' + a + '\n            \u503C\u673A\u67DC\u53F0\u529E\u7406\u503C\u673A\u3002';
  },
  ticketChanges46: '实际承运',
  ticketChanges47: '收起',
  ticketChanges48: '展开',
  ticketChanges49: '航班详情',
  ticketChanges50: function ticketChanges50(a) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0A\u4E00\u822A\u73ED\u4E0D\u8DB3' + a / 60000 + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges5aa: function ticketChanges5aa(a) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + a / 60000 + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges51: function ticketChanges51(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u4E0E\u4E0A\u4E00\u822A\u73ED\u8854\u63A5\u65F6\u95F4\u4E0D\u8DB3' + (a === true ? b : c) + '\u5206\u949F\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges53: function ticketChanges53(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === 0 ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges54: function ticketChanges54(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === true ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges55: function ticketChanges55(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === 0 ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges56: function ticketChanges56(a, b, c) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u8DDD\u79BB\u4E0B\u4E00\u822A\u73ED\u4E0D\u8DB3' + (a === true ? b : c) + '\u5206\u949F\uFF0C\u4E3A\u4E86\u60A8\u7684\u987A\u5229\u51FA\u884C\uFF0C\u8BF7\u9009\u62E9\u5176\u5B83\u822A\u73ED\u3002';
  },
  ticketChanges57: function ticketChanges57(a, b) {
    return '\u60A8\u597D\uFF01\u65B0\u822A\u73ED\u65E5\u671F\u5728\u539F\u822A\u73ED\u65E5\u671F\u524D' + a + '\u5929\uFF0C\u540E' + b + '\u5929\uFF08\u542B\u822A\u73ED\u8D77\u98DE\u5F53\u5929\uFF09\u5185\u53EF\u8FDB\u884C\u975E\u81EA\u613F\u53D8\u66F4\uFF08\u514D\u6536\u624B\u7EED\u8D39\uFF09\uFF0C\u5F53\u524D\u60A8\u6240\u9009\u65E5\u671F\u5DF2\u8D85\u51FA\u9650\u5236\uFF0C\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF08\u53EF\u80FD\u9700\u652F\u4ED8\u8D39\u7528\uFF09\u3002\u70B9\u51FB\u3010\u7EE7\u7EED\u3011\uFF0C\u672C\u6B21\u5C06\u6309\u81EA\u613F\u53D8\u66F4\u5904\u7406\uFF0C\u70B9\u51FB\u3010\u91CD\u65B0\u9009\u62E9\u3011\uFF0C\u53EF\u91CD\u65B0\u9009\u62E9\u65E5\u671F\u3002';
  },
  ticketChanges58: function ticketChanges58(a, b) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u81F3' + b + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges59: function ticketChanges59(a, b) {
    return '\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u81F3' + b + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges60: function ticketChanges60(a, b) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u81F3\u8D77\u98DE\u540E' + b + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges61: function ticketChanges61(a) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u4E4B\u540E';
  },
  ticketChanges62: function ticketChanges62(a) {
    return '\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u4E4B\u5916';
  },
  ticketChanges63: function ticketChanges63(a) {
    return '\u8D77\u98DE\u524D' + a + '\u5C0F\u65F6\u4E4B\u524D';
  },
  ticketChanges64: function ticketChanges64(a) {
    return '\u8D77\u98DE\u540E' + a + '\u5C0F\u65F6\u4E4B\u5185';
  },
  ticketChanges65: '不支持在线变更60分钟内起飞的航班。',
  ticketChanges66: '本次航班临近起飞时间，请先联系在线客服咨询，或与值机柜台确认仍可值机后再预订，因误机产生的费用须自行承担。',
  ticketChanges67: '同意并继续',
  ticketChanges68: '您好,如您变更至首都机场航班,您的南航北京大兴无限次套票奖励机票权益将失效作废',
  ticketChanges69: '您好,如您变更至代码共享航班,您的南航北京大兴无限次套票奖励机票权益将失效作废',
  ticketChanges70: '取消变更',
  ticketChanges71: '继续变更',
  ticketChanges71a: function ticketChanges71a(a, b) {
    return '\u6CE8\uFF1A\u59CB\u53D1\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + a + '\uFF0C\u5230\u8FBE\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + b + '\uFF0C\u8BF7\u52A1\u5FC5\u786E\u8BA4';
  },
  ticketChanges71s: function ticketChanges71s(a) {
    return '\u6CE8\uFF1A\u59CB\u53D1\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + a + '\uFF0C\u8BF7\u52A1\u5FC5\u786E\u8BA4';
  },
  ticketChanges71d: function ticketChanges71d(a) {
    return '\u6CE8\uFF1A\u5230\u8FBE\u673A\u573A\u5C06\u53D8\u66F4\u4E3A' + a + '\uFF0C\u8BF7\u52A1\u5FC5\u786E\u8BA4';
  },
  ticketChanges72: '部分航班始发地改为',
  ticketChanges73: '部分航班目的地改为',
  ticketChanges74: '，请注意区分。',
  ticketChanges75: '更换行程',
  updateDetail0: '单号：',
  updateDetail1: '变更单：',
  updateDetail2: '退票单：',
  updateDetail3: '票号: ',
  updateDetail4: '票价(不含税费)',
  updateDetail5: '总价 : ',
  updateDetail6: '总变更费 : ',
  updateDetail7: '应退金额 : ',
  updateDetail8: '取消行程成功',
  updateDetail9: '取消行程失败',
  updateDetail10: '已提交未确认',
  updateDetail11: '已确认待退票',
  updateDetail12: '已退票',
  updateDetail13: '已取消',
  updateDetail14: '已调账',
  updateDetail15: '已退款',
  updateDetail16: '已关闭',
  updateDetail17: '已受理',
  updateDetail18: '处理中',
  updateDetail19: '处理失败',
  updateDetail21: '处理成功',
  updateDetail22: '审核中',
  updateDetail23: '审核不通过',
  updateDetail24: '待支付',
  updateDetail25: '支付失败',
  updateDetail26: '退款处理中',
  updateDetail27: '自动处理中',
  updateDetail28: '变更失败',
  updateDetail29: '退款异常',
  updateDetail30: '待人工处理',
  updateDetail31: '人工处理中',
  updateDetail32: '待电话确认',
  updateDetail33: '重新提交',
  updateDetail34: '放弃变更',
  updateDetail35: '已电话通知',
  updateDetail36: '变更成功',
  updateDetail37: '退款成功',
  updateDetail38: '状态错误',
  updateDetail39: '您好，外币客票暂不支持小程序端/H5/APP处理，请前往官网办理，谢谢。',
  updateDetail40: function updateDetail40(a, b) {
    return '\u672C\u6B21\u53D8\u66F4\u9700\u6263\u51CF' + a + b + '\u516C\u91CC\uFF0C\u5982\u4EA4\u6613\u5931\u8D25\u7CFB\u7EDF\u5C06\u5168\u989D\u9000\u8FD8' + a + '\u3002';
  },
  updateDetail4122: '备注',
  updateDetail41: '自愿变更可能收取一定的手续费及票价价差；航班延误或取消，符合规定的允许免费改期一次。',
  updateDetail42: '当客票包含多个使用规则时，将按照发生变更的航程中最严格的使用规则执行。变更费按各变更航段最高收费标准收取，按次计费。',
  updateDetail43: '客票变更需在客票有效期内进行。',
  updateDetail44: '若变更费为待审核，具体变更费用以审核后短信中的金额为准。',
  updateDetail45: '自愿退票可能会收取一定手续费；航班延误或取消，符合规定的可以免手续办理所有未使用航段的退票。',
  updateDetail46: '当客票包含多个使用规则时，将按照全航程最严格的使用规则执行。并且如客票已部分使用，退票时，需扣除已使用航段上相应的适用票价及已使用税款，收取退票手续费和误机费（如有）。',
  updateDetail47: '若退票费为待审核，具体退票费用以审核后短信中的金额为准，提交退票后不得取消。',
  updateDetail48: '所有未使用的可退航段需一起申请退票。',
  updateDetail49: '2-11岁儿童及2岁以下占座婴儿，变更/退票时收取与成人相同的费用；2岁以下不占座婴儿，变更/退票时不收取费用。',
  updateDetail50: '以上规定仅供参考，其余未说明事项请以南航实际规定为准，如有疑问，请联系95539。',
  updateDetail51: '行程已取消',
  updateDetail52: '客票号',
  updateDetail53: '退改费用及更多退改规则，',
  updateDetail54: '请查询“退改说明”',
  updateDetail55: '证件号',
  updateDetail56: '变更',
  updateDetail57: '退票',
  updateDetail5723: '手续费：',
  updateDetail58: '去支付',
  updateDetail59: '可输入票号/证件号/姓名进行搜索',
  updateDetail60: '票号或证件号或姓名有误',
  updateDetail61: '重新登录',
  updateDetail62: '当前您没有可办理退改的机票。',
  updateDetail63: '已处理',
  updateDetail64: '抱歉！暂无法找到您可退改的客票。建议您先完成',
  updateDetail65: '您现在暂无可退改订单/客票',
  updateDetail66: '暂无符合您搜索的机票',
  updateDetail67: '暂未查询到符合要求的客票/订单',
  updateDetail68: '点击',
  updateDetail69: '查询更多客票',
  updateDetail70: '航班时间',
  updateDetail71: '旅客类型',
  updateDetail72: '该功能已关闭，暂不支持访问',
  updateDetail73: '请输入错购客票信息',
  updateDetail74: '请输入新购客票信息',
  updateDetail75: '请选择客票错购场景',
  updateDetail76: '请输入客票号！',
  updateDetail77: '请输入正确的客票号！',
  updateDetail78: '点击选票或输入票号',
  updateDetail79: '出发',
  updateDetail80: '暂无搜索结果',
  updateDetail81: '正在查询...',
  updateDetail82: '错购客票',
  updateDetail83: '点击选票或输入新票号',
  updateDetail84: '新购客票',
  updateDetail85: '错购场景',
  updateDetail86: '提交申请',
  updateDetail87: '机票退改',
  updateDetail88: '变更进度',
  updateDetail89: '取消行程进度',
  updateDetail90: '退票进度',

  gender: '性别',
  nationality: '国籍',
  tipError: function tipError(a, b) {
    return '\u65C5\u5BA2' + a + '\u7684' + b + '\u683C\u5F0F\u9519\u8BEF';
  },
  certiIssuing: '证件签发地',
  supplement: function supplement(a) {
    return '\u8BF7\u8865\u5145\u65C5\u5BA2' + a + '\u7684\u4FE1\u606F';
  },
  suppleMessage: function suppleMessage(a, b) {
    return '\u8BF7\u8865\u5145\u65C5\u5BA2' + a + '\u7684' + b;
  },
  passenger: '旅客',
  save: '保存',
  SuppPsginfo: '补充旅客信息',
  male: '男',
  female: '女',
  selectDetailInfo: '请选择详细信息',
  prePsgMessage: '请确认所填姓名和乘机证件一致',
  mandatory: '必选',
  dateBirth: '出生日期',
  country: '国家/地区',
  documentType: '证件类型',
  Required: '必填',
  validityPeriod: '证件有效期',
  additionalTip: '购买产品数量不可超过成人数量',
  additionalTip2: '该宝贝不能购买更多哦',
  additionalTip3: '选择休息室',
  checked: '已选择',
  checked123: '/人起',
  recommends: '为您推荐一下服务',
  orderTotal: '订单总额',
  details: '明细',
  addPsgTip: '您好,本次变更需补充旅客信息',
  replenish: '去补充',
  replenish123: '请输入公务员信息。',
  verifyTip: '校验失败，请稍后重试或联系在线客服咨询。',
  verifyTip2: '输入的公务员姓名与变更乘机人不符，请重新输入。',
  verifyTip3: '输入的银行卡bin号位数不符，请重新输入。',
  verifyTip4: '本次变更需扣减里程公里，如交易失败系统将全额退还里程',
  verifyTip5: '自愿变更后，竞拍调整费用（如有）将自动退款。',
  verifyTip6: '非自愿变更后，竞拍调整费用（如有）是否可退将与变更后新客票状态关联。',
  chooseFood: '请选择是否机上用餐',
  yes: '是',
  no: '否',
  good: '好的',
  no123: '奖励',
  foodSelect: function foodSelect(a) {
    return '\u52FE\u9009\u201C\u5426\u201D\uFF0C\u53D6\u6D88\u673A\u4E0A\u7528\u9910\uFF0C\u83B7\u53D6' + a + '\u5956\u52B1';
  },
  greenFlight: '绿色飞行',
  benefits: '权益福利',
  civilMsg: '请输入公务员信息',
  foodPsg: '请选择机上用餐的旅客',
  greenPsg: '请选择绿色飞行的旅客',
  selectAll: '全选',
  submitChange: '提交变更',
  inputPsgName: '请输入联系人姓名',
  telephone: '联系手机',
  telephone123: '请输入联系手机',
  VerificationCode: '验证码',
  rcRuleTip5: '可能产生相应退票手续费',
  rcRuleTip6: '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为自愿退票，按照',
  rcRuleTip1: '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为自愿退票，按照退改规则可能产生相应退票手续费。',
  rcRuleTip2: '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为非自愿退票，免收退票手续费。',
  rcRuleTip3: '此次为自愿退票，按照退改规则可能产生相应退票手续费。',
  rcRuleTip4: '此次为非自愿退票，免收退票手续费。',
  rfInstruction: '退改签说明',
  unused: '完全未使用',
  partiallyUsed: '部分已使用',
  noChange: '不得变更',
  noRefund: '不得退票',
  referenceTip: '以上说明仅供参考，请以实际情况说明。',
  officialCard: '是指公务卡卡号的前6位；<br/>例如：工行的公务员卡Bin号是628288；',
  bankCardNo: '银行卡Bin号',
  inpuitCardholder: '请输入持卡人',
  reCode2: '推荐码（选填）',
  inputRecode: '请输入员工推荐码',
  reCode1: '推荐码',
  segPsg: '/航段/人',
  people: '/人',
  people123: '人',
  fillInfo: '填写信息',
  gotoRc: '前往退改',
  queryTip3: '当前您没有已取消行程的订单',
  queryTip4: '当前您没有可办理取消行程的机票。',
  queryTip5: '未找到相关客票/订单信息',
  ticketN: '票号：',
  ticketN123: '乘机人',
  ticketNow: '当前',
  totalPrice: '总价：',
  totalChangeFee: '总变更费：',
  muTip: '该客票暂不支持自助取消行程，请联系东航客服95530处理。',
  caTip: '该客票暂不支持自助取消行程，请联系国航客服95583处理。',
  huTip: '该客票暂不支持自助取消行程，请联系海航客服95339处理。',
  psgTicNo: '客票号：',
  cancellationTip: '取消行程费用及更多规则，请查询“取消行程说明”',
  cancellationInt: '取消行程说明',
  reCertification: '重新认证',
  faceFail: '对不起，未通过实名认证',
  fail: '失败',
  faceSuccess: '恭喜您，通过实名认证',
  success: '成功',
  weekDay: '一,二,三,四,五,六,日',
  discountRecom: '优惠推荐',
  csair: '中国南方航空',
  changeDes: '变更说明',
  refundDes: '退票说明',
  couponUse: '可用优惠券',
  couponUnUse: '不可用优惠券',
  close: '关闭',
  tikcetPrice: '票面价：',
  refundhfee: '当前退票手续费：',
  changehfee: '当前变更手续费：',
  irefundRule: '客票符合非自愿退改条件，费用计算按非自愿退改规则进行处理',
  calTip1: '按当前时间和自愿退票计算',
  calTip2: '按当前时间和自愿变更计算',
  immeRefund: '马上退票',
  changeSeg: '变更航程',
  cancelTip1: '若您的航程后续仍需出行，但出行时间待定，可取消行程，待出行时间确认后，对客票进行变更操作，变更手续费按当前取消行程时间计算。',
  cancelTip2: '取消行程后，将无法再乘坐本航班，且无法恢复。',
  costCal: '费用计算',
  percentage: '百分比展示',
  numerical: '数值展示',
  process: '申请流程',
  viewDe: '查看详情',
  free: '免费',
  onlyTax: '仅退税费',
  front: '前',
  timeNode: '时间节点',
  noTimeLimit: '不限制时间',
  couponTip8: '变更费券',
  couponTip10: '不满足价格限制',
  couponTip12: '与已选优惠券的支付方式不可同时使用',
  pSeat: '国内优选座位',
  speedyBoarding: '快速登机',
  couponInfo1: '因所选择机票变更手续费为0，无需使用优惠券',
  couponInfo5: '仅限会员本人使用',
  couponInfo6: '航班日期不符合条件',
  couponInfo9: '订单所选原航班的航班时刻需在以下范围内：',
  couponInfo11: '最高抵用',
  couponInfo12: '价格限制',
  couponInfo14: '用于变更时，可用于以下变更后舱位',
  couponInfo15: '当日变更',
  couponInfo16: '仅航班当天允许使用',
  couponInfo17: '可用的支付方式',
  couponInfo18: '变更时限',
  couponInfo22: '客票预定后',
  applicationDate: '适用日期',
  to: '至',
  except: '除外',
  outinHours: '小时之外',
  networkFail1: '您的网络好像不给力哦',
  networkFail2: '服务器繁忙，请您稍后再试',
  discounted: '降价客票',
  discountedTip1: '请输入旧客票信息',
  discountedTip2: '请输入新客票信息',
  discountedTip6: '新旧客票号不能相同，请重新输入',
  oldTic: '旧客票',
  newTic: '新客票',
  login: '登录',
  idTikcetNo: '证件号或者票号',
  surnamePsg: '乘机人的姓氏',
  namePsg: '乘机人的名字',
  kindTip1: '1.请使用乘机人的姓名、证件号或者票号进行查询。',
  kindTip2: '2.变更适用于南航国内客票，以及航班不正常情况下的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip3: '3.退票适用于南航国内客票，以及南航官网、APP、微信小程序、微信公众号、客服渠道购买的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。',
  kindTip4: '4.对于以上暂未支持自助退改的客票，请联系南航客服95539办理退改。',
  kindTip5: '请使用乘机人的姓名,证件号或票号如<br />7840000000000进行查询',
  queryRc: '查询退改记录',
  confirmMsg: '请确认您的信息',
  invoice2: '纳税人识别号:',
  invoice3: '公司地址:',
  invoice4: '公司电话:',
  invoice5: '公司开户行:',
  invoice6: '公司账号:',
  invoice7: '收票人手机:',
  invoice9: '退票旅客:',
  invoice10: '请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收',
  invoiceApoint: '提交发票预约信息',
  inputInvoice: '请输入您的电子发票信息',
  invoiceCont: '发票内容: 退票手续费',
  invoiceType: '发票类型:',
  invoiceMsg1: '个人',
  invoiceMsg2: '企业',
  invoiceMsg3: '非企业性单位',
  invoiceMsg4: '选择发票抬头',
  invoiceMsg5: '请输入公司名称',
  invoiceMsg6: '请输入纳税人识别号',
  optional: '选填',
  invoiceMsg7: '请输入联系人邮箱',
  invoiceMsg8: '请输入联系人手机',
  invoiceTip1: '为同行人开具:',
  invoiceTip2: '1.请您确认填写信息是否正确，邮箱请填写真实地址，否则将无法收到电子发票邮件！',
  invoiceTip3: '2.税总（2017）16号文件规定，2017年7月起，企业必须提供税号才能开票，否则不能作为报销凭据。',
  view: '查看',
  companyName: '公司名称',
  TaxCode: '纳税人识别码',
  companyAddress: '公司地址',
  companyPhone: '公司电话',
  openBank: '公司开户行',
  companyAccount: '公司账号',
  voiceTitle: '我的发票抬头',
  default: '默认',
  taxId: '税号:',
  addPsg: '添加同行人',
  selectDate: '选择新航班日期',
  additional1: '请选择需要取消的附加产品',
  additional2: '提交退票申请后，机票包含的',
  additional3: '将跟随机票一起作废，请谨慎操作。',
  trainTip1: function trainTip1(a) {
    return '\u6B64\u4E3A\u7A7A\u94C1\u8054\u8FD0\u8BA2\u5355\uFF0C\u65C5\u5BA2' + a + '\u4F7F\u7528\u4E86\u706B\u8F66\u7968\u4F18\u60E0\u5238\uFF0C\u673A\u7968\u4E0E\u706B\u8F66\u7968\u9700\u4E00\u8D77\u9000\u8BA2\uFF0C\u8C22\u8C22';
  },
  trainTip2: '此为空铁联运订单，机票与火车票需一起退订，谢谢',
  selectResaon: '请选择退票原因！',
  notCancel: '暂不取消',
  notCancel123: '确认取消',
  domestic: '国内',
  international: '国际',
  additional5: '您好！退票成功后请留意额度返回情况，如未成功返回，可登录员工旅行专区申请返回额度。',
  firstJn: '第一程',
  firstJn12321: '到',
  asd0: '自愿退票',
  asd1: '个人原因',
  asd2: '非自愿退票',
  asd3: '航班延误',
  asd4: '航班取消',
  asd5: '航班超售',
  asd6: '航班变动',
  asd7: '因病退票',
  asd8: '其它',

  inputTip1: '系统繁忙，请稍后重试！您也可以联系原出票单位办理。',
  inputTip2: '请输入联系人',
  inputTip3: '请输入手机号',
  inputTip4: '联系手机:',
  trainPrice: '高铁票价',
  trainHandFee: '高铁手续费',
  fareCost: '票价',
  fuelTaxTotal: '燃油费差',
  airportTaxTotal: '机场税差',
  premium: '可退保险费',
  airportTax: '机场税',
  fuelCost: '燃油费',
  counterFee: '手续费',
  refundCoupon: '退票优惠券',
  totalTax: '可退税费',
  ticketPrice: '票价',
  deductionMileage: '抵扣里程',
  mileageCharge: '里程手续费',
  discontedFee: '手续费优惠',
  retainUpgrades: '退票挽留升舱',
  mileageTxt: '实际到账里程数请登录会员里程账户查看。',
  actualMileage: '实退里程',
  expiredMileage: '过期里程',
  delayMileage: '延期里程',
  actualExpired: '实际过期里程',
  reSubmitTip1: '提交退票申请后，机票包含的',
  reSubmitTip2: '将跟随机票一起作废，请谨慎操作。',
  reSubmitTip3: '1.以上里程过期信息仅供参考；',
  reSubmitTip4: ' 2.非自愿退票退还的奖励里程将按原有效期顺延 6 个月；',
  reSubmitTip5: ' 3.退还到账里程如已过期则视为失效，请以实际到账为准。',
  reSubmitTip6: '此次为非自愿退票，免收退票手续费。',
  reSubmitTip7: '此次为自愿退票，按照退改规则可能产生相应退票手续费。',
  reSubmitTip8: '具体退还金额以审核为准，退还金额将在审核通过后短信通知您。此次为非自愿退票，免收退票手续费。',
  reSubmitTip9: '因近期退票业务量大，您的退票申请预计7天内完成退款，手续费将参照客票使用条件计算，具体退还金额请以审核结果为准。',
  reSubmitTip10: '因疫情防控需要，请密切关注南航官网发布的特殊退改政策公告。需要办理特殊退改的客票，请联系原购票单位或者南航客服95539办理。',
  caRules: '计算规则',
  couponQuantity: '优惠券数量',
  couponperiod: '优惠券有效期',
  period: '有效期',
  mileageperiod: '里程有效期',
  aa: '张',
  coValue: '优惠券面值',
  mileageLimit: '里程额度',
  limit: '额度',
  coCode: '优惠券券码',
  giveCou: '赠送优惠券',
  giveMileage: '赠送里程',
  feeInfo: '费用信息',
  addSvc: '附加服务',
  guaranteeSvc: '保障服务',
  trainFee: '应退高铁金额',
  expiredInfo: '过期信息',
  expiredInfo123: '费用总计',
  voucher: '代金券',
  refundMileage: '应退里程',
  seletedCoupon: '已选优惠券',
  couponSelectTipR: '可用于抵扣退票手续费',
  couponSelectTipC: '可用于抵扣变更手续费',
  csairAccount: ' 南航账户',
  couponUseTip1: '可在南航官方渠道为本人或他人购买机票、选座、行李额、贵宾休息室等产品时全额抵扣，也可以拆分多次使用，有效期自退票之日起2年有效，',
  couponUseTip2: '不可提现。',
  couponUseTip3: function couponUseTip3(a, b) {
    return '\u53EF\u5728\u5357\u822A\u5B98\u65B9\u6E20\u9053\u8D2D\u4E70\u673A\u7968\u65F6\u90E8\u5206\u62B5\u6263\uFF0C\u4E0D\u53EF\u62C6\u5206\u591A\u6B21\u4F7F\u7528\uFF0C\u4EC5\u9650\n                ' + a + '\uFF08\u5361\u53F7\uFF1A' + b + '\n                \uFF09\u672C\u4EBA\u4F7F\u7528\uFF0C\n                <strong>\u4E0D\u53EF\u63D0\u73B0\uFF0C\u4E0D\u9000\u4E0D\u8865</strong>\n                \uFF0C\u4F7F\u7528\u89C4\u5219\u4EE5\u5B9E\u9645\u5230\u8D26\u67E5\u8BE2\u7ED3\u679C\u4E3A\u51C6\u3002';
  },
  actualTrans: '实际承运',
  transportation1: '该航班为',
  transportation2: '承运的南航代码共享航班，登机前请到',
  transportation3: '值机柜台办理值机。',
  transportation4: '按住滑块,拖动完成拼图',
  transportation5: '请登录退改客票的购票人或乘机人帐号进行操作',
  tips: '提示',
  memberShip1: '诚邀非会员:',
  memberShip2: '申请加入南航会员明珠俱乐部,尊享会员权益',
  skip: '跳过',
  memberShip3: '单个文件名不超过150字',
  memberShip4: '填写信息',
  memberShip5: '因您的退票手续费需人工计算，优惠券抵扣金额将根据优惠券使用条件和人工计算结果得出，详细计算规则请查看优惠券使用条件。',
  memberShip6: '请输入明珠会员密码',
  memberShip7: '由于银联系统对于姓名包含特殊符号暂时没有统一标准，认证失败可尝试取消特殊符号选项再试一次。',
  reInput: '重新输入',
  feedback: '我要反馈',
  manualService: '在线人工客服',
  onliveService: '在线客服',
  automatic1: '自动加载中...',
  automatic2: '自动处理中...',
  additional: '附加产品',
  addproducts: '增加产品',
  adjustment: '竞拍调整',
  copy: '1份',
  trainTicket: '火车票',
  excessBaggage: '逾重行李',
  paidSeat: '付费选座',
  interval: '间',
  late: '晚',
  Processing1: '正在为您处理...',
  Processing2: '您的变更申请已提交，请稍后在“处理中”或“已退改”列表中查看详情或完成支付。若无法查询到相关变更申请，请重新提交变更，谢谢。',
  Processing3: '您的退票申请已提交，稍后请在“处理中”或“已退改”模块查看。若您无法查询到您的退票申请，请重新点击“退票”按钮申请客票退票，谢谢。',
  progress: '进度条',
  veriTip1: '请输入员工推荐码',
  veriTip2: '验证码输入有误，请重新输入',
  veriTip3: '请确认您是乘机人本人，或已征得乘机人的许可进行取消值机，若非以上情形，您将有可能被追究法律责任。',
  checkTip1: '注：在您成功操作取消值机后将无法登机。',
  checkTip2: '您确定要取消已办理的值机手续吗？',
  seMethod: '选择“退款至南航账户”',
  rewardTip2: '享受额外权益奖励。',
  rewardTip3: '元机票优惠券',
  modify22: '前往修改',
  giveUp: '放弃',
  sureT: '应退',
  sureTs: '实退',
  deleFile: '是否确认删除文件',
  deleteS: '文件已删除，可重新上传文件',
  uploadF: '上传附件',
  File: '附件',
  zhengm: '请上传相关证明文件',
  as1: '特殊退票申请',
  as2: '如因疾病原因，需申请特殊退改，请选择原因后，按指引上传相关证明材料或联系原出票单位办理。',
  as3: '尊敬的旅客，如您有同行人，请在退票申请页选择乘机人处勾选，并一同提交身份证明材料。',
  as4: '疫情防控',
  as5: '病退申请',
  as6: '情况说明',
  as7: '请上传文字版情况说明图片',
  as8: '身份证明',
  as9: '继续添加',
  as0: '疫情证明文件',
  as11: '医疗机构就诊缴费发票或住院押金证明',
  as12: '请上传身份证正反面图片',
  as13: '请确认您是乘机人本人，或已征得乘机人的许可进行取消值机，若非以上情形，您将有可能被追究法律责任。',
  as14: '注：在您成功操作取消值机后将无法登机。',
  as15: '选择新航班',
  load11: '加载中',
  loginFail: '登录失效',
  timeOut: '网络超时',
  yichang: '网络异常',
  title: '温馨提示',
  title_delay: '航班延误/取消',
  title_explain: '退改说明',
  title_Confirm_error: '提交失败',
  applicationSubmission: '申请提交',
  back: '返回',
  okBtn: '确定',
  cancel: '取消',

  goon: '继续',
  myOrder: '我的订单',
  goonRefund: '继续退票',
  goonChange: '继续变更',
  quitChange: '放弃变更',
  allsubmit: '一起提交',
  ressubmit: '重新提交'
}, _defineProperty(_language$morequeryte, 'yes', '是'), _defineProperty(_language$morequeryte, 'no', '否'), _defineProperty(_language$morequeryte, 'keepsubmit', '继续提交'), _defineProperty(_language$morequeryte, 'orderStatusChange', '您好！当前变更单的状态已改变，不可再进行支付'), _defineProperty(_language$morequeryte, 'cardBin', '银行卡Bin'), _defineProperty(_language$morequeryte, 'cardBinMsg', '是指公务卡卡号的前6位;</br>例如:工行的公务卡卡Bin是628288</br>'), _defineProperty(_language$morequeryte, 'updateDetail', {
  title: '温馨提示',
  content: '您好！需先进行实名认证，您可以在移动端按以下任一方式认证：</br></br>1、南航APP首页—我—在线实名认证；</br>2、南航官网首页—服务大厅—在线实名验证；',
  noticket: '您好！根据您输入的信息，未找到可退改的客票，请重新输入。',
  cancelOrder: '您好！您确定要取消该变更单吗? ',
  cancelOrderOk: '取消变更成功！',
  cancelOrderFailed: '抱歉！暂时无法取消变更。请稍后重试或联系南航客服95539。',
  costCalculation: '费用计算',
  huChangeTip: '本渠道仅支持该客票办理自愿变更，若想办理航班不正常改签，请前往海航官网或者APP进行办理，如有疑问请联系在线客服或海航客服95339'
}), _defineProperty(_language$morequeryte, 'endorsedApply', {
  addPsgSuccess: '添加同行人成功',
  OneAdult: '您好！该旅客已进行过航班改期，后续将以改期的航班时间进行变更。',
  ManyAdult: '您好！该旅客已进行过航班改期，本次变更仅限航班时间相同的旅客，航班时间不同的旅客们需分别申请变更。',
  flightDelayOrCancel: "<p>1.国内客票可免费变更航班日期前后7天内（含航班当天）的航班。</p><p style='margin: 0.2rem 0;'>2.国际客票可免费变更航班日期前7天、后14天（含航班当天）的航班。</p><p>3.头等舱、公务舱、明珠经济舱、经济舱全价票可选航班日期不受此限制。</p>",
  needSelectPsg: {
    content: '您好！添加同行人需先选择乘机人。'
  },
  pleaseSelectChangeFlightAndPsg: '请您先勾选所需变更的航段和乘机人！',
  pleaseSelectRefundFlightAndPsg: '请您先勾选所需退票的航段和乘机人！',
  pleaseSelectChangeFlight: '请您先勾选所需变更的航段！',
  pleaseSelectRefundFlight: '请您先勾选所需退票的航段！',
  pleaseSelectTrainFlight: '您好！若需单独退订高铁产品，可通过 “我的订单” - “假期” - “高铁订单” 操作退款',
  pleaseSelectPsg: '请您先勾选乘机人！',
  pleaseSelectHtlight: '您好！若需单独退订酒店产品，可通过“我的订单-酒店”操作退款',
  selectedPsgMustHasAdult: '您好！暂不支持单独儿童变更。如有疑问，请联系南航客服95539处理。',
  selectedPsgbady: '您好！暂不支持单独婴儿自助变更。如有疑问，请联系南航客服95539处理。',
  selectedFlightError: function selectedFlightError(text) {
    return '\u60A8\u597D\uFF01' + text + '\u7684\u822A\u73ED\u9700\u8981\u52FE\u9009\u540E\u65B9\u53EF\u8FDB\u884C\u4E00\u4E0B\u6B65\u64CD\u4F5C\uFF0C\u8BF7\u786E\u5B9A\u662F\u5426\u52FE\u9009\u8BE5\u884C\u6BB5\uFF1F';
  },

  selectedFlightSuccess: '选择成功，请再选择下一段航班日期!',
  onlySelectOneAdultInTAOrder: '您好，此类型客票仅允许选择一个成人乘机人进行退票操作！',
  cancelCheckIn: '取消值机',
  selectMutiplePerson: '该产品同一订单的乘机人需同时退改，请勾选所有乘机人。',
  hotelChangeTip: '该类型订单中所有可变航段和乘机人需一同变更。'
}), _defineProperty(_language$morequeryte, 'selectDateObj', {
  selectedFlightDateBefore: '您好！您选日期不能在前一个航班日期之前，请重新选择日期。',
  selectedFlightDateAfter: '您好！您选日期不能在后一个航班日期之后，请重新选择日期。',
  selectedFlightDateBeyondWQT: '该日期无法享受优惠变更手续费的权益，请确认是否更改日期。',
  selectedFlightDateSeasonTicket: '本期双城旅行产品旅行截止日期为2023年1月5日。您选择变更后的航班日期，后续产品保障不足90日。是否继续？',
  selectedFlightDateExceeds: '抱歉! 中转运价客票要求航班衔接时间不得大于24小时, 请重新选择',
  selectMuFlightDate: '您好！新航班日期在原航班日期前3天，后3天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。'
}), _defineProperty(_language$morequeryte, 'ticketChanges', {
  optionalFlight: '您好！当天除您已订的航班外，无其它可选航班，建议您重新选择日期，如有疑问，请联系在线客服咨询或原出票地办理。',
  electionFlight: '您有一段航班是处于重选状态，请选择完毕再进行其它航班重选！',
  checkpending: '本次变更的费用需要人工审核，在您选择完新航班并提交申请后，客服稍后短信通知您审核结果及变更费用。',
  changeCabin_1: '您好，该航班的明珠经济舱剩余座位不足或售罄，是否变更至经济舱？',
  changeCabin_2: '您好，该航班无明珠经济舱，是否变更至经济舱？',
  compareCabin: function compareCabin(text) {
    return '\u60A8\u6240\u9009\u8231\u4F4D\u4E3A\u964D\u8231\u53D8\u66F4\uFF0C\u5DF2\u5151\u6362' + text + '\u4E0D\u9000\u8FD8\u3002';
  }
}), _defineProperty(_language$morequeryte, 'addPersonMessage', {
  afterSaleChangeConfirm_ok: {
    title: '提交成功',
    content: ''
  },
  afterSaleChangeConfirm_error: "非常抱歉的通知您, 您的改签申请提交失败。 原因可能是您所选航班座位已售空， 或同时改签人数过多造成系统改签出错。你可以拔打<a href='tel://95539 '> <u>95539</u></a>人工服务垂询。",
  afterSaleChangeConfirm_fail: {
    title: '提示',
    content: ''
  }
}), _defineProperty(_language$morequeryte, 'applySubmit', {
  inputContactInfo: {
    content: '请输入并保存联系人信息'
  },
  inputRightContactInfo: '您好！请输入正确的手机号',
  verificationCode: '请输入六位验证码！',
  afterSaleChangeReqPayOK_error: '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或拨打南航客服95539处理。',
  afterSaleRefundApp_error: '尊敬的旅客，您好！退票申请中遇到问题，请重新提交或联系南航客服95539处理。',
  checkTips_fzy: "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；<br/>2、此次为非自愿退票，免收退票手续费。</div>",
  bingtui_zy: "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；<br/>2、您将提交病退申请，若您的材料符合要求，将为您免费办理退票；若您的材料不符合要求，系统将按自愿退票规则进行办理，自愿退票手续费可通过服务大厅“退改计算器”模块查看或联系客服咨询。</div>",
  checkTips_zy: "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/><span>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；</span><br/>2、此次为自愿退票，按照退改规则可能产生相应退票手续费。</div>",
  checkTips_zy_lessFare: function checkTips_zy_lessFare(contentProps) {
    if (contentProps.isDomestic) {
      return '<strong style=\'color:#262626;\'>\u60A8\u597D\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5FEB\u5B8C\u6210\u9000\u6B3E\u5BA1\u6838\uFF0C\u5E76\u77ED\u4FE1\u901A\u77E5\u60A8\u3002</strong><div>\n            <div class="lessFare_tips_area">\n              <div class="lessFare_tipsT">\n                <span>\u5E94\u9000\u91D1\u989D</span>\n                <span>' + (contentProps.curr + contentProps.totalCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u7968\u4EF7</span>\n                <span>' + (contentProps.curr + contentProps.ticketCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u673A\u573A\u7A0E</span>\n                <span>' + (contentProps.curr + contentProps.airTaxCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u71C3\u6CB9\u8D39</span>\n                <span>' + (contentProps.curr + contentProps.ryTaxCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u624B\u7EED\u8D39</span>\n                <span>' + (contentProps.curr + '-' + contentProps.totalCharge) + '</span>\n              </div>\n            </div>\n          </div><div style=\'margin-top: 10px; text-align:left; color:#262626\'>\u6E29\u99A8\u63D0\u793A\uFF1A<br/><span>1\u3001\u60A8\u63D0\u4EA4\u9000\u7968\u540E\u539F\u5B9A\u5EA7\u4F4D\u5C06\u88AB\u53D6\u6D88\uFF0C\u5BA2\u7968\u65E0\u6CD5\u7EE7\u7EED\u4F7F\u7528\uFF0C\u5B9E\u9645\u9000\u8FD8\u91D1\u989D\u5C06\u4EE5\u5BA1\u6838\u7ED3\u679C\u4E3A\u51C6\uFF1B</span><br/>2\u3001\u6B64\u6B21\u4E3A\u81EA\u613F\u9000\u7968\uFF0C\u6309\u7167\u9000\u6539\u89C4\u5219\u53EF\u80FD\u4EA7\u751F\u76F8\u5E94\u9000\u7968\u624B\u7EED\u8D39\u3002</div>';
    } else {
      return '<strong style=\'color:#262626;\'>\u60A8\u597D\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5FEB\u5B8C\u6210\u9000\u6B3E\u5BA1\u6838\uFF0C\u5E76\u77ED\u4FE1\u901A\u77E5\u60A8\u3002</strong><div>\n            <div class="lessFare_tips_area">\n              <div class="lessFare_tipsT">\n                <span>\u5E94\u9000\u91D1\u989D</span>\n                <span>' + (contentProps.curr + contentProps.totalCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u7968\u4EF7</span>\n                <span>' + (contentProps.curr + contentProps.ticketCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u53EF\u9000\u7A0E\u8D39</span>\n                <span>' + (contentProps.curr + contentProps.totalTaxCosts) + '</span>\n              </div>\n              <div class="lessFare_tips">\n                <span>\u624B\u7EED\u8D39</span>\n                <span>' + (contentProps.curr + '-' + contentProps.totalCharge) + '</span>\n              </div>\n            </div>\n          </div><div style=\'margin-top: 10px; text-align:left; color:#262626\'>\u6E29\u99A8\u63D0\u793A\uFF1A<br/><span>1\u3001\u60A8\u63D0\u4EA4\u9000\u7968\u540E\u539F\u5B9A\u5EA7\u4F4D\u5C06\u88AB\u53D6\u6D88\uFF0C\u5BA2\u7968\u65E0\u6CD5\u7EE7\u7EED\u4F7F\u7528\uFF0C\u5B9E\u9645\u9000\u8FD8\u91D1\u989D\u5C06\u4EE5\u5BA1\u6838\u7ED3\u679C\u4E3A\u51C6\uFF1B</span><br/>2\u3001\u6B64\u6B21\u4E3A\u81EA\u613F\u9000\u7968\uFF0C\u6309\u7167\u9000\u6539\u89C4\u5219\u53EF\u80FD\u4EA7\u751F\u76F8\u5E94\u9000\u7968\u624B\u7EED\u8D39\u3002</div>';
    }
  },
  checkTips_pengdingzy: "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/><span>1、您提交退票后原定座位将被取消，客票无法继续使用，实际退还金额将以审核结果为准；</span><br/>2、此次为自愿退票，按照退改规则可能产生相应退票手续费。<br/><span style='color:#e5004a'>3、实际退票手续费将按客票使用规则进行人工审核，人工审核完成后将直接进行退款处理。</span>因退票手续费可能较高，若您不知晓退票手续费计算规则，建议联系原出票渠道或南航客服咨询后进行提交。</div>",
  yddqTip: "<strong style='color:#262626;'>您好，我们将尽快完成退款审核，并短信通知您。</strong><div style='margin-top: 10px; text-align:left; color:#262626'>温馨提示：<br/>1、您提交退票后原定座位将被取消，实际退还金额将以审核结果为准；<br/>2、本次因疫情原因申请的退票需要人工审核。如符合疫情文件，退票将按非自愿退票，免收退票手续费；如不符合疫情文件，退票将按自愿退票，按照客票使用条件可能产生相应退票手续费。</div>",
  quotaTip: "<span style='color:#e5004a'>额度将在退票后几分钟内到账（若超出额度数不予退回），若未到账，可通过员工旅行-返回额度申请</span>",
  contact_important: '请补充联系人信息',
  error_certno: '请输入证件号',
  error_certnoF: '请输入正确的证件号',
  error_name: '请输入持卡人',
  no_verification: '请输入验证码！',
  get_verification: '请获取验证码！',
  error_verification: '您输入的验证码有误，请重新输入。',
  overtime_verification: '您输入的验证码已超时，请重新获取。',
  eleven_phone: '请输入11位国内手机号。 ',
  isCheckedRead: '请阅读并同意服务协议',
  artificial: '您好！本次变更需人工审核，客服稍后短信通知您审核结果及变更费用。',
  error_cardNo: '抱歉，您输入的银行卡信息有误，请重新输入。',
  no_bankcard: '请输入16-19位银行卡号',
  error_referral: '推荐码格式不正确！',
  changeCabin: '尊敬的旅客，您选择新航班的明珠经济舱已售罄，系统将自动为您安排同航班经济舱座位。<br/>变更成功后，您可前往南航机场柜台领取明珠经济舱体验券。<br/>请确认是否继续提交？',
  happyFlying: '您好！按照南航套票产品规则：机票一旦出票，不得变更、不得签转。',
  repeat: '文件名重复，无法上传，请更名后上传',
  selectedError: '附件上传格式为Word（.doc/.docx/.DOC/.DOCX）、Excel（.xls/.xlsx/.XLS/.XLSX）、PDF（.pdf/.PDF）、文本文件(.txt/.TXT) 或JPG(.jpg/.JPG)、PNG(.png/.PNG)格式，每个附件大小不能超20M',
  muFileError: "附件上传格式为'JPG', 'PNG', 'DOC', 'JPEG', 'DOCX'，所有附件大小不能超2M。",
  fileSize: '您好，您所提交的附件内容为空，请核对后提交，谢谢。',
  fileTip: '请根据实际情况，按需上传如下附件：1.情况说明 2.身份证正反面图片或其他身份证明官方材料 3.出行受阻官方证明材料 4.目的地活动延期或取消官方证明材料 5.健康码或核酸检测异常截图6.其他疫情原因导致无法出行的官方证明材料。',
  fileTipIll: '请上传南航认可医疗机构开具的医疗缴费发票或住院押金证明。',
  fileTipProof: '请根据实际情况，按需上传如下附件：<br/>1.本人手持购票证件（姓名页）和抗原检测阳性结果合照，要求本人人脸、姓名页证件和抗原阳性结果须同框。<br/>2.学校放假计划调整证明文件和学生证(封面和姓名页)图片。<br/>3.其他疫情原因导致无法出行的官方证明材料。',
  noRefundMode: '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
  thanksPerson: '谢谢您的支持与配合！',
  contactInfo: '温馨提示：请您认真核对航班信息、乘机人姓名及证件信息、联系电话等，以免影响乘机。',
  transferInfo: '您的客票调整至中转航班后，如已预定附加服务可能无法保障，具体以现场核销为准, ',
  pleaseCheckIsFood: '请您先勾选是否机上用餐',
  fileSuppleTip: '您已勾选了病退申请，但未上传身份证明或相关医疗证明材料，请补充材料后提交。'
}), _defineProperty(_language$morequeryte, 'feeQuery', {
  selectFlight: '请选择想要退票或变更的航段! ',
  refundrules: '您好！根据退改规则，所有未使用航段必须同时申退。',
  canotChange: '您选择的航段不可变更，请重新选择',
  modification: '抱歉，您选择的航段不可变更'
}), _defineProperty(_language$morequeryte, 'loginFeeQuery', {
  inputTicketNoOrId: '请输入票号或者证件号！',
  inputName: '请输入旅客姓名！',
  inputTicketNo: '请输入航班号！',
  inputFlightDate: '请选择航班日期！'
}), _defineProperty(_language$morequeryte, 'refundChangeCompute', {}), _defineProperty(_language$morequeryte, 'detailsMessage', {
  inputContactPersonName: '联系人信息很重要，请补充完整',
  inputRightContactPersonName: '请输入正确的联系人姓名',
  inputContactPersonPhone: '联系人信息很重要，请补充完整',
  inputRightContactPersonPhone: '您输入的联系手机不正确，请重新输入'
}), _defineProperty(_language$morequeryte, 'realNameVerify', {
  descTitle: '退款账户认证说明',
  descContent: '您提交的退票我们将把退款退回您（婴儿请提供携带成人的银行账户）本人的银行账户，请填写有效银联卡并完成认证，退款将在0-20个工作日退回到您提供的银行账户，具体时间以各家银行为准。',
  createRefundTa_error: "<div>很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者拔打<a style='display: inline-block;' href='tel:95539 '> <u>95539</u></a>人工服务垂询。</div>"
}), _defineProperty(_language$morequeryte, 'ReformProcess', {}), _defineProperty(_language$morequeryte, 'subInfomation', {
  payOverTime: {
    title: '支付超时'
  }
}), _defineProperty(_language$morequeryte, 'ElectronicInvoice', {
  noCompanyName: '请输入公司名称',
  noTaxpayerIdCode: '请输入纳税人识别码',
  noEmail: '请输入收票人邮箱',
  noPhone: '请输入收票人电话',
  erroeEmail: '邮箱输入有误，请重新输入',
  errorTaxpayerIdCode: '纳税人识别号不符合规则',
  errorPhone: '请正确输入收票人电话',
  tip: '点击“提交”后将为勾选的乘机人自动填充同样的发票信息并一并提交，请慎重勾选！'
}), _defineProperty(_language$morequeryte, 'changeMember', {
  checkMember: '您还没有勾选要入会的乘机人，请先勾选要入会的乘机人'
}), _defineProperty(_language$morequeryte, 'rateTip', {
  rateTip: '请选择评分！',
  rateSuccess: '感谢您的反馈！'
}), _defineProperty(_language$morequeryte, 'mileageMsg', {
  title: function title(text) {
    return text + '\u8BA1\u7B97\u89C4\u5219';
  },
  info: function info(text) {
    return '\u8BA1\u7B97\u516C\u5F0F:<br/>\u5B9E\u9645\u8FC7\u671F' + text + '=\u8FC7\u671F' + text + ' - \u5EF6\u671F' + text + '<br/>\u5B9E\u9000' + text + '=\u5E94\u9000' + text + ' - \u5B9E\u9645\u8FC7\u671F' + text;
  },

  btn: '知道了'
}), _defineProperty(_language$morequeryte, 'cancelPage', {
  CancellationTip: "<p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem; margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem' ><strong style='font-size:0.26rem;color:#009cd9'> 提前了解 </strong><br/> 请在取消行程前留意客票的退改政策，部分客票可能存在不允许变更或退票的规则</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem ;margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 无法恢复</strong><br/>取消航班行程后，将无法再乘坐本航班，且无法恢复。</p><p style='background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem;margin:0.1rem 0;text-align:left;color:#262626; font-size:0.2rem'><strong style='font-size:0.26rem;color:#009cd9'> 后续出行</strong><br/>在确定好新的行程后，您可在机票退改模块点击“变更”按钮，预订新的航班。</p>"
}), _defineProperty(_language$morequeryte, 'tchan', '机票变更'), _defineProperty(_language$morequeryte, 'trefun', '退票申请'), _defineProperty(_language$morequeryte, 'tchanges', '变更申请'), _defineProperty(_language$morequeryte, 'cancelt', '取消行程申请'), _defineProperty(_language$morequeryte, 'tcu', '退改/升舱'), _defineProperty(_language$morequeryte, 'gongwu', '公务员信息认证'), _defineProperty(_language$morequeryte, 'payresun', '支付结果'), _defineProperty(_language$morequeryte, 'yasd', '退款账户认证'), _defineProperty(_language$morequeryte, 'refundName', '退票详情'), _defineProperty(_language$morequeryte, 'changeName', '变更详情'), _defineProperty(_language$morequeryte, 'refundSeat', '取消行程详情'), _defineProperty(_language$morequeryte, 'serveC', '餐食服务'), _defineProperty(_language$morequeryte, 'contact', '联系'), _defineProperty(_language$morequeryte, 'refundSubmitTip1', '系统正在处理您的退票请求，请稍等！'), _defineProperty(_language$morequeryte, 'refundSubmitTip2', '如提交失败，请稍后尝试重新提交'), _defineProperty(_language$morequeryte, 'ticInfo', '客票信息'), _defineProperty(_language$morequeryte, 'lessPrice', function lessPrice(refundMoney) {
  return '\u6839\u636E\u5BA2\u7968\u9000\u7968\u653F\u7B56\u89C4\u5B9A\uFF0C\u8BE5\u673A\u7968\u53EF\u9000\u91D1\u989D\u8F83\u4F4E\uFF08' + refundMoney + '\uFF09\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u7EE7\u7EED\u63D0\u4EA4\u9000\u7968\u3002';
}), _language$morequeryte);

/***/ }),

/***/ "H7xP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAABIFBMVEUAAAAWcKAJbpsHbZ00eZ8fb5sRb5sFbJwNb54FbJwFbZwHbJwGbZwEbJ0GbZwGbpwGbJ0IbZwIbZz///8FbJwEbZ0GbJwFbZ3b6vEHa5wGbJv+//8GbZ0EbZz////z9/v////S5e7///+Gt88EbZwFbJ38/f72+vzW5+/f7PPm8PTu9fi51uTC3Of3+fz////7+/vX5+/i7vT////////+/v6kytoce6ZopsNAkLQYeKRTm7y91uX1+Pj19fvp6enr9Pf////q8vfp8vf////J4OrO4+y51uOiyduEt86w0N9op8RdosD1+fv7+/wziK8qg63Pz9/W5+59ssvp8vfn8fZeob4WdqXI3+pKlLf9/f2uz+H///////////////9d96jmAAAAX3RSTlMAChciBAcOMBJnXkdAOCgsVEMdq2I8WDTGTFH3TXb769/PgH5xbfrvysK+tLCqTUAp1tC/tYiFbmNhUlE5IhAL6Ofd1NPFsKKflY99eXhZVEgIw6Ofk4p/eXVnZTIYF5cmAi4AAAMuSURBVEjHzZfpUtswFIWbyI73FduJFwIJLWSDspYdSmkpW0vpvvv936LXV7IxmSFB/tUzDDPI+ThXVzqy8uQBHT0H/XlSTUftNE03KoCCIIjiRgp6z80CWavV3mXwyTE3W2s0ZPkgzbTFD8t10HwGt1f5YDCuu4SQz2i9wWnckF1iSdIvQHl7JoAxsZqG78cIzx9zOQMsGY7mDKj1Fq+z5GtheAkkb8/QWdeiaDel2uTqNsJ2YL9i9ApP3bJr+QAHy4hiz3g6ZhqarapXKVN3KvS32+3+LibtRKqqLjE4PpwG38ZQ4BGtm1h6Enjem9x6c2oIN+FTM2zSUHfgKRdprpWJWchD+JPV3YRJK9uLOTx/O4nNQxiv5isdqYqylk7tmQBoHXSCHjOZhsNBv9XrvCzgeKasrdXStpAxhMP00YpXSsYuMS3re/p4vS7nyJQMYz/l0OG9EOpOVRhDeMlTtsDqxgTrof2Rp2HivQQnAW7luRaq1+t1OuWlalH1+/3BYPjloFETyglOrlPQ4rUHifA8RXn2dHb2bpOMYBgVRJoukTrCJee3KehcQVH2W7E957bpqOepQaI3zbo8Bq/DhzpKGf5UGF8oD8JY9l6MBl6p7CKSa4o3uezd5dHoSg0CO1OgekAvMXbxhxrYqCgKNTBmcHmpAIRnmuNoWhgFqvI1N162ExhG6b4hASvXxLFNkoQaPGuCDN8JbW+Ud2tP02FYQlkmyVg0Lm9PRzfwGTFhp8Mhlh+9LxxwMwmTW4eaRWE8GIDCI1D2px7uMnbdaeI4SpblBrLjkbSyghoguU7g5D6nbHvHMHG8Bsp+iSKyY4cBgYIa8Cz7ZwC3WLd8C5oLDJUgULJsTWvKCsKrATjvxbRbHySCk5x8AOJc7tZ9gXXLMF26MBNoEM6lOHrPaLfYdpp86LPZ3B36c7RbbB8/Uux1s4PGZ9AtKJrz7e5gQJewW1zG+Io9LXWL9+V+0wb21Oc0Zum+WQDt025VudAkmoHdEniqpnAYaqzoSpc4v4ndqnR9hAyjcaWLq0XZaldm4mKYKl3WWUArfU0oEspN04RWYuEHeBEC+v/qH23PFh93FGgeAAAAAElFTkSuQmCC"

/***/ }),

/***/ "HERM":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "HW6M":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "HXwK":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("fAzg");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "Hx0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules
var Animate = __webpack_require__("8aSS");

// CONCATENATED MODULE: ./node_modules/rc-util/es/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rc-notification/es/Notice.js









var Notice_Notice = function (_Component) {
  inherits_default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, defineProperty_default()(_className, '' + componentClass, 1), defineProperty_default()(_className, componentClass + '-closable', props.closable), defineProperty_default()(_className, props.className, !!props.className), _className);
      return reactfrom_dll_reference_vendor_library_default.a.createElement(
        'div',
        { className: classnames_default()(className), style: props.style, onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer
        },
        reactfrom_dll_reference_vendor_library_default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? reactfrom_dll_reference_vendor_library_default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          reactfrom_dll_reference_vendor_library_default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(reactfrom_dll_reference_vendor_library["Component"]);

Notice_Notice.propTypes = {
  duration: prop_typesfrom_dll_reference_vendor_library_default.a.number,
  onClose: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  children: prop_typesfrom_dll_reference_vendor_library_default.a.any
};
Notice_Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ var es_Notice = (Notice_Notice);
// CONCATENATED MODULE: ./node_modules/rc-notification/es/Notification.js















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification_Notification = function (_Component) {
  inherits_default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      _this.setState(function (previousState) {
        var notices = previousState.notices;
        if (!notices.filter(function (v) {
          return v.key === key;
        }).length) {
          return {
            notices: notices.concat(notice)
          };
        }
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var noticeNodes = this.state.notices.map(function (notice) {
        var onClose = createChainedFunction(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return reactfrom_dll_reference_vendor_library_default.a.createElement(
          es_Notice,
          extends_default()({
            prefixCls: props.prefixCls
          }, notice, {
            onClose: onClose
          }),
          notice.content
        );
      });
      var className = (_className = {}, defineProperty_default()(_className, props.prefixCls, 1), defineProperty_default()(_className, props.className, !!props.className), _className);
      return reactfrom_dll_reference_vendor_library_default.a.createElement(
        'div',
        { className: classnames_default()(className), style: props.style },
        reactfrom_dll_reference_vendor_library_default.a.createElement(
          Animate["a" /* default */],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(reactfrom_dll_reference_vendor_library["Component"]);

Notification_Notification.propTypes = {
  prefixCls: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  transitionName: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  animation: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.string, prop_typesfrom_dll_reference_vendor_library_default.a.object]),
  style: prop_typesfrom_dll_reference_vendor_library_default.a.object
};
Notification_Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification_Notification.newInstance = function newNotificationInstance(properties) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = objectWithoutProperties_default()(_ref2, ['getContainer']);

  var div = void 0;
  if (getContainer) {
    div = getContainer();
  } else {
    div = document.createElement('div');
    document.body.appendChild(div);
  }
  var notification = react_domfrom_dll_reference_vendor_library_default.a.render(reactfrom_dll_reference_vendor_library_default.a.createElement(Notification_Notification, props), div);
  return {
    notice: function notice(noticeProps) {
      notification.add(noticeProps);
    },
    removeNotice: function removeNotice(key) {
      notification.remove(key);
    },

    component: notification,
    destroy: function destroy() {
      react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(div);
      if (!getContainer) {
        document.body.removeChild(div);
      }
    }
  };
};

/* harmony default export */ var es_Notification = (Notification_Notification);
// CONCATENATED MODULE: ./node_modules/rc-notification/es/index.js

/* harmony default export */ var es = __webpack_exports__["default"] = (es_Notification);

/***/ }),

/***/ "I7B8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("NZ8V");
var descriptor = __webpack_require__("YTz9");
var setToStringTag = __webpack_require__("LhDF");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("aLzV")(IteratorPrototype, __webpack_require__("hgbu")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "IByH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "ITLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("59gI");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "JCET":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("QISU");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "JYxR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Checkbox = __webpack_require__("Z09J");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _getDataAttr = __webpack_require__("M9vV");

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

var _omit = __webpack_require__("JkBm");

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AgreeItem = function (_React$Component) {
    (0, _inherits3['default'])(AgreeItem, _React$Component);

    function AgreeItem() {
        (0, _classCallCheck3['default'])(this, AgreeItem);
        return (0, _possibleConstructorReturn3['default'])(this, (AgreeItem.__proto__ || Object.getPrototypeOf(AgreeItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(AgreeItem, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                style = _props.style,
                className = _props.className;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-agree', true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, (0, _getDataAttr2['default'])(this.props), { className: wrapCls, style: style }),
                _react2['default'].createElement(_Checkbox2['default'], (0, _extends3['default'])({}, (0, _omit2['default'])(this.props, ['style']), { className: prefixCls + '-agree-label' }))
            );
        }
    }]);
    return AgreeItem;
}(_react2['default'].Component);

exports['default'] = AgreeItem;

AgreeItem.defaultProps = {
    prefixCls: 'am-checkbox'
};
module.exports = exports['default'];

/***/ }),

/***/ "Jiug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "JkBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),

/***/ "JyN8":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("Wdy1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("xVc6") });


/***/ }),

/***/ "K+tY":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("455d"),
    eq = __webpack_require__("jjNC");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "KL7P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KSGD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(3);

/***/ }),

/***/ "L1QY":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "LNGb":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "LhDF":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("GCs6").f;
var has = __webpack_require__("x//u");
var TAG = __webpack_require__("hgbu")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "LjTL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "LocR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("qs+f") && !__webpack_require__("zyKz")(function () {
  return Object.defineProperty(__webpack_require__("PY1i")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "M6eO":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "M7g5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Steps = __webpack_require__("56Hq");

var _Steps2 = _interopRequireDefault(_Steps);

var _Step = __webpack_require__("ifV3");

var _Step2 = _interopRequireDefault(_Step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Steps2["default"].Step = _Step2["default"];
exports["default"] = _Steps2["default"];
module.exports = exports['default'];

/***/ }),

/***/ "M9vV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (props) {
    return Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
};

module.exports = exports['default'];

/***/ }),

/***/ "Mbmb":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.dayjs=e()}(this,function(){"use strict";var t="millisecond",e="second",n="minute",r="hour",i="day",s="week",u="month",a="quarter",o="year",f="date",h=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d+)?$/,c=/\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,d={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},$=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},l={s:$,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+$(r,2,"0")+":"+$(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,u),s=n-i<0,a=e.clone().add(r+(s?-1:1),u);return+(-(r+(n-i)/(s?i-a:a-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return{M:u,y:o,w:s,d:i,D:f,h:r,m:n,s:e,ms:t,Q:a}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},y="en",M={};M[y]=d;var m=function(t){return t instanceof S},D=function(t,e,n){var r;if(!t)return y;if("string"==typeof t)M[t]&&(r=t),e&&(M[t]=e,r=t);else{var i=t.name;M[i]=t,r=i}return!n&&r&&(y=r),r||!n&&y},v=function(t,e){if(m(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new S(n)},g=l;g.l=D,g.i=m,g.w=function(t,e){return v(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var S=function(){function d(t){this.$L=D(t.locale,null,!0),this.parse(t)}var $=d.prototype;return $.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(g.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(h);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},$.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},$.$utils=function(){return g},$.isValid=function(){return!("Invalid Date"===this.$d.toString())},$.isSame=function(t,e){var n=v(t);return this.startOf(e)<=n&&n<=this.endOf(e)},$.isAfter=function(t,e){return v(t)<this.startOf(e)},$.isBefore=function(t,e){return this.endOf(e)<v(t)},$.$g=function(t,e,n){return g.u(t)?this[e]:this.set(n,t)},$.unix=function(){return Math.floor(this.valueOf()/1e3)},$.valueOf=function(){return this.$d.getTime()},$.startOf=function(t,a){var h=this,c=!!g.u(a)||a,d=g.p(t),$=function(t,e){var n=g.w(h.$u?Date.UTC(h.$y,e,t):new Date(h.$y,e,t),h);return c?n:n.endOf(i)},l=function(t,e){return g.w(h.toDate()[t].apply(h.toDate("s"),(c?[0,0,0,0]:[23,59,59,999]).slice(e)),h)},y=this.$W,M=this.$M,m=this.$D,D="set"+(this.$u?"UTC":"");switch(d){case o:return c?$(1,0):$(31,11);case u:return c?$(1,M):$(0,M+1);case s:var v=this.$locale().weekStart||0,S=(y<v?y+7:y)-v;return $(c?m-S:m+(6-S),M);case i:case f:return l(D+"Hours",0);case r:return l(D+"Minutes",1);case n:return l(D+"Seconds",2);case e:return l(D+"Milliseconds",3);default:return this.clone()}},$.endOf=function(t){return this.startOf(t,!1)},$.$set=function(s,a){var h,c=g.p(s),d="set"+(this.$u?"UTC":""),$=(h={},h[i]=d+"Date",h[f]=d+"Date",h[u]=d+"Month",h[o]=d+"FullYear",h[r]=d+"Hours",h[n]=d+"Minutes",h[e]=d+"Seconds",h[t]=d+"Milliseconds",h)[c],l=c===i?this.$D+(a-this.$W):a;if(c===u||c===o){var y=this.clone().set(f,1);y.$d[$](l),y.init(),this.$d=y.set(f,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},$.set=function(t,e){return this.clone().$set(t,e)},$.get=function(t){return this[g.p(t)]()},$.add=function(t,a){var f,h=this;t=Number(t);var c=g.p(a),d=function(e){var n=v(h);return g.w(n.date(n.date()+Math.round(e*t)),h)};if(c===u)return this.set(u,this.$M+t);if(c===o)return this.set(o,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(f={},f[n]=6e4,f[r]=36e5,f[e]=1e3,f)[c]||1,l=this.$d.getTime()+t*$;return g.w(l,this)},$.subtract=function(t,e){return this.add(-1*t,e)},$.format=function(t){var e=this;if(!this.isValid())return"Invalid Date";var n=t||"YYYY-MM-DDTHH:mm:ssZ",r=g.z(this),i=this.$locale(),s=this.$H,u=this.$m,a=this.$M,o=i.weekdays,f=i.months,h=function(t,r,i,s){return t&&(t[r]||t(e,n))||i[r].substr(0,s)},d=function(t){return g.s(s%12||12,t,"0")},$=i.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:g.s(a+1,2,"0"),MMM:h(i.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:g.s(this.$D,2,"0"),d:String(this.$W),dd:h(i.weekdaysMin,this.$W,o,2),ddd:h(i.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:g.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:g.s(u,2,"0"),s:String(this.$s),ss:g.s(this.$s,2,"0"),SSS:g.s(this.$ms,3,"0"),Z:r};return n.replace(c,function(t,e){return e||l[t]||r.replace(":","")})},$.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},$.diff=function(t,f,h){var c,d=g.p(f),$=v(t),l=6e4*($.utcOffset()-this.utcOffset()),y=this-$,M=g.m(this,$);return M=(c={},c[o]=M/12,c[u]=M,c[a]=M/3,c[s]=(y-l)/6048e5,c[i]=(y-l)/864e5,c[r]=y/36e5,c[n]=y/6e4,c[e]=y/1e3,c)[d]||y,h?M:g.a(M)},$.daysInMonth=function(){return this.endOf(u).$D},$.$locale=function(){return M[this.$L]},$.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=D(t,e,!0);return r&&(n.$L=r),n},$.clone=function(){return g.w(this.$d,this)},$.toDate=function(){return new Date(this.valueOf())},$.toJSON=function(){return this.isValid()?this.toISOString():null},$.toISOString=function(){return this.$d.toISOString()},$.toString=function(){return this.$d.toUTCString()},d}(),p=S.prototype;return v.prototype=p,[["$ms",t],["$s",e],["$m",n],["$H",r],["$W",i],["$M",u],["$y",o],["$D",f]].forEach(function(t){p[t[1]]=function(e){return this.$g(e,t[0],t[1])}}),v.extend=function(t,e){return t(e,S,v),v},v.locale=D,v.isDayjs=m,v.unix=function(t){return v(1e3*t)},v.en=M[y],v.Ls=M,v.p={},v});


/***/ }),

/***/ "MhA3":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "Mqyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/css-animation/es/Event.js
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ var Event = (TransitionEvents);
// EXTERNAL MODULE: ./node_modules/component-classes/index.js
var component_classes = __webpack_require__("onlG");
var component_classes_default = /*#__PURE__*/__webpack_require__.n(component_classes);

// CONCATENATED MODULE: ./node_modules/css-animation/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });




var isCssAnimationSupported = Event.endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var es_cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : typeof_default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = component_classes_default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    Event.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  Event.addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

es_cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    Event.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  Event.addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

es_cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

es_cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ var es = __webpack_exports__["a"] = (es_cssAnimation);

/***/ }),

/***/ "N1YQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "NMac":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("8ANE");
var anObject = __webpack_require__("FKWp");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("3fMt")(Function.call, __webpack_require__("rjjF").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "NU0k":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("NZra");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "NZ8V":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("FKWp");
var dPs = __webpack_require__("r3+g");
var enumBugKeys = __webpack_require__("B5V0");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("PY1i")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("+iDZ").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "NZra":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "Ngpj":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Ntt2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var LIBRARY = __webpack_require__("c8Kh");
var wksExt = __webpack_require__("4DQ7");
var defineProperty = __webpack_require__("GCs6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "NveE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__("f17K");
var objectAssign = __webpack_require__("T1yJ");
var decodeComponent = __webpack_require__("r6Pz");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),

/***/ "O27J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(208);

/***/ }),

/***/ "O5te":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OAAv":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("uWbD"),
    isIterateeCall = __webpack_require__("hlir");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "OIlo":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "OTY+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnnexHeader", function() { return AnnexHeader; });
/* harmony export (immutable) */ __webpack_exports__["AddValHeader"] = AddValHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_accordion_style_css__ = __webpack_require__("01WB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_accordion_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_accordion_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion__ = __webpack_require__("oyG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_checkbox_style_css__ = __webpack_require__("fs/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_checkbox_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_checkbox_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_checkbox__ = __webpack_require__("Bp4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_steps_style_css__ = __webpack_require__("1KgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_steps_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_steps_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_steps__ = __webpack_require__("TiPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tips__ = __webpack_require__("EjGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asstes_addval_icon_jpg__ = __webpack_require__("8tDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asstes_addval_icon_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__asstes_addval_icon_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asstes_attach_icon_jpg__ = __webpack_require__("oHrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asstes_attach_icon_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asstes_attach_icon_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_TicPopUp__ = __webpack_require__("2H8H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_less__ = __webpack_require__("fgXa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__asstes_arrow2_png__ = __webpack_require__("Ex0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__asstes_arrow2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__asstes_arrow2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__ = __webpack_require__("mekh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__asstes_tip2_png__ = __webpack_require__("0PNg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__asstes_tip2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__asstes_tip2_png__);







var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Step = __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_steps___default.a.Step;

var CheckboxItem = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_checkbox___default.a.CheckboxItem;
var Panel = __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a.Panel;

var _ref = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_9__asstes_attach_icon_jpg___default.a,
  alt: ''
});

var AnnexHeader = function (_PureComponent) {
  _inherits(AnnexHeader, _PureComponent);

  function AnnexHeader() {
    _classCallCheck(this, AnnexHeader);

    return _possibleConstructorReturn(this, (AnnexHeader.__proto__ || Object.getPrototypeOf(AnnexHeader)).apply(this, arguments));
  }

  _createClass(AnnexHeader, [{
    key: 'render',
    value: function render() {
      var lang = this.props.lang;

      return _jsx('div', {
        className: 'title'
      }, void 0, _ref, _jsx('span', {}, void 0, lang.additional), this.props.children);
    }
  }]);

  return AnnexHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

var _ref2 = _jsx('div', {
  className: 'title'
}, void 0, _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8__asstes_addval_icon_jpg___default.a,
  alt: ''
}), _jsx('span', {}, void 0, '\u589E\u52A0\u4EA7\u54C1'));

function AddValHeader() {
  return _ref2;
}

var Compute = function (_PureComponent2) {
  _inherits(Compute, _PureComponent2);

  function Compute() {
    var _ref3;

    var _temp, _this2, _ret;

    _classCallCheck(this, Compute);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref3 = Compute.__proto__ || Object.getPrototypeOf(Compute)).call.apply(_ref3, [this].concat(args))), _this2), _this2.state = {
      num: _this2.props.value
    }, _this2._handleOperate = function (type) {
      return function () {
        _this2.setState(function (state) {
          if (type === 'add' && _this2.props.max > state.num) {
            return {
              num: state.num + 1
            };
          }
          if (type === 'cut' && state.num > _this2.props.min) {
            return {
              num: state.num - 1
            };
          }
        }, function () {
          _this2.props.change(_this2.state.num);
        });
      };
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(Compute, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({ num: newProps.value });
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: 'compute'
      }, void 0, _jsx('div', {
        role: 'button',
        onClick: this._handleOperate('cut')
      }, void 0, '-'), _jsx('div', {}, void 0, this.state.num), _jsx('div', {
        role: 'button',
        onClick: this._handleOperate('add')
      }, void 0, '+'));
    }
  }]);

  return Compute;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

var DriveCompute = function (_PureComponent3) {
  _inherits(DriveCompute, _PureComponent3);

  function DriveCompute() {
    var _ref4;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, DriveCompute);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref4 = DriveCompute.__proto__ || Object.getPrototypeOf(DriveCompute)).call.apply(_ref4, [this].concat(args))), _this3), _this3.state = {
      numD: _this3.props.value
    }, _this3._handleOperateD = function (type) {
      return function () {
        _this3.setState(function (state) {
          if (type === 'add' && _this3.props.max > state.numD) {
            return {
              numD: state.numD + 1
            };
          }
          if (type === 'cut' && state.numD > _this3.props.min) {
            return {
              numD: state.numD - 1
            };
          }
        }, function () {
          _this3.props.changeNum(_this3.state.numD);
        });
      };
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(DriveCompute, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({ numD: newProps.value });
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: 'compute'
      }, void 0, _jsx('div', {
        role: 'button',
        onClick: this._handleOperateD('cut')
      }, void 0, '-'), _jsx('div', {}, void 0, this.state.numD), _jsx('div', {
        role: 'button',
        onClick: this._handleOperateD('add')
      }, void 0, '+'));
    }
  }]);

  return DriveCompute;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

var _ref6 = _jsx('div', {
  className: 'bgcvcc'
});

var _ref7 = _jsx('div', {
  className: 'bgcvv'
});

var _ref8 = _jsx('div', {
  className: 'doorTip'
}, void 0, _jsx('div', {}, void 0, ' ', _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_15__asstes_tip2_png___default.a
})), _jsx('div', {}, void 0, '\u672C\u6B21\u53D6\u6D88\u63A5\u9001\u673A\u670D\u52A1\u53EF\u80FD\u4F1A\u4EA7\u751F\u8D39\u7528\uFF0C\u5177\u4F53\u9000\u6B3E\u91D1\u989D\u4EE5\u5BA2\u670D\u5BA1\u6838\u7ED3\u679C\u4E3A\u51C6\u3002'));

var _ref9 = _jsx('div', {
  className: 'stepLine'
}, void 0, _jsx('div', {}), _jsx('div', {}));

var _ref10 = _jsx('div', {
  className: 'stepLine'
}, void 0, _jsx('div', {}));

var _ref11 = _jsx('img', {
  alt: '',
  src: __WEBPACK_IMPORTED_MODULE_12__asstes_arrow2_png___default.a,
  className: 'flightIcon'
});

var ProductSelector = function (_Component) {
  _inherits(ProductSelector, _Component);

  function ProductSelector() {
    var _ref5;

    var _temp3, _this4, _ret3;

    _classCallCheck(this, ProductSelector);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this4 = _possibleConstructorReturn(this, (_ref5 = ProductSelector.__proto__ || Object.getPrototypeOf(ProductSelector)).call.apply(_ref5, [this].concat(args))), _this4), _this4.state = {
      activeKey: !_this4.props.data || !_this4.props.data.length ? ['panel'] : [],
      setStatus: [],
      bagStatus: [],
      bidStatus: [],
      roomStatus: {}, // key vale
      val: 0,
      htProduct: [], //hotel
      trainProduct: [], //train
      doorToDoorList: [],
      doorNum: {},
      doorActive: [],
      canCheck: 0
      // trainKey: this.props.trainlist.length ? ['panel'] : [],
    }, _this4._changeData = function (index) {
      return function (val) {
        _this4.props.onChange(index, val);
      };
    }, _this4._onChangeAnteroom = function (key) {
      return function (val) {
        _this4.setState({
          roomStatus: Object.assign({}, _this4.state.roomStatus, _defineProperty({}, key, val))
        });
        // return data;
      };
    }, _this4._onChangeDrive = function (key, item) {
      return function (val) {
        _this4.setState({
          doorNum: Object.assign({}, _this4.state.doorNum, _defineProperty({}, key, val))
        });
        console.log(Object.keys(_this4.state.doorNum), val);
      };
    }, _this4.getDoorList = function () {
      var _this4$state = _this4.state,
          doorNum = _this4$state.doorNum,
          doorToDoorList = _this4$state.doorToDoorList;

      var doorArr = [];
      Object.keys(doorNum).forEach(function (key) {
        for (var index = 0; index < doorNum[key]; index++) {
          doorArr.push(doorToDoorList[key]);
        }
      });
      return doorArr;
    }, _this4._renderText = function (data) {
      return _jsx('div', {
        className: 'productItem'
      }, void 0, _jsx('div', {
        className: 'text ' + (data.soStyle ? data.soStyle : '')
      }, void 0, data.text), _jsx('div', {
        className: 'num'
      }, void 0, '' + (data.type === 'num' ? data.value : '0') + data.unit));
    }, _this4._renderItem = function (data, index) {
      return _jsx('div', {
        className: 'productItem'
      }, void 0, _jsx('div', {
        className: 'text'
      }, void 0, data.text), _jsx('div', {}, void 0, data.type === 'num' && _jsx(Compute, {
        value: data.value,
        max: data.max,
        min: data.min,
        change: _this4._changeData(index)
      }), data.type === 'checkbox' && _jsx('div', {
        className: 'select'
      }, void 0, _jsx(CheckboxItem, {
        defaultChecked: data.value,
        className: 'am-checkbox-reset-gray',
        onChange: _this4._changeData(index)
      }))));
    }, _this4.selectAllDoor = function (e, selectDoor) {
      var _this4$state2 = _this4.state,
          doorToDoorList = _this4$state2.doorToDoorList,
          canCheck = _this4$state2.canCheck,
          doorActive = _this4$state2.doorActive;


      var doorObj = {};
      if (selectDoor.length === 0) {
        doorToDoorList.forEach(function (it, index) {
          doorObj[index] = it.numMax;
        });
      }

      _this4.setState({
        doorNum: doorObj
        // canCheck: canCheck + 1
      });
      if (doorActive.length !== 0 || selectDoor.length !== 0) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, _this4.renderDoorTitle = function (selectDoor) {
      var lang = _this4.props.lang;

      return _jsx('div', {
        className: ''
      }, void 0, _jsx('div', {
        className: 'doorheader'
      }, void 0, _jsx('div', {
        style: { fontWeight: 'bold' }
      }, void 0, lang.refCuponDoor), _jsx('div', {
        className: 'zxczxc',
        role: 'button',
        onClick: function onClick(e) {
          return _this4.selectAllDoor(e, selectDoor);
        }
      }, void 0, selectDoor.length === 0 && _ref6, selectDoor.length > 0 && _ref7)));
    }, _this4.selectAccordion = function () {
      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return function (key) {
        console.log(close);
        if (!close) return false;
        _this4.setState({
          doorActive: key
        });
      };
    }, _this4.onChange = function (key) {
      var _this4$props = _this4.props,
          data = _this4$props.data,
          soData = _this4$props.soData;

      if ((!data || !data.length) && (soData === null || Object.keys(soData).length !== 0)) return;
      _this4.setState({ activeKey: key });
    }, _this4.changeDoor = function (key) {
      console.log(key);
      // event.stopPropagation();
    }, _this4.formateArray = function (origin, val) {
      return val.reduce(function (p, n) {
        var i = p.indexOf(n);
        if (i >= 0) {
          p.splice(i, 1);
          return p;
        }
        return p.concat(n);
      }, origin);
    }, _this4.onSelectAll = function (key) {
      var type = '';
      if (key === 'setStatus') type = 'sselection';
      if (key === 'bagStatus') type = 'baggage';
      if (key === 'roomStatus') type = 'anteroom';
      if (key === 'bidStatus') type = 'biddingAmend';
      _this4.setState(_defineProperty({}, key, _this4.state[key].length < _this4.props.soData[type].length ? _this4.props.soData[type].map(function (item) {
        return item.psgname + item.segOrder;
      }) : []));
    }, _this4.onSelect = function (type, val) {
      if (type = 'bidStatus') return;
      _this4.setState(_defineProperty({}, type, val.reduce(function (p, n) {
        var i = p.indexOf(n);
        // const i = JSON.stringify(p).indexOf(JSON.stringify(n));
        if (i >= 0) {
          p.splice(i, 1);
          return p;
        }
        return p.concat(n);
      }, _this4.state[type])));
    }, _this4.selectAllTrain = function () {
      var arr = _this4.state.trainProduct.length < _this4.props.trainlist.length ? _this4.props.trainlist.map(function (item) {
        return item.xname;
      }) : [];
      _this4.setState({
        trainProduct: arr
      });
      _this4.props.checkTrainBox(arr);
    }, _this4.onSelectTrain = function (val) {
      var arr = val.reduce(function (p, n) {
        var i = p.indexOf(n);
        if (i >= 0) {
          p.splice(i, 1);
          return p;
        }
        return p.concat(n);
      }, _this4.state.trainProduct);
      _this4.setState({
        trainProduct: arr
      });
      _this4.props.checkTrainBox(arr);
    }, _this4.selectHotel = function (e, val) {
      var _this4$props2 = _this4.props,
          flightCheckBoxData = _this4$props2.flightCheckBoxData,
          flightRele = _this4$props2.flightRele,
          lang = _this4$props2.lang;

      var htValue = [];
      if (flightCheckBoxData.length === 0 && !_this4.state.htProduct.length) {
        Object(__WEBPACK_IMPORTED_MODULE_10_TicPopUp__["default"])(lang.title, lang.endorsedApply.pleaseSelectHtlight);
      }
      // 强关联
      if (flightCheckBoxData.length && flightRele) {
        htValue.push(val);
      }
      if (e.target.checked) {
        htValue.push(val);
      }
      _this4.setState({
        htProduct: htValue
      });
    }, _this4.getHotelData = function () {
      return _this4.state.htProduct;
    }, _this4.getTrainData = function () {
      return _this4.state.trainProduct;
    }, _this4.getSelectData = function () {
      var data = {};
      Object.keys(_this4.props.soData).forEach(function (key) {
        var type = '';
        if (key === 'sselection') type = 'setStatus';
        if (key === 'baggage') type = 'bagStatus';
        if (key === 'anteroom') type = 'roomStatus';
        if (key === 'biddingAmend') type = 'bidStatus';

        if (key === 'anteroom') {
          var room = _this4.makeAnterRoom(_this4.props.soData[key] || []);
          data[key] = Object.keys(room).reduce(function (a, b) {
            return a.concat(room[b].slice(0, _this4.state[type][b] ? _this4.state[type][b] : 0));
          }, []);
          return false;
        }
        data[key] = _this4.props.soData[key].filter(function (item) {
          return _this4.state[type].includes(item.psgname + item.segOrder);
        });
      });

      var totalCount = 0;
      Object.keys(data).forEach(function (key) {
        totalCount += data[key].length;
      });

      // if (totalCount === 0) return null;
      if (totalCount === 0) return {};
      return data;
    }, _this4.makeAnterRoom = function (arr) {
      return arr.reduce(function (a, b) {
        if (!a[b.depAirport]) a[b.depAirport] = [];
        a[b.depAirport].push(b);
        return a;
      }, {});
    }, _temp3), _possibleConstructorReturn(_this4, _ret3);
  }

  // changeTap = key => {
  //   const { trainlist } = this.props;
  //   if (!trainlist.length) return;
  //   this.setState({ trainKey: key });
  // }

  _createClass(ProductSelector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this5 = this;

      var _props = this.props,
          psg = _props.psg,
          soData = _props.soData,
          trainlist = _props.trainlist,
          airportTransferList = _props.airportTransferList;

      if (airportTransferList && airportTransferList.length > 0) {
        var doorArr = [];
        doorArr = airportTransferList.reduce(function (obj, item) {
          console.log(obj, item);
          var find = obj.find(function (i) {
            return i.serviceType === item.serviceType && i.carModelName === item.carModelName;
          });
          var _d = Object.assign({}, item, {
            numMax: 1
          });
          find ? find.numMax++ : obj.push(_d);
          return obj;
        }, []);
        // });
        this.setState({ doorToDoorList: doorArr });
      }
      if (psg === 1) {
        Object.keys(soData).forEach(function (key) {
          var type = '';
          if (key === 'anteroom') {
            type = 'roomStatus';
            _this5.setState(_defineProperty({}, type, soData[key].reduce(function (a, b) {
              if (!a[b.depAirport]) a[b.depAirport] = 0;
              a[b.depAirport]++;
              return a;
            }, {})));
            return false;
          }
          if (key === 'sselection') type = 'setStatus';
          if (key === 'baggage') type = 'bagStatus';
          if (key === 'biddingAmend') type = 'bidStatus';
          _this5.setState(_defineProperty({}, type, soData[key].map(function (item) {
            return item.psgname + item.segOrder;
          })));
        });
      }
      if (trainlist && trainlist.length > 0) {
        this.setState({
          trainProduct: trainlist.map(function (item) {
            return item.xname;
          })
        });
        this.props.checkTrainBox(trainlist.map(function (item) {
          return item.xname;
        }));
      }
    }

    //  参数变更触发的周期钩子

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this6 = this;

      if (!nextProps.data || !nextProps.data.length) {
        if (!this.state.activeKey.length) {
          this.setState({ activeKey: ['panel'] });
        }
      }

      // 此处存在so产品重新渲染组件导致勾选的问题;
      // console.log(this.flightCheckBoxData, nextProps.presonCheckBoxData);
      if (nextProps.flightCheckBoxData && this.flightCheckBoxData !== nextProps.flightCheckBoxData) {
        this.setState({
          htProduct: nextProps.flightCheckBoxData.length > 0 ? nextProps.hotelData : []
        });
      }

      var soData = nextProps.soData;

      if (soData === null || Object.keys(soData).length === 0) return;
      var changeObj = {};
      Object.keys(soData).forEach(function (key) {
        var type = '';
        if (key === 'sselection') type = 'setStatus';
        if (key === 'baggage') type = 'bagStatus';
        if (key === 'anteroom') type = 'roomStatus';
        if (key === 'biddingAmend') type = 'bidStatus';
        if (key === 'anteroom') {
          var room = _this6.makeAnterRoom(soData[key] || []);
          Object.keys(_this6.state[type]).reduce(function (a, b) {
            if (!room[b]) delete _this6.state[type][b];
            if (room[b] && _this6.state[type][b] > room[b].length) _this6.state[type][b] = room[b].length;
            changeObj[key] = _this6.state[type];
          }, {});
          return false;
        }

        if (_this6.state[type] && _this6.state[type].length) {
          var arr = soData[key].map(function (item) {
            return item.psgname + item.segOrder;
          });
          changeObj[type] = _this6.state[type].filter(function (item) {
            return arr.includes(item);
          });
        }
      });

      this.setState(changeObj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props2 = this.props,
          title = _props2.title,
          minTitle = _props2.minTitle,
          data = _props2.data,
          remark = _props2.remark,
          operate = _props2.operate,
          otherItem = _props2.otherItem,
          soData = _props2.soData,
          hotelData = _props2.hotelData,
          trainlist = _props2.trainlist,
          lang = _props2.lang,
          hotelNationArr = _props2.hotelNationArr,
          daxingProduct = _props2.daxingProduct,
          hotelSummary = _props2.hotelSummary,
          airportTransferList = _props2.airportTransferList;


      var accordionClassName = 'am-accordion-reset';
      if (title && title.props && title.props.children) accordionClassName += ' md-head';
      var proClassName = 'productSelector ' + operate;
      if ((!data || !data.length) && (soData === null || Object.keys(soData).length < 0)) {
        proClassName += ' no-open';
      }

      var anteroom = [];
      if (soData !== null) {
        anteroom = soData.anteroom;
      }

      var _state = this.state,
          setStatus = _state.setStatus,
          bagStatus = _state.bagStatus,
          roomStatus = _state.roomStatus,
          htProduct = _state.htProduct,
          bidStatus = _state.bidStatus,
          trainProduct = _state.trainProduct,
          doorToDoorList = _state.doorToDoorList,
          doorNum = _state.doorNum;

      var room = this.makeAnterRoom(anteroom || []);
      var selectDoor = this.getDoorList();
      var hasBob = selectDoor.some(function (item) {
        return item.commissionFee === true;
      });
      return _jsx('div', {
        className: proClassName
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a, {
        className: accordionClassName,
        activeKey: this.state.activeKey,
        onChange: this.onChange
      }, void 0, _jsx(Panel, {
        header: title
      }, 'panel', _jsx('div', {
        className: 'plate'
      }, void 0, _jsx('p', {}, void 0, minTitle), data.map(function (item, index) {
        if (operate === 'edit') {
          if (item.show) {
            if (item.value !== 0) {
              return _this7._renderItem(item, index);
            }
            return '';
          } else {
            return _this7._renderItem(item, index);
          }
        }
        return _this7._renderText(item);
      })), hasBob && _ref8, _jsx('div', {
        className: 'plate htPlate'
      }, void 0, hotelData.map(function (item, index) {
        return _jsx('div', {
          className: 'productItem'
        }, void 0, _jsx('div', {
          className: 'htText',
          style: { webkitBoxOrient: 'vertical' }
        }, void 0, item.hotelName), _jsx('div', {
          className: operate === 'detail' ? 'htNum' : ''
        }, void 0, ' ', item.manydays, lang.interval, item.manynights, lang.late), operate === 'edit' ? _jsx('div', {
          className: 'selectht'
        }, void 0, _jsx(CheckboxItem
        // defaultChecked={flightCheckBoxData.length > 0}
        , {
          className: 'am-checkbox-reset-blue',
          onChange: function onChange(e) {
            return _this7.selectHotel(e, item);
          },
          checked: htProduct.length > 0
        }, index)) : '');
      })), soData !== null && Object.keys(soData).length !== 0 && _jsx('div', {
        className: 'soPlate'
      }, void 0, soData.sselection && soData.sselection.length !== 0 && _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a, {
        className: 'my-accordion'
      }, void 0, operate === 'edit' && _jsx(CheckboxItem, {
        className: 'am-checkbox-reset-blue check_all',
        onChange: function onChange() {
          _this7.onSelectAll('setStatus');
        },
        checked: setStatus.length === soData.sselection.length
      }), _jsx(Panel, {
        header: lang.paidSeat,
        className: operate === 'edit' ? 'moreCheck' : 'numCheck'
      }, void 0, _jsx('div', {
        className: 'plate'
      }, void 0, soData.sselection.map(function (item, index) {
        return _jsx('div', {
          className: 'soProductItem'
        }, void 0, _jsx('div', {
          className: 'text'
        }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__["l" /* getCode3Widget */])(item.depAirport).cityName, ' -', ' ', Object(__WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__["l" /* getCode3Widget */])(item.arrAirport).cityName, ' ', item.psgname, ' ', item.baggageAndPaidSeat), _jsx('div', {
          className: 'select'
        }, void 0, operate === 'edit' ? _jsx(CheckboxItem, {
          className: 'am-checkbox-reset-blue',
          onChange: function onChange() {
            _this7.onSelect('setStatus', [item.psgname + item.segOrder]);
          },
          checked: setStatus.indexOf(item.psgname + item.segOrder) !== -1
        }, index) : lang.copy));
      })))), soData.baggage && soData.baggage.length !== 0 && _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a, {
        className: 'my-accordion'
      }, void 0, operate === 'edit' && _jsx(CheckboxItem, {
        className: 'am-checkbox-reset-blue check_all',
        onChange: function onChange() {
          _this7.onSelectAll('bagStatus');
        },
        checked: bagStatus.length === soData.baggage.length
      }), _jsx(Panel, {
        header: lang.excessBaggage,
        className: operate === 'edit' ? 'moreCheck' : 'numCheck'
      }, void 0, _jsx('div', {
        className: 'plate'
      }, void 0, soData.baggage.map(function (item, index) {
        return _jsx('div', {
          className: 'soProductItem'
        }, void 0, _jsx('div', {
          className: 'text'
        }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__["l" /* getCode3Widget */])(item.depAirport).cityName, ' -', ' ', Object(__WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__["l" /* getCode3Widget */])(item.arrAirport).cityName, ' ', item.psgname, ' ', item.baggageAndPaidSeat), _jsx('div', {
          className: 'select'
        }, void 0, operate === 'edit' ? _jsx(CheckboxItem, {
          className: 'am-checkbox-reset-blue',
          onChange: function onChange() {
            _this7.onSelect('bagStatus', [item.psgname + item.segOrder]);
          },
          checked: bagStatus.indexOf(item.psgname + item.segOrder) !== -1
        }) : lang.copy));
      })))), soData.anteroom && soData.anteroom.length !== 0 && _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a, {
        className: 'my-accordion'
      }, void 0, _jsx(Panel, {
        header: lang.refCupon19,
        className: 'numCheck'
      }, void 0, _jsx('div', {
        className: 'plate'
      }, void 0, Object.keys(room).map(function (key, index) {
        var item = room[key][0];
        if (operate === 'edit') {
          return _jsx('div', {
            className: 'soProductItem'
          }, void 0, _jsx('div', {
            className: 'text'
          }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__["l" /* getCode3Widget */])(item.depAirport).airportName, ' '), _jsx(Compute, {
            value: roomStatus[key] || 0,
            max: room[key].length,
            min: 0,
            change: _this7._onChangeAnteroom(key)
          }));
        }

        return _this7._renderText({
          text: Object(__WEBPACK_IMPORTED_MODULE_13__csair_emp_helpers__["l" /* getCode3Widget */])(item.depAirport).airportName,
          value: room[key].length,
          type: 'num',
          unit: lang.unit,
          soStyle: 'textSo'
        });
      })))), soData.biddingAmend && soData.biddingAmend.length !== 0 && _jsx('div', {
        className: 'plate'
      }, void 0, soData.biddingAmend.map(function (item, index) {
        return _jsx('div', {
          className: 'soProductItem'
        }, void 0, _jsx('div', {
          className: 'text'
        }, void 0, lang.adjustment), _jsx('div', {
          className: 'select'
        }, void 0, operate === 'edit' ? _jsx(CheckboxItem, {
          className: 'am-checkbox-reset-blue',
          onChange: function onChange() {
            _this7.onSelect('bidStatus', [item.psgname + item.segOrder]);
          },
          checked: bidStatus.indexOf(item.psgname + item.segOrder) !== -1
        }) : _jsx('span', {}, void 0, '\xA5', item.totalMoney)));
      }))), hotelNationArr && hotelNationArr.length !== 0 && _jsx('div', {
        className: 'plate hotelNaPlate'
      }, void 0, _jsx('div', {
        className: 'productItem'
      }, void 0, _jsx('div', {
        className: 'htText',
        style: { webkitBoxOrient: 'vertical' }
      }, void 0, hotelSummary.roomNames), _jsx('div', {
        className: operate === 'detail' ? 'htNum' : ''
      }, void 0, ' ', hotelSummary.totalRooms, lang.interval, hotelSummary.days, lang.late))), daxingProduct && daxingProduct.length !== 0 && _jsx('div', {
        className: 'plate hotelNaPlate'
      }, void 0, _jsx('div', {
        className: 'productItem'
      }, void 0, _jsx('div', {
        className: 'htText',
        style: { webkitBoxOrient: 'vertical' }
      }, void 0, hotelSummary.daXingProductName), _jsx('div', {
        className: operate === 'detail' ? 'htNum' : ''
      }, void 0, ' ', hotelSummary.daXingProductNumber, lang.Zhang))), doorToDoorList && doorToDoorList.length !== 0 && _jsx('div', {
        className: 'doorToDoorM'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a, {
        className: 'doorToDoor',
        activeKey: this.state.doorActive,
        onChange: this.selectAccordion(selectDoor)
      }, void 0, _jsx(Panel, {
        header: this.renderDoorTitle(selectDoor),
        className: operate === 'edit' ? 'doorToDoorS' : ''
      }, void 0, _jsx('div', {
        className: 'driveProduct'
      }, void 0, doorToDoorList.map(function (item, index) {
        return _jsx('div', {
          className: 'driveProductList'
        }, void 0, _jsx('div', {
          className: 'text'
        }, void 0, _jsx('div', {}, void 0, item.carModelName, _jsx('span', {
          className: item.serviceType === '3' ? 'jieji' : 'songji'
        }, void 0, item.serviceType === '3' ? '接机车' : item.serviceType === '4' ? '送机车' : '')), _jsx('div', {}, void 0, item.serviceType === '4' ? item.vehicleUsageTime : '')), _jsx('div', {
          className: 'select'
        }, void 0, _jsx('div', {
          className: 'depDoor'
        }, void 0, _ref9, _jsx('div', {
          className: 'addressName'
        }, void 0, item.departurePlace)), _jsx('div', {
          className: 'arrDoor'
        }, void 0, _ref10, _jsx('div', {
          className: 'addressName'
        }, void 0, item.endAddress)), operate === 'edit' ? _jsx(DriveCompute, {
          value: doorNum[index] || 0,
          max: item.numMax,
          min: 0,
          changeNum: _this7._onChangeDrive(index, item)
        }) : _jsx('div', {
          className: 'showNum'
        }, void 0, '\xD7 ', item.numMax)));
      }))))), trainlist && trainlist.length !== 0 && _jsx('div', {
        className: 'trainPlate'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_accordion___default.a, {
        className: 'my-accordion',
        defaultActiveKey: '1'
      }, void 0, operate === 'edit' && _jsx(CheckboxItem, {
        className: 'check_all',
        onChange: function onChange() {
          _this7.selectAllTrain();
        },
        checked: trainlist.length === trainProduct.length
      }), _jsx(Panel, {
        header: lang.trainTicket,
        className: operate === 'edit' ? 'moreCheck' : 'numCheck'
      }, void 0, _jsx('div', {
        className: 'plate'
      }, void 0, trainlist.map(function (item, index) {
        return _jsx('div', {
          className: 'trainProductItem'
        }, void 0, _jsx('div', {
          className: 'text'
        }, void 0, _jsx('div', {}, void 0, item.fromStationName, _ref11, item.toStationName), _jsx('div', {}, void 0, ' ', item.xname, ' | ', item.trainDate, ' ', item.startTime, ' ', '| ', item.trainCode)), _jsx('div', {
          className: 'select'
        }, void 0, operate === 'edit' ? _jsx(CheckboxItem, {
          onChange: function onChange() {
            _this7.onSelectTrain([item.xname]);
          },
          checked: trainProduct.indexOf(item.xname) !== -1
        }, index) : lang.copy));
      }))))), !hotelSummary && otherItem, !hotelSummary && remark)));
    }
  }]);

  return ProductSelector;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

ProductSelector.defaultProps = {
  /**
   * @description 操作方式
   * @example
   *  edit: 编辑
   *  read: 读 (默认)
   *  detail: 详情
   */
  operate: 'read', // 是否展示操作按钮，当为false只展示
  title: '',
  remark: '',
  minTitle: '',
  data: [
    // {
    //   text: '广州 - 北京轻轨票',
    //   type: 'num',
    //   max: 3,
    //   value: 0,
    //   unit: '张',
    // },
    // {
    //   text: '休息室',
    //   type: 'checkbox',
    //   value: false,
    //   unit: '份',
    // },
  ],
  otherItem: null,
  onChange: function onChange(index, val) {},
  trainlist: [],
  hotelNationArr: [],
  hotelSummary: '',
  airportTransferList: []
};


/* harmony default export */ __webpack_exports__["default"] = (ProductSelector);

/***/ }),

/***/ "OoWg":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('observable');


/***/ }),

/***/ "OvRC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("AFOY"), __esModule: true };

/***/ }),

/***/ "PHYd":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("tfRM");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "PJh5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(0);

/***/ }),

/***/ "PKzc":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("455d"),
    eq = __webpack_require__("jjNC");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "PX8L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PY1i":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
var document = __webpack_require__("YjQv").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "PbQV":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("ksFB");
var toLength = __webpack_require__("GhAV");
var toAbsoluteIndex = __webpack_require__("+VX5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "Pf15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "QISU":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("htHW"),
    arrayIncludes = __webpack_require__("31Lb"),
    arrayIncludesWith = __webpack_require__("OIlo"),
    cacheHas = __webpack_require__("doQp"),
    createSet = __webpack_require__("M6eO"),
    setToArray = __webpack_require__("MhA3");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "QXxj":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"question-circle\" ><title>Operation Icons Copy 12</title><g fill-rule=\"evenodd\"><path d=\"M21.186 3C10.333 3 1.827 11.506 1.827 22.358 1.827 32.494 10.333 41 21.186 41c10.133 0 18.641-8.506 18.641-18.642C39.827 11.506 31.32 3 21.186 3m15.641 19c0 8.823-7.179 16-16 16-8.823 0-16-7.177-16-16s7.177-16 16-16c8.821 0 16 7.177 16 16z\"/><path d=\"M22.827 31.5a1.5 1.5 0 1 1-2.999.001 1.5 1.5 0 0 1 3-.001M26.827 16.02c0 .957-.203 1.822-.61 2.593-.427.792-1.117 1.612-2.073 2.457-.867.734-1.453 1.435-1.754 2.096-.302.7-.453 1.693-.453 2.979a.828.828 0 0 1-.823.855.828.828 0 0 1-.584-.22.877.877 0 0 1-.24-.635c0-1.305.168-2.38.506-3.227.336-.883.93-1.682 1.779-2.4 1.01-.883 1.71-1.692 2.1-2.428.337-.645.504-1.38.504-2.209-.018-.936-.3-1.7-.85-2.289-.654-.717-1.62-1.075-2.896-1.075-1.506 0-2.596.535-3.269 1.6-.46.754-.689 1.645-.689 2.677a.92.92 0 0 1-.266.66.747.747 0 0 1-.558.25.73.73 0 0 1-.585-.194c-.16-.164-.239-.393-.239-.69 0-1.819.584-3.272 1.754-4.357C18.644 11.486 19.927 11 21.433 11h.293c1.452 0 2.638.414 3.561 1.241 1.027.902 1.54 2.162 1.54 3.78z\"/></g></symbol>";
module.exports = sprite.add(image, "question-circle");

/***/ }),

/***/ "RH2O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(218);

/***/ }),

/***/ "RLiO":
/***/ (function(module, exports, __webpack_require__) {

var Sniffr = __webpack_require__("BNrO");

/**
 * List of SVG attributes to fix url target in them
 * @type {string[]}
 */
var fixAttributes = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke'
];

/**
 * Query to find'em
 * @type {string}
 */
var fixAttributesQuery = '[' + fixAttributes.join('],[') + ']';
/**
 * @type {RegExp}
 */
var URI_FUNC_REGEX = /^url\((.*)\)$/;

/**
 * Convert array-like to array
 * @param {Object} arrayLike
 * @returns {Array.<*>}
 */
function arrayFrom(arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
}

/**
 * Handles forbidden symbols which cannot be directly used inside attributes with url(...) content.
 * Adds leading slash for the brackets
 * @param {string} url
 * @return {string} encoded url
 */
function encodeUrlForEmbedding(url) {
  return url.replace(/\(|\)/g, "\\$&");
}

/**
 * Replaces prefix in `url()` functions
 * @param {Element} svg
 * @param {string} currentUrlPrefix
 * @param {string} newUrlPrefix
 */
function baseUrlWorkAround(svg, currentUrlPrefix, newUrlPrefix) {
  var nodes = svg.querySelectorAll(fixAttributesQuery);

  if (!nodes) {
    return;
  }

  arrayFrom(nodes).forEach(function (node) {
    if (!node.attributes) {
      return;
    }

    arrayFrom(node.attributes).forEach(function (attribute) {
      var attributeName = attribute.localName.toLowerCase();

      if (fixAttributes.indexOf(attributeName) !== -1) {
        var match = URI_FUNC_REGEX.exec(node.getAttribute(attributeName));

        // Do not touch urls with unexpected prefix
        if (match && match[1].indexOf(currentUrlPrefix) === 0) {
          var referenceUrl = encodeUrlForEmbedding(newUrlPrefix + match[1].split(currentUrlPrefix)[1]);
          node.setAttribute(attributeName, 'url(' + referenceUrl + ')');
        }
      }
    });
  });
}

/**
 * Because of Firefox bug #353575 gradients and patterns don't work if they are within a symbol.
 * To workaround this we move the gradient definition outside the symbol element
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
 * @param {Element} svg
 */
var FirefoxSymbolBugWorkaround = function (svg) {
  var defs = svg.querySelector('defs');

  var moveToDefsElems = svg.querySelectorAll('symbol linearGradient, symbol radialGradient, symbol pattern');
  for (var i = 0, len = moveToDefsElems.length; i < len; i++) {
    defs.appendChild(moveToDefsElems[i]);
  }
};

/**
 * Fix for browser (IE, maybe other too) which are throwing 'WrongDocumentError'
 * if you insert an element which is not part of the document
 * @see http://stackoverflow.com/questions/7981100/how-do-i-dynamically-insert-an-svg-image-into-html#7986519
 * @param {Element} svg
 */
function importSvg(svg) {
  try {
    if (document.importNode) {
      return document.importNode(svg, true);
    }
  } catch(e) {}

  return svg;
}

/**
 * @type {string}
 */
var DEFAULT_URI_PREFIX = '#';

/**
 * @type {string}
 */
var xLinkHref = 'xlink:href';
/**
 * @type {string}
 */
var xLinkNS = 'http://www.w3.org/1999/xlink';
/**
 * @type {string}
 */
var svgOpening = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="' + xLinkNS + '"';
/**
 * @type {string}
 */
var svgClosing = '</svg>';
/**
 * @type {string}
 */
var contentPlaceHolder = '{content}';

/**
 * Representation of SVG sprite
 * @constructor
 */
function Sprite() {
  var baseElement = document.getElementsByTagName('base')[0];
  var currentUrl = window.location.href.split('#')[0];
  var baseUrl = baseElement && baseElement.href;
  this.urlPrefix = baseUrl && baseUrl !== currentUrl ? currentUrl + DEFAULT_URI_PREFIX : DEFAULT_URI_PREFIX;

  var sniffr = new Sniffr();
  sniffr.sniff();
  this.browser = sniffr.browser;
  this.content = [];

  if (this.browser.name !== 'ie' && baseUrl) {
    window.addEventListener('spriteLoaderLocationUpdated', function (e) {
      var currentPrefix = this.urlPrefix;
      var newUrlPrefix = e.detail.newUrl.split(DEFAULT_URI_PREFIX)[0] + DEFAULT_URI_PREFIX;
      baseUrlWorkAround(this.svg, currentPrefix, newUrlPrefix);
      this.urlPrefix = newUrlPrefix;

      // Don't update <use>s only for Chrome lower than 49
      if (this.browser.name !== 'chrome' || this.browser.version[0] >= 49) {
        var nodes = arrayFrom(document.querySelectorAll('use[*|href]'));
        nodes.forEach(function (node) {
          var href = node.getAttribute(xLinkHref);
          if (href && href.indexOf(currentPrefix) === 0) {
            node.setAttributeNS(xLinkNS, xLinkHref, newUrlPrefix + href.split(DEFAULT_URI_PREFIX)[1]);
          }
        });
      }
    }.bind(this));
  }
}

Sprite.styles = ['position:absolute', 'width:0', 'height:0'];

Sprite.spriteTemplate = function(){ return svgOpening + ' style="'+ Sprite.styles.join(';') +'"><defs>' + contentPlaceHolder + '</defs>' + svgClosing; }
Sprite.symbolTemplate = function() { return svgOpening + '>' + contentPlaceHolder + svgClosing; }

/**
 * @type {Array<String>}
 */
Sprite.prototype.content = null;

/**
 * @param {String} content
 * @param {String} id
 */
Sprite.prototype.add = function (content, id) {
  if (this.svg) {
    this.appendSymbol(content);
  }

  this.content.push(content);

  return DEFAULT_URI_PREFIX + id;
};

/**
 *
 * @param content
 * @param template
 * @returns {Element}
 */
Sprite.prototype.wrapSVG = function (content, template) {
  var svgString = template.replace(contentPlaceHolder, content);

  var svg = new DOMParser().parseFromString(svgString, 'image/svg+xml').documentElement;
  var importedSvg = importSvg(svg);

  if (this.browser.name !== 'ie' && this.urlPrefix) {
    baseUrlWorkAround(importedSvg, DEFAULT_URI_PREFIX, this.urlPrefix);
  }

  return importedSvg;
};

Sprite.prototype.appendSymbol = function (content) {
  var symbol = this.wrapSVG(content, Sprite.symbolTemplate()).childNodes[0];

  this.svg.querySelector('defs').appendChild(symbol);
  if (this.browser.name === 'firefox') {
    FirefoxSymbolBugWorkaround(this.svg);
  }
};

/**
 * @returns {String}
 */
Sprite.prototype.toString = function () {
  var wrapper = document.createElement('div');
  wrapper.appendChild(this.render());
  return wrapper.innerHTML;
};

/**
 * @param {HTMLElement} [target]
 * @param {Boolean} [prepend=true]
 * @returns {HTMLElement} Rendered sprite node
 */
Sprite.prototype.render = function (target, prepend) {
  target = target || null;
  prepend = typeof prepend === 'boolean' ? prepend : true;

  var svg = this.wrapSVG(this.content.join(''), Sprite.spriteTemplate());

  if (this.browser.name === 'firefox') {
    FirefoxSymbolBugWorkaround(svg);
  }

  if (target) {
    if (prepend && target.childNodes[0]) {
      target.insertBefore(svg, target.childNodes[0]);
    } else {
      target.appendChild(svg);
    }
  }

  this.svg = svg;

  return svg;
};

module.exports = Sprite;


/***/ }),

/***/ "RP4F":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 72 72\" id=\"dislike\" ><title>&#x54ED;&#x8138;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path fill=\"#FFF\" d=\"M47 22h2v6h-2zM23 22h2v6h-2z\"/><path d=\"M21 51s4.6-7 15-7 15 7 15 7\" stroke=\"#FFF\" stroke-width=\"2\"/></g></symbol>";
module.exports = sprite.add(image, "dislike");

/***/ }),

/***/ "RVTP":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("Fxj9"),
    getPrototype = __webpack_require__("vb1w"),
    isObjectLike = __webpack_require__("XUab");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "RcCz":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"left\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><defs><path id=\"left_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"left_b\"><use xlink:href=\"#left_a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#left_b)\"><defs><path id=\"left_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"left_d\"><use xlink:href=\"#left_c\" overflow=\"visible\"/></clipPath></g><path d=\"M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z\"/></symbol>";
module.exports = sprite.add(image, "left");

/***/ }),

/***/ "S/kR":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"info-circle\" ><circle cx=\"13.828\" cy=\"19.63\" r=\"1.938\"/><circle cx=\"21.767\" cy=\"19.63\" r=\"1.938\"/><circle cx=\"29.767\" cy=\"19.63\" r=\"1.938\"/><path d=\"M22.102 4.161c-9.918 0-17.958 7.146-17.958 15.961 0 4.935 2.522 9.345 6.481 12.273v5.667l.038.012a2.627 2.627 0 1 0 4.501 1.455l.002.001 5.026-3.539c.628.059 1.265.093 1.911.093 9.918 0 17.958-7.146 17.958-15.961-.001-8.816-8.041-15.962-17.959-15.962zm-.04 29.901c-.902 0-1.781-.081-2.642-.207l-5.882 4.234c-.024.025-.055.04-.083.06l-.008.006a.511.511 0 0 1-.284.095.525.525 0 0 1-.525-.525l.005-6.375c-3.91-2.516-6.456-6.544-6.456-11.1 0-7.628 7.107-13.812 15.875-13.812s15.875 6.184 15.875 13.812-7.107 13.812-15.875 13.812z\"/></symbol>";
module.exports = sprite.add(image, "info-circle");

/***/ }),

/***/ "SG5I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("uMhA");

__webpack_require__("PX8L");

/***/ }),

/***/ "SPxJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SWGL":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "Sf+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = webEntry;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRecommendCode;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRecommendCode;
/* harmony export (immutable) */ __webpack_exports__["a"] = codeExtLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_urlConfig__ = __webpack_require__("8oYa");



/**
 * @returns number 0:App 1:触屏 2: 小程序
 */
function webEntry() {
  if (window.CSNativeObject && window.CSNativeObject.nativeSetTitle && typeof window.CSNativeObject.nativeSetTitle === 'function') {
    return 0;
  } else if (sessionStorage.getItem('persist:emp') && JSON.parse(JSON.parse(sessionStorage.getItem('persist:emp')).updateDetail).urlQuery.type === 'B') {
    return 2;
  } else {
    return 1;
  }
}
//获取推荐码
function getRecommendCode(type) {
  var num = type || webEntry();
  if (num === 0) {
    // app
    var cache = window.CSNativeObject.getDataLocalStorage ? window.CSNativeObject.getDataLocalStorage(JSON.stringify({ keyName: 'employeeReferral' })) : '';
    var data = cache ? typeof cache === 'string' ? JSON.parse(cache) : '' : '';
    return data ? __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(data.referralTime)) <= 3600000 ? data.referralCode : '' : '';
  } else if (num === 1) {
    // 触屏
    return window.csmbpRecommendUtil && window.csmbpRecommendUtil.getRecommendCode();
  } else {
    // 小程序
    return JSON.parse(JSON.parse(sessionStorage.getItem('persist:emp')).updateDetail).urlQuery.recommendCode || '';
  }
}
//更新推荐码
function saveRecommendCode(code, type) {
  var num = type || webEntry();
  if (num === 0) {
    // app
    window.CSNativeObject.saveDataLocalStorage(JSON.stringify({
      employeeReferral: {
        referralCode: code,
        referralTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD HH:mm:ss')
      }
    }));
  } else if (num === 1) {
    // 触屏
    window.csmbpRecommendUtil && window.csmbpRecommendUtil.saveRecommendCode(code);
  } else {
    // 小程序
    return false;
  }
}

/**
 * 推荐码引入外部链接（仅在触屏上有用）
 */
function codeExtLink() {
  if (webEntry() === 1) {
    var oscript = document.createElement('script');
    oscript.src =  false ? url.app_url + 'public/csmbpRecommendUtil.js' : __WEBPACK_IMPORTED_MODULE_1__config_urlConfig__["default"].login_url + 'static/public/csmbpRecommendUtil.js';
    document.body.appendChild(oscript);
  }
}

/***/ }),

/***/ "Sk4Y":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "SldL":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "T1yJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "THEY":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "TJq6":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("jjNC");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "TVqP":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "TiPK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _rcSteps = __webpack_require__("M7g5");

var _rcSteps2 = _interopRequireDefault(_rcSteps);

var _index = __webpack_require__("YK8K");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Steps = function (_React$Component) {
    (0, _inherits3['default'])(Steps, _React$Component);

    function Steps() {
        (0, _classCallCheck3['default'])(this, Steps);
        return (0, _possibleConstructorReturn3['default'])(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Steps, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.direction !== 'horizontal') {
                return;
            }
            // set tail's left position based on main's width for each step dynamically.
            this.stepRefs.forEach(function (s) {
                if (s.refs.tail) {
                    s.refs.tail.style.left = s.refs.main.offsetWidth / 2 + 'px';
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.stepRefs = [];
            var _props = this.props,
                children = _props.children,
                status = _props.status;

            var current = this.props.current;
            // flattern the array at first https://github.com/ant-design/ant-design-mobile/issues/934
            var newChildren = _react2['default'].Children.map(children, function (item) {
                return item;
            });
            newChildren = _react2['default'].Children.map(newChildren, function (item, index) {
                var className = item.props.className;
                if (index < newChildren.length - 1 && newChildren[index + 1].props.status === 'error') {
                    className = className ? className + ' error-tail' : 'error-tail';
                }
                var icon = item.props.icon;
                if (!icon) {
                    if (index < current) {
                        // 对应 state: finish
                        icon = 'check-circle-o';
                    } else if (index > current) {
                        // 对应 state: wait
                        icon = 'ellipsis';
                        className = className ? className + ' ellipsis-item' : 'ellipsis-item';
                    }
                    if (status === 'error' && index === current || item.props.status === 'error') {
                        icon = 'cross-circle-o';
                    }
                }
                icon = typeof icon === 'string' ? _react2['default'].createElement(_index2['default'], { type: icon }) : icon;
                return _react2['default'].cloneElement(item, { icon: icon, className: className, ref: function ref(c) {
                        return _this2.stepRefs[index] = c;
                    } });
            });
            return _react2['default'].createElement(
                _rcSteps2['default'],
                (0, _extends3['default'])({ ref: 'rcSteps' }, this.props),
                newChildren
            );
        }
    }]);
    return Steps;
}(_react2['default'].Component);

exports['default'] = Steps;

Steps.Step = _rcSteps2['default'].Step;
Steps.defaultProps = {
    prefixCls: 'am-steps',
    iconPrefix: 'ant',
    labelPlacement: 'vertical',
    direction: 'vertical',
    current: 0
};
module.exports = exports['default'];

/***/ }),

/***/ "TzkF":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"search\" ><title>System Icons Copy 8</title><path d=\"M32.981 29.255l8.914 8.293L39.603 40l-8.859-8.242a15.952 15.952 0 0 1-10.754 4.147C11.16 35.905 4 28.763 4 19.952 4 11.142 11.16 4 19.99 4s15.99 7.142 15.99 15.952c0 3.472-1.112 6.685-2.999 9.303zm.05-9.21c0 7.123-5.701 12.918-12.88 12.918-7.177 0-13.016-5.795-13.016-12.918 0-7.12 5.839-12.917 13.017-12.917 7.178 0 12.879 5.797 12.879 12.917z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "search");

/***/ }),

/***/ "V/++":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _ListItem = __webpack_require__("nwKQ");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var List = function (_React$Component) {
    (0, _inherits3['default'])(List, _React$Component);

    function List() {
        (0, _classCallCheck3['default'])(this, List);
        return (0, _possibleConstructorReturn3['default'])(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    (0, _createClass3['default'])(List, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                children = _a.children,
                className = _a.className,
                style = _a.style,
                renderHeader = _a.renderHeader,
                renderFooter = _a.renderFooter,
                restProps = __rest(_a, ["prefixCls", "children", "className", "style", "renderHeader", "renderFooter"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                renderHeader ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-header' },
                    typeof renderHeader === 'function' ? renderHeader() : renderHeader
                ) : null,
                children ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-body' },
                    children
                ) : null,
                renderFooter ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-footer' },
                    typeof renderFooter === 'function' ? renderFooter() : renderFooter
                ) : null
            );
        }
    }]);
    return List;
}(_react2['default'].Component);

exports['default'] = List;

List.Item = _ListItem2['default'];
List.defaultProps = {
    prefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),

/***/ "V9Z5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VD8v":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("x//u");
var toObject = __webpack_require__("wXdB");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "VIWw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vzau":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 43 38\" id=\"koubei\" ><title>&#x53E3;&#x7891;</title><g fill-rule=\"evenodd\"><path d=\"M4.921 1.227c-1.814 0-3.284 1.452-3.284 3.243v8.459c0 8.86 6.073 16.517 13.589 19.49a.701.701 0 0 1 .31.233c.138.196.122.388.122.388v2.148s-.012.463.393.865c.242.241.506.338.794.368.885.094 1.962.214 4.493-.119a23.972 23.972 0 0 0 12.492-5.61c5.866-5.067 8.145-11.896 8.145-17.763V4.563c0-1.792-1.47-3.336-3.285-3.336H4.92z\"/><path d=\"M33.506 12.506c0-1.06.873-1.918 1.95-1.918 1.078 0 1.95.858 1.95 1.918 0 1.059-.872 1.918-1.95 1.918-1.077 0-1.95-.86-1.95-1.918z\" fill=\"#FFF\"/><path d=\"M9.127 13.465c0 6.087 5.564 12.847 12.626 12.784 3.336-.03 8.006-1.522 10.778-5.784\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g></symbol>";
module.exports = sprite.add(image, "koubei");

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(189);

/***/ }),

/***/ "W6Rd":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "WKQ7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "WO/L":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("HXwK"),
    getPrototype = __webpack_require__("vb1w"),
    isPrototype = __webpack_require__("rELt");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "WQjr":
/***/ (function(module, exports, __webpack_require__) {

!function(t,i){ true?module.exports=i():"function"==typeof define&&define.amd?define(i):t.dayjs_plugin_utc=i()}(this,function(){"use strict";return function(t,i,e){var s=i.prototype;e.utc=function(t){return new i({date:t,utc:!0,args:arguments})},s.utc=function(t){var i=e(this.toDate(),{locale:this.$L,utc:!0});return t?i.add(this.utcOffset(),"minute"):i},s.local=function(){return e(this.toDate(),{locale:this.$L,utc:!1})};var f=s.parse;s.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),f.call(this,t)};var n=s.init;s.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else n.call(this)};var u=s.utcOffset;s.utcOffset=function(t,i){var e=this.$utils().u;if(e(t))return this.$u?0:e(this.$offset)?u.call(this):this.$offset;var s=Math.abs(t)<=16?60*t:t,f=this;if(i)return f.$offset=s,f.$u=0===t,f;if(0!==t){var n=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(f=this.local().add(s+n,"minute")).$offset=s,f.$x.$localOffset=n}else f=this.utc();return f};var o=s.format;s.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return o.call(this,i)},s.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},s.isUTC=function(){return!!this.$u},s.toISOString=function(){return this.toDate().toISOString()},s.toString=function(){return this.toDate().toUTCString()};var r=s.toDate;s.toDate=function(t){return"s"===t&&this.$offset?e(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():r.call(this)};var a=s.diff;s.diff=function(t,i,s){if(this.$u===t.$u)return a.call(this,t,i,s);var f=this.local(),n=e(t).local();return a.call(f,n,i,s)}}});


/***/ }),

/***/ "WcGK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("24Tv");

/***/ }),

/***/ "WdqR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "Wdy1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var ctx = __webpack_require__("3fMt");
var hide = __webpack_require__("aLzV");
var has = __webpack_require__("x//u");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "WqOw":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("TJq6");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "X+/p":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.dayjs_plugin_timezone=e()}(this,function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,u=o().utcOffset(),a=function(t,n,i){void 0===i&&(i={});var o=new Date(t);return function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i).formatToParts(o)},f=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],v=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+v+":"+r[4]+":"+r[5]+":000",l=+e;return(o.utc(h).valueOf()-(l-=l%1e3))/6e4},s=i.prototype;s.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate().toLocaleString("en-US",{timeZone:t}),a=Math.round((this.toDate()-new Date(i))/1e3/60),f=o(i).$set("millisecond",this.$ms).utcOffset(u-a,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},s.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find(function(t){return"timezonename"===t.type.toLowerCase()});return n&&n.value},o.tz=function(t,e,n){var i=n&&e,u=n||e||r,a=f(+o(),u);if("string"!=typeof t)return o(t).tz(u);var s=function(t,e,n){var i=t-60*e*1e3,o=f(i,n);if(e===o)return[i,e];var r=f(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),a,u),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=u,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}});


/***/ }),

/***/ "XUab":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "Xxa5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("jyFz");


/***/ }),

/***/ "YK8K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var warnMsg = 'Icon props.type is invalid, have you set svg-sprite-loader correctly? see https://goo.gl/kN8oiw';

var Icon = function (_React$Component) {
    (0, _inherits3['default'])(Icon, _React$Component);

    function Icon() {
        (0, _classCallCheck3['default'])(this, Icon);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));

        _this.renderSvg = function () {
            var type = _this.props.type;

            var svg = void 0;
            try {
                svg = __webpack_require__("Zele")("./" + type + '.svg');
            } catch (e) {} finally {
                return svg;
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Icon, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                type = _a.type,
                className = _a.className,
                style = _a.style,
                size = _a.size,
                restProps = __rest(_a, ["type", "className", "style", "size"]);
            if (!type || typeof type !== 'string') {
                console.error(warnMsg);
                return null;
            }
            var xlinkHref = this.renderSvg();
            var outerIcon = void 0;
            if (!xlinkHref) {
                outerIcon = true;
                xlinkHref = type;
                if (!/^#/.test(type)) {
                    console.error(warnMsg);
                }
            } else {
                if (!/^#/.test(xlinkHref)) {
                    console.error(warnMsg);
                }
                xlinkHref = '#' + type;
            }
            var iconClassName = (0, _classnames2['default'])((_classNames = {
                'am-icon': true
            }, (0, _defineProperty3['default'])(_classNames, 'am-icon-' + (outerIcon ? type.substr(1) : type), true), (0, _defineProperty3['default'])(_classNames, 'am-icon-' + size, true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames));
            return _react2['default'].createElement(
                'svg',
                (0, _extends3['default'])({ className: iconClassName, style: style }, restProps),
                _react2['default'].createElement('use', { xlinkHref: xlinkHref })
            );
        }
    }]);
    return Icon;
}(_react2['default'].Component);

exports['default'] = Icon;

Icon.defaultProps = {
    size: 'md'
};
module.exports = exports['default'];

/***/ }),

/***/ "YTz9":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "YjQv":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "Yv2V":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("HERM");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "YwPS":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("HERM"),
    baseRest = __webpack_require__("uWbD"),
    customDefaultsMerge = __webpack_require__("oZb9"),
    mergeWith = __webpack_require__("jbs9");

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),

/***/ "Z09J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _rcCheckbox = __webpack_require__("jF3+");

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _omit = __webpack_require__("JkBm");

var _omit2 = _interopRequireDefault(_omit);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Checkbox = function (_React$Component) {
    (0, _inherits3['default'])(Checkbox, _React$Component);

    function Checkbox() {
        (0, _classCallCheck3['default'])(this, Checkbox);
        return (0, _possibleConstructorReturn3['default'])(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Checkbox, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                style = _props.style,
                children = _props.children;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), _classNames));
            var mark = _react2['default'].createElement(
                'label',
                { className: wrapCls, style: style },
                _react2['default'].createElement(_rcCheckbox2['default'], (0, _omit2['default'])(this.props, ['className', 'style'])),
                children
            );
            if (this.props.wrapLabel) {
                return mark;
            }
            return _react2['default'].createElement(_rcCheckbox2['default'], this.props);
        }
    }]);
    return Checkbox;
}(_react2['default'].Component);

exports['default'] = Checkbox;

Checkbox.defaultProps = {
    prefixCls: 'am-checkbox',
    wrapLabel: true
};
module.exports = exports['default'];

/***/ }),

/***/ "Zele":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./check-circle-o.svg": "jGHP",
	"./check-circle.svg": "ygug",
	"./check.svg": "+MS5",
	"./cross-circle-o.svg": "sdiJ",
	"./cross-circle.svg": "D2L8",
	"./cross.svg": "ZlHB",
	"./down.svg": "ytCb",
	"./ellipsis-circle.svg": "cCn+",
	"./ellipsis.svg": "k2pG",
	"./exclamation-circle.svg": "43O/",
	"./info-circle.svg": "S/kR",
	"./koubei-o.svg": "DON5",
	"./koubei.svg": "Vzau",
	"./left.svg": "RcCz",
	"./loading.svg": "CIhR",
	"./question-circle.svg": "QXxj",
	"./right.svg": "scfM",
	"./search.svg": "TzkF",
	"./up.svg": "7dw9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zele";

/***/ }),

/***/ "ZlHB":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"cross\" ><path d=\"M24.008 21.852l8.969-8.968L31.093 11l-8.969 8.968L13.156 11l-1.884 1.884 8.968 8.968-9.24 9.24 1.884 1.885 9.24-9.24 9.24 9.24 1.885-1.884-9.24-9.24z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "cross");

/***/ }),

/***/ "Zp9L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("YK8K");

var _index2 = _interopRequireDefault(_index);

var _rcTouchable = __webpack_require__("zMcl");

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child) {
    if (isString(child.type) && isTwoCNChar(child.props.children)) {
        return _react2['default'].cloneElement(child, {}, child.props.children.split('').join(' '));
    }
    if (isString(child)) {
        if (isTwoCNChar(child)) {
            child = child.split('').join(' ');
        }
        return _react2['default'].createElement(
            'span',
            null,
            child
        );
    }
    return child;
}

var Button = function (_React$Component) {
    (0, _inherits3['default'])(Button, _React$Component);

    function Button() {
        (0, _classCallCheck3['default'])(this, Button);
        return (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Button, [{
        key: 'render',
        value: function render() {
            var _wrapCls;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                type = _a.type,
                size = _a.size,
                inline = _a.inline,
                across = _a.across,
                disabled = _a.disabled,
                icon = _a.icon,
                loading = _a.loading,
                activeStyle = _a.activeStyle,
                activeClassName = _a.activeClassName,
                onClick = _a.onClick,
                delayPressIn = _a.delayPressIn,
                delayPressOut = _a.delayPressOut,
                restProps = __rest(_a, ["children", "className", "prefixCls", "type", "size", "inline", "across", "disabled", "icon", "loading", "activeStyle", "activeClassName", "onClick", "delayPressIn", "delayPressOut"]);
            var wrapCls = (_wrapCls = {}, (0, _defineProperty3['default'])(_wrapCls, className, className), (0, _defineProperty3['default'])(_wrapCls, prefixCls, true), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-primary', type === 'primary'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-ghost', type === 'ghost'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-warning', type === 'warning'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-small', size === 'small'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-inline', inline), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-across', across), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-loading', loading), _wrapCls);
            var iconType = loading ? 'loading' : icon;
            var kids = _react2['default'].Children.map(children, insertSpace);
            if (iconType) {
                wrapCls[prefixCls + '-icon'] = true;
            }
            var delayProps = {};
            if (delayPressIn) {
                delayProps.delayPressIn = delayPressIn;
            }
            if (delayPressOut) {
                delayProps.delayPressOut = delayPressOut;
            }
            // use div, button native is buggy @yiminghe
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                (0, _extends3['default'])({ activeClassName: activeClassName || (activeStyle ? prefixCls + '-active' : undefined), disabled: disabled, activeStyle: activeStyle }, delayProps),
                _react2['default'].createElement(
                    'a',
                    (0, _extends3['default'])({ role: 'button', className: (0, _classnames2['default'])(wrapCls) }, restProps, { onClick: disabled ? undefined : onClick, 'aria-disabled': disabled }),
                    iconType ? _react2['default'].createElement(_index2['default'], { 'aria-hidden': 'true', type: iconType, size: size === 'small' ? 'xxs' : 'md' }) : null,
                    kids
                )
            );
        }
    }]);
    return Button;
}(_react2['default'].Component);

Button.defaultProps = {
    prefixCls: 'am-button',
    size: 'large',
    inline: false,
    across: false,
    disabled: false,
    loading: false,
    activeStyle: {}
};
exports['default'] = Button;
module.exports = exports['default'];

/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "ZuYg":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BQO6"), __esModule: true };

/***/ }),

/***/ "a/OS":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("iANj");
var global = __webpack_require__("YjQv");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("c8Kh") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "a1o4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * 退改程序功能路由
 * */
/* harmony default export */ __webpack_exports__["default"] = ({
  ticket: {
    key: 'ticket',
    name: '',
    path: '/ticket',
    child: {
      updateDetail: {
        key: 'updateDetail',
        name: '机票退改',
        path: '/ticket/updateDetail'
      },
      search: {
        key: 'search',
        name: '退改搜索',
        path: '/ticket/search'
      },
      addPersonMessage: {
        key: 'addPersonMessage',
        name: '补充旅客信息',
        path: '/ticket/addPersonMessage'
      },
      addProductShop: {
        key: 'addProductShop',
        name: '推荐服务',
        path: '/ticket/addProductShop'
      },
      realNameVerify: {
        key: 'realNameVerify',
        name: '退款账户认证',
        path: '/ticket/realNameVerify'
      },
      reformProcess: {
        key: 'ReformProcess',
        refundName: '退票详情',
        changeName: '变更详情',
        refundSeat: '取消行程详情',
        path: '/ticket/ReformProcess'
      },
      ticketChange: {
        key: 'TicketChange',
        name: '',
        path: '/ticket/TicketChange'
      },
      endorsedApply: {
        key: 'EndorsedApply',
        changeName: '变更申请',
        refundName: '退票申请',
        refundSeat: '取消行程申请',
        path: '/ticket/EndorsedApply'
      },
      selectDate: {
        key: 'selectDate',
        refundName: '选择航班日期',
        changeName: '选择航班日期',
        path: '/ticket/selectDate'
      },
      applySubmit: {
        key: 'ApplySubmit',
        refundName: '退票申请',
        refundSeat: '取消行程申请',
        changeName: '机票变更',
        path: '/ticket/ApplySubmit'
      },
      loginFeeQuery: {
        key: 'loginFeeQuery',
        name: '退改费用查询',
        path: '/ticket/loginFeeQuery'
      },
      feeQuery: {
        key: 'feeQuery',
        name: '退改费用查询',
        path: '/ticket/feeQuery',
        childs: {
          login: {
            key: 'login',
            name: '退改费用查询',
            path: '/ticket/feeQuery/login'
          },
          list: {
            key: 'list',
            name: '退改费用查询',
            path: '/ticket/feeQuery/list'
          },
          detail: {
            key: 'detail',
            name: '退改费用查询',
            path: '/ticket/feeQuery/detail'
          }
        }
      },
      ticketFeeQuery: {
        key: 'ticketFeeQuery',
        name: '退改费用查询',
        path: '/ticket/ticketFeeQuery'
      },
      changeFlight: {
        key: 'changeFlight',
        name: '优惠推荐',
        path: '/ticket/changeFlight'
      },
      easyLogin: {
        key: 'easyLogin',
        name_easy: '退改/升舱',
        name_more: '机票退改',
        path: '/ticket/easyLogin'
      },
      pay: {
        key: 'pay',
        name: '支付结果',
        path: '/ticket/pay'
      },
      electronicInvoice: {
        key: 'electronicInvoice',
        name: '电子发票',
        path: '/ticket/electronicInvoice'
      },
      officialTicket: {
        key: 'officialTicket',
        name: '公务员信息认证',
        path: '/ticket/officialTicket'
      },
      moreInvoice: {
        key: 'moreInvoice',
        name: '我的电子发票',
        path: '/ticket/moreInvoice'
      },
      invoiceDetails: {
        key: 'invoiceDetails',
        name: '查看',
        path: '/ticket/invoiceDetails'
      },
      coupon: {
        key: 'coupon',
        name: '优惠券',
        path: '/ticket/coupon'
      },
      refundCoupon: {
        key: 'refundCoupon',
        name: '退票优惠券',
        path: '/ticket/refundCoupon'
      },
      refundApply: {
        key: 'refundApply',
        name: '退票申请',
        path: '/ticket/refundApply'
      },
      faceRecognition: {
        key: 'faceRecognition',
        name: '微信人脸识别认证',
        path: '/ticket/faceRecognition'
      },
      certificationResults: {
        key: 'certificationResults',
        name: '微信人脸识别认证',
        path: '/ticket/certificationResults'
      },
      wrongPurchase: {
        key: 'wrongPurchase',
        name: '错购申请',
        path: '/ticket/wrongPurchase'
      },
      viewProgress: {
        key: 'viewProgress',
        name: '查看进度',
        path: '/ticket/viewProgress'
      },
      facemoreQurey: {
        key: 'facemoreQurey',
        name: '更多查询',
        path: '/ticket/facemoreQurey'
      },
      // changeRefundExplain: {
      //   key: 'changeRefundExplain',
      //   name: '退改说明',
      //   path: '/ticket/changeRefundExplain',
      // },
      changeRefundExplain: {
        key: 'changeRefundExplain',
        name: '退改说明',
        path: '/ticket/changeRefundExplain',
        childs: {
          list: {
            key: 'list',
            name: '退改费用查询',
            path: '/ticket/changeRefundExplain/list'
          },
          detail: {
            key: 'detail',
            name: '退改费用查询',
            path: '/ticket/changeRefundExplain/detail'
          }
        }
      },
      cancelLation: {
        key: 'cancelLation',
        name: '取消行程',
        path: '/ticket/cancelLation'
      },
      // GN: [ID1678500][2024-11-26]
      discountTicketApplication: {
        key: 'discountTicketApplication',
        name: '降价客票申请',
        path: '/ticket/discountTicketApplication'
      }
    }
  }
});

/***/ }),

/***/ "aJUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/toast/style/css.web.js
var css_web = __webpack_require__("gj9y");
var css_web_default = /*#__PURE__*/__webpack_require__.n(css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/toast/index.web.js
var index_web = __webpack_require__("qZDr");
var index_web_default = /*#__PURE__*/__webpack_require__.n(index_web);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ../emp-helpers/dist/es/index.js + 57 modules
var es = __webpack_require__("mekh");

// EXTERNAL MODULE: ./src/config/urlConfig.js
var urlConfig = __webpack_require__("8oYa");

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__("oFuF");

// CONCATENATED MODULE: ./src/utils/setApiMessageObj.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var statusCodeMsg = {};
function requestMergeCode(apiKey, apiArr) {
  apiArr.forEach(function (data) {
    if (!statusCodeMsg[apiKey]) {
      statusCodeMsg[apiKey] = data;
    } else {
      statusCodeMsg[apiKey] = Object.assign({}, statusCodeMsg[apiKey], data);
    }
  });
}
/**
 * 匹配状态码提示语
 * @param {string} [code='']
 * @param {*} [invalidArgs=[]]
 * @param {*} [reqConfig={}] ajax 请求配置
 * @return {string}
 */
function getStatusCodeMsg() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var invalidArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var reqConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultMsg = arguments[3];

  var _url = reqConfig.url ? reqConfig.url : this.url;
  if (!_url) return '';
  // _url = new URL('http://' + _url);
  var urls = _url.split('/');
  var api = urls[urls.length - 1] || urls[urls.length - 2];
  api = api.split('?')[0];
  if (!statusCodeMsg[api] || !statusCodeMsg[api][code]) {
    return defaultMsg ? defaultMsg : '';
  }
  var msg = statusCodeMsg[api][code];
  var _invalidArgs = Array.isArray(invalidArgs) ? [].concat(_toConsumableArray(invalidArgs)) : [];
  return msg.replace(/(\${invalidArg})/g, function () {
    return _invalidArgs.shift();
  }).replace(/CHD/g, '');
}

/**
 * 兼容后台接口读取规则invalidCode、invalidArgs
 * @param {object} response 后台接口返参
 * @return {}
 */
function getStatusCodeFiled(response) {
  var _response = Array.isArray(response) ? response[0] : response;
  if (!_response) {
    return {
      invalidCode: '',
      invalidArgs: []
    };
  }

  return {
    invalidCode: _response.errorInfo ? _response.errorInfo.invalidCode : _response.error ? _response.error.invalidCode ? _response.error.invalidCode : _response.error.errorCode : _response.invalidCode,
    invalidArgs: _response.errorInfo ? _response.errorInfo.invalidArgs : _response.invalidArgs
  };
}
/**
 * 设置状态码信息
 * @param {object | array} response 后台接口返参，可当 helpers.httpClient 响应中间件使用
 * @param {object} reqConfig ajax xhr
 * @return {respoonse}
 */
function setResponseMsg2(response, reqConfig) {
  if (!response || Array.isArray(response) && !response.length) return response;

  var statusCode = getStatusCodeFiled(response);
  var msg = getStatusCodeMsg(statusCode.invalidCode, statusCode.invalidArgs, reqConfig);
  var result = Array.isArray(response) ? response[0] : response;

  function finProAndSetMsg(obj) {
    var obj_isOpen = window.sessionStorage.getItem('integral_Switch');
    var propertyChainList = ['checkMsg', 'warning', 'error.errorMsg', 'errorInfo.errorMsg', 'errorInfo.description', 'refundModeRes.error.errorMsg', 'showMsg', 'responseMessage', 'message'];
    for (var k = 0; k < propertyChainList.length; k++) {
      var isBreak = false;
      var subPropertyList = propertyChainList[k].split('.');
      var copyObj = null;
      var Num_of_copies = 0;
      for (var j = 0; j < subPropertyList.length; j++) {
        if (copyObj) {
          if (!copyObj[subPropertyList[j]]) {
            copyObj = null;
            Num_of_copies = 0;
            break;
          }
          if (copyObj[subPropertyList[j]] instanceof Object) {
            Num_of_copies += 1;
            copyObj = copyObj[subPropertyList[j]];
          }
        }
        if (copyObj) {
          if (typeof copyObj[subPropertyList[j]] === 'string' && j == subPropertyList.length - 1 && subPropertyList.length - 1 == Num_of_copies) {
            isBreak = true;
            break;
          }
        }
        if (copyObj === null) {
          if (!obj[subPropertyList[j]]) {
            copyObj = null;
            Num_of_copies = 0;
            break;
          }
          if (obj[subPropertyList[j]] instanceof Object) {
            Num_of_copies += 1;
            copyObj = obj[subPropertyList[j]];
          }
        }
        if (typeof obj[subPropertyList[j]] === 'string' && j == subPropertyList.length - 1 && subPropertyList.length - 1 == Num_of_copies) {
          isBreak = true;
          break;
        }
      }
      if (isBreak) {
        var _ret = function () {
          var copyObject = null;
          subPropertyList.forEach(function (item) {
            if (copyObject == null) {
              if (obj[item]) {
                copyObject = obj[item];
              }
            } else {
              if (copyObject[item] && copyObject[item] instanceof Object) {
                copyObject = copyObject[item];
              }
              if (typeof copyObject[item] == 'string') {
                if (obj_isOpen == 'Y') {
                  copyObject[item] = msg ? msg : copyObject[item].replace(/(里程)/g, '积分');
                } else {
                  copyObject[item] = msg ? msg : copyObject[item];
                }
              }
            }
          });
          if (subPropertyList.length === 1) {
            if (obj_isOpen == 'Y') {
              obj[subPropertyList[0]] = msg ? msg : obj[subPropertyList[0]].replace(/(里程)/g, '积分');
            } else {
              obj[subPropertyList[0]] = msg ? msg : obj[subPropertyList[0]];
            }
          }
          return 'break';
        }();

        if (_ret === 'break') break;
      }
    }
  }
  finProAndSetMsg(result);
  if (Array.isArray(response)) return [result];

  return result;
}
// EXTERNAL MODULE: ./src/utils/enEXchange.js
var enEXchange = __webpack_require__("D6oK");

// EXTERNAL MODULE: ./src/config/routerConfig.js
var routerConfig = __webpack_require__("a1o4");

// EXTERNAL MODULE: ./src/components/PopUp/index.js
var PopUp = __webpack_require__("2H8H");

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/icon/style/css.web.js
var style_css_web = __webpack_require__("h2Na");
var style_css_web_default = /*#__PURE__*/__webpack_require__.n(style_css_web);

// EXTERNAL MODULE: ./node_modules/antd-mobile/lib/icon/index.web.js
var icon_index_web = __webpack_require__("YK8K");
var icon_index_web_default = /*#__PURE__*/__webpack_require__.n(icon_index_web);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./src/components/BusyPopup/index.less
var BusyPopup = __webpack_require__("VIWw");
var BusyPopup_default = /*#__PURE__*/__webpack_require__.n(BusyPopup);

// EXTERNAL MODULE: ./src/components/Btn/index.js
var Btn = __webpack_require__("yU3I");

// EXTERNAL MODULE: ./src/config/commonlang/cn.js
var cn = __webpack_require__("GxNa");

// EXTERNAL MODULE: ./src/config/commonlang/en.js
var en = __webpack_require__("/aCt");

// CONCATENATED MODULE: ./src/components/BusyPopup/index.js



var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var popPwdQueue = [];

var BusyPopup_PopPwdComponent = function (_Component) {
  _inherits(PopPwdComponent, _Component);

  function PopPwdComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopPwdComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopPwdComponent.__proto__ || Object.getPrototypeOf(PopPwdComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.onChange = function (e) {
      _this.setState({ value: e.target.value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopPwdComponent, [{
    key: 'render',
    value: function render() {
      var lang = cn["a" /* default */];
      var isEN = window.sessionStorage.getItem('language') == 'en';
      if (isEN) {
        lang = en["a" /* default */];
      }
      if (window.sessionStorage.getItem('persist:emp')) {
        lang = JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App).lang;
      }
      var _props = this.props,
          onCancel = _props.onCancel,
          onConfirm = _props.onConfirm,
          destroy = _props.destroy;
      var value = this.state.value;

      return _jsx('section', {
        className: 'pop-pwd'
      }, void 0, _jsx('div', {
        id: 'ppc',
        className: 'pop-pwd-content',
        role: 'dialog',
        tabIndex: '-1',
        'aria-modal': 'true'
      }, void 0, _jsx(icon_index_web_default.a, {
        type: 'cross',
        onClick: function onClick(e) {
          return onCancel(destroy);
        },
        role: 'button',
        'aria-label': '\u5173\u95ED'
      }), _jsx('p', {}, void 0, lang.inputTip1), _jsx('div', {
        className: 'pop-btns'
      }, void 0, _jsx(Btn["default"], {
        text: lang.Understood,
        onClick: function onClick(e) {
          return onConfirm(destroy, value);
        }
      }))));
    }
  }]);

  return PopPwdComponent;
}(reactfrom_dll_reference_vendor_library["Component"]);

BusyPopup_PopPwdComponent.props = {
  title: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  destroy: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onConfirm: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onCancel: prop_typesfrom_dll_reference_vendor_library_default.a.func
};
BusyPopup_PopPwdComponent.defaultProps = {
  title: '',
  destroy: function destroy() {},
  onConfirm: function onConfirm(destroy, value) {
    destroy && destroy();
  },
  onCancel: function onCancel(destroy) {
    destroy && destroy();
  }
};


function PopPwd(prop) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  var timeoutEvn = null;
  function keydownFun(e) {
    var dom = document.getElementById('ppc');
    var focusableElements = dom.getElementsByTagName('*');
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var isTabPressed = e.key === 'Tab' || e.shiftKey && e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  var destroy = function destroy() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  react_domfrom_dll_reference_vendor_library_default.a.render(reactfrom_dll_reference_vendor_library_default.a.createElement(BusyPopup_PopPwdComponent, Object.assign({}, prop, { destroy: destroy })), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('ppc').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(function () {
    focus();
    trapFocus();
  }, 200);
  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

PopPwd.clear = function () {
  if (popPwdQueue && popPwdQueue.length) {
    popPwdQueue.forEach(function (progess) {
      progess();
    });
    popPwdQueue = [];
  }
};
// EXTERNAL MODULE: ./src/components/LoginPopup/index.less
var LoginPopup = __webpack_require__("SPxJ");
var LoginPopup_default = /*#__PURE__*/__webpack_require__.n(LoginPopup);

// CONCATENATED MODULE: ./src/components/LoginPopup/index.js
var LoginPopup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LoginPopup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LoginPopup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPopup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPopup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var LoginPopup_popPwdQueue = [];

var LoginPopup_LoginpopComponent = function (_Component) {
  LoginPopup__inherits(LoginpopComponent, _Component);

  function LoginpopComponent() {
    var _ref;

    var _temp, _this, _ret;

    LoginPopup__classCallCheck(this, LoginpopComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LoginPopup__possibleConstructorReturn(this, (_ref = LoginpopComponent.__proto__ || Object.getPrototypeOf(LoginpopComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.onChange = function (e) {
      _this.setState({ value: e.target.value });
    }, _temp), LoginPopup__possibleConstructorReturn(_this, _ret);
  }

  LoginPopup__createClass(LoginpopComponent, [{
    key: 'render',
    value: function render() {
      var lang = cn["a" /* default */];
      var isEN = window.sessionStorage.getItem('language') == 'en';
      if (isEN) {
        lang = en["a" /* default */];
      }
      if (window.sessionStorage.getItem('persist:emp')) {
        lang = JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App).lang;
      }
      var _props = this.props,
          onCancel = _props.onCancel,
          onConfirm = _props.onConfirm,
          destroy = _props.destroy,
          toLogin = _props.toLogin;
      var value = this.state.value;

      return LoginPopup__jsx('section', {
        className: 'loginPop'
      }, void 0, LoginPopup__jsx('div', {
        id: 'lctct',
        className: 'login-content',
        role: 'dialog',
        tabIndex: '-1',
        'aria-modal': 'true'
      }, void 0, LoginPopup__jsx('p', {
        className: 'popUP_title'
      }, void 0, lang.reminder1), LoginPopup__jsx('p', {}, void 0, lang.transportation5), LoginPopup__jsx('div', {
        className: 'pop-btns'
      }, void 0, LoginPopup__jsx(Btn["default"], {
        text: lang.login,
        onClick: function onClick(e) {
          return onConfirm(destroy, toLogin);
        }
      }))));
    }
  }]);

  return LoginpopComponent;
}(reactfrom_dll_reference_vendor_library["Component"]);

LoginPopup_LoginpopComponent.props = {
  title: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  destroy: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onConfirm: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onCancel: prop_typesfrom_dll_reference_vendor_library_default.a.func
};
LoginPopup_LoginpopComponent.defaultProps = {
  title: '',
  destroy: function destroy() {},
  onConfirm: function onConfirm(destroy, toLogin) {
    toLogin && toLogin();
    destroy && destroy();
  },
  onCancel: function onCancel(destroy) {
    destroy && destroy();
  }
};


function renderLoginPop(props) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  var timeoutEvn = null;
  function keydownFun(e) {
    var dom = document.getElementById('lctct');
    var focusableElements = dom.getElementsByTagName('*');
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var isTabPressed = e.key === 'Tab' || e.shiftKey && e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  var destroy = function destroy() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    react_domfrom_dll_reference_vendor_library_default.a.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  react_domfrom_dll_reference_vendor_library_default.a.render(reactfrom_dll_reference_vendor_library_default.a.createElement(LoginPopup_LoginpopComponent, Object.assign({}, props, { destroy: destroy, toLogin: props.toLogin })), div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('lctct').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(function () {
    focus();
    trapFocus();
  }, 200);
  LoginPopup_popPwdQueue.push(destroy);
  return LoginPopup_popPwdQueue[LoginPopup_popPwdQueue.length - 1];
}

function loginPopup(toLogin) {
  renderLoginPop({
    toLogin: toLogin
  });
}

// PopPwd.clear = () => {
//   if (popPwdQueue && popPwdQueue.length) {
//     popPwdQueue.forEach(progess => {
//       progess();
//     });
//     popPwdQueue = [];
//   }
// };
// EXTERNAL MODULE: ./src/components/ProgressBar/index.js
var ProgressBar = __webpack_require__("7OyB");

// CONCATENATED MODULE: ./src/store/axiosMiddleware.js
/* harmony export (immutable) */ __webpack_exports__["c"] = login;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony export (immutable) */ __webpack_exports__["b"] = axiosMiddleware;




var readConfig = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.createHttp('post', urlConfig["default"].getConfig, {
              data: {
                key: ['is_Easy_Login_Turn_On']
              }
            });

          case 2:
            response = _context.sent;

            if (!response.data.map['is_Easy_Login_Turn_On']) {
              _context.next = 6;
              break;
            }

            window.location.href = urlConfig["default"].common_query_easy_url + '?redirect=' + encodeURIComponent(urlConfig["default"].pageInfoDto.homeUrl) + '&channel=emp';
            return _context.abrupt('return', false);

          case 6:
            login();

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function readConfig() {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













var axiosMiddleware_isEN = window.sessionStorage.getItem('language') ? window.sessionStorage.getItem('language') == 'en' : location.href.includes('language=en');
function isAxiosRequest(action) {
  return action.payload && action.payload.request;
}
function jumpPage() {
  var curl = window.location.href;
  if (curl.includes('refundTicket')) {
    window.location.href = urlConfig["default"].fastRefundUrl;
  }
  // if (
  //   curl.includes('ticketChange') ||
  //   curl.includes('/ticket/selectDate') ||
  //   curl.includes('/ticket/TicketChange')
  // ) {
  //   window.errorProcess();
  //   window.location.href = urlConfig.fastChange;
  // }
  if (curl.includes('updateDetail') || curl.includes('ticketChange') || curl.includes('/ticket/selectDate') || curl.includes('/ticket/TicketChange')) {
    PopPwd();
  }
}
function getParams(url) {
  var theRequest = {};
  if (url.indexOf('?') !== -1) {
    var str = url.split('?');
    if (str[1] === '') {
      return theRequest;
    }
    var strs = str[1].split('&');
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}

function login() {
  var url = '';
  // let query = JSON.parse(
  //   JSON.parse(sessionStorage.getItem('persist:emp')).updateDetail
  // ).urlQuery;
  var persist_emp = JSON.parse(sessionStorage.getItem('persist:emp'));
  var p = getParams(window.location.href);
  if (p.moreQuery) delete p.moreQuery;
  if (p.easyQuery) delete p.easyQuery;
  if (p.urlParams) delete p.urlParams;
  if (p.selectTabStyle) delete p.selectTabStyle;
  var query = persist_emp ? JSON.parse(persist_emp.updateDetail).urlQuery : p;
  if (window.location.hash.indexOf(routerConfig["default"].ticket.child.reformProcess.path) !== -1) {
    url = encodeURIComponent(urlConfig["default"].app_url + 'ticketRefund/#' + routerConfig["default"].ticket.child.reformProcess.path + window.location.hash.slice(window.location.hash.indexOf('?')));
  } else if (window.location.hash.indexOf(routerConfig["default"].ticket.child.wrongPurchase.path) !== -1) {
    url = encodeURIComponent(urlConfig["default"].app_url + 'ticketRefund/#' + routerConfig["default"].ticket.child.wrongPurchase.path);
  } else if (window.location.hash.indexOf(routerConfig["default"].ticket.child.feeQuery.path) !== -1) {
    url = encodeURIComponent(urlConfig["default"].app_url + 'ticketRefund/#' + routerConfig["default"].ticket.child.feeQuery.childs.login.path);
  } else if (window.location.hash.indexOf(routerConfig["default"].ticket.child.cancelLation.path) !== -1) {
    url = encodeURIComponent(urlConfig["default"].app_url + 'ticketRefund/#' + routerConfig["default"].ticket.child.cancelLation.path);
  } else {
    url = encodeURIComponent(urlConfig["default"].app_url + 'ticketRefund/#' + routerConfig["default"].ticket.child.updateDetail.path + '?' + Object(util["toQueryString"])(query));
  }
  if (persist_emp) {
    var App = JSON.parse(persist_emp.App);
    App.userInfo.channel = null;
    persist_emp.App = JSON.stringify(App);
    sessionStorage.setItem('persist:emp', JSON.stringify(persist_emp));
  }
  if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram'
  // &&
  // (query.channel == 'cuss' ||
  //   JSON.parse(persist_emp ? persist_emp.updateDetail : '{}')
  //     .faceCheckChannel)
  ) {
      // uniteLogin(
      //   `${urlConfig.login_url
      //   }personal_new/login/#/?t=forward&redirect=${url}&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=2&topBarRightCode=empty&coopAccount=`,
      //   function () {
      //     Toast.info('登录失效', 1);
      //   }
      // );
      wx.miniProgram.navigateTo({
        url: '/page/jump?action=login&loginNextUrl=' + url + '&loginNextUrlRefresh=1'
      });
    } else {
    Object(es["K" /* uniteLogin */])(urlConfig["default"].login_url + 'personal_new/login/#/?t=forward&redirect=' + url + '&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=0&coopAccount=', function () {
      index_web_default.a.info(axiosMiddleware_isEN ? en["a" /* default */].loginFail : '登录失效', 1);
    });
  }
}

var client = new es["a" /* HttpClient */]({
  timeout: 0,
  responseType: 'json',
  headers: {
    'x-requested-with': 'XMLHttpRequest'
  }
}, {
  config: {
    channel: true,
    channelRoutes: [routerConfig["default"].ticket.child.endorsedApply.path, routerConfig["default"].ticket.child.refundApply.path, routerConfig["default"].ticket.child.selectDate.path, routerConfig["default"].ticket.child.ticketChange.path, routerConfig["default"].ticket.child.applySubmit.path]
  },
  load: {
    loading: function loading() {
      index_web_default.a.loading(axiosMiddleware_isEN ? en["a" /* default */].load11 : '加载中', 0);
      if (document.getElementById('wrapper')) {
        document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
      }
    },
    ending: function ending() {
      index_web_default.a.hide();
      if (document.getElementById('wrapper')) {
        document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
      }
    }
  },
  request: {
    interceptors: [{
      interceptor: function interceptor(config) {
        // 异常测试，其它时候需要注释掉
        // config = enhanceRequest(config);
        if (config.url.indexOf(urlConfig["default"].downloadFile) !== -1) {
          config['responseType'] = 'blob';
        }
        if (window.location.href.includes('certificationResults')) {
          index_web_default.a.hide();
          if (document.getElementById('wrapper')) {
            document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
          }
        }
        config.headers['login-channel'] = navigator.userAgent.toLowerCase().includes('toutiaomicroapp') ? 'd' : Object(es["r" /* getRequestChannel */])(config._channel);
        return config;
      },
      error: function error(_error) {
        index_web_default.a.hide();
        if (document.getElementById('wrapper')) {
          document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
        }
        return _error;
      }
    }]
  },
  response: {
    interceptors: [{
      interceptor: function interceptor(response) {
        // 接口数据 三字码 根据CMC重置
        if (response.config.url.indexOf(urlConfig["default"].downloadFile) !== -1) {
          console.log(response);
          return response.data;
        }
        if (response.config.url.indexOf(urlConfig["default"].afterSaleChangeReqDetail) !== -1 && Array.isArray(response.data.segInfoList)) {
          response.data.segInfoList.forEach(function (item) {
            var depCode3Obj = Object(es["l" /* getCode3Widget */])(item.depAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
            var arrCode3Obj = Object(es["l" /* getCode3Widget */])(item.arrAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
            var oldarrCode3Obj = Object(es["l" /* getCode3Widget */])(item.oldarrAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
            var olddepCode3Obj = Object(es["l" /* getCode3Widget */])(item.olddepAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
            // item.depAirportNameSimple = getAbAirport(depCode3Obj);
            // item.arrAirportNameSimple = getAbAirport(arrCode3Obj);
            item.depAirportNameSimple = Object(es["k" /* getAbAirport */])(depCode3Obj) || depCode3Obj.airportName || item.depairportname;
            item.arrAirportNameSimple = Object(es["k" /* getAbAirport */])(arrCode3Obj) || arrCode3Obj.airportName || item.arrairportname;
            item.olddepAirportNameSimple = Object(es["k" /* getAbAirport */])(olddepCode3Obj) || olddepCode3Obj.airportName || item.olddepairportname;
            item.oldarrAirportNameSimple = Object(es["k" /* getAbAirport */])(oldarrCode3Obj) || oldarrCode3Obj.airportName || item.oldarrairportname;
            item.departCityName = depCode3Obj.cityName;
            item.arriveCityName = arrCode3Obj.cityName;
            item.depairportname = depCode3Obj.airportName;
            item.arrairportname = arrCode3Obj.airportName;
            item.oldDepartCityName = olddepCode3Obj.cityName;
            item.oldArriveCityName = oldarrCode3Obj.cityName;
          });
        }
        if (response.config.url.indexOf(urlConfig["default"].afterGetRefundOrderDetail) !== -1 && Array.isArray(response.data.segmentInfos)) {
          response.data.segmentInfos.forEach(function (item) {
            var depCode3Obj = Object(es["l" /* getCode3Widget */])(item.depAirportCode, false, axiosMiddleware_isEN ? 'en' : 'cn');
            var arrCode3Obj = Object(es["l" /* getCode3Widget */])(item.arrAirportCode, false, axiosMiddleware_isEN ? 'en' : 'cn');
            item.depAirportNameSimple = Object(es["k" /* getAbAirport */])(depCode3Obj) || depCode3Obj.airportName || item.depAirport;
            item.arrAirportNameSimple = Object(es["k" /* getAbAirport */])(arrCode3Obj) || arrCode3Obj.airportName || item.arrAirport;
            item.depCity = depCode3Obj.cityName;
            item.arrCity = arrCode3Obj.cityName;
            item.depAirport = depCode3Obj.airportName;
            item.arrAirport = arrCode3Obj.airportName;
          });
        }
        if ((response.config.url.indexOf(urlConfig["default"].getTicektList) !== -1 || response.config.url.indexOf(urlConfig["default"].getMoreTicektList) !== -1 || response.config.url.indexOf(urlConfig["default"].getIntreatmentBack) !== -1) && Array.isArray(response.data.orderList)) {
          response.data.orderList.forEach(function (item) {
            var arrCode3Obj = Object(es["l" /* getCode3Widget */])(item.arrAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
            var depCode3Obj = Object(es["l" /* getCode3Widget */])(item.depAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
            if (item.transitAirport) {
              var transitCode3Obj = Object(es["l" /* getCode3Widget */])(item.transitAirport, false, axiosMiddleware_isEN ? 'en' : 'cn');
              item.transitCityName = transitCode3Obj.cityName;
              item.transitAirportName = transitCode3Obj.airportName;
            }
            item.depCityName = depCode3Obj.cityName;
            item.arrCityName = arrCode3Obj.cityName;
            item.depAirportName = depCode3Obj.airportName;
            item.arrAirportName = arrCode3Obj.airportName;
          });
        }
        if (response.config.url.indexOf(urlConfig["default"].checkOrderTicket) !== -1 && response.data.ticketFlights) {
          response.data.ticketFlights.flightList.forEach(function (item) {
            var depCode3Obj = Object(es["l" /* getCode3Widget */])(item.depAirport, item.planeType, axiosMiddleware_isEN ? 'en' : 'cn');
            var arrCode3Obj = Object(es["l" /* getCode3Widget */])(item.arrAirport, item.planeType, axiosMiddleware_isEN ? 'en' : 'cn');
            item.depAirportNameSimple = Object(es["k" /* getAbAirport */])(depCode3Obj);
            item.arrAirportNameSimple = Object(es["k" /* getAbAirport */])(arrCode3Obj);
            item.depCityName = depCode3Obj.cityName;
            item.arrCityName = arrCode3Obj.cityName;
            item.depAirportName = depCode3Obj.airportName;
            item.arrAirportName = arrCode3Obj.airportName;
            item.departMCT = {
              gn_gn: item.departDDMCT,
              gn_gj: item.departDIMCT,
              gj_gj: item.departAIMCT,
              gj_gn: item.departADMCT
            };
            item.arriveMCT = {
              gn_gn: item.arrivalDDMCT,
              gn_gj: item.arrivalDIMCT,
              gj_gj: item.arrivalAIMCT,
              gj_gn: item.arrivalADMCT
            };
          });
        }
        if (response.config.url.indexOf(urlConfig["default"].changeReqNewFlightDetail) !== -1 && Array.isArray(response.data.list)) {
          response.data.list.forEach(function (item) {
            var arrCode3Obj = Object(es["l" /* getCode3Widget */])(item.arriveAirport, item.planeStyle, axiosMiddleware_isEN ? 'en' : 'cn');
            var depCode3Obj = Object(es["l" /* getCode3Widget */])(item.departAirport, item.planeStyle, axiosMiddleware_isEN ? 'en' : 'cn');
            item.depAirportNameSimple = Object(es["k" /* getAbAirport */])(depCode3Obj);
            item.arrAirportNameSimple = Object(es["k" /* getAbAirport */])(arrCode3Obj);
            item.departCity = depCode3Obj.cityName;
            item.arriveCity = arrCode3Obj.cityName;
            item.departAirportName = depCode3Obj.airportName;
            item.arriveAirportName = arrCode3Obj.airportName;
            // 处理单段变中转多段数据
            if (item.flightItemList && item.flightItemList.length > 0) {
              item.flightItemList.forEach(function (key) {
                var arrCode3Obj = Object(es["l" /* getCode3Widget */])(key.arriveAirport, item.planeStyle, axiosMiddleware_isEN ? 'en' : 'cn');
                var depCode3Obj = Object(es["l" /* getCode3Widget */])(key.departAirport, item.planeStyle, axiosMiddleware_isEN ? 'en' : 'cn');
                key.depAirportNameSimple = Object(es["k" /* getAbAirport */])(depCode3Obj);
                key.arrAirportNameSimple = Object(es["k" /* getAbAirport */])(arrCode3Obj);
                key.departCity = depCode3Obj.cityName;
                key.arriveCity = arrCode3Obj.cityName;
                key.departAirportName = depCode3Obj.airportName;
                key.arriveAirportName = arrCode3Obj.airportName;
              });
            }
          });
          if (response.data.bayArea && response.data.bayArea.segmentOptions) {
            response.data.bayArea.segmentOptions.forEach(function (child) {
              var arrCode = Object(es["l" /* getCode3Widget */])(child.arriveAirportCode, false, axiosMiddleware_isEN ? 'en' : 'cn');
              var depCode = Object(es["l" /* getCode3Widget */])(child.departAirportCode, false, axiosMiddleware_isEN ? 'en' : 'cn');
              child.text = depCode.airportNameSimple + '-' + arrCode.airportNameSimple;
            });
          }
        }

        // 系统异常，进入预约流程
        var err = void 0;
        if (Array.isArray(response.data)) {
          if (response.data[0]) err = response.data[0].errorInfo || response.data[0].error;
        } else {
          err = response.data.errorInfo || response.data.error;
        }
        if (err && Object(es["n" /* getInterfaceError */])(err.errorCode) && JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App)['sysConfig']['the_flag_fastchange']) {
          jumpPage();
        }
        if (response.config.url.includes('getAreaCodeList')) {
          return response;
        }
        response.data = Object(es["H" /* setResponseMsg */])(response.data);

        // GN: [ID1556600][2024-10-16]
        // if (window.sessionStorage.getItem('csSwitch') == 'Y') {
        //   let type = window.sessionStorage.getItem('scopeType');
        //   if (/(updateDetail)/.test(window.location.href)) {
        //     if (response.config.url.includes('moreQuery')) {
        //       requestMergeCode('moreQuery', [
        //         require('../utils/apiAppeaNewMessgae/moreQuery.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (response.config.url.includes('checkOrderTicket')) {
        //       requestMergeCode('checkOrderTicket', [
        //         type
        //           ? type.includes('bg')
        //             ? require('../utils/apiAppeaNewMessgae/checkOrderTicket.change.json')
        //             : require('../utils/apiAppeaNewMessgae/checkOrderTicket.refund.json')
        //           : require('../utils/apiAppeaNewMessgae/checkOrderTicket.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(changeRefundExplain)/.test(window.location.href)) {
        //     if (response.config.url.includes('queryRefundChangeFee')) {
        //       requestMergeCode('queryRefundChangeFee', [
        //         require('../utils/apiAppeaNewMessgae/queryRefundChangeFee.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (response.config.url.includes('checkOrderTicketTPWL')) {
        //       requestMergeCode('checkOrderTicketTPWL', [
        //         require('../utils/apiAppeaNewMessgae/checkOrderTicket.tpwl.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(cancelLation)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicketTPWL')) {
        //       requestMergeCode('checkOrderTicketTPWL', [
        //         require('../utils/apiAppeaNewMessgae/checkOrderTicket.tpwl.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(EndorsedApply)/.test(window.location.href)) {
        //     let selectStyle = '';
        //     if (/(ticketChange)/.test(window.location.href))
        //       selectStyle = 'change';
        //     if (/(refundTicket)/.test(window.location.href))
        //       selectStyle = 'refund';
        //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';
        //     if (response.config.url.includes('cancelCheckIn')) {
        //       requestMergeCode('cancelCheckIn', [
        //         require('../utils/apiAppeaNewMessgae/cancelCheckIn.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (response.config.url.includes('checkFlightDate')) {
        //       requestMergeCode('checkFlightDate', [
        //         require('../utils/apiAppeaNewMessgae/checkFlightDate.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('checkTicketFlight')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiAppeaNewMessgae/checkTicketFlight.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiAppeaNewMessgae/checkTicketFlight.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkTicketFlightTPWL', [
        //           require('../utils/apiAppeaNewMessgae/checkTicketFlight.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('checkOrderTicket')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiAppeaNewMessgae/checkOrderTicket.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiAppeaNewMessgae/checkOrderTicket.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkOrderTicketTPWL', [
        //           require('../utils/apiAppeaNewMessgae/checkOrderTicket.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(refundApply)/.test(window.location.href)) {
        //     if (response.config.url.includes('afterSaleRefundApp')) {
        //       requestMergeCode('afterSaleRefundApp', [
        //         require('../utils/apiAppeaNewMessgae/createRefund.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (response.config.url.includes('createRefundTa')) {
        //       requestMergeCode('createRefundTa', [
        //         require('../utils/apiAppeaNewMessgae/createRefundTa.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (response.config.url.includes('submitFastRefundMultiple')) {
        //       requestMergeCode('submitFastRefundMultiple', [
        //         require('../utils/apiAppeaNewMessgae/submitFastRefundMultiple.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(selectDate)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkFlightDate')) {
        //       requestMergeCode('checkFlightDate', [
        //         require('../utils/apiAppeaNewMessgae/checkFlightDate.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(TicketChange)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkFlightDate')) {
        //       requestMergeCode('checkFlightDate', [
        //         require('../utils/apiAppeaNewMessgae/checkFlightDate.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (
        //       response.config.url.includes(
        //         'afterSaleChangeReqNewFlightDetail'
        //       )
        //     ) {
        //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
        //         require('../utils/apiAppeaNewMessgae/afterSaleChangeReqNewFlightDetail.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(ApplySubmit)/.test(window.location.href)) {
        //     let apiname = '';
        //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
        //       apiname = 'afterSaleChangeReqPayOK';
        //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
        //       apiname = 'afterSaleVolChangeReqPayOK';
        //     if (response.config.url.includes('touchConfirmIntVol'))
        //       apiname = 'touchConfirmIntVol';
        //     if (
        //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
        //         response.config.url
        //       )
        //     ) {
        //       requestMergeCode(apiname, [
        //         require('../utils/apiAppeaNewMessgae/change.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        // } else {
        //   let type = window.sessionStorage.getItem('scopeType');
        //   if (/(updateDetail)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicket')) {
        //       requestMergeCode('checkOrderTicket', [
        //         type
        //           ? type.includes('bg')
        //             ? require('../utils/apiAppeaOldMessgae/checkOrderTicket.change.json')
        //             : require('../utils/apiAppeaOldMessgae/checkOrderTicket.refund.json')
        //           : require('../utils/apiAppeaOldMessgae/checkOrderTicket.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(cancelLation)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicketTPWL')) {
        //       requestMergeCode('checkOrderTicketTPWL', [
        //         require('../utils/apiAppeaOldMessgae/checkOrderTicket.tpwl.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(EndorsedApply)/.test(window.location.href)) {
        //     let selectStyle = '';
        //     if (/(ticketChange)/.test(window.location.href))
        //       selectStyle = 'change';
        //     if (/(refundTicket)/.test(window.location.href))
        //       selectStyle = 'refund';
        //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';

        //     if (response.config.url.includes('checkTicketFlight')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiAppeaOldMessgae/checkTicketFlight.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiAppeaOldMessgae/checkTicketFlight.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkTicketFlightTPWL', [
        //           require('../utils/apiAppeaOldMessgae/checkTicketFlight.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('checkOrderTicket')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiAppeaOldMessgae/checkOrderTicket.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiAppeaOldMessgae/checkOrderTicket.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkOrderTicketTPWL', [
        //           require('../utils/apiAppeaOldMessgae/checkOrderTicket.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(refundApply)/.test(window.location.href)) {
        //     if (response.config.url.includes('afterSaleRefundApp')) {
        //       requestMergeCode('afterSaleRefundApp', [
        //         require('../utils/apiAppeaOldMessgae/createRefund.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('submitFastRefundMultiple')) {
        //       requestMergeCode('submitFastRefundMultiple', [
        //         require('../utils/apiAppeaOldMessgae/submitFastRefundMultiple.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(TicketChange)/.test(window.location.href)) {
        //     if (
        //       response.config.url.includes(
        //         'afterSaleChangeReqNewFlightDetail'
        //       )
        //     ) {
        //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
        //         require('../utils/apiAppeaOldMessgae/afterSaleChangeReqNewFlightDetail.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(ApplySubmit)/.test(window.location.href)) {
        //     let apiname = '';
        //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
        //       apiname = 'afterSaleChangeReqPayOK';
        //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
        //       apiname = 'afterSaleVolChangeReqPayOK';
        //     if (response.config.url.includes('touchConfirmIntVol'))
        //       apiname = 'touchConfirmIntVol';
        //     if (
        //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
        //         response.config.url
        //       )
        //     ) {
        //       requestMergeCode(apiname, [
        //         require('../utils/apiAppeaOldMessgae/change.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        // }

        // if (window.sessionStorage.getItem('atSwitch') == 'Y') {
        //   let type = window.sessionStorage.getItem('scopeType');
        //   if (/(updateDetail)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicket')) {
        //       requestMergeCode('checkOrderTicket', [
        //         type
        //           ? type.includes('bg')
        //             ? require('../utils/apiArtiNewMessage/checkOrderTicket.change.json')
        //             : require('../utils/apiArtiNewMessage/checkOrderTicket.refund.json')
        //           : require('../utils/apiArtiNewMessage/checkOrderTicket.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(changeRefundExplain)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicketTPWL')) {
        //       requestMergeCode('checkOrderTicketTPWL', [
        //         require('../utils/apiArtiNewMessage/checkOrderTicket.tpwl.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(cancelLation)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicketTPWL')) {
        //       requestMergeCode('checkOrderTicketTPWL', [
        //         require('../utils/apiArtiNewMessage/checkOrderTicket.tpwl.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(EndorsedApply)/.test(window.location.href)) {
        //     let selectStyle = '';
        //     if (/(ticketChange)/.test(window.location.href))
        //       selectStyle = 'change';
        //     if (/(refundTicket)/.test(window.location.href))
        //       selectStyle = 'refund';
        //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';

        //     if (response.config.url.includes('checkTicketFlight')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiArtiNewMessage/checkTicketFlight.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiArtiNewMessage/checkTicketFlight.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkTicketFlightTPWL', [
        //           require('../utils/apiArtiNewMessage/checkTicketFlight.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('checkOrderTicket')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiArtiNewMessage/checkOrderTicket.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiArtiNewMessage/checkOrderTicket.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkOrderTicketTPWL', [
        //           require('../utils/apiArtiNewMessage/checkOrderTicket.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(refundApply)/.test(window.location.href)) {
        //     if (response.config.url.includes('afterSaleRefundApp')) {
        //       requestMergeCode('afterSaleRefundApp', [
        //         require('../utils/apiArtiNewMessage/createRefund.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('submitFastRefundMultiple')) {
        //       requestMergeCode('submitFastRefundMultiple', [
        //         require('../utils/apiArtiNewMessage/submitFastRefundMultiple.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(selectDate)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkFlightDate')) {
        //       requestMergeCode('checkFlightDate', [
        //         require('../utils/apiArtiNewMessage/checkFlightDate.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(TicketChange)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkFlightDate')) {
        //       requestMergeCode('checkFlightDate', [
        //         require('../utils/apiArtiNewMessage/checkFlightDate.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //     if (
        //       response.config.url.includes(
        //         'afterSaleChangeReqNewFlightDetail'
        //       )
        //     ) {
        //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
        //         require('../utils/apiArtiNewMessage/afterSaleChangeReqNewFlightDetail.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(ApplySubmit)/.test(window.location.href)) {
        //     let apiname = '';
        //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
        //       apiname = 'afterSaleChangeReqPayOK';
        //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
        //       apiname = 'afterSaleVolChangeReqPayOK';
        //     if (response.config.url.includes('touchConfirmIntVol'))
        //       apiname = 'touchConfirmIntVol';
        //     if (
        //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
        //         response.config.url
        //       )
        //     ) {
        //       requestMergeCode(apiname, [
        //         require('../utils/apiArtiNewMessage/change.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        // } else {
        //   let type = window.sessionStorage.getItem('scopeType');
        //   if (/(updateDetail)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicket')) {
        //       requestMergeCode('checkOrderTicket', [
        //         type
        //           ? type.includes('bg')
        //             ? require('../utils/apiOldMessage/checkOrderTicket.change.json')
        //             : require('../utils/apiOldMessage/checkOrderTicket.refund.json')
        //           : require('../utils/apiOldMessage/checkOrderTicket.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(cancelLation)/.test(window.location.href)) {
        //     if (response.config.url.includes('checkOrderTicketTPWL')) {
        //       requestMergeCode('checkOrderTicketTPWL', [
        //         require('../utils/apiOldMessage/checkOrderTicket.tpwl.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(EndorsedApply)/.test(window.location.href)) {
        //     let selectStyle = '';
        //     if (/(ticketChange)/.test(window.location.href))
        //       selectStyle = 'change';
        //     if (/(refundTicket)/.test(window.location.href))
        //       selectStyle = 'refund';
        //     if (/(TPWL)/.test(window.location.href)) selectStyle = 'tpwl';

        //     if (response.config.url.includes('checkTicketFlight')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiOldMessage/checkTicketFlight.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkTicketFlight', [
        //           require('../utils/apiOldMessage/checkTicketFlight.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkTicketFlightTPWL', [
        //           require('../utils/apiOldMessage/checkTicketFlight.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }

        //     if (response.config.url.includes('checkOrderTicket')) {
        //       if (selectStyle === 'refund') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiOldMessage/checkOrderTicket.refund.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'change') {
        //         requestMergeCode('checkOrderTicket', [
        //           require('../utils/apiOldMessage/checkOrderTicket.change.json'),
        //         ]);
        //       }
        //       if (selectStyle === 'tpwl') {
        //         requestMergeCode('checkOrderTicketTPWL', [
        //           require('../utils/apiOldMessage/checkOrderTicket.tpwl.json'),
        //         ]);
        //       }
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(refundApply)/.test(window.location.href)) {
        //     if (response.config.url.includes('submitFastRefundMultiple')) {
        //       requestMergeCode('submitFastRefundMultiple', [
        //         require('../utils/apiOldMessage/submitFastRefundMultiple.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }

        //   if (/(TicketChange)/.test(window.location.href)) {
        //     if (
        //       response.config.url.includes(
        //         'afterSaleChangeReqNewFlightDetail'
        //       )
        //     ) {
        //       requestMergeCode('afterSaleChangeReqNewFlightDetail', [
        //         require('../utils/apiOldMessage/afterSaleChangeReqNewFlightDetail.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        //   if (/(ApplySubmit)/.test(window.location.href)) {
        //     let apiname = '';
        //     if (response.config.url.includes('afterSaleChangeReqPayOK'))
        //       apiname = 'afterSaleChangeReqPayOK';
        //     if (response.config.url.includes('afterSaleVolChangeReqPayOK'))
        //       apiname = 'afterSaleVolChangeReqPayOK';
        //     if (response.config.url.includes('touchConfirmIntVol'))
        //       apiname = 'touchConfirmIntVol';
        //     if (
        //       /(afterSaleChangeReqPayOK)|(afterSaleVolChangeReqPayOK)|(touchConfirmIntVol)/.test(
        //         response.config.url
        //       )
        //     ) {
        //       requestMergeCode(apiname, [
        //         require('../utils/apiOldMessage/change.json'),
        //       ]);
        //       response.data = setResponseMsg2(
        //         response.data,
        //         response.config
        //       );
        //     }
        //   }
        // }
        response.data = Object(enEXchange["b" /* setResponseMsg3 */])(response.data, response.config);
        return response;
      },
      error: function error(_error2) {
        index_web_default.a.hide();
        if (document.getElementById('wrapper')) {
          document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
        }
        if (_error2.errorCode) {
          switch (_error2.errorCode) {
            case 9998:
              if (axiosMiddleware_isEN) {
                Object(PopUp["default"])(en["a" /* default */].reminder1, en["a" /* default */].timeOut);
              } else {
                Object(PopUp["default"])('温馨提示', '网络超时');
              }
              break;
            case 9999:
              if (!_error2.response || _error2.response.status !== 999) {
                if (_error2.response.status === 504 && (_error2.response.config.url.includes('afterSaleVolChangeReqPayOK') || _error2.response.config.url.includes('afterSaleChangeReqPayOK') || _error2.response.config.url.includes('afterSaleRefundApp') || _error2.response.config.url.includes('createRefundTa') || _error2.response.config.url.includes('createGPChange') || _error2.response.config.url.includes('createE2EChange') || _error2.response.config.url.includes('createE2ERefund'))) {
                  ProgressBar["a" /* default */].clear();
                  var isAIComming = window.sessionStorage.getItem('isAIComming');
                  var isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
                  var enterUrl = window.sessionStorage.getItem('enterUrl') ? window.sessionStorage.getItem('enterUrl') : "https://emp.csair.com/" + 'ticketRefund/#/ticket/updateDetail?' + (isAIComming ? 'channel=AI&from=assistant' : isAICommingFT ? 'channel=AI' : '');
                  var tip = _error2.response.config.url.includes('afterSaleVolChangeReqPayOK') || _error2.response.config.url.includes('afterSaleChangeReqPayOK') || _error2.response.config.url.includes('createGPChange') || _error2.response.config.url.includes('createE2EChange') ? axiosMiddleware_isEN ? en["a" /* default */].Processing2 : '您的变更申请已提交，请稍后在“处理中”或“已退改”列表中查看详情或完成支付。若无法查询到相关变更申请，请重新提交变更，谢谢。' : axiosMiddleware_isEN ? en["a" /* default */].Processing3 : '您的退票申请已提交，稍后请在“处理中”或“已退改”模块查看。若您无法查询到您的退票申请，请重新点击“退票”按钮申请客票退票，谢谢。';
                  if (!window.sessionStorage.getItem('进度条')) {
                    console.log(window.location.href, '超时地址');
                    Object(PopUp["default"])(axiosMiddleware_isEN ? en["a" /* default */].reminder1 : '温馨提示', tip, function () {
                      if (window.location.href.includes('refundApply') && window.location.href.includes('channel=AI')) {
                        window.location.href = "https://emp.csair.com/" + 'ticketRefund/#/ticket/updateDetail?';
                        return;
                      }
                      window.location.href = enterUrl;
                    }, '', [{
                      text: axiosMiddleware_isEN ? en["a" /* default */].refCupon33 : '确认',
                      onPress: function onPress() {
                        if (window.location.href.includes('refundApply') && window.location.href.includes('channel=AI')) {
                          window.location.href = "https://emp.csair.com/" + 'ticketRefund/#/ticket/updateDetail?';
                          return;
                        }
                        window.location.href = enterUrl;
                      }
                    }], '3.85rem');
                  }
                } else {
                  if (axiosMiddleware_isEN) {
                    Object(PopUp["default"])(en["a" /* default */].reminder1, en["a" /* default */].yichang);
                  } else {
                    Object(PopUp["default"])('温馨提示', '网络异常');
                  }
                }
              }
              break;
            default:
              break;
          }
        }

        if (_error2.response) {
          // 系统异常，进入预约流程
          if (_error2.response.status >= 500 && _error2.response.status < 999 && JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).App)['sysConfig']['the_flag_fastchange']) {
            jumpPage();
          }
          // 用户权限失效，登录操作
          if (_error2.response.status === 999) {
            loginPopup(readConfig);
            return _error2;
          }
        }
        return _error2;
      }
    }]
  }
});

function axiosMiddleware(_ref2) {
  var dispatch = _ref2.dispatch,
      getState = _ref2.getState;

  return function (next) {
    return function (action) {
      // 是否是axios规范action
      if (!isAxiosRequest(action)) {
        return next(action);
      }

      var type = action.type,
          closeLoading = action.closeLoading,
          request = action.payload.request,
          cache = action.cache;


      var options = {
        config: request,
        loading: !closeLoading
      };
      if (cache) options.cache = cache;

      next(Object.assign({}, action, { type: type })); // 请求前action

      return client.createHttp(request.method, request.url, options).then(function (response) {
        var newAction = {
          type: action.type + '_SUCCESS',
          payload: response,
          meta: {
            previousAction: action
          }
        };

        // 防止该中间件向下响应导致报错
        if (response.errorCode && (response.errorCode === 9999 || response.errorCode === 9998)) {
          newAction.payload = response.response || { data: {} };
        }

        next(newAction);
        return newAction;
      }, function (error) {
        var nextAction = {
          type: action.type + '_FAIL',
          error: error,
          meta: {
            previousAction: action
          }
        };
        if (error.errorCode === 9999 && error.response.status === 999) {
          return error;
        }
        next(nextAction);
        return nextAction;
      });
    };
  };
}

/***/ }),

/***/ "aLzV":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var createDesc = __webpack_require__("YTz9");
module.exports = __webpack_require__("qs+f") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "abPz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("Aq0r");
var step = __webpack_require__("beh1");
var Iterators = __webpack_require__("yYxz");
var toIObject = __webpack_require__("ksFB");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("4dmN")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "auxS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA2CAMAAABQrCHsAAAAqFBMVEUAAAD+///9///+///9///////////9///////9///8///9///////////////////9///9///9///9///9///9///////9///9///8///8///9///////////9///9///9///9///////////////////////9///8///9///9///9///8///8///9///9///8///////////9///9///9///8///9//9z023KAAAAN3RSTlMAgPl5ZkoJ5TTqxaImGQUC9O7Zvpd1IPvUycG1ORDerYdrUUVBLBTOsqWTj1xZi29dPRfg355fkjTDkAAAAchJREFUSMft1el6qjAQgOEBQUBBEAtudWvdWrXbWb77v7Pj1IOtViX2d98/yQMMQ5JJkBPeXGvZTQM78Tq9+sRvSLm3rMMhe+TGctFs2eYEr1KVs+Y3qKS32vjhvFGNZq/P9RQ1vJMz3CZbrZej94Zjj63R6XQZW/1QvoqdAFhE8pV+3S9XThvoXS+XYxbQm8tZjg3p4PgiUL+4MtMEWodP+G1YlqzKHTCWTxod6FalRAbt2eGgklxKtaAme7kNEykX2rD5POk1MWHBouhHNkzFxCD5ePJJU5l5hL7seOCKmRzsgahX8GIx1IVNkfVGTFXgofjAqZiaQVPL6haCWIwN4XbbPMMfMVcHZ9dMxFwGj9umoynNudATqbZpV8VcBIGIDx25RgID3WsjuUYKoUx0ja9R03kYQ8tSTiSX3VcslWrVjig0fbnkgb078dirXczEh4rYYL0Du6RsdyPpaRQgSjslm9/ad36ifqLORV1dh6uh1mHtGzV/L37TcH/VKeiRHTmW0V72+zYqtcRU46WLaq5CMZWPA9TCKTk519a7tUjs9lF2vfSIXvOfkw1Rv7O5lLI40Hdjw1/iXvCUi5kwKGK6f0/MwD+t73D8JQxTkgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "axIB":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "b+bF":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("sTRE"),
    isLength = __webpack_require__("ZuYg");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "bBQ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/autoCheck.37d1141c.gif";

/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "bSeU":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "beh1":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "bpde":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c8Kh":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "cCn+":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis-circle\" ><title>ellipsis-circle-cp</title><g fill-rule=\"evenodd\"><path d=\"M22.13.109C10.049.109.255 9.903.255 21.984s9.794 21.875 21.875 21.875 21.875-9.794 21.875-21.875S34.211.109 22.13.109zm0 40.7c-10.396 0-18.825-8.429-18.825-18.825 0-10.396 8.429-18.825 18.825-18.825 10.396 0 18.825 8.429 18.825 18.825 0 10.396-8.429 18.825-18.825 18.825z\"/><circle cx=\"21.888\" cy=\"22.701\" r=\"2.445\"/><circle cx=\"12.23\" cy=\"22.701\" r=\"2.445\"/><circle cx=\"31.546\" cy=\"22.701\" r=\"2.445\"/></g></symbol>";
module.exports = sprite.add(image, "ellipsis-circle");

/***/ }),

/***/ "cW2c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "cbHt":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "cz0U":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "d7ze":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "dACV":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("t8pr"),
    getTag = __webpack_require__("+Ds/"),
    isArguments = __webpack_require__("6+fr"),
    isArray = __webpack_require__("cW2c"),
    isArrayLike = __webpack_require__("b+bF"),
    isBuffer = __webpack_require__("Fq9N"),
    isPrototype = __webpack_require__("rELt"),
    isTypedArray = __webpack_require__("d7ze");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "dCxW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "doQp":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("cz0U");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "eGYj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loadingHardly.6b58b342.gif";

/***/ }),

/***/ "eawX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "evKR":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "f17K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ "fAzg":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "fMlP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fgXa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhTm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");
var transformData = __webpack_require__("12Os");
var isCancel = __webpack_require__("WKQ7");
var defaults = __webpack_require__("nCfu");
var isAbsoluteURL = __webpack_require__("IByH");
var combineURLs = __webpack_require__("/dMe");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "fs/i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("WcGK");

__webpack_require__("lxLf");

/***/ }),

/***/ "gCWN":
/***/ (function(module, exports) {



/***/ }),

/***/ "gCui":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/x-cloud.f26e4882.png";

/***/ }),

/***/ "gLkT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gj9y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("h2Na");

__webpack_require__("tpC5");

/***/ }),

/***/ "gvQx":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 72 72\" id=\"success\" ><title>&#x6210;&#x529F;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M19 34.54l11.545 11.923L52.815 24\"/></g></symbol>";
module.exports = sprite.add(image, "success");

/***/ }),

/***/ "h2Na":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("qcQk");

/***/ }),

/***/ "hVCa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAMAAADeWG8gAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAARnQU1BAACxjwv8YQUAAAABc1JHQgCuzhzpAAAAqFBMVEUAAADMzMzMzMzNzc3Ly8vLy8vLy8v////Ly8u/v7/MzMzJycnKysrMzMzMzMzLy8vMzMzLy8vLy8vLy8vLy8vNzc3MzMzNzc3KysrMzMzLy8vMzMzMzMzLy8vMzMzMzMzNzc3Ly8v2+v/MzMz0+P7x9fnS0tP1+f/m5+ri5Of19/3Y2dvY2drR0dL0+Pzm6OvNzc7x8/nu8PTT09Tn6ezz9/3l5+rR0tLlmZB7AAAAInRSTlMA1FYkt+n5AuoEWyYiI1rL68yyWf3X9VdYztXpz9D7tlzl0fST6wAAAJpJREFUGNNVkNcWgzAMQ80IUCjde9FGgTBK9/j/PysrPXAfdWzZEhGRPZ04cEy3R4r+GDU7TykM+SeU4TXH1qgUe4jzhZekGRaWphMNEL15jXiW6zqZiLni/hAJNBoh5C0ELAJkS5EJNp2p9FZ4LTteL8zmq+qiUD4R3O5fIsO6zuQzfOPy+wiO0STyVca9989dNHE6sODYNPEDtLYaM62h9cEAAAAASUVORK5CYII="

/***/ }),

/***/ "hdgR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__("iGbA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Roger = function (_PureComponent) {
  _inherits(Roger, _PureComponent);

  function Roger() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Roger);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Roger.__proto__ || Object.getPrototypeOf(Roger)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      canClick: true,
      seconds: 5,
      timer: true
    }, _this.componentWillUnmount = function () {
      _this.props.callback();
    }, _this.settimer = function () {
      _this.settimer = setInterval(function () {
        _this.setState(function (preState) {
          return { seconds: preState.seconds - 1 };
        }, function () {
          if (_this.state.seconds === 0) {
            clearInterval(_this.settimer);
            var div = document.getElementsByClassName('container')[0].children[1];
            __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unmountComponentAtNode(div);
            div.parentNode.removeChild(div);
          }
        });
      }, 1000);
    }, _this.onClick = function () {
      _this.props.click();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Roger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.settimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          text = _props.text,
          lang = _props.lang;
      var _state = this.state,
          seconds = _state.seconds,
          timer = _state.timer;

      return _jsx('div', {
        className: 'roger_btn'
      }, void 0, _jsx('button', {
        className: 'roger ' + (className || ''),
        onClick: this.onClick
      }, void 0, text || lang.Understood, ' ', timer ? seconds + 's' : ''));
    }
  }]);

  return Roger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Roger.defaultProps = {
  click: function click() {},
  callback: function callback() {}
};

/* harmony default export */ __webpack_exports__["default"] = (Roger);

/***/ }),

/***/ "hgbu":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("a/OS")('wks');
var uid = __webpack_require__("GmwO");
var Symbol = __webpack_require__("YjQv").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "hlir":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "htHW":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("cW2c");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "iANj":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "iGbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifV3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function isString(str) {
  return typeof str === 'string';
}

var Step = function (_React$Component) {
  _inherits(Step, _React$Component);

  function Step() {
    _classCallCheck(this, Step);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Step.prototype.render = function render() {
    var _classNames, _classNames2;

    var _props = this.props,
        className = _props.className,
        prefixCls = _props.prefixCls,
        style = _props.style,
        itemWidth = _props.itemWidth,
        _props$status = _props.status,
        status = _props$status === undefined ? 'wait' : _props$status,
        iconPrefix = _props.iconPrefix,
        icon = _props.icon,
        wrapperStyle = _props.wrapperStyle,
        adjustMarginRight = _props.adjustMarginRight,
        stepNumber = _props.stepNumber,
        description = _props.description,
        title = _props.title,
        progressDot = _props.progressDot,
        restProps = _objectWithoutProperties(_props, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'progressDot']);

    var iconClassName = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls + '-icon', true), _defineProperty(_classNames, iconPrefix + 'icon', true), _defineProperty(_classNames, iconPrefix + 'icon-' + icon, icon && isString(icon)), _defineProperty(_classNames, iconPrefix + 'icon-check', !icon && status === 'finish'), _defineProperty(_classNames, iconPrefix + 'icon-cross', !icon && status === 'error'), _classNames));

    var iconNode = void 0;
    var iconDot = _react2["default"].createElement('span', { className: prefixCls + '-icon-dot' });
    // `progressDot` enjoy the highest priority
    if (!!progressDot) {
      if (typeof progressDot === 'function') {
        iconNode = _react2["default"].createElement(
          'span',
          { className: prefixCls + '-icon' },
          progressDot(iconDot, { index: stepNumber - 1, status: status, title: title, description: description })
        );
      } else {
        iconNode = _react2["default"].createElement(
          'span',
          { className: prefixCls + '-icon' },
          iconDot
        );
      }
    } else if (icon && !isString(icon)) {
      iconNode = _react2["default"].createElement(
        'span',
        { className: prefixCls + '-icon' },
        icon
      );
    } else if (icon || status === 'finish' || status === 'error') {
      iconNode = _react2["default"].createElement('span', { className: iconClassName });
    } else {
      iconNode = _react2["default"].createElement(
        'span',
        { className: prefixCls + '-icon' },
        stepNumber
      );
    }
    var classString = (0, _classnames2["default"])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-status-' + status, true), _defineProperty(_classNames2, prefixCls + '-custom', icon), _defineProperty(_classNames2, className, !!className), _classNames2));
    return _react2["default"].createElement(
      'div',
      _extends({}, restProps, {
        className: classString,
        style: _extends({ width: itemWidth, marginRight: adjustMarginRight }, style)
      }),
      _react2["default"].createElement(
        'div',
        {
          ref: 'tail',
          className: prefixCls + '-tail',
          style: { paddingRight: -adjustMarginRight }
        },
        _react2["default"].createElement('i', null)
      ),
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-step' },
        _react2["default"].createElement(
          'div',
          {
            className: prefixCls + '-head',
            style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
          },
          _react2["default"].createElement(
            'div',
            { className: prefixCls + '-head-inner' },
            iconNode
          )
        ),
        _react2["default"].createElement(
          'div',
          { ref: 'main', className: prefixCls + '-main' },
          _react2["default"].createElement(
            'div',
            {
              className: prefixCls + '-title',
              style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
            },
            title
          ),
          description ? _react2["default"].createElement(
            'div',
            { className: prefixCls + '-description' },
            description
          ) : ''
        )
      )
    );
  };

  return Step;
}(_react2["default"].Component);

exports["default"] = Step;


Step.propTypes = {
  className: _propTypes2["default"].string,
  prefixCls: _propTypes2["default"].string,
  style: _propTypes2["default"].object,
  wrapperStyle: _propTypes2["default"].object,
  itemWidth: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  status: _propTypes2["default"].string,
  iconPrefix: _propTypes2["default"].string,
  icon: _propTypes2["default"].node,
  adjustMarginRight: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  stepNumber: _propTypes2["default"].string,
  description: _propTypes2["default"].any,
  title: _propTypes2["default"].any,
  progressDot: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].func])
};
module.exports = exports['default'];

/***/ }),

/***/ "jF3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
var prop_typesfrom_dll_reference_vendor_library = __webpack_require__("KSGD");
var prop_typesfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: ./node_modules/rc-util/es/PureRenderMixin.js
var PureRenderMixin = __webpack_require__("zbne");
var PureRenderMixin_default = /*#__PURE__*/__webpack_require__.n(PureRenderMixin);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rc-checkbox/es/Checkbox.js












var Checkbox_Checkbox = function (_React$Component) {
  inherits_default()(Checkbox, _React$Component);

  function Checkbox(props) {
    classCallCheck_default()(this, Checkbox);

    var _this = possibleConstructorReturn_default()(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    Checkbox__initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  createClass_default()(Checkbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          style = _props.style,
          name = _props.name,
          type = _props.type,
          disabled = _props.disabled,
          readOnly = _props.readOnly,
          tabIndex = _props.tabIndex,
          onClick = _props.onClick,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          others = objectWithoutProperties_default()(_props, ['prefixCls', 'className', 'style', 'name', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur']);

      var globalProps = Object.keys(others).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
          prev[key] = others[key];
        }
        return prev;
      }, {});

      var checked = this.state.checked;

      var classString = classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-checked', checked), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), _classNames));

      return reactfrom_dll_reference_vendor_library_default.a.createElement(
        'span',
        { className: classString, style: style },
        reactfrom_dll_reference_vendor_library_default.a.createElement('input', extends_default()({
          name: name,
          type: type,
          readOnly: readOnly,
          disabled: disabled,
          tabIndex: tabIndex,
          className: prefixCls + '-input',
          checked: !!checked,
          onClick: onClick,
          onFocus: onFocus,
          onBlur: onBlur,
          onChange: this.handleChange
        }, globalProps)),
        reactfrom_dll_reference_vendor_library_default.a.createElement('span', { className: prefixCls + '-inner' })
      );
    }
  }]);

  return Checkbox;
}(reactfrom_dll_reference_vendor_library_default.a.Component);

Checkbox_Checkbox.propTypes = {
  prefixCls: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  className: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  style: prop_typesfrom_dll_reference_vendor_library_default.a.object,
  name: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  type: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  defaultChecked: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.number, prop_typesfrom_dll_reference_vendor_library_default.a.bool]),
  checked: prop_typesfrom_dll_reference_vendor_library_default.a.oneOfType([prop_typesfrom_dll_reference_vendor_library_default.a.number, prop_typesfrom_dll_reference_vendor_library_default.a.bool]),
  disabled: prop_typesfrom_dll_reference_vendor_library_default.a.bool,
  onFocus: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onBlur: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onChange: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  onClick: prop_typesfrom_dll_reference_vendor_library_default.a.func,
  tabIndex: prop_typesfrom_dll_reference_vendor_library_default.a.string,
  readOnly: prop_typesfrom_dll_reference_vendor_library_default.a.bool
};
Checkbox_Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var Checkbox__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: extends_default()({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      }
    });
  };
};

/* harmony default export */ var es_Checkbox = (Checkbox_Checkbox);
// CONCATENATED MODULE: ./node_modules/rc-checkbox/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return es_Checkbox; });


/***/ }),

/***/ "jFhi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGHP":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"check-circle-o\" ><g fill-rule=\"evenodd\"><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z\"/><path d=\"M12.2 23.2L10 25.3l10 9.9L37.2 15 35 13 19.8 30.8z\"/></g></symbol>";
module.exports = sprite.add(image, "check-circle-o");

/***/ }),

/***/ "jbrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["BaseLayout"] = BaseLayout;
/* harmony export (immutable) */ __webpack_exports__["CustomerService"] = CustomerService;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__ = __webpack_require__("mekh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_customer_service_png__ = __webpack_require__("auxS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_customer_service_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_customer_service_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_customer_service2_png__ = __webpack_require__("LjTL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_customer_service2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_customer_service2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__("V9Z5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function BaseLayout(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return _jsx('div', {
    id: 'wrapper',
    className: 'wrapper ' + (className || '')
  }, void 0, children);
}

var _ref2 = _jsx('img', {
  alt: '',
  src: __WEBPACK_IMPORTED_MODULE_3__assets_customer_service2_png___default.a
});

function CustomerService() {
  function handleClickCallPhone() {
    Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["w" /* gspNewVersion */])(window.location.hash.indexOf('orderType=S') > -1 ? ['变更详情页-返回首页-按钮', '072-0050-23028-12201'] : ['退票详情页-返回首页-按钮', '072-0053-23028-12201'], {
      1: '点击一次触发一次',
      2: '国双新版',
      3: Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])() ? 'App' : 'Mobile'
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])() ? Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["d" /* appTell */])('95539') : window.location.href = 'tel://95539';
  }

  return _jsx('a', {
    role: 'button',
    href: 'javascript:void(0)',
    onClick: handleClickCallPhone,
    className: 'customerService'
  }, void 0, _ref2);
}

/***/ }),

/***/ "jbs9":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("0aDT"),
    createAssigner = __webpack_require__("OAAv");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "jjNC":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "jyFz":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("SldL");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "k2pG":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis\" ><circle cx=\"21.888\" cy=\"22\" r=\"4.045\"/><circle cx=\"5.913\" cy=\"22\" r=\"4.045\"/><circle cx=\"37.863\" cy=\"22\" r=\"4.045\"/></symbol>";
module.exports = sprite.add(image, "ellipsis");

/***/ }),

/***/ "k8CY":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("cbHt");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "kROs":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("PKzc"),
    baseAssignValue = __webpack_require__("455d");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "kiBT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BzqH"), __esModule: true };

/***/ }),

/***/ "ko9u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/x-plane.345b0a56.png";

/***/ }),

/***/ "ksFB":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("wiaE");
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "lkEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var BtnWrapper = function (_PureComponent) {
  _inherits(BtnWrapper, _PureComponent);

  function BtnWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BtnWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BtnWrapper.__proto__ || Object.getPrototypeOf(BtnWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchEvent = function (event) {
      event.stopPropagation();
      switch (event.type) {
        case 'touchstart':
          _this.originColor = [];
          _this.startX = event.changedTouches[0].pageX;
          _this.startY = event.changedTouches[0].pageY;
          _this.props.bgColor.forEach(function (item) {
            var itemStyle = Object.keys(item)[0];
            _this.originColor.push(_defineProperty({}, '' + itemStyle, _this.color.style['' + itemStyle]));
            _this.color.style['' + itemStyle] = item[itemStyle];
          });
          break;
        case 'touchend':
          _this.originColor.forEach(function (item) {
            var itemStyle = Object.keys(item)[0];
            _this.originColor.push(_defineProperty({}, '' + itemStyle, _this.color.style['' + itemStyle]));
            _this.color.style['' + itemStyle] = item[itemStyle];
          });
          break;
        default:
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BtnWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
        ref: function ref(color) {
          return _this2.color = color;
        },
        onTouchStart: this.handleTouchEvent,
        onTouchMove: this.handleTouchEvent,
        onTouchEnd: this.handleTouchEvent
      });
    }
  }]);

  return BtnWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

BtnWrapper.PropTypes = {
  bgColor: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].array,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["PropTypes"].element.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (BtnWrapper);

/***/ }),

/***/ "lxLf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m5tV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_nav_bar_style_css__ = __webpack_require__("G4fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_nav_bar_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_nav_bar_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar__ = __webpack_require__("/7Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__("dCxW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_toleft22_png__ = __webpack_require__("uZ73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_toleft22_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_toleft22_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__csair_emp_helpers__ = __webpack_require__("mekh");



var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          iconName = _props.iconName,
          leftContent = _props.leftContent,
          onLeftClick = _props.onLeftClick,
          title = _props.title,
          rightContent = _props.rightContent,
          style = _props.style,
          display = _props.navBar.display;

      var isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
      // isTTWebView 若为 true，则是在头条小程序的 web-view 中打开
      var isTTWebView = navigator.userAgent.toLowerCase().includes('toutiaomicroapp');
      if (Object(__WEBPACK_IMPORTED_MODULE_8__csair_emp_helpers__["C" /* isCsairApp */])()) {
        window.CSNativeObject.nativeSetTitle && window.CSNativeObject.nativeSetTitle(title);
      }
      return !isTTWebView && !isAICommingFT && display && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar___default.a,
        Object.assign({}, iconName ? { iconName: iconName } : {}, {
          leftContent: leftContent,
          onLeftClick: onLeftClick,
          rightContent: rightContent,
          style: style
        }),
        title
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Header.defaultProps = {
  iconName: '',
  leftContent: _jsx('img', {
    src: __WEBPACK_IMPORTED_MODULE_7__assets_toleft22_png___default.a
  }),
  rightContent: '',
  onLeftClick: function onLeftClick() {},
  style: {
    backgroundColor: 'transparent',
    color: '#262626'
  },
  title: 'navbar',
  navBar: {
    display: true
  }
};
Header.PropTypes = {
  iconName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onLeftClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  rightContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    navBar: state.App.navBar
  };
}, function (dispatch) {
  return {};
})(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["withRouter"])(Header)));

/***/ }),

/***/ "meRA":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("TJq6");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "mekh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../emp-helpers/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ../emp-helpers/node_modules/axios/index.js
var axios = __webpack_require__("zDzn");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../emp-helpers/node_modules/lodash/defaultsDeep.js
var defaultsDeep = __webpack_require__("YwPS");
var defaultsDeep_default = /*#__PURE__*/__webpack_require__.n(defaultsDeep);

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/compose.js
/**
 * 从右到左组成单参数函数
 * @param {...Function} funcs 需组合的函数.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    if (funcs.length === 0) {
        return function (arg) { return arg; };
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return a(b.apply(void 0, args));
        };
    });
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/request/createError.js
/**
 * 错误对象，可能还包含不止以下信息
 * @typedef {object} Error
 * @property {number} errorCode 错误状态码
 * @property {*} errorData 错误数据
 * @property {string} errorMessage 错误信息
 */
/**
 * 使用指定的消息创建错误
 * @param {object} [error={}] other错误相关数据
 * @param {number} [errorCode=9999] 错误状态码
 * @param {*} [errorData=''] 错误相关数据
 * @param {string} [errorMessage='http link failed'] 错误信息
 * @returns {Error} 创建的错误
 */
function createError(error, errorCode, errorData, errorMessage) {
    if (errorCode === void 0) {
        errorCode = 9999;
    }
    if (errorData === void 0) {
        errorData = '';
    }
    if (errorMessage === void 0) {
        errorMessage = 'http link failed';
    }
    return Object.assign({}, error, {
        errorCode: errorCode,
        errorData: errorData,
        errorMessage: errorMessage,
    });
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/request/RequestQueue.js
/**
 * 请求队列
 */
var RequestQueue = /** @class */ (function () {
    function RequestQueue() {
        this._loading = false;
        this._queue = {};
        this._eventEmitter = {
            loading: [],
            ending: [],
        };
    }
    /**
     * 注册loading事件
     * @param {('loading' | 'ending')} key
     * @param {function} fn 回调函数
     */
    RequestQueue.prototype.on = function (key, fn) {
        this._eventEmitter[key].push(fn);
    };
    /**
     * 增加
     * @param {*} key
     * @param {*} config
     */
    RequestQueue.prototype.add = function (key, config) {
        this._queue[key] = config;
        this.notify();
    };
    RequestQueue.prototype.remove = function (key) {
        delete this._queue[key];
        this.notify();
    };
    RequestQueue.prototype.count = function () {
        return Object.keys(this._queue).length;
    };
    RequestQueue.prototype.get = function (key) {
        return this._queue[key];
    };
    RequestQueue.prototype.filter = function (key) {
        var _this_1 = this;
        return Object.keys(this._queue)
            .filter(function (keyName) { return keyName === key; })
            .map(function (keyName) { return _this_1._queue[keyName]; });
    };
    RequestQueue.prototype.notify = function () {
        var keys = Object.keys(this._queue);
        var _this = this;
        var count = keys.filter(function (name) {
            return _this._queue[name].loading;
        }).length;
        if (count && !this._loading) {
            this._loading = true;
            this._eventEmitter.loading.forEach(function (fn) {
                fn();
            });
        }
        if (!count && !keys.length) {
            this._loading = false;
            this._eventEmitter.ending.forEach(function (fn) {
                fn();
            });
        }
    };
    return RequestQueue;
}());
/* harmony default export */ var request_RequestQueue = (RequestQueue);

// EXTERNAL MODULE: ../emp-helpers/node_modules/query-string/index.js
var query_string = __webpack_require__("NveE");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/parsePath.js
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 * @param {string} path
 */
function parsePath(path) {
    var partialPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            partialPath.hash = path.substr(hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            partialPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
    }
    return partialPath;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/request/channelControl.js
/**
 * 退票挽留，渠道重置功能
 * 1、初始化设置默认渠道（HttpClient实例过程）
 * 2、监听 /EMP/userinfo 接口设置默认渠道
 * 3、判断URL存在channel参数
 * 3.1、存在，当前更新请求地址附加channel参数和缓存
 * 3.2、不存在，读取判断缓存
 */


var channelKey = 'emp_channel';
function isYXPT(channel) {
    channel = channel || JSON.parse(window.sessionStorage.getItem(channelKey)).use_channel;
    return /(YXPT|JFBGZF)/.test(typeof channel === 'string' ? channel.toLocaleUpperCase() : '');
}
function setChannleInUserInfoApi(response) {
    if (response === void 0) {
        response = { config: config };
    }
    if (!this._config.channel) {
        return response;
    }
    if (response.config && response.config.url.indexOf('/EMP/userinfo') !== -1) {
        if (!this._base.default_channel) {
            this._base.default_channel = response.data.data.channel;
            window.sessionStorage.setItem(channelKey, JSON.stringify(this._base));
        }
    }
}
function resetUrl(config, channel) {
    var _url = Object(query_string["parseUrl"])(config.url);
    _url.query.channel = channel;
    config.url = _url.url + '?' + Object(query_string["stringify"])(_url.query);
    return config;
}
function updateUseChannel(channel) {
    this._base.use_channel = channel;
    window.sessionStorage.setItem(channelKey, JSON.stringify(this._base));
}
function getUrlParams(url) {
    return Object(query_string["parse"])(parsePath(url || window.location.href).search);
}
function includeRoutes() {
    return (this._config.channelRoutes.filter(function (route) { return window.location.href.indexOf(route) !== -1; })
        .length > 0);
}
function queryChannelTabel(ticketNo, orderNo) {
    var _this = this;
    var bool = includeRoutes.call(this);
    return Object.keys(this._base.channel_table)
        .filter(function (key) {
        return (bool &&
            (_this._base.channel_table[key].ticketNo === ticketNo ||
                _this._base.channel_table[key].orderNo === orderNo));
    })
        .pop();
}
function channelControl(config) {
    if (!this._config.channel || config.url.indexOf('/EMP') === -1) {
        return config;
    }
    var requestParams = getUrlParams(config.url);
    if (requestParams.channel) {
        updateUseChannel.call(this, requestParams.channel);
        return config;
    }
    var _a = getUrlParams(), channel = _a.channel, ticketNo = _a.ticketNo, orderNo = _a.orderNo;
    if (channel && this._base.use_channel !== channel) {
        // 存储渠道
        this._base.channel_table[new Date().getTime()] = {
            channel: channel,
            ticketNo: ticketNo,
            orderNo: orderNo,
        };
        // 更新当前使用的渠道
        updateUseChannel.call(this, channel);
        // url 带渠道，重置渠道
        return resetUrl(config, channel);
    }
    if (!channel &&
        !queryChannelTabel.call(this, ticketNo, orderNo) &&
        this._base.use_channel !== this._base.default_channel) {
        updateUseChannel.call(this, this._base.default_channel);
        return resetUrl(config, this._base.default_channel);
    }
    return config;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/request/HttpClient.js

/**
 * @file http 请求类
 * @author mrlyj<mr.lyj@outlook.com>
 */






/**
 * 基于 axios 封装的请求类
 *
 * support feature
 * - 请求缓存
 * - 重复请求过滤
 * - interceptors middleware（多拦截器中间件）
 * - 异常错误处理
 *  - errorCode 9999 errorMessage 'http link failed'（包含所有未能正常返回的http status）
 *  - errorCode 9998 errorMessage 'timeout request'
 *  - errorCode 3040 errorMessage 'read cache'
 *  - errorCode 2040 errorMessage 'repeat request'
 * - 请求队列start和end callback
 *
 * @todo
 * plan
 * - SWR（http协议 stale-while-revalidate 缓存功能）
 * - loading delay
 *
 * depend
 * - axios 0.18.0 暂不支持过高的版本
 *
 * issue
 * - baseURL 绝对地址和相对地址时，会导致缓存失效 fix
 *
 * @example
 * const client = new HttpClient({}) // 实例http请求对象
 * // 请求/api/todos 返回Promise对象
 * client.createHttp("get", "/api/todos")
 * // 请求/api/todos 返回Promise对象，使用localStorage缓存请求
 * client.createHttp("get", "/api/todos", {
 *  cache: 'local'
 * })
 *
 * // 请求/api/todos 返回Promise对象，开启请求缓存，自定义存取器，适用于Hybird模式开发
 * const client = new HttpClient({}, {
 *  store: {
 *    getData: function (key) { return ...读取数据... },
 *    setData: function (key, data) {
 *      ...保存数据...
 *    },
 *  }
 * })
 * client.createHttp("get", "/api/todos", {
 *  cache: 'local',
 * })
 *
 * @version 0.0.1
 * @class
 */
var HttpClient_HttpClient = /** @class */ (function () {
    /**
     * @constructor
     * @param {AxiosRequestConfig} config axios 请求配置
     * @param {object} [options] 扩展选项
     * @param {string} [options.cacheKey=http-cache] 缓存key
     * @param {(Store|boolean)} [options.store=false] 存取器
     * @param {Config} [options.config] 配置
     * @param {RequestOption} [options.request] 请求
     * @param {ResponseOption} [options.response] 响应
     * @param {function} [options.load] 请求 load 操作
     */
    function HttpClient(config, options) {
        var _this_1 = this;
        if (options === void 0) {
            options = {};
        }
        var _this = this;
        options = defaultsDeep_default()(options, {
            cacheKey: 'http-cache',
            store: false,
            load: {},
            config: {
                channel: false,
                channelRoutes: [],
            },
            request: { interceptors: [] },
            response: { interceptors: [] },
        });
        this._queue = new request_RequestQueue();
        Object.keys(options.load).forEach(function (name) {
            _this._queue.on(name, options.load[name]);
        });
        /**
         * 实例传参配置副本
         */
        this._config = options.config;
        /**
         * 基础信息
         */
        this._base = window.sessionStorage.getItem(channelKey)
            ? JSON.parse(window.sessionStorage.getItem(channelKey))
            : {
                default_channel: '',
                use_channel: '',
                channel_table: {},
            };
        /**
         * 定义缓存级别
         * @readonly
         * @type {string[]}
         * @default ['', 'memory', 'session', 'local']
         */
        this._CACHE_LEVEL = ['', 'memory', 'session', 'local'];
        /**
         * 缓存key
         * @type {string}
         */
        this.cacheKey = options.cacheKey;
        /**
         * axios实例对象
         * @protected
         * @type {AxiosInstance}
         */
        this.axiosInstance = axios_default.a.create(config);
        /**
         * 存取器
         * @type {Store}
         */
        this.store = options.store;
        /**
         * 内存缓存对象
         * @type {object}
         */
        this.memoryData = {};
        /**
         * 请求拦截中间件
         * @type {requestOption}
         */
        this.requestInterceptors = {
            interceptors: __spreadArrays(options.request.interceptors.map(function (item) { return item.interceptor; })),
            errors: __spreadArrays(options.request.interceptors.map(function (item) { return item.error; })),
        };
        /**
         * 响应拦截中间件
         * @type {responseOption}
         */
        this.responseMiddlewares = {
            interceptors: __spreadArrays(options.response.interceptors.map(function (item) { return item.interceptor; })),
            errors: __spreadArrays(options.response.interceptors.map(function (item) { return item.error; })),
        };
        // 重写内部 axios 实例的响应拦截对象 use 方法
        var resUse = this.axiosInstance.interceptors.response.use;
        this.axiosInstance.interceptors.response.use = function (interceptor, errorHandler) {
            resUse.call(_this_1.axiosInstance.interceptors.response, function (response) {
                var middlewares = __spreadArrays(_this_1.responseMiddlewares.interceptors, [
                    _this_1._cachePipe,
                    _this_1._responsePipe,
                ]);
                return interceptor(compose.apply(void 0, middlewares)(response));
            }, function (error) {
                var middlewares = __spreadArrays(_this_1.responseMiddlewares.errors, [
                    _this_1._responseErrorPipe,
                    _this_1._responsePipe,
                ]);
                return errorHandler(compose.apply(void 0, middlewares)(error));
            });
        };
        // 运行拦截器
        this.axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) { return error; });
        // 重写内部 axios 实例的请求拦截对象 use 方法
        var reqUse = this.axiosInstance.interceptors.request.use;
        this.axiosInstance.interceptors.request.use = function (interceptor, errorHandler) {
            reqUse.call(_this_1.axiosInstance.interceptors.request, function (config) {
                var middlewares = __spreadArrays(_this_1.requestInterceptors.interceptors, [
                    _this_1._cancelPipe,
                    _this_1._enhanceRequestPipe,
                ]);
                return interceptor(compose.apply(void 0, middlewares)(config));
            }, errorHandler);
        };
        // 运行拦截器
        this.axiosInstance.interceptors.request.use(function (config) { return config; }, function (error) { return error; });
        // bind this
        this._enhanceRequestPipe = this._enhanceRequestPipe.bind(this);
        this._clearCache = this._clearCache.bind(this);
        this._cancelPipe = this._cancelPipe.bind(this);
        this._cachePipe = this._cachePipe.bind(this);
        this._responsePipe = this._responsePipe.bind(this);
        this._responseErrorPipe = this._responseErrorPipe.bind(this);
    }
    /**
     * 发起请求
     * @method
     * @param {string} method=GET 请求方式
     * @param {string} url 请求地址
     * @param {object} [param]
     * @param {Method} param.method axios请求方式
     * @param {AxiosRequestConfig} param.config axios请求配置
     * @param {object} param.data 请求入惨
     * @param {string} param.cache 缓存级别
     * @param {boolean} param.forceRequest 请求入惨
     * @param {boolean} param.loading
     */
    HttpClient.prototype.createHttp = function (method, url, options) {
        if (method === void 0) {
            method = 'GET';
        }
        if (options === void 0) {
            options = {};
        }
        return __awaiter(this, void 0, void 0, function () {
            var cancel, token, params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = Object.assign({}, {
                            config: {},
                            data: {},
                            cache: '',
                            forceRequest: false,
                            loading: true,
                        }, options);
                        if (!this._CACHE_LEVEL.includes(options.cache)) {
                            throw new Error('Cache Parameter Error');
                        }
                        if (this.store && options.cache && options.cache !== this._CACHE_LEVEL[3]) {
                            throw new Error('Cache Parameter Must Set Local, Because you used a custom store, request url: ' + url);
                        }
                        token = new axios_default.a.CancelToken(function (_cancel) {
                            cancel = _cancel;
                        });
                        params = Object.assign({}, {
                            method: method,
                            data: options.data,
                            url: url,
                            status: {
                                path: url,
                            },
                        }, options.config, {
                            cancelToken: token,
                            cache: options.cache,
                            cancel: cancel,
                            forceRequest: options.forceRequest,
                            loading: options.loading,
                        });
                        if (options.cache) {
                            params.clearCache = this._clearCache(params);
                        }
                        return [4 /*yield*/, this.axiosInstance.request(params)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 清除缓存功能
     * @param {*} options
     */
    HttpClient.prototype._clearCache = function (config) {
        var key = this._getCacheKey(config);
        var _this = this;
        return function () {
            switch (config.cache) {
                case 'memory':
                    delete _this.memoryData[key];
                    break;
                case 'session':
                    sessionStorage.removeItem(key);
                    break;
                case 'local':
                    _this.store ? _this.store.clearData(key) : localStorage.removeItem(key);
                    break;
                default:
                    break;
            }
        };
    };
    /**
     * 获取请求标示
     * @param {EnhanceAxiosRequestConfig} config axios 请求配置
     * @returns {string} 请求标示
     */
    HttpClient.prototype._getRequestKey = function (config) {
        if (config === void 0) {
            config = {};
        }
        // return config.method + '-' + config.status.path;
        return config.method + '-' + config.status ? config.status.path ? config.status.path : "/EMP/getAllCity" : "/EMP/getAllCity";
    };
    /**
     * 获取规定缓存 key
     * @method
     * @param {EnhanceAxiosRequestConfig} config
     */
    HttpClient.prototype._getCacheKey = function (config) {
        return this.cacheKey + '-' + config.url.replace(config.baseURL, '');
    };
    /**
     * 缓存数据
     * @method
     * @param {AxiosResponse} response axios 响应内容
     * @returns {AxiosResponse}
     */
    HttpClient.prototype._cachePipe = function (response) {
        var status = response.status, config = response.config;
        if (status === 200) {
            var key = this._getCacheKey(config);
            switch (config.cache) {
                case 'memory':
                    this.memoryData[key] = response.data;
                    break;
                case 'session':
                    sessionStorage.setItem(key, JSON.stringify(response.data));
                    break;
                case 'local':
                    this.store
                        ? this.store.setData(key, response.data)
                        : localStorage.setItem(key, JSON.stringify(response.data));
                    break;
                default:
                    break;
            }
        }
        return response;
    };
    /**
     * 扩展请求信息
     * @param {EnhanceAxiosRequestConfig} config axios 配置
     * @returns {EnhanceAxiosRequestConfig}
     */
    HttpClient.prototype._enhanceRequestPipe = function (config) {
        var config = channelControl.call(this, config);
        config._channel = this._base.use_channel;
        return config;
    };
    /**
     * 读取缓存，取消请求
     * @method
     * @param {EnhanceAxiosRequestConfig} config axios 配置
     * @returns {EnhanceAxiosRequestConfig}
     */
    HttpClient.prototype._cancelPipe = function (config) {
        // 判断是否强制刚更新缓存，忽略缓存后续操作
        var atomicService = false;
        if (window.CSNativeObject && window.CSNativeObject.getOSType) {
            var osType = window.CSNativeObject.getOSType().toLowerCase();
            atomicService = osType === 'harmony_atomicservice';
        }
        if (config.forceRequest)
            return config;
        var cache = config.cache, cancel = config.cancel;
        var key = this._getCacheKey(config);
        var reqKey = this._getRequestKey(config);
        var reqs = this._queue.filter(reqKey);
        if (atomicService && key.includes('getAllCity'))
            return config;
        if (reqs.length !== 0) {
            reqs.forEach(function (item) {
                item.cancel({
                    cancelMark: 'repeat',
                    config: config,
                });
            });
        }
        else {
            switch (cache) {
                case 'memory':
                    if (this.memoryData[key]) {
                        cancel({
                            cancelMark: 'cache',
                            config: config,
                            cacheData: this.memoryData[key],
                        });
                    }
                    break;
                case 'session':
                    if (sessionStorage.getItem(key)) {
                        cancel({
                            cancelMark: 'cache',
                            config: config,
                            cacheData: JSON.parse(sessionStorage.getItem(key)),
                        });
                    }
                    break;
                case 'local':
                    if (this.store) {
                        var c = this.store.getData(key);
                        if (c)
                            cancel({
                                cancelMark: 'cache',
                                config: config,
                                cacheData: c,
                            });
                    }
                    else {
                        var c = localStorage.getItem(key);
                        if (c)
                            cancel({
                                cancelMark: 'cache',
                                config: config,
                                cacheData: JSON.parse(c),
                            });
                    }
                    break;
                default:
                    break;
            }
        }
        this._queue.add(reqKey, config);
        return config;
    };
    /**
     * 响应报错格式
     * @param {AxiosError} axios 报错信息
     * @returns {EnhanceAxiosError}
     */
    HttpClient.prototype._responseErrorPipe = function (error) {
        //拦截请求，返回缓存数据
        if (axios_default.a.isCancel(error)) {
            switch (error.message.cancelMark) {
                case 'cache':
                    return createError(error.message, 3040, '', 'read cache');
                case 'repeat':
                    return createError(error.message, 2040, '', 'repeat request');
                default:
                    break;
            }
        }
        if (error.code && error.code === 'ECONNABORTED') {
            return createError(error, 9998, '', 'timeout request');
        }
        return createError(error);
    };
    /**
     * 相应内容处理
     * @param {*} response
     */
    HttpClient.prototype._responsePipe = function (response) {
        setChannleInUserInfoApi.call(this, response);
        var key = this._getRequestKey(axios_default.a.isCancel(response) ? response.message.config : response.config);
        this._queue.remove(key);
        return response;
    };
    return HttpClient;
}());
/* harmony default export */ var request_HttpClient = (HttpClient_HttpClient);
/**
 * axios 错误
 * @typedef {object} AxiosError
 * @property {AxiosRequestConfig} config
 * @property {string} code
 * @property {*} request
 * @property {AxiosResponse} response
 * @property {boolean} isAxiosError
 * @property {function} toJSON
 */
/**
 * 配置
 * @typedef {object} Config
 * @property {boolean} channel false
 */
/**
 * 存取器
 * @typedef {object} Store
 * @property {function} getData 读取数据
 * @property {function} setData 保存数据
 * @property {function} clearData 清除数据
 */
/**
 * 请求选项
 * @typedef {object} RequestOption
 * @property {(array|Interceptor)} interceptors 拦截器
 */
/**
 * 响应选项
 * @typedef {object} ResponseOption
 * @property {(array|Interceptor)} interceptors 拦截器
 */
/**
 * 拦截器
 * @typeof {object} Interceptor
 * @property {object} interceptor 拦截方法
 * @property {object} error 报错方法
 */
/**
 * 增强的 axios 配置
 * @typedef {object} EnhanceAxiosRequestConfig
 * @extends AxiosRequestConfig
 * @property {string} cache 缓存标示
 * @property {boolean} forceRequest 强制请求，忽略缓存功能
 * @property {object} data 请求数据
 * @property {AxiosRequestConfig} config axios配置，优先级高于data其它选项
 * @property {number} loadingDelay loading延迟时间（暂未开发）
 * @property {(boolean|string)} [loadStatus='loading']
 */
/**
 * 错误信息
 * @typedef {object} EnhanceAxiosError
 * @extends AxiosError
 * @property {string} errorCode 错误码
 * @property {string} errorMessage 错误信息
 * @property {string | object} errorData 错误数据
 */

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/isCsairApp.js
var isAtomicService = function () {
    var atomicService = false;
    if (window.CSNativeObject && window.CSNativeObject.getOSType) {
        var osType = window.CSNativeObject.getOSType().toLowerCase();
        atomicService = osType === 'harmony_atomicservice';
    }
    return atomicService;
};
/**
 * 判断是否是南航app运行环境
 * @returns {boolean}
 */
function isCsairApp() {
    return window.CSNativeObject && !isAtomicService() ? true : false;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/appLocalStorge.js

/**
 * 保存本地数据
 * @param {string} key
 * @param data
 */
function saveLocalData(key, data) {
    var _a;
    if (isCsairApp()) {
        window.CSNativeObject.saveDataLocalStorage(JSON.stringify((_a = {}, _a[key] = data, _a)));
    }
    else {
        localStorage.setItem(key, JSON.stringify(data));
    }
}
/**
 * 获取本地数据
 * @param {string} key
 * @returns
 */
function getLocalData(key) {
    var data = null;
    if (isCsairApp()) {
        data = window.CSNativeObject.getDataLocalStorage(JSON.stringify({ keyName: key }));
    }
    else {
        data = localStorage.getItem(key);
    }
    try {
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
    }
    catch (error) {
        data = null;
    }
    return data;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/setAppHeaderTitle.js
/**
 * set csair app navigation Bar title
 * @param {string} title
 */
function setAppHeaderTitle(title) {
    try {
        window.CSNativeObject.nativeSetTitle(title || '');
    }
    catch (e) { }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/appFaceAuth.js
/**
 * app人脸识别，使用简易人脸认证流程
 * @param {function} callBack 调用人脸识别功能操作完成后回调函数
 * @param {function} failCallBack 调用人脸识别功能失败的回调函数
 */
function appFaceAuth(callBack, failCallBack) {
    window.authCallBack = callBack;
    if (window.CSNativeObject.nativeAuth) {
        window.CSNativeObject.nativeAuth(JSON.stringify({
            simpleFaceChannel: 'true',
            callBackMethod: 'authCallBack',
            channel: 'REFUND_TICKET',
        }));
        return false;
    }
    failCallBack();
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/appLogin.js
/**
 * csair app login
 * @param {fucntion} error 调用登录func异常回调函数
 */
function appLogin(error) {
    error = error || function () { };
    try {
        switch (window.CSNativeObject.getOSType()) {
            case 'android':
                // android 需要登出再登录，解决安卓token失效后一直死循环查不出数据问题
                window.appLoginOut = function () {
                    window.appLogin = function () {
                        window.location.reload();
                    };
                    window.CSNativeObject.nativeLogin('appLogin');
                };
                window.CSNativeObject.nativeLoginOut('appLoginOut');
                break;
            case 'iPhone':
                window.appLogin = function () {
                    window.location.reload();
                };
                window.CSNativeObject.nativeLogin('appLogin');
                break;
            default:
                error();
                break;
        }
    }
    catch (e) {
        error();
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/appWebViewRebound.js
/**
 * csair app webview 橡皮筋效果开关
 * @param {bool} [close=true]
 */
function iosWebViewRebound(close) {
    close = close || true;
    try {
        if (window.CSNativeObject.getOSType() === 'iPhone') {
            window.CSNativeObject.configWebView(JSON.stringify({
                bounces: close,
            }));
        }
    }
    catch (error) { }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/iosWebViewRebound.js
/**
 * ios webview 橡皮筋效果开关
 * @param {bool} close
 */
function iosWebViewRebound_iosWebViewRebound(close) {
    if (close === void 0) {
        close = true;
    }
    try {
        if (window.CSNativeObject.getOSType() === 'iPhone') {
            window.CSNativeObject.configWebView(JSON.stringify({
                bounces: close,
            }));
        }
    }
    catch (error) { }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/appToPage.js
/**
 * ios webview 橡皮筋效果开关
 * @param {bool} close
 */
function appToPage(params) {
    try {
        window.CSNativeObject.jumpToNative(JSON.stringify(params));
    }
    catch (error) { }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/appTell.js
function appTell(phone) {
    try {
        window.CSNativeObject.nativeContactWithPhone({ phone: phone });
    }
    catch (e) { }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/app/index.js










// CONCATENATED MODULE: ../emp-helpers/dist/es/business/code3Widget.js



var _version = 'v0.1.0';
// 三字码镜像
var codeMirror = {
    countiy: '',
    province: '',
    cityCountryCode3: '',
    cityCode3: '',
    cityName: '',
    airporCode3: '',
    airportName: '',
    airportNameSimple: '',
    airportPhoneticSimple: '',
    airportPhoneticTotal: '',
    isInternational: false,
    busCityTerminalList: []
};
var cityWidget = {};
var request = new request_HttpClient({
    timeout: 0,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'x-requested-with': 'XMLHttpRequest',
    },
}, {
    store: {
        clearData: function (key) {
            if (isCsairApp()) {
                saveLocalData(key, '');
            }
            else {
                localStorage.removeItem(key);
            }
        },
        getData: function (key) {
            return getLocalData(key);
        },
        setData: function (key, data) {
            if (data.code && data.code === '0000' && Array.isArray(data.result)) {
                var codeObj = transformData(data.result);
                codeObj.version = data.version + _version;
                saveLocalData(key, codeObj);
            }
        },
    },
});
/**
 * 数据格式转换 处理/cityWidget/getAllCity接口
 * @param {array} arr
 */
function transformData(arr) {
    if (arr === void 0) {
        arr = [];
    }
    var codeObj = {};
    if (!Array.isArray(arr))
        return codeObj;
    arr.forEach(function (_a) {
        var code3 = _a.code3, cityCountryCode3 = _a.cityCountryCode3, countiy = _a.countiy, name = _a.name, province = _a.province, searchAirportList = _a.searchAirportList, busCityTerminalList = _a.busCityTerminalList, enCountiy = _a.enCountiy, enProvince = _a.enProvince, enName = _a.enName;
        var cityObj = Object.assign({}, codeMirror, {
            cityCountryCode3: cityCountryCode3,
            cityCode3: code3,
            countiy: countiy,
            enCountiy: enCountiy,
            province: province,
            enProvince: enProvince,
            cityName: name,
            cityEnName: enName,
            busCityTerminalList: busCityTerminalList || []
        });
        if (!codeObj[code3]) {
            codeObj[code3] = cityObj;
        }
        if (Array.isArray(busCityTerminalList)) {
            busCityTerminalList.forEach(function (it) {
                var siteCode3 = it.siteCode3;
                it.cityCountryCode3 = cityCountryCode3;
                it.cityCode3 = code3;
                it.countiy = countiy;
                it.enCountiy = enCountiy;
                it.province = province;
                it.enProvince = enProvince;
                it.cityName = name;
                it.cityEnName = enName;
                it.airportName = it.name;
                it.airportEnName = it.enname;
                it.airportNameSimple = it.name;
                it.airportEnNameSimple = it.enname;
                var newObj = {
                    airporCode3: siteCode3,
                };
                codeObj[siteCode3] = Object.assign({}, cityObj, newObj);
            });
        }
        if (Array.isArray(searchAirportList)) {
            searchAirportList.forEach(function (airportItem) {
                var airporCode3 = airportItem.code3;
                var airportObj = {
                    airporCode3: airporCode3,
                    airportName: airportItem.name,
                    airportEnName: airportItem.enName,
                    airportNameSimple: airportItem.nameSimple,
                    airportEnNameSimple: airportItem.enNameSimple,
                    airportPhoneticSimple: airportItem.phoneticSimple,
                    airportPhoneticTotal: airportItem.phoneticTotal,
                    isInternational: airportItem.isInternational === 'Y',
                    busCityTerminalList: busCityTerminalList || []
                };
                codeObj[airporCode3] = Object.assign({}, cityObj, airportObj);
                if (Array.isArray(busCityTerminalList)) {
                    busCityTerminalList.forEach(function (it) {
                        var siteCode3 = it.siteCode3;
                        it.cityCountryCode3 = cityCountryCode3;
                        it.cityCode3 = code3;
                        it.countiy = countiy;
                        it.enCountiy = enCountiy;
                        it.province = province;
                        it.enProvince = enProvince;
                        it.cityName = name;
                        it.cityEnName = enName;
                        it.airportName = it.name;
                        it.airportEnName = it.enname;
                        it.airportNameSimple = it.name;
                        it.airportEnNameSimple = it.enname;
                        it.airportPhoneticSimple = airportItem.phoneticSimple;
                        it.airportPhoneticTotal = airportItem.phoneticTotal;
                        it.isInternational = airportItem.isInternational === 'Y';
                        var newObj = {
                            airporCode3: siteCode3,
                        };
                        codeObj[siteCode3] = Object.assign({}, cityObj, airportObj, newObj);
                    });
                }
            });
        }
        return codeObj;
    });
    return codeObj;
}
function getCode3Data() {
    return request.createHttp('get', '/EMP/getAllCity', { cache: 'local', loading: false });
}
function getCode3DataVersion() {
    return request.createHttp('get', '/EMP/getVersion', { loading: false });
}
/**
 * 匹配三字码
 * @param {string} 机场三字码
 * @returns {string}
 */
function getCode3Widget(code3, ftype, lang) {
    if (lang === void 0) {
        lang = "cn";
    }
    if (!code3)
        return codeMirror;
    // if (ftype && ftype === "BUS") {
    //   return cityWidget[code3].busCityTerminalList.filter(it = it.siteCode3 == code3).length > 0
    //     ? cityWidget[code3].busCityTerminalList.filter(it = it.siteCode3 == code3)
    //     : codeMirror
    // }
    var ftypeTest = /bus/i;
    if (lang.toLocaleLowerCase().indexOf('en') !== -1) {
        var codeInfo = cityWidget[code3] || codeMirror;
        if (ftype && ftypeTest.test(ftype)) {
            if (cityWidget[code3]) {
                codeInfo = cityWidget[code3].busCityTerminalList.filter(function (it) { return it.siteCode3 == code3; })[0] || cityWidget[code3] || codeMirror;
            }
        }
        codeInfo.countiy = codeInfo.enCountiy;
        codeInfo.province = codeInfo.enProvince;
        codeInfo.cityName = codeInfo.cityEnName;
        codeInfo.airportName = codeInfo.airportEnName;
        codeInfo.airportNameSimple = codeInfo.airportEnNameSimple;
        return codeInfo;
    }
    if (ftype && ftypeTest.test(ftype)) {
        if (cityWidget[code3]) {
            return cityWidget[code3].busCityTerminalList.filter(function (it) { return it.siteCode3 == code3; })[0] || (cityWidget[code3] || codeMirror);
        }
    }
    return cityWidget[code3] || codeMirror;
}
/**
 * 创建城市控件数据
 */
function createCode3Widget() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, errorCode, cacheData, config, status, data, version;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getCode3Data()];
                case 1:
                    _a = _b.sent(), errorCode = _a.errorCode, cacheData = _a.cacheData, config = _a.config, status = _a.status, data = _a.data;
                    if (status === 200) {
                        cityWidget = transformData(data.result);
                        cityWidget.version = data.version;
                        return [2 /*return*/, false];
                    }
                    if (!(errorCode && errorCode === 3040))
                        return [3 /*break*/, 3];
                    cityWidget = cacheData;
                    return [4 /*yield*/, getCode3DataVersion()];
                case 2:
                    version = _b.sent();
                    if (typeof version.data === 'number' &&
                        cacheData.version &&
                        cacheData.version !== version.data + _version) {
                        config.clearCache();
                        createCode3Widget();
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * 获取机场简称, 即去掉城市名
 * @returns {string}
 */
function getAbAirport(codeData) {
    return codeData.airportNameSimple
        ? codeData.airportNameSimple === codeData.cityName
            ? codeData.airportNameSimple
            : codeData.airportNameSimple.replace(codeData.cityName, '')
        : '';
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getAirlineName.js
/**
 * @description 航司二字码获取航司名称
 * @param {string} code
 */
function getAirlineName(code) {
    if (!code)
        return '';
    return ({
        CZ: '中国南方航空公司',
        MU: '中国东方航空公司',
        MF: '厦门航空有限公司',
        CA: '中国国际航空公司',
        HU: '海南航空股份有限公司',
        FM: '中国上海航空公司',
        OQ: '重庆航空',
        ZH: '深圳航空有限责任公司',
        GS: '天津航空有限责任公司',
        '3U': '四川航空股份有限公司',
        NS: '河北航空有限公司',
        G5: '华夏航空公司',
        KL: '荷兰皇家航空公司',
        AF: '法国航空公司',
        WS: '西捷航空公司',
        DL: '达美航空公司',
        KE: '大韩航空公司',
        OK: '捷克航空公司',
        JL: '日本航空公司',
        QF: '澳洲航空公司',
        SU: '俄罗斯国际航空公司',
        MX: '墨西哥航空公司',
        AZ: '意大利航空公司',
        PE: '欧罗巴航空公司',
        KQ: '肯亚航空公司',
        VN: '越南航空公司',
        RO: '罗马尼亚航空公司',
        CI: '中华航空公司',
        SV: '沙特阿拉伯航空公司',
        ME: '中东航空公司',
        AR: '阿根廷航空公司',
        GA: '嘉鲁达印尼航空公司',
        GJ: '长龙航空公司',
        OZ: '韩亚航空公司',
    }[code.substring(0, 2).toLocaleUpperCase()] ||
        code ||
        '');
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getTerminal.js
/**
 * 用于处理新航班列表接口 展示航站楼， --不展示
 * @param {string} val
 * @returns {string}
 */
function getTerminal(val) {
    if (!val)
        return '';
    if (/-/.test(val))
        return '';
    if (val.indexOf('T') === -1)
        val = 'T' + val;
    return val || '';
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getPhysicalCabinName.js
/**
 * 获取物理舱名称
 * @param {string} 南航舱位
 * @returns 对应的业务中文名称
 */
function getPhysicalCabinName(s) {
    switch (s) {
        case 'F':
        case 'First':
            return '头等舱';
        case 'J':
        case 'C':
        case 'D':
        case 'I':
        case 'O':
        case 'Business':
            return '公务舱';
        case 'W':
        case 'S':
        case 'PremiumEconomy':
            return '明珠经济舱';
        case 'Y':
        case 'B':
        case 'M':
        case 'H':
        case 'P':
        case 'K':
        case 'U':
        case 'A':
        case 'L':
        case 'Q':
        case 'E':
        case 'V':
        case 'Z':
        case 'T':
        case 'N':
        case 'R':
        case 'G':
        case 'X':
        case 'Economy':
            return '经济舱';
        default:
            break;
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/compareCabin.js

/**
 * 比较两个舱位级别
 * @param {string} c1 舱位1
 * @param {string} c2 舱位2
 * @returns {Number} -1 c1<c2;  0 c1=c2;  1 c1>c2
 */
function compareCabin(c1, c2) {
    var cName1 = getPhysicalCabinName(c1);
    var cName2 = getPhysicalCabinName(c2);
    if (cName1 === cName2)
        return 0;
    if (cName1 === '头等舱')
        return 1;
    if (cName1 === '公务舱' && cName2 !== '头等舱')
        return 1;
    if (cName1 === '明珠经济舱' && !['头等舱', '公务舱'].includes(cName2))
        return 1;
    if (cName1 === '经济舱' && !['头等舱', '公务舱', '明珠经济舱'].includes(cName2))
        return 1;
    return -1;
}

// EXTERNAL MODULE: ../emp-helpers/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("69qq");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getCookieUserInfo.js

/**
 * 从cookie获取用户信息
 * @returns
 */
function getCookieUserInfo() {
    var csmbplogintype = js_cookie_default.a.get('csmbplogintype');
    var loginType = '';
    if (csmbplogintype === '-3') {
        loginType = 'OA';
    }
    return {
        loginType: loginType,
    };
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/filterPsgName.js
/**
 * @description 过滤旅客姓名规则
 * @param {string} str 旅客姓名
 * @param {*} rules 过滤条件
 */
function filterPsgName(str, rules) {
    if (rules !== 1 && rules !== 2) {
        if (rules === 5)
            str = str.replace(/( GM)$/g, '');
        if (rules === 6)
            str = str.replace(/( JC)$/g, '');
        return str;
    }
    return str.replace(/( CHD)$/g, '');
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getPsgType.js
/**
 * @description 获取旅客类型
 * @param {number | string} type
 * @returns {string} 对应类型描述
 */
function getPsgType(type) {
    type = typeof type === 'string' ? Number(type) : type;
    if (type === 1 || type === 2) {
        return '儿童';
    }
    else if (type === 3) {
        return '婴儿';
    }
    else if (type === 0 || type === 5 || type === 6) {
        return '成人';
    }
    return '';
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getCertType.js
/**
 * @description 获取证件类型
 * @param {string} str
 * @returns {string} 对应类型描述
 */
function getCertType(str) {
    switch (str) {
        case 'NI':
            return '身份证';
        case 'PP':
            return '护照号';
        case 'P':
            return '护照号';
        case 'ID':
            return '其他证件';
        default:
            return '身份证';
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getInterfaceError.js
/**
 * 接口异常状态码匹配
 * checkOrderTicket
 * checkTicketFlight
 * checkFlightDate
 * afterSaleChangeReqNewFlightDetail
 * queryChangeCost
 * getNameAndPhone
 * @param {string} code
 * @returns {boolean}
 */
function getInterfaceError(code) {
    return /(1111)|(4002)|(5003)|(5005)|(5006)|(8005)|(40001)|(60010)|(60011)|(80004)|(80006)|(80008)|(90000)|(90001)|(91002)|(91004)/g.test(code);
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/transformCurrency.js
/**
 * @description 货币转换
 * @param {string} currency
 * @returns {string} 转换后的货币
 */
function transformCurrency(currency) {
    if (typeof currency !== 'string')
        return '';
    return currency === 'CNY' ? '￥' : currency;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/refundPsgsScopes.js
/**
 *  旅客退票类型规则
 * @param {*} arr
 */
function refundPsgsScopes(arr) {
    if (arr === void 0) {
        arr = [];
    }
    var fzytp = 0, zytp = 0;
    arr
        .reduce(function (p, n) { return p.concat(n); }, [])
        .forEach(function (item) {
        if (item === 'zytp')
            zytp += 1;
        if (item === 'fzytp')
            fzytp += 1;
    });
    if (fzytp !== 0 && zytp !== 0 && fzytp !== zytp) {
        return 'zytp';
    }
    if (fzytp !== 0 && zytp !== 0 && fzytp === zytp) {
        return 'fzytp';
    }
    if (fzytp === 0 && zytp) {
        return 'zytp';
    }
    if (fzytp && zytp === 0) {
        return 'fzytp';
    }
    return '';
}

// EXTERNAL MODULE: ../emp-helpers/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__("Mbmb");
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);

// EXTERNAL MODULE: ../emp-helpers/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("dACV");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/checkConnectingTime.js



/**
 * 校验衔接时间
 * 国内或者国际中转，以第二段的起飞地和目的地作为判断
 * 缺口程，则按第一段的目的地和第二段的起飞地作为判断
 * @param {array} flights
 * @param {object} flights.departMCT
 * @param {number} flights.departMCT.gn_gn 国内转国内最短衔接时间
 * @param {number} flights.departMCT.gn_gj 国内转国际最短衔接时间
 * @param {number} flights.departMCT.gj_gj 国际转国际最短衔接时间
 * @param {number} flights.departMCT.gj_gn 国际转国内最短衔接时间
 * @param {object} flights.arriveMCT
 * @param {number} flights.arriveMCT.gn_gn 国内转国内最短衔接时间
 * @param {number} flights.arriveMCT.gn_gj 国内转国际最短衔接时间
 * @param {number} flights.arriveMCT.gj_gj 国际转国际最短衔接时间
 * @param {number} flights.arriveMCT.gj_gn 国际转国内最短衔接时间
 * @param {string} flights.arriveDate 到达日期
 * @param {string} flights.arriveTime 到达时间
 * @param {string} flights.departDate 起飞日期
 * @param {string} flights.departTime 起飞时间
 * @param {string} flights.departAirport 起飞机场三字码
 * @param {string} flights.arriveAirport 达到机场三字码
 * @returns {number} 正常符合的情况 返回 type false，不符合的情况 返回具体衔接时间不足的具体时间
 */
function checkConnectingTime(flights) {
    if (flights === void 0) {
        flights = [];
    }
    if (!Array.isArray(flights) || flights.length !== 2) {
        return false;
    }
    if (isEmpty_default()(flights[0]) || isEmpty_default()(flights[1])) {
        return false;
    }
    var shortTime = 3600000; // 衔接时间默认一小时
    var prev = flights[0];
    var next = flights[1];
    var prev_arrTimestamp = dayjs_min_default()(prev.arriveDate + " " + (prev.arriveTime || prev.arrTime)).valueOf();
    var next_depTimestamp = dayjs_min_default()((next.departDate || next.flightDate) + " " + (next.departTime || next.depTime)).valueOf();
    var arrCode = prev.arriveAirport || prev.arriveAirportCode || prev.arrAirport;
    var depCode = next.departAirport || next.departAirportCode || next.depAirport;
    // 缺口层判断
    if (arrCode !== depCode) {
        var arrCode3Data = getCode3Widget(arrCode);
        var depCode3Data = getCode3Widget(depCode);
        var mct = next.departMCT || next.mctMap[depCode];
        // 第一段目的地国际、第二段目的地国际
        if (arrCode3Data.isInternational && depCode3Data.isInternational) {
            shortTime = Number(mct.gj_gj) * 60 * 1000;
        }
        // 第一段目的地国内、第二段目的地国内
        if (!arrCode3Data.isInternational && !depCode3Data.isInternational) {
            shortTime = Number(mct.gn_gn) * 60 * 1000;
        }
        // 第一段目的地国内、第二段目的地国际
        if (!arrCode3Data.isInternational && depCode3Data.isInternational) {
            shortTime = Number(mct.gn_gj) * 60 * 1000;
        }
        // 第一段目的地国际、第二段目的地国内
        if (arrCode3Data.isInternational && !depCode3Data.isInternational) {
            shortTime = Number(mct.gj_gn) * 60 * 1000;
        }
        if (next_depTimestamp - prev_arrTimestamp < shortTime) {
            return shortTime;
        }
        return 0;
    }
    if (arrCode === depCode) {
        var depCode3Data = getCode3Widget(next.departAirport || next.departAirportCode || next.depAirport);
        var arrCode3Data = getCode3Widget(next.arriveAirport || next.arriveAirportCode || next.arrAirport);
        var mct = next.departMCT || next.mctMap[depCode];
        // 国内转国内
        if (!depCode3Data.isInternational && !arrCode3Data.isInternational) {
            shortTime = Number(mct.gn_gn) * 60 * 1000;
        }
        // 国内转国际
        if (!depCode3Data.isInternational && arrCode3Data.isInternational) {
            shortTime = Number(mct.gn_gj) * 60 * 1000;
        }
        // 国际转国内
        if (depCode3Data.isInternational && !arrCode3Data.isInternational) {
            shortTime = Number(mct.gj_gn) * 60 * 1000;
        }
        // 国际转国际
        if (depCode3Data.isInternational && arrCode3Data.isInternational) {
            shortTime = Number(mct.gj_gn) * 60 * 1000;
        }
        if (next_depTimestamp - prev_arrTimestamp < shortTime) {
            return shortTime;
        }
        return 0;
    }
    return 0;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getCabinTypeName.js
/**
 * 获取舱位类型术语名词
 * 英语 => 中文
 * 中文 => 英语
 * @param {string} key
 * @returns {string}
 */
function getCabinTypeName(key) {
    switch (key) {
        case 'Business':
            return '公务舱';
        case '公务舱':
            return 'Business';
        case 'Economy':
            return '经济舱';
        case '经济舱':
            return 'Economy';
        case 'First':
            return '头等舱';
        case '头等舱':
            return 'First';
        case 'PremiumEconomy':
            return '明珠经济舱';
        case '明珠经济舱':
            return 'PremiumEconomy';
        default:
            break;
    }
}

// EXTERNAL MODULE: ../emp-helpers/node_modules/lodash/uniq.js
var uniq = __webpack_require__("JCET");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/hasOPEN.js

/**
 * 获取open信息
 * @param {*} _flights 所有航段
 * @param {*} _psgs 勾选的旅客
 */
function hasOPEN(_flights, _segmentIds, _psgs) {
    var flightNumList = [];
    _flights.forEach(function (ite) {
        if (ite.valid) {
            flightNumList.push(ite.segmentId);
        }
        ;
    });
    var opFlightNoList = [];
    _psgs.forEach(function (params) {
        if (Array.isArray(params.openSegmentList) && params.openSegmentList.length) {
            params.openSegmentList.forEach(function (item) {
                if (flightNumList.includes(item)) {
                    opFlightNoList.push(item);
                }
                ;
            });
        }
        ;
    });
    _psgs.forEach(function (params) {
        if (Array.isArray(params.openSegmentList) && params.openSegmentList.length) {
            params.openSegmentList = opFlightNoList;
        }
        ;
    });
    var segmentIds = uniq_default()(_psgs
        .filter(function (psg) {
        return Array.isArray(psg.openSegmentList) && psg.openSegmentList.length;
    })
        .map(function (psg) {
        return psg.openSegmentList;
    })
        .reduce(function (p, n) {
        return p.concat(n);
    }, [])
        .filter(function (seg) {
        return _segmentIds.indexOf(Number(seg)) === -1;
    }));
    var flights = _flights.filter(function (flight) {
        return segmentIds.indexOf(flight.segmentId) !== -1;
    });
    return {
        segmentIds: segmentIds,
        flights: flights,
    };
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/gsp.js

var filed = ['T', 'GWD-005238', 'trackEvent'];
var opt = {
    1: 'EMP团队组',
    2: '东道新版',
};
var opt1 = {
    1: 'EMP项目组-机票退改',
    2: 'UX新版',
};
var opt2 = {
    1: '产品-机票退改',
    2: '国双新版',
};
function gspCMSAD(WTCode, open) {
    if (open === void 0) {
        open = true;
    }
    open &&
        window._gsq &&
        window._gsq.push(filed.concat([
            '2021-EMP退改-变更支付完成页面',
            '变更支付完成页面-CMS广告',
            '010-001-71001-003',
            0,
            __assign(__assign({}, opt), { 3: '广告', 6: WTCode }),
        ]));
}
function gspRecommendFunc(i, open) {
    if (open === void 0) {
        open = true;
    }
    var table = [
        [
            '2021-EMP退改-变更支付完成页面',
            '变更支付完成页面-选择&办登机牌',
            '010-002-71001-103',
            0,
            opt,
        ],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-接送机', '010-003-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-代客泊车', '010-004-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-贵宾休息室', '010-005-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-额外行李', '010-006-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-一人多座预售', '010-007-71001-103', 0, opt],
    ];
    open && window._gsq && window._gsq.push(filed.concat(table[i]));
}
function gspCollect(node, options, open) {
    if (open === void 0) {
        open = true;
    }
    open &&
        window._gsq &&
        window._gsq.push(filed.concat(node).concat([
            0,
            __assign(__assign({}, opt), options),
        ]));
}
function gspUpgrades(node, options, open) {
    if (open === void 0) {
        open = true;
    }
    open &&
        window._gsq &&
        window._gsq.push(filed.concat(node).concat([
            0,
            __assign(__assign({}, opt1), options),
        ]));
}
// export function gspNewVersion(node, options, open = true) {
//   open &&
//     window._gsq &&
//     window._gsq.push(
//       filed.concat(node).concat([
//         0,
//         {
//           ...opt2,
//           ...options,
//         },
//       ])
//     );
// }
function gspNewVersion(options, params) {
    try {
        var clickValue = 0; //事件值
        var filed_1 = ["T", "GWD-005238", "trackEvent", "产品-机票退改"];
        window._gsq &&
            window._gsq.push(filed_1.concat(options).concat([clickValue, params]));
    }
    catch (err) {
        console.log("_gsq异常", err);
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/coupon.js
/**
 * 票联拆分
 */
function splitCoupon(ticket) {
    if (typeof ticket === 'string') {
        var tickets = ticket.split('-');
        return tickets.reduce(function (p, n, i) {
            if (i === 0)
                return p.concat(Number(n));
            var preTicket = p[p.length - 1];
            var curTicket = Number(String(preTicket).substr(0, String(preTicket).length - n.length) + n);
            var num = curTicket - preTicket;
            if (num < 0) {
                p.push(curTicket);
                return p;
            }
            while (num--) {
                if (num >= 0) {
                    preTicket++;
                    p.push(preTicket);
                }
            }
            return p;
        }, []);
    }
    return [ticket];
}
/**
 *
 */
function getSegmentInTicket(flight, flights, ticket) {
    var coupon = splitCoupon(ticket);
    var index = 0;
    for (var i = 0; i < flights.length; i++) {
        var f = flights[i];
        if (f.couponNo === 1 && i !== 0)
            index++;
        if (flight.segmentId === f.segmentId) {
            break;
        }
    }
    return coupon[index];
}

// EXTERNAL MODULE: ../emp-helpers/node_modules/lodash/uniqWith.js
var uniqWith = __webpack_require__("9MLQ");
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith);

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/getNewOldFlights.js

/**
 * 适用于变更详情接口返回segInfoList字段
 */
function getNewOldFlights(flights) {
    if (flights === void 0) {
        flights = [];
    }
    return {
        oldFlights: 
        // .map(function (flight) {
        //   return Object.keys(flight).reduce(function (obj, key) {
        //     key = key.replace('old', '').replace(key[0], key[0].toLowerCase());
        //     obj[key] = flight[key] || '';
        //     return obj;
        //   }, {});
        // })
        uniqWith_default()(flights.filter(function (flight) {
            return flight.oldFlightDate;
        }), function (a, b) {
            return (a.oldFlightDate + "-" + a.oldDepTime + "-" + a.oldFlightNo + "-" + a.olddepAirport + "-" + a.oldarrAirport ===
                b.oldFlightDate + "-" + b.oldDepTime + "-" + b.oldFlightNo + "-" + b.olddepAirport + "-" + b.oldarrAirport);
        }),
        newFlights: uniqWith_default()(flights, function (a, b) {
            return (a.flightDate + "-" + a.depTime + "-" + a.flightNo + "-" + a.depAirport + "-" + a.arrAirport ===
                b.flightDate + "-" + b.depTime + "-" + b.flightNo + "-" + b.depAirport + "-" + b.arrAirport);
        }),
    };
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/transformStatusCodeMsg.js

/**
 * []英文中括号+限制3个大写字母，eg：[CAN]，转换成【】中文中括号+城市名，eg：【广州】
 * @export
 */
function transformStatusCodeMsg(msg, lang) {
    if (!msg)
        return msg;
    return msg.replace(/\[[A-Z]{3,3}\]/g, function (m) {
        var name = getCode3Widget(m.replace(/\[|\]/g, ''), lang).cityName;
        return name ? "\u3010" + name + "\u3011" : '';
    });
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/setResponseMsg.js

function setResponseMsg(response) {
    if (!response || (Array.isArray(response) && !response.length))
        return response;
    var result = Array.isArray(response) ? response[0] : response;
    if (result.hasOwnProperty('checkMsg'))
        result.checkMsg = transformStatusCodeMsg(result.checkMsg);
    if (result.hasOwnProperty('warning'))
        result.warning = transformStatusCodeMsg(result.warning);
    if (result.error && result.error.hasOwnProperty('errorMsg'))
        result.error.errorMsg = transformStatusCodeMsg(result.error.errorMsg);
    if (result.errorInfo && result.errorInfo.hasOwnProperty('errorMsg'))
        result.errorInfo.errorMsg = transformStatusCodeMsg(result.errorInfo.errorMsg);
    if (result.errorInfo && result.errorInfo.hasOwnProperty('description'))
        result.errorInfo.description = transformStatusCodeMsg(result.errorInfo.description);
    if (result.hasOwnProperty('showMsg'))
        result.showMsg = transformStatusCodeMsg(result.showMsg);
    if (result.hasOwnProperty('responseMessage'))
        result.responseMessage = transformStatusCodeMsg(result.responseMessage);
    if (result.hasOwnProperty('message')) {
        if (typeof result.message !== "object") {
            result.message = transformStatusCodeMsg(result.message ? result.message : '');
        }
        else {
            if (typeof result.message === "object" && result.message !== null)
                result.message.exceptionMsg = result.message.exceptionMsg ? transformStatusCodeMsg(result.message.exceptionMsg) : '';
        }
    }
    if (Array.isArray(response))
        return [result];
    return result;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/setUpgradesMsg.js


var setUpgradesMsg_request = new request_HttpClient({
    timeout: 0,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'x-requested-with': 'XMLHttpRequest',
    },
}, {
    store: {
        clearData: function (key) {
            if (isCsairApp()) {
                saveLocalData(key, '');
            }
            else {
                localStorage.removeItem(key);
            }
        },
        getData: function (key) {
            return getLocalData(key);
        },
        setData: function (key, data) {
            saveLocalData(key, data);
        },
    },
});
function getUpgradesCodeMsg() {
    return setUpgradesMsg_request.createHttp('get', "/public/apiStatusCodeMsg/cn/checkOrderTicket.change.u.json", { cache: 'local', loading: false });
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/business/index.js






















// CONCATENATED MODULE: ../emp-helpers/dist/es/request/enhanceRequest.js


/**
 * 通过url添加参数扩充body参数
 *
 * @example
 * url http://localhost:3000/#/ticket/updateDetail?rp=orderNo-S123&in=queryOrderTickets
 * request url http://localhost:3000/EMP/queryOrderTickets
 * request body { orderNo: S123 }
 *
 * @param {AxiosRequestConfig} config axios 请求 config
 * @returns {AxiosRequestConfig}
 */
function enhanceRequest(config) {
    var _parsePath = parsePath(window.location.href);
    var _url = Object(query_string["parse"])(_parsePath.search);
    if (config.url.includes(_url.in)) {
        if (_url.in && _url.rp) {
            var arr = _url.rp.split('-');
            config.data[arr[0]] = arr[1];
        }
    }
    return config;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/request/getRequestChannel.js
/**
 * ajax 请求头部 login-channel
 * @returns
 */
function getRequestChannel(channel) {
    var _channel = channel ||
        (Boolean(window.sessionStorage.getItem('emp_channel'))
            ? JSON.parse(window.sessionStorage.getItem('emp_channel')).use_channel
            : '');
    if (_channel && /(FDCS)/.test(_channel)) {
        return 'f';
    }
    if ((!_channel && /(\/ssChangeRefund)/.test(window.location.href)) ||
        (_channel && _channel.toLocaleLowerCase() === 'ss')) {
        return 's';
    }
    return 'm';
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/request/index.js





// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/arrTransformObj.js
/**
 * 数组转换对象
 * 如果数组的子元素不为Object，则过滤
 *
 * @param {array} arr
 * @param {object} arr.item
 * @returns {object}
 */
function arrTransformObj(arr, field) {
    arr = arr || [];
    return arr.reduce(function (pre, next) {
        if (Object.prototype.toString.call(next) !== '[object Object]')
            return pre;
        pre[next[field]] = next;
        return pre;
    }, {});
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/insertStr.js
/**
 * 字符串插入字符串
 * @param {string} 被插入的字符串
 * @param {number} 插入的位置
 * @param {string} 插入的字符串
 * @returns {string} 新的字符串
 */
function insertStr(soure, start, newStr) {
    return soure.slice(0, start) + newStr + soure.slice(start);
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/arrayUnique.js
/**
 * 过滤方式去重
 * @param {array} array
 * @returns {array}
 */
function arrayUnique(array) {
    var res = [];
    for (var i = 0, arrayLen = array.length; i < arrayLen; i++) {
        for (var j = 0, resLen = res.length; j < resLen; j++) {
            if (array[i] === res[j]) {
                break;
            }
        }
        if (j === resLen) {
            res.push(array[i]);
        }
    }
    return res;
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/sleep.js
/**
 * 定时器
 * @param {number} interval 时间，毫秒
 */
function sleep(interval) {
    return new Promise(function (resolve) {
        setTimeout(resolve, interval);
    });
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/transformName.js
var camelizeRE = /-(\w)/g;
function camelize(str) {
    return str.replace(camelizeRE, function (_, c) { return c.toUpperCase(); });
}
function camesplitlize(str) {
    return str
        .replace(/([A-Z])/g, '-$1')
        .toLowerCase()
        .replace(/-/, '');
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/utils/index.js








// EXTERNAL MODULE: ../emp-helpers/node_modules/bowser/es5.js
var es5 = __webpack_require__("4T41");
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);

// CONCATENATED MODULE: ../emp-helpers/dist/es/m/absoluteLayoutRestPage.js

/**
 * 优化使用最外层是绝对布局的page，在iOS平台上弹起键盘后收缩键盘，页面整体上移
 */
function absoluteLayoutRestPage() {
    if (es5_default.a.getParser(window.navigator.userAgent).getOS().name === 'iOS') {
        document.addEventListener('scroll', function (e) {
            if (document.activeElement.tagName === 'INPUT' ||
                document.activeElement.tagName === 'TEXTAREA') {
                var activeElement_1 = document.activeElement;
                function blurEvent() {
                    setTimeout(function () {
                        var scrollHeight = document.documentElement.scrollTop || window.scrollY || 0;
                        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                        activeElement_1.removeEventListener('blur', blurEvent);
                    }, 300);
                }
                activeElement_1.addEventListener('blur', blurEvent);
            }
        });
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/m/fixIosCursor.js
/**
 * fix iOS输入框获取焦点时滚动屏幕，光标卡在焦点时位置。
 */
function fixIosCursor() {
    if (Bowser.getParser(window.navigator.userAgent).getOS().name === 'iOS') {
        document.addEventListener('scroll', function () {
            if (document.activeElement.tagName === 'INPUT' ||
                document.activeElement.tagName === 'TEXTAREA') {
                setTimeout(function () {
                    document.activeElement.blur();
                }, 100);
            }
        });
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/m/index.js



// CONCATENATED MODULE: ../emp-helpers/dist/es/pay/uppPay.js
/**
 * @description upp支付
 * @param {string} url 支付地址
 * @param {array} arr [encodeMsg, signMsg, merAppId, merId, local]
 */
function uppPay(url, arr) {
    if (arr === void 0) {
        arr = [];
    }
    var form = document.createElement('form');
    form.style.display = 'none';
    form.setAttribute('method', 'post');
    form.setAttribute('name', 'form1');
    form.setAttribute('id', 'form1');
    form.setAttribute('action', url);
    var str = ['encodeMsg', 'signMsg', 'merAppId', 'merId', 'locale'];
    arr.forEach(function (item, i) {
        var input = document.createElement('input');
        input.setAttribute('name', str[i]);
        input.setAttribute('value', item);
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/pay/index.js


// CONCATENATED MODULE: ../emp-helpers/dist/es/date/getDayGrids.js


/**
 * @description 获取日期所在月的号列表网格数据
 * @param {string} dateStr 日期字符串，YYYY-MM-DD
 * @returns {object} {
 *  year: 年,
 *  month: 月,
 *  weekList: [
 *    {
 *      value: 日期值, YYYY-MM-DD,
 *      valueOf: 时间戳，毫秒
 *      isBefore: 当前日期之前,
 *      isAfter: 当前日期之后
 *      isSameDate: 同一天
 *      isSameMonth: 同月,
 *      isToday: 今天
 *    }
 *  ]
 * }
 */
function getDayGrids(dateStr) {
    var dateMonent = dayjs_min_default()(dateStr);
    var dateObj = {
        year: dateMonent.year(),
        month: dateMonent.month() + 1,
    };
    // 二维日期集合， [周[天]]
    var weekList = [];
    // 月份第一天
    var firstMonent = dateMonent.clone().startOf('month');
    var firstWeekDay = firstMonent.day();
    // 月份最后一天
    var lastMonent = dateMonent.clone().endOf('month');
    var lastWeekDay = lastMonent.day();
    // 当月的天数
    var dayCount = dateMonent.daysInMonth();
    // 1号不是周日，补齐欠缺
    dayCount += firstWeekDay;
    // 月末不是周六，补齐欠缺
    dayCount += 6 - lastWeekDay;
    var todayMonent = dayjs_min_default()().startOf('day');
    var nextYearTodayMonent = todayMonent.clone().add(1, 'years');
    for (var i = 0; i < dayCount; i++) {
        var index = Math.floor(i / 7);
        var curMonent = null;
        if (firstWeekDay <= 6) {
            curMonent = firstMonent.clone().add(i - firstWeekDay, 'days');
        }
        else {
            curMonent = firstMonent.clone().add(i, 'days');
        }
        var curDate = {
            value: curMonent.format('YYYY-MM-DD'),
            day: curMonent.get('date'),
            valueOf: curMonent.valueOf(),
            unix: curMonent.unix(),
            isBefore: curMonent.isBefore(todayMonent),
            isAfter: curMonent.isAfter(todayMonent),
            isSameDate: curMonent.isSame(dateMonent),
            isSameMonth: curMonent.isSame(dateMonent, 'month'),
            isAfterNextYearToday: curMonent.isAfter(nextYearTodayMonent),
            isToday: curMonent.format('YYYY-MM-DD') === todayMonent.format('YYYY-MM-DD'),
        };
        if (!weekList[index])
            weekList[index] = [curDate];
        else
            weekList[index].push(curDate);
    }
    return __assign(__assign({}, dateObj), { weekList: weekList });
}

// EXTERNAL MODULE: ../emp-helpers/node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__("X+/p");
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);

// EXTERNAL MODULE: ../emp-helpers/node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__("WQjr");
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);

// CONCATENATED MODULE: ../emp-helpers/dist/es/date/getTimestampTZ8.js



dayjs_min_default.a.extend(utc_default.a);
dayjs_min_default.a.extend(timezone_default.a);
/**
 * 获取相对于东八区的时间戳
 * 例如
 *  西五区 2020-02-02 02:02
 *  转换到时间戳
 *  在东八区转换回时间是 2020-02-02 15:02
 *  想要获取一样的时间节点，要进行相对于东八区偏移量计算
 * @param {Date实例} date
 * @returns {string} 时间戳
 */
function getTimestampTZ8(date) {
    if (date === void 0) {
        date = new Date();
    }
    var now = dayjs_min_default()(date);
    var tz8 = now.tz('Asia/Shanghai');
    var offset = now.utcOffset();
    var timeOffset = Math.abs(offset / 60);
    if (offset > 0) {
        if (offset < 8) {
            return tz8.subtract(8 - timeOffset, 'h').valueOf();
        }
        if (offset > 8) {
            return tz8.add(timeOffset - 8, 'h').valueOf();
        }
        return tz8.valueOf();
    }
    return tz8.subtract(8 + timeOffset, 'h').valueOf();
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/date/index.js



// CONCATENATED MODULE: ../emp-helpers/dist/es/login/index.js


/**
 * 统一登录，适用于h5和csair app
 * @param {string} h5URL 登录地址
 * @param {function} error 报错回调
 */
function uniteLogin(h5URL, error) {
    if (isCsairApp()) {
        appLogin(error);
    }
    else {
        window.location.href = h5URL;
    }
}

// CONCATENATED MODULE: ../emp-helpers/dist/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return createCode3Widget; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getCode3Widget; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getAbAirport; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAirlineName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return getTerminal; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return compareCabin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return getCookieUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return filterPsgName; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getPsgType; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getCertType; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return getInterfaceError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return getPhysicalCabinName; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return transformCurrency; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "E", function() { return refundPsgsScopes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return checkConnectingTime; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getCabinTypeName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return hasOPEN; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return gspCMSAD; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return gspRecommendFunc; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return gspCollect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return gspUpgrades; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return gspNewVersion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return getSegmentInTicket; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "I", function() { return splitCoupon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return getNewOldFlights; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "J", function() { return transformStatusCodeMsg; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "H", function() { return setResponseMsg; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUpgradesCodeMsg; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return request_HttpClient; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return enhanceRequest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "D", function() { return isYXPT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return getRequestChannel; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return compose; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return arrTransformObj; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "A", function() { return insertStr; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return arrayUnique; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return parsePath; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return sleep; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return camelize; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return camesplitlize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "F", function() { return saveLocalData; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return getLocalData; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "C", function() { return isCsairApp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "G", function() { return setAppHeaderTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return appFaceAuth; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return appLogin; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return iosWebViewRebound; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "B", function() { return iosWebViewRebound_iosWebViewRebound; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return appToPage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return appTell; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return absoluteLayoutRestPage; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fixIosCursor; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return uppPay; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDayGrids; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getTimestampTZ8; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "K", function() { return uniteLogin; });










/***/ }),

/***/ "mkdO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("h2Na");

__webpack_require__("bpde");

/***/ }),

/***/ "n5Ex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "nCfu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("97gm");
var normalizeHeaderName = __webpack_require__("eawX");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("tXv+");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("tXv+");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "nSP+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "nWat":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "nclR":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("Wdy1");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("NMac").set });


/***/ }),

/***/ "nwKQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Brief = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__("zMcl");

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

var _omit = __webpack_require__("JkBm");

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var Brief = exports.Brief = function (_React$Component) {
    (0, _inherits3['default'])(Brief, _React$Component);

    function Brief() {
        (0, _classCallCheck3['default'])(this, Brief);
        return (0, _possibleConstructorReturn3['default'])(this, (Brief.__proto__ || Object.getPrototypeOf(Brief)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Brief, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'am-list-brief', style: this.props.style },
                this.props.children
            );
        }
    }]);
    return Brief;
}(_react2['default'].Component);

var ListItem = function (_React$Component2) {
    (0, _inherits3['default'])(ListItem, _React$Component2);

    function ListItem(props) {
        (0, _classCallCheck3['default'])(this, ListItem);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

        _this2.onClick = function (ev) {
            var _this2$props = _this2.props,
                onClick = _this2$props.onClick,
                platform = _this2$props.platform;

            var isAndroid = platform === 'android' || platform === 'cross' && !!navigator.userAgent.match(/Android/i);
            if (!!onClick && isAndroid) {
                if (_this2.debounceTimeout) {
                    clearTimeout(_this2.debounceTimeout);
                    _this2.debounceTimeout = null;
                }
                var Item = ev.currentTarget;
                var RippleWidth = Math.max(Item.offsetHeight, Item.offsetWidth);
                var ClientRect = ev.currentTarget.getBoundingClientRect();
                var pointX = ev.clientX - ClientRect.left - Item.offsetWidth / 2;
                var pointY = ev.clientY - ClientRect.top - Item.offsetWidth / 2;
                var coverRippleStyle = {
                    width: RippleWidth + 'px',
                    height: RippleWidth + 'px',
                    left: pointX + 'px',
                    top: pointY + 'px'
                };
                _this2.setState({
                    coverRippleStyle: coverRippleStyle,
                    RippleClicked: true
                }, function () {
                    _this2.debounceTimeout = setTimeout(function () {
                        _this2.setState({
                            coverRippleStyle: { display: 'none' },
                            RippleClicked: false
                        });
                    }, 1000);
                });
            }
            if (onClick) {
                onClick(ev);
            }
        };
        _this2.state = {
            coverRippleStyle: { display: 'none' },
            RippleClicked: false
        };
        return _this2;
    }

    (0, _createClass3['default'])(ListItem, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _wrapCls,
                _classNames,
                _classNames2,
                _classNames3,
                _this3 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                activeStyle = _a.activeStyle,
                error = _a.error,
                align = _a.align,
                wrap = _a.wrap,
                disabled = _a.disabled,
                children = _a.children,
                multipleLine = _a.multipleLine,
                thumb = _a.thumb,
                extra = _a.extra,
                arrow = _a.arrow,
                onClick = _a.onClick,
                onLongPress = _a.onLongPress,
                restProps = __rest(_a, ["prefixCls", "className", "activeStyle", "error", "align", "wrap", "disabled", "children", "multipleLine", "thumb", "extra", "arrow", "onClick", "onLongPress"]);var _state = this.state,
                coverRippleStyle = _state.coverRippleStyle,
                RippleClicked = _state.RippleClicked;

            var wrapCls = (_wrapCls = {}, (0, _defineProperty3['default'])(_wrapCls, className, className), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item', true), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-disabled', disabled), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-error', error), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-top', align === 'top'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-middle', align === 'middle'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-bottom', align === 'bottom'), _wrapCls);
            var rippleCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-ripple', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-ripple-animate', RippleClicked), _classNames));
            var lineCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-line', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-line-multiple', multipleLine), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-line-wrap', wrap), _classNames2));
            var arrowCls = (0, _classnames2['default'])((_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow', true), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow-horizontal', arrow === 'horizontal'), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow-vertical', arrow === 'down' || arrow === 'up'), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow-vertical-up', arrow === 'up'), _classNames3));
            var content = _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, (0, _omit2['default'])(restProps, ['platform']), { onClick: function onClick(ev) {
                        _this3.onClick(ev);
                    }, className: (0, _classnames2['default'])(wrapCls) }),
                thumb ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-thumb' },
                    typeof thumb === 'string' ? _react2['default'].createElement('img', { src: thumb }) : thumb
                ) : null,
                _react2['default'].createElement(
                    'div',
                    { className: lineCls },
                    children !== undefined && _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-content' },
                        children
                    ),
                    extra !== undefined && _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-extra' },
                        extra
                    ),
                    arrow && _react2['default'].createElement('div', { className: arrowCls, 'aria-hidden': 'true' })
                ),
                _react2['default'].createElement('div', { style: coverRippleStyle, className: rippleCls })
            );
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { disabled: disabled || !onClick && !onLongPress, activeStyle: activeStyle, activeClassName: prefixCls + '-item-active', onLongPress: onLongPress },
                content
            );
        }
    }]);
    return ListItem;
}(_react2['default'].Component);

ListItem.defaultProps = {
    prefixCls: 'am-list',
    align: 'middle',
    error: false,
    multipleLine: false,
    wrap: false,
    platform: 'cross'
};
ListItem.Brief = Brief;
exports['default'] = ListItem;

/***/ }),

/***/ "oFuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["type"] = type;
/* harmony export (immutable) */ __webpack_exports__["compare"] = compare;
/* harmony export (immutable) */ __webpack_exports__["cityToAirPort"] = cityToAirPort;
/* harmony export (immutable) */ __webpack_exports__["isAllTrue"] = isAllTrue;
/* harmony export (immutable) */ __webpack_exports__["toQueryString"] = toQueryString;
/* harmony export (immutable) */ __webpack_exports__["overscroll"] = overscroll;
/* harmony export (immutable) */ __webpack_exports__["getDirection"] = getDirection;
/* harmony export (immutable) */ __webpack_exports__["transformateCn"] = transformateCn;
/* harmony export (immutable) */ __webpack_exports__["huAnalyzeUseText"] = huAnalyzeUseText;
/* harmony export (immutable) */ __webpack_exports__["analyzeUseText"] = analyzeUseText;
/* harmony export (immutable) */ __webpack_exports__["submitPay"] = submitPay;
/* harmony export (immutable) */ __webpack_exports__["cabinSort"] = cabinSort;
/* harmony export (immutable) */ __webpack_exports__["getCertificateType"] = getCertificateType;
/* harmony export (immutable) */ __webpack_exports__["getMuCertificateType"] = getMuCertificateType;
/* harmony export (immutable) */ __webpack_exports__["getCaCertificateType"] = getCaCertificateType;
/* harmony export (immutable) */ __webpack_exports__["getHuCertificateType"] = getHuCertificateType;
/* harmony export (immutable) */ __webpack_exports__["getPsgType"] = getPsgType;
/* harmony export (immutable) */ __webpack_exports__["allLogin"] = allLogin;
/* harmony export (immutable) */ __webpack_exports__["isOfficialTicket"] = isOfficialTicket;
/* harmony export (immutable) */ __webpack_exports__["createWechatSdk"] = createWechatSdk;
/* harmony export (immutable) */ __webpack_exports__["createFanTaiSdk"] = createFanTaiSdk;
/* harmony export (immutable) */ __webpack_exports__["sortFlightList"] = sortFlightList;
/* harmony export (immutable) */ __webpack_exports__["parseLoginUrlParams"] = parseLoginUrlParams;
/* harmony export (immutable) */ __webpack_exports__["saveLocalData"] = saveLocalData;
/* harmony export (immutable) */ __webpack_exports__["getLocalData"] = getLocalData;
/* harmony export (immutable) */ __webpack_exports__["physicsCabinsAssort"] = physicsCabinsAssort;
/* harmony export (immutable) */ __webpack_exports__["touchScroll"] = touchScroll;
/* harmony export (immutable) */ __webpack_exports__["idNoFormatCheck"] = idNoFormatCheck;
/* harmony export (immutable) */ __webpack_exports__["userAgentType"] = userAgentType;
/* harmony export (immutable) */ __webpack_exports__["encrypt"] = encrypt;
/* harmony export (immutable) */ __webpack_exports__["getOrderChannel"] = getOrderChannel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "session", function() { return session; });
/* harmony export (immutable) */ __webpack_exports__["getPageName"] = getPageName;
/* harmony export (immutable) */ __webpack_exports__["getChangeStatus"] = getChangeStatus;
/* harmony export (immutable) */ __webpack_exports__["getGoogleApp"] = getGoogleApp;
/* harmony export (immutable) */ __webpack_exports__["getHaiwaiApp"] = getHaiwaiApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__ = __webpack_require__("mekh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Url__ = __webpack_require__("8oYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Routes__ = __webpack_require__("a1o4");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






// 类型判断
function type(o) {
  var s = Object.prototype.toString(o);
  return s.match(/\[object (.*?)\]/)[1].toLowerCase();
}

// array sort
function compare(x, y) {
  if (x < y) {
    return -1;
  } else if (x > y) {
    return 1;
  } else {
    return 0;
  }
}

// 城市机场名过滤函数
function cityToAirPort() {
  var city = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var airport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var targetName = void 0;
  if (!city || city === airport) {
    targetName = airport;
  } else if (!airport || city === airport) {
    targetName = city;
  } else if (city === airport.substring(0, city.length)) {
    targetName = airport.substring(city.length, airport.length);
  } else {
    targetName = airport;
  }

  return targetName;
}

// 遍历数组中是否全部为true
function isAllTrue(arr) {
  var i = arr.length;
  while (i--) {
    if (!arr[i]) {
      return false;
    }
  }
  return true;
}

// 设置APP头部title
// export function setAppHeaderTitle(title) {
//   try {
//     window.CSNativeObject.nativeSetTitle(title || '');
//   } catch (e) {
//     // catch exception;
//   }
// }

// 对params参数处理  返回一个由‘&’拼接的字符串
function toQueryString(obj) {
  return obj ? Object.keys(obj).sort().map(function (key) {
    if (key === '' || key === null || key === undefined) {
      return false;
    }

    var val = obj[key];
    if (Array.isArray(val)) {
      return val.sort().map(function (val2) {
        return key + '=' + val2;
      }).join('&');
    }

    if (val === '' || val === undefined) {
      return false;
    }

    return key + '=' + encodeURI(val);
  }).join('&') : '';
}

// 默认时间判断
function overscroll(el) {
  el.addEventListener('touchstart', function () {
    var top = el.scrollTop,
        totalScroll = el.scrollHeight,
        currentScroll = top + el.offsetHeight;
    if (top === 0) {
      el.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      el.scrollTop = top - 1;
    }
  });
  el.addEventListener('touchmove', function (evt) {
    if (el.offsetHeight < el.scrollHeight) evt._isScroller = true;
  });
}

// 获得角度
function getAngle(angx, angy) {
  return Math.atan2(angy, angx) * 180 / Math.PI;
}

// 根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
function getDirection(startx, starty, endx, endy) {
  var angx = endx - startx;
  var angy = endy - starty;
  var result = 0;

  // 如果滑动距离太短
  if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
    return result;
  }

  var angle = getAngle(angx, angy);
  if (angle >= -135 && angle <= -45) {
    result = 1;
  } else if (angle > 45 && angle < 135) {
    result = 2;
  } else if (angle >= 135 && angle <= 180 || angle >= -180 && angle < -135) {
    result = 3;
  } else if (angle >= -45 && angle <= 45) {
    result = 4;
  }

  return result;
}

// 解析变更使用条件
function transformateCn(str) {
  if (/(.+)?\d(.+)?/.test(str)) {
    return str.replace('不得变更', 'nochange').replace('不得退票', 'norefund').replace(/[\u4E00-\u9FA5]/g, '').replace(/[a-zA-Z]/g, '').replace('()', '').replace('nochange', '不得变更').replace('norefund', '不得退票');
  } else if (str === '') {
    return '----,----';
  } else if (str.indexOf('前后退票免费') !== -1 || str.indexOf('前后变更免费') !== -1) {
    return '免费,免费';
  } else if (str.indexOf('前免费') !== -1) {
    return '免费';
  } else if (str.indexOf('后免费') !== -1) {
    return '免费';
  } else {
    return str.indexOf('不得变更') !== -1 && str.indexOf('不得退票') === -1 ? '不得变更,不得变更' : '----,----';
  }
}

/**
 * @description 使用条件区间解析
 * @param {string} time 时间
 * @param {string} sign 'r' | 'b' r为退票、b为变更
 * @param {array} arr 子元素必须为ReissueDetails、RefundDetails
 * @returns {array} 子元素类型为 { text: string; percent: string }
 * interface ReissueDetails {
 *  appointClass: string;
 *  autoNote: string;
 *  chargeType: string,
 *  control: string;
 *  discountCalMethod: string;
 *  discountPercent: number;
 *  discountRule: string;
 *  discountType: string;
 *  flight: string;
 *  flightDateEnd: number;
 *  flightDateEndUnit: string;
 *  flightDateStart: number;
 *  flightDateStartUnit: string;
 *  free: string;
 *  freeFrequency: number;
 *  frequency: number;
 *  inadvisability: string;
 *  lowestAmount: number;
 *  ticketStatus: string;
 * }
 * interface RefundDetails {}
 * 具体字段说明看全渠道客票变更reshop响应说明
 */
function huAnalyzeUseText(time, sign, arr, language) {
  if (language == 'en') {
    return arr.map(function (item) {
      var obj = {
        text: '',
        percent: 0
      };
      var isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
      var date = isEnd ? item.flightDateEnd > 0 ? 'flightDateStart' : 'flightDateEnd' : 'flightDateStart';
      var unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
      var percentName = sign === 'r' ? 'percentage' : 'discountPercent';
      if (!item[unit] && !item[date]) return '';
      var t = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase()).format('YYYY-MM-DD HH:mm');

      // 前、后时间都为0
      if (!item.flightDateStart && !item.flightDateEnd) {
        return {
          text: 'Around ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM-DD HH:mm'),
          percent: /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? 'Free' : item[percentName] + '%',
          time: time
        };
      }
      obj.text = '' + (
      // isEnd ? '前（包含）' : '后'
      isEnd ? item.flightDateEnd > 0 ? 'After ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') + '\uFF08excluding\uFF09' : 'Before ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') + '\uFF08include\uFF09' : 'After ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm'));
      obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? 'Free' : item[percentName] + '%';
      obj.time = t;
      return obj;
    }).sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isAfter(b.time) ? 1 : __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isSame(b.time) && a.text.indexOf('After') !== -1 ? 1 : -1;
    });
  } else {
    return arr.map(function (item) {
      var obj = {
        text: '',
        percent: 0
      };
      var isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
      var date = isEnd ? item.flightDateEnd > 0 ? 'flightDateStart' : 'flightDateEnd' : 'flightDateStart';
      var unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
      var percentName = sign === 'r' ? 'percentage' : 'discountPercent';
      if (!item[unit] && !item[date]) return '';
      var t = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase()).format('YYYY-MM-DD HH:mm');

      // 前、后时间都为0
      if (!item.flightDateStart && !item.flightDateEnd) {
        return {
          text: __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM-DD HH:mm') + ' \u524D\u540E',
          percent: /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? '免费' : item[percentName] + '%',
          time: time
        };
      }

      obj.text = __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') + ' ' + (
      // isEnd ? '前（包含）' : '后'
      isEnd ? item.flightDateEnd > 0 ? '后（不含）' : '前（包含）' : '后');
      obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? '免费' : item[percentName] + '%';
      obj.time = t;
      return obj;
    }).sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isAfter(b.time) ? 1 : __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isSame(b.time) && a.text.indexOf('后') !== -1 ? 1 : -1;
    });
  }
}

function analyzeUseText(time, sign, arr, type, language) {
  if (language == 'en') {
    return arr.map(function (item) {
      var obj = {
        text: '',
        percent: 0
      };
      var isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
      var date = isEnd ? 'flightDateEnd' : 'flightDateStart';
      var unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
      var percentName = sign === 'r' ? 'percentage' : 'discountPercent';
      if (!item[unit] && !item[date]) return '';
      var t = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase()).format('YYYY-MM-DD HH:mm');

      // 前、后时间都为0
      if (!item.flightDateStart && !item.flightDateEnd) {
        return {
          text: 'Around ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM-DD HH:mm'),
          percent: /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? 'Free' : item[percentName] + '%',
          time: time
        };
      }

      obj.text = '' + (
      // isEnd ? '前（包含）' : '后'
      type === 'JXFLIGHT' ? isEnd ? 'Before ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') : 'After ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') + '\uFF08include\uFF09' : isEnd ? 'Before ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') + '\uFF08include\uFF09' : 'After ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm'));
      obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? 'Free' : item[percentName] + '%';
      obj.time = t;
      return obj;
    }).sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isAfter(b.time) ? 1 : __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isSame(b.time) && a.text.indexOf('After') !== -1 ? 1 : -1;
    });
  } else {
    return arr.map(function (item) {
      var obj = {
        text: '',
        percent: 0
      };
      var isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
      var date = isEnd ? 'flightDateEnd' : 'flightDateStart';
      var unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
      var percentName = sign === 'r' ? 'percentage' : 'discountPercent';
      if (!item[unit] && !item[date]) return '';
      var t = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase()).format('YYYY-MM-DD HH:mm');

      // 前、后时间都为0
      if (!item.flightDateStart && !item.flightDateEnd) {
        return {
          text: __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM-DD HH:mm') + ' \u524D\u540E',
          percent: /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? '免费' : item[percentName] + '%',
          time: time
        };
      }

      obj.text = __WEBPACK_IMPORTED_MODULE_0_moment___default()(t).format('MM-DD HH:mm') + ' ' + (
      // isEnd ? '前（包含）' : '后'
      type === 'JXFLIGHT' ? isEnd ? '前' : '后（包含）' : isEnd ? '前（包含）' : '后');
      obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote) ? '100%' : item[percentName] === 0 || !item[percentName] ? '免费' : item[percentName] + '%';
      obj.time = t;
      return obj;
    }).sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isAfter(b.time) ? 1 : __WEBPACK_IMPORTED_MODULE_0_moment___default()(a.time).isSame(b.time) && a.text.indexOf('后') !== -1 ? 1 : -1;
    });
  }
}
/**
 * upp支付
 * @param {array} arr [encodeMsg, signMsg, merAppId, merId, local]
 */
function submitPay(_ref) {
  var token = _ref.token,
      merAppId = _ref.merAppId,
      merId = _ref.merId,
      version = _ref.version,
      language = _ref.language,
      DYurl = _ref.DYurl;

  // 跳转至upp，修改store当前url
  var store_a = JSON.parse(sessionStorage.getItem('persist:emp'));
  var store_b = JSON.parse(JSON.parse(sessionStorage.getItem('persist:emp')).App);
  store_b.oldLocation.pathname = location.hash.slice(1, location.hash.indexOf('?'));
  store_a.App = JSON.stringify(store_b);
  sessionStorage.setItem('persist:emp', JSON.stringify(store_a));
  if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
    var url = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_Url__["default"].app_url + 'ticketRefund/#' + __WEBPACK_IMPORTED_MODULE_3_Routes__["default"].ticket.child.updateDetail.path + '?');
    wx.miniProgram.navigateTo({
      url: '/sub/uppPayCenter/index?token=' + token + '&merAppId=' + merAppId + '&merId=' + merId + '&version=' + version + '&local=' + language + '&showBackUrl=' + url
    });
    return false;
  }
  // isTTWebView 若为 true，则是在头条小程序的 web-view 中打开
  var isTTWebView = navigator.userAgent.toLowerCase().includes('toutiaomicroapp');
  if (isTTWebView) {
    var _url = encodeURIComponent(DYurl);
    tt.miniProgram.navigateTo({
      url: '/subs/payCenter/dyPayment?merId=' + merId + '&merAppId=' + merAppId + '&token=' + token + '&version=' + version + '&jumpPath=' + _url
    });
    return false;
  }

  window.location.href = __WEBPACK_IMPORTED_MODULE_2_Url__["default"].uppPay + '?token=' + token + '&merAppId=' + merAppId + '&merId=' + merId + '&version=' + version + '&language=' + language;
}

// 新航班舱位排序
function cabinSort(arr) {
  var spacearr = ['E/V/Z/T/N/R/G/X', 'U/A/L/Q', 'B/M/H/P/K', 'Y', 'S', 'W', 'C/D/I/O', 'J', 'F'];

  var cabinLists = [];
  var trag = arr.some(function (it) {
    return it.giftMiles;
  });

  arr.forEach(function (item) {
    /**
     * 同仓位只取一个
     */

    if (!trag) {
      spacearr = spacearr.map(function (child) {
        return typeof child === 'string' && child.indexOf(item.cabin) !== -1 ? item : child;
      });
    } else {
      spacearr.forEach(function (child, i) {
        if (child.indexOf(item.cabin) !== -1) {
          item.innnk = i;
          cabinLists.push(item);
        }
      });
    }
  });
  if (!trag) {
    spacearr = spacearr.filter(function (item) {
      return !(typeof item === 'string');
    });
    return spacearr;
  } else {
    return cabinLists.sort(function (a, b) {
      return a.innnk - b.innnk;
    });
  }
}

// 证件类型
function getCertificateType(str, lang) {
  switch (str) {
    case 'NI':
      return lang.ni; // '身份证'
    case 'PP':
      return lang.pp; // '护照号'
    case 'P':
      return lang.pp; // '护照号'
    case 'ID':
      return lang.othersId; // '其他证件'
    default:
      return lang.ni;
  }
}

function getMuCertificateType(str) {
  switch (str) {
    case '709':
      return '身份证';
    case 'HH':
      return '户口簿';
    case 'BR':
      return '出生证明';
    case 'MI':
      return '军官证';
    case 'POL':
      return '警官证';
    case '9CT':
      return '台胞证';
    case '9CC':
      return '回乡证';
    case 'TRP':
      return '台湾居民居住证';
    case 'GRP':
      return '港澳居民居住证';
    case 'PT':
      return '护照';
    case 'F1':
      return '其它';
    case '710':
      return '外国人永久居留证';
    case 'S':
      return '海员证';
    case '9PF':
      return '外国人出入境证';
    default:
      return '其它证件';
  }
}

function getCaCertificateType(str) {
  switch (str) {
    case 'CA-RC':
      return '身份证';
    case 'CA-2RC':
      return '身份证';
    case 'PT':
      return '护照';
    case 'CA-EPT':
      return '电子护照';
    case 'CA-209':
      return '户口簿';
    case 'CA-MM':
      return '军人及武警证件';
    case 'CA-ML':
      return '通行证';
    case 'F1':
      return '其它证件';
    case 'CA-FD':
      return '外国人永久居留证';
    case 'S':
      return '海员证';
    case 'CA-DCM':
      return '外交部签发的驻华外交人员证';
    default:
      return '其它证件';
  }
}

function getHuCertificateType(str) {
  switch (str) {
    case 'NI':
      return '身份证';
    case 'PP':
      return '护照';
    case 'JG':
      return '军官证';
    case 'WG':
      return '外国人永久居留证';
    case 'ID14':
      return '外国人永久居留证';
    case 'HM':
      return '港澳台居民居住证';
    case 'ID':
      return '其他证件';
    case 'ID1':
      return '港澳通行证';
    case 'ID2':
      return '大陆居民来往台湾通行证';
    case 'ID5':
      return '士官证';
    case 'ID10':
      return '海员证';
    case 'ID15':
      return '出生医学证明';
    case 'ID16':
      return '户口簿';
    case 'ID17':
      return '学生证';
    default:
      return '其它证件';
  }
}

// 旅客类型
function getPsgType(peppleType, type) {
  if (peppleType === 0) {
    return '成人';
  } else if (peppleType === 1) {
    return '儿童';
  } else if (peppleType === 2) {
    // 为无陪伴儿童
    return '儿童';
  } else if (peppleType === 3) {
    return '婴儿';
  } else if (peppleType === 5) {
    return '成人';
  } else {
    return '';
  }
}

// 登录
function allLogin(query) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])()) {
    try {
      // 需要先判断 android 需要登出再登录， ios 直接登录
      if (window.CSNativeObject.getOSType() === 'android') {
        // 先退出，再登录，解决安卓token失效后一直死循环查不出数据问题
        window.CSNativeObject.nativeLoginOut('callback');
        window.callback = function (params) {
          window.CSNativeObject.nativeLogin('callback');
          window.callback = function (params2) {
            window.location.reload();
          };
        };
      } else {
        window.CSNativeObject.nativeLogin('callback');
        window.callback = function (params2) {
          window.location.reload();
        };
      }
    } catch (e) {
      // catch exception;
    }
  } else {
    var url = '';
    if (window.location.hash.indexOf(__WEBPACK_IMPORTED_MODULE_3_Routes__["default"].ticket.child.reformProcess.path) !== -1) {
      url = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_Url__["default"].app_url + 'ticketRefund/#' + __WEBPACK_IMPORTED_MODULE_3_Routes__["default"].ticket.child.reformProcess.path + window.location.hash.slice(window.location.hash.indexOf('?')));
    } else {
      url = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_Url__["default"].app_url + 'ticketRefund/#' + __WEBPACK_IMPORTED_MODULE_3_Routes__["default"].ticket.child.updateDetail.path + '?' + toQueryString(query));
    }
    if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
      window.location.href = __WEBPACK_IMPORTED_MODULE_2_Url__["default"].login_url + 'personal_new/login/#/?t=forward&redirect=' + url + '&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=2&topBarRightCode=empty&coopAccount=';
    } else {
      window.location.href = __WEBPACK_IMPORTED_MODULE_2_Url__["default"].login_url + 'personal_new/login/#/?t=forward&redirect=' + url + '&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=0&coopAccount=';
    }
  }
}

/**
 * @description 判断是否为公务票
 * @param {array} arr
 * @returns {bool}
 */
function isOfficialTicket() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return arr.filter(function (item) {
    return item.civilSeat;
  }).length > 0;
}

/**
 * @description 创建script获取微信jsdk
 */
function createWechatSdk() {
  var oscript = document.createElement('script');
  oscript.src = 'https://res.wx.qq.com/open/js/jweixin-1.4.0.js';
  document.body.appendChild(oscript);
}
function createFanTaiSdk() {
  var oscript = document.createElement('script');
  oscript.src = 'https://public-1251849568.cos.ap-guangzhou.myqcloud.com/jssdk/finclip-jssdk-1.4.20.js';
  document.body.appendChild(oscript);
}

/**
 * @description 航班列表排序
 * @param {array} arr
 */
function sortFlightList(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.sort(function (a, b) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()((a.flightDate || a.deptDate) + ' ' + (a.depTime || a.deptTime)).unix() - __WEBPACK_IMPORTED_MODULE_0_moment___default()((b.flightDate || b.deptDate) + ' ' + (b.depTime || b.deptTime)).unix();
  });
}
/**
 * 解析common项目跳转过来Url参数
 * urlParams=mode-easy_lastName-lian_firstName-jie_account-784123123
 * @param {String} str
 * @returns {Object} { mode: easy, lastName, firstName, account }
 */
function parseLoginUrlParams(str) {
  return decodeURIComponent(str).split('_').reduce(function (a, b) {
    var before = b.match(/(\S*)-/)[1];
    var after = b.match(/-(\S*)/)[1];
    if (a[before]) {
      return a;
    }
    a[before] = after;
    return a;
  }, {});
}

/**
 * @description 保存本地数据
 * @param {string} key
 * @param data
 */
function saveLocalData(key, data) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])()) {
    window.CSNativeObject.saveDataLocalStorage(JSON.stringify(_defineProperty({}, key, JSON.stringify(data))));
  } else {
    localStorage.setItem(key, JSON.stringify(data));
  }
}

/**
 * @description 获取本地数据
 * @param {string} key
 * @returns
 */
function getLocalData(key) {
  var data = null;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])()) {
    data = window.CSNativeObject.getDataLocalStorage(JSON.stringify({ keyName: key }));
  } else {
    data = localStorage.getItem(key);
  }
  try {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
  } catch (error) {
    data = null;
  }
  return data;
}

/**
 * @description 物理舱位分类
 * @param {string} cabintype 以英文逗号隔开的字符串
 * @returns {}
 */
function physicsCabinsAssort(cabintype) {
  var cabinClass = {
    firstClass: {
      zh_cn: '头等舱',
      type: 'F'
    },
    businessClass: {
      zh_cn: '公务舱',
      type: 'J/C/D/I/O'
    },
    mzEconomyClass: {
      zh_cn: '明珠经济舱',
      type: 'W/S'
    },
    economyClass: {
      zh_cn: '经济舱',
      type: 'Y/B/M/H/P/K/U/A/L/Q/E/V/Z/T/N/R/G/X'
    }
  };
  var obj = Object.assign({}, cabinClass);
  var keys = Object.keys(cabinClass);
  cabintype.split(',').forEach(function (type) {
    keys.forEach(function (key) {
      if (!obj[key]._type) obj[key]._type = '';
      if (cabinClass[key].type.indexOf(type) !== -1) {
        obj[key]._type += (!obj[key]._type ? '' : ',') + type;
      }
    });
  });
  return obj;
}

function touchScroll(scroll) {
  var ios = navigator.userAgent.indexOf('iPhone'); //判断是否为ios
  if (ios !== -1) {
    touchScroll(scroll);
  }

  var canScroll = true;
  function touchScroll(el) {
    canScroll = false;
    //el需要滑动的元素
    el.addEventListener('touchmove', function (e) {
      canScroll = true;
    });
    document.body.addEventListener('touchmove', function (e) {
      if (!canScroll) {
        e.preventDefault(); //阻止默认事件(上下滑动)
      } else {
        //需要滑动的区域
        var top = el.scrollTop; //对象最顶端和窗口最顶端之间的距离
        var scrollH = el.scrollHeight; //含滚动内容的元素大小
        var offsetH = el.offsetHeight; //网页可见区域高
        var cScroll = top + offsetH; //当前滚动的距离

        //被滑动到最上方和最下方的时候
        if (top == 0) {
          top = 1; //0～1之间的小数会被当成0
        } else if (cScroll === scrollH) {
          el.scrollTop = top - 0.1;
        }
      }
    }, { passive: false }); //passive防止阻止默认事件不生效
  }
}

// 身份证号码校验
function idNoFormatCheck(num) {
  num = num.toUpperCase(); // 字符串转换为大写
  if (/^[A-KM-QT-XZ]{1}[1|2][0-9]{8}$/.test(num)) {
    return true; //台 校验码=10-通算值的末尾数
    //通算值= 首字母对应的第一位验证码 + 首字母对应的第二位验证码*9 + 性别码*8 + 第二位数字*7 + 第三位数字*6 + 第四位数字*5 + 第五位数字*4 + 第六位数字*3 + 第七位数字*2 + 第八位数字*1
  }
  if (/^[1|5|7][0-9]{6}[0−9aA][0−9aA]$/.test(num)) {
    return true; //澳
  }
  if (/^((\s[A-Za-z]|([A-Za-z]{2}))\d{6}(([0−9aA][0−9aA])|([0-9aA])))$/.test(num)) {
    return true; //港
  }
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
    return false;
  }
  var len, re;
  len = num.length;
  if (len != 15 && len != 18) {
    return false;
  }
  re = new RegExp(len == 15 ? /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/ : /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
  var arrSplit = num.match(re);
  var dtmBirth = new Date((len == 15 ? '19' : '') + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
  var bGoodDay;
  bGoodDay = (len == 15 && dtmBirth.getYear() == Number(arrSplit[2]) || len == 18 && dtmBirth.getFullYear() == Number(arrSplit[2])) && dtmBirth.getMonth() + 1 == Number(arrSplit[3]) && dtmBirth.getDate() == Number(arrSplit[4]);
  if (!bGoodDay) {
    return false;
  }
  var valnum;
  var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
  var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
  var nTemp = 0,
      i;
  if (len == 15) {
    num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
  }
  for (i = 0; i < num.length - 1; i++) {
    nTemp += num.substr(i, 1) * arrInt[i];
  }
  valnum = arrCh[nTemp % 11];
  if (valnum != num.substr(num.length - 1, 1)) {
    return false;
  }
  return true;
}

// 问卷判断用户端
function userAgentType() {
  var channel = '通用';
  if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
    channel = '小程序';
  } else if ((navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) && Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])()) {
    channel = 'APP Android';
  } else if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])()) {
    channel = 'APP IOS';
  } else if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) && !Object(__WEBPACK_IMPORTED_MODULE_1__csair_emp_helpers__["C" /* isCsairApp */])()) {
    channel = 'H5 移动';
  } else if (navigator.userAgent.match(/(Windows NT)/i)) {
    channel = 'H5 PC';
  }
  return channel;
}

// 敏感信息处理
function encrypt(word) {
  var keyStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'refUnd!2#ProD%26';

  var key = window.CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = window.CryptoJS.enc.Utf8.parse(word);
  var encrypted = window.CryptoJS.AES.encrypt(srcs, key, {
    mode: window.CryptoJS.mode.ECB,
    padding: window.CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

function getOrderChannel() {
  var chan = userAgentType();
  if (chan === '小程序') {
    return 'W_XCX';
  } else if (chan === 'APP Android') {
    return 'A_A';
  } else if (chan === 'APP IOS') {
    return 'A_I';
  } else if (navigator.userAgent.toLowerCase().match(/micromessenger/i)) {
    //微信浏览器环境
    return 'W_H5';
  } else if (chan === 'H5 PC') {
    return 'T_N';
  } else if (chan === 'H5 移动') {
    return 'T_N';
  } else {
    return 'N_N';
  }
}

/**
 * 设置与获取sessionStorage
 *@public
 * @return {String}
 * */
var session = function session(key, data) {
  if (!key) {
    console.error('key不能为空');
    return '';
  }
  if (data) {
    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
      sessionStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, data);
    }
  } else {
    try {
      if (sessionStorage.getItem(key)) {
        if (sessionStorage.getItem(key).includes('{') || sessionStorage.getItem(key).includes('[')) {
          return JSON.parse(sessionStorage.getItem(key));
        }
        return sessionStorage.getItem(key);
      }
    } catch (e) {
      return sessionStorage.getItem(key);
    }
  }
};

function getPageName(page) {
  var pageNameP = '';
  if (page) {
    if (page.includes('/ticket/updateDetail')) {
      pageNameP = '机票退改列表页';
    } else if (page.includes('/ticket/changeRefundExplain/list')) {
      pageNameP = '机票退改-退改说明选择客票页';
    } else if (page.includes('/ticket/changeRefundExplain/detail')) {
      pageNameP = '机票退改-退改说明页';
    } else if (page.includes('/ticket/selectDate')) {
      pageNameP = '机票退改-选择变更日期页';
    } else if (page.includes('/ticket/TicketChange')) {
      pageNameP = '机票退改-变更新航班页';
    } else if (page.includes('/ticket/ApplySubmit')) {
      pageNameP = '机票退改-变更提交申请页';
    } else if (page.includes('/ticket/coupon')) {
      pageNameP = '机票退改-变更优惠券列表页';
    } else if (page.includes('/ticket/addPersonMessage')) {
      pageNameP = '机票退改-补充旅客信息页';
    } else if (page.includes('/ticket/pay')) {
      pageNameP = '机票退改-支付成功页';
    } else if (page.includes('/ticket/ReformProcess')) {
      if (page.includes('orderType=T')) {
        if (page.includes('TJ')) {
          pageNameP = '机票退改-取消行程详情页';
        } else {
          pageNameP = '机票退改-退票详情页';
        }
      } else {
        pageNameP = '机票退改-变更详情页';
      }
    } else if (page.includes('/ticket/EndorsedApply')) {
      if (page.includes('ticketChangeType=refundTicket')) {
        if (page.includes('channel=TPWL')) {
          pageNameP = '机票退改-取消行程选人选航段页';
        } else {
          pageNameP = '机票退改-退票选人选航段页';
        }
      } else {
        pageNameP = '机票退改-变更选人选航段页';
      }
    } else if (page.includes('/ticket/refundApply')) {
      if (page.includes('channel=TPWL')) {
        pageNameP = '机票退改-取消行程提交申请页';
      } else {
        pageNameP = '机票退改-退票提交申请页';
      }
    } else if (page.includes('/ticket/refundCoupon')) {
      pageNameP = '机票退改-退票优惠券列表页';
    } else if (page.includes('/ticket/cancelLation')) {
      pageNameP = '机票退改-取消行程列表页';
    } else if (page.includes('/ticket/wrongPurchase')) {
      pageNameP = '机票退改-错购提交申请页';
    } else if (page.includes('/ticket/discountTicketApplication')) {
      pageNameP = '机票退改-降价客票提交申请页';
    } else if (page.includes('/ticket/feeQuery/login')) {
      pageNameP = '退改计算器-凭证号登录页';
      // } else if (page.includes()) {
      //   pageNameP = '机票退改-码上改签查询页'
    } else if (page.includes('/ticket/feeQuery/detail')) {
      pageNameP = '退改计算器-退改费用查询页';
    }
  }
  return pageNameP;
}

function getChangeStatus(changeStatus) {
  var flag = '';
  switch (changeStatus) {
    case '0':
      flag = '审核中';
      break;
    case '1':
      flag = '审核不通过';
      break;
    case '2':
      flag = '待支付';
      break;
    case '3':
      flag = '支付中';
      break;
    case '4':
      flag = '支付失败';
      break;
    case '5':
      flag = '处理中';
      break;
    case '6':
      flag = '取消';
      break;
    case '7':
      flag = '变更失败';
      break;
    case '8':
      flag = '变更成功';
      break;
    case '14':
      flag = '人工处理';
      break;
    case '15':
      flag = '重新提单';
      break;
    case '16':
      flag = '放弃变更';
      break;
    case '17':
      flag = '已电话通知';
      break;
    case '18':
      flag = '等待处理';
      break;
    case '19':
      flag = '变更处理中';
      break;
    case '20':
      flag = '处理失败';
      break;
    default:
      break;
  }
  return flag;
}

function getGoogleApp() {
  if (window.CSNativeObject && typeof window.CSNativeObject.getAnalyticsSwitch == 'function') {
    return true;
  } else {
    return false;
  }
}

function getHaiwaiApp() {
  if (window.CSNativeObject && window.CSNativeObject.getCurrentLocaleCountryInfo && typeof window.CSNativeObject.getCurrentLocaleCountryInfo == 'function') {
    try {
      window.getCountryInfo = function (blackResult) {
        if (typeof blackResult === 'string') {
          blackResult = JSON.parse(blackResult);
        }
        console.log(blackResult, 'blackResult');
        return blackResult.countryCode;
        // if (
        //   blackResult.countryCode !== 'CN'
        // ) {
        //   return true;
        // } else {
        //   return false
        // }
      };
      window.CSNativeObject.getCurrentLocaleCountryInfo(JSON.stringify({
        callBackMethod: 'getCountryInfo'
      }));
    } catch (error) {
      console.log(error);
      return false;
    }
  } else {
    return false;
  }
}

/***/ }),

/***/ "oHrP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attach_icon.493f624b.jpg";

/***/ }),

/***/ "oZb9":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("0aDT"),
    isObject = __webpack_require__("fAzg");

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),

/***/ "onlG":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__("Gsca");
} catch (err) {
  var index = __webpack_require__("Gsca");
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),

/***/ "oyG0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _rcCollapse = __webpack_require__("CGvQ");

var _rcCollapse2 = _interopRequireDefault(_rcCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Accordion = function (_React$Component) {
    (0, _inherits3['default'])(Accordion, _React$Component);

    function Accordion() {
        (0, _classCallCheck3['default'])(this, Accordion);
        return (0, _possibleConstructorReturn3['default'])(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Accordion, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_rcCollapse2['default'], this.props);
        }
    }]);
    return Accordion;
}(_react2['default'].Component);

exports['default'] = Accordion;

Accordion.Panel = _rcCollapse.Panel;
Accordion.defaultProps = {
    prefixCls: 'am-accordion'
};
module.exports = exports['default'];

/***/ }),

/***/ "p4nV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "pEGt":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("DvwR");
var enumBugKeys = __webpack_require__("B5V0");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pMKr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "q73u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "qP46":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "qZDr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _rcNotification = __webpack_require__("Hx0i");

var _rcNotification2 = _interopRequireDefault(_rcNotification);

var _index = __webpack_require__("YK8K");

var _index2 = _interopRequireDefault(_index);

var _classnames2 = __webpack_require__("HW6M");

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var messageInstance = void 0;
var prefixCls = 'am-toast';
function getMessageInstance(mask) {
    var _classnames;

    if (messageInstance) {
        messageInstance.destroy();
        messageInstance = null;
    }
    messageInstance = _rcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        style: {},
        transitionName: 'am-fade',
        className: (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-mask', mask), (0, _defineProperty3['default'])(_classnames, prefixCls + '-nomask', !mask), _classnames))
    });
    return messageInstance;
}
function notice(content, type) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var _onClose = arguments[3];
    var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var iconType = {
        info: '',
        success: __webpack_require__("gvQx"),
        fail: __webpack_require__("6fbY"),
        offline: __webpack_require__("RP4F"),
        loading: 'loading'
    }[type];
    var instance = getMessageInstance(mask);
    instance.notice({
        duration: duration,
        style: {},
        content: !!iconType ? _react2['default'].createElement(
            'div',
            { className: prefixCls + '-text ' + prefixCls + '-text-icon', role: 'alert', 'aria-live': 'assertive' },
            _react2['default'].createElement(_index2['default'], { type: iconType, size: 'lg' }),
            _react2['default'].createElement(
                'div',
                { className: prefixCls + '-text-info' },
                content
            )
        ) : _react2['default'].createElement(
            'div',
            { className: prefixCls + '-text', role: 'alert', 'aria-live': 'assertive' },
            _react2['default'].createElement(
                'div',
                null,
                content
            )
        ),
        onClose: function onClose() {
            if (_onClose) {
                _onClose();
            }
            instance.destroy();
            instance = null;
            messageInstance = null;
        }
    });
}
exports['default'] = {
    SHORT: 3,
    LONG: 8,
    show: function show(content, duration, mask) {
        return notice(content, 'info', duration, function () {}, mask);
    },
    info: function info(content, duration, onClose, mask) {
        return notice(content, 'info', duration, onClose, mask);
    },
    success: function success(content, duration, onClose, mask) {
        return notice(content, 'success', duration, onClose, mask);
    },
    fail: function fail(content, duration, onClose, mask) {
        return notice(content, 'fail', duration, onClose, mask);
    },
    offline: function offline(content, duration, onClose, mask) {
        return notice(content, 'offline', duration, onClose, mask);
    },
    loading: function loading(content, duration, onClose, mask) {
        return notice(content, 'loading', duration, onClose, mask);
    },
    hide: function hide() {
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        }
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "qcQk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qs+f":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zyKz")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "r3+g":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var anObject = __webpack_require__("FKWp");
var getKeys = __webpack_require__("pEGt");

module.exports = __webpack_require__("qs+f") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "r6Pz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ "r9K6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rELt":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "rKx+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ajQ");
var $Object = __webpack_require__("iANj").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "re1T":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("5I/1");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "rjjF":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("bSeU");
var createDesc = __webpack_require__("YTz9");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var has = __webpack_require__("x//u");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("qs+f") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "sTRE":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("Fxj9"),
    isObject = __webpack_require__("fAzg");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "scfM":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"right\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><defs><path id=\"right_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"right_b\"><use xlink:href=\"#right_a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#right_b)\"><defs><path id=\"right_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"right_d\"><use xlink:href=\"#right_c\" overflow=\"visible\"/></clipPath></g><path d=\"M30.601 21.399L18.368 9.166l-2.121 2.121 10.118 10.119-10.118 10.118 2.121 2.121 12.233-12.233-.006-.006z\"/></symbol>";
module.exports = sprite.add(image, "right");

/***/ }),

/***/ "sdiJ":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"cross-circle-o\" ><title>step-48-&#x9519;&#x8BEF;-&#x5B9E;&#x5FC3;</title><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.799-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.721 7.723c-.726.728-.558 1.646-.065 2.177.494.532 1.554.683 2.312-.174l7.587-7.584 7.644 7.623c.796.799 1.608.725 2.211.146.604-.579.72-1.442-.075-2.24l-7.657-7.669 7.544-7.521c.811-.697.9-1.76.297-2.34-.92-.885-1.849-.338-2.264.078l-7.685 7.667z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "cross-circle-o");

/***/ }),

/***/ "t8pr":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("L1QY");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "tUq7":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("kROs"),
    keysIn = __webpack_require__("nWat");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "tVq+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__("V/++");

var _index2 = _interopRequireDefault(_index);

var _Checkbox = __webpack_require__("Z09J");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _omit = __webpack_require__("JkBm");

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ListItem = _index2['default'].Item;
function noop() {}

var CheckboxItem = function (_React$Component) {
    (0, _inherits3['default'])(CheckboxItem, _React$Component);

    function CheckboxItem() {
        (0, _classCallCheck3['default'])(this, CheckboxItem);
        return (0, _possibleConstructorReturn3['default'])(this, (CheckboxItem.__proto__ || Object.getPrototypeOf(CheckboxItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(CheckboxItem, [{
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                listPrefixCls = _props.listPrefixCls,
                className = _props.className,
                children = _props.children,
                disabled = _props.disabled,
                _props$checkboxProps = _props.checkboxProps,
                checkboxProps = _props$checkboxProps === undefined ? {} : _props$checkboxProps;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-disabled', disabled === true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            // Note: if not omit `onChange`, it will trigger twice on check listitem
            var otherProps = (0, _omit2['default'])(this.props, ['listPrefixCls', 'onChange', 'disabled', 'checkboxProps']);
            if (disabled) {
                delete otherProps.onClick;
            } else {
                otherProps.onClick = otherProps.onClick || noop;
            }
            var extraProps = {};
            ['name', 'defaultChecked', 'checked', 'onChange', 'disabled'].forEach(function (i) {
                if (i in _this2.props) {
                    extraProps[i] = _this2.props[i];
                }
            });
            return _react2['default'].createElement(
                ListItem,
                (0, _extends3['default'])({}, otherProps, { prefixCls: listPrefixCls, className: wrapCls, thumb: _react2['default'].createElement(_Checkbox2['default'], (0, _extends3['default'])({}, checkboxProps, extraProps)) }),
                children
            );
        }
    }]);
    return CheckboxItem;
}(_react2['default'].Component);

exports['default'] = CheckboxItem;

CheckboxItem.defaultProps = {
    prefixCls: 'am-checkbox',
    listPrefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),

/***/ "tXv+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");
var settle = __webpack_require__("Ae6m");
var buildURL = __webpack_require__("n5Ex");
var parseHeaders = __webpack_require__("WdqR");
var isURLSameOrigin = __webpack_require__("q73u");
var createError = __webpack_require__("CCtP");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("Jiug");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p4nV");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "tYO1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0/jl");
__webpack_require__("gCWN");
__webpack_require__("3ggi");
__webpack_require__("OoWg");
module.exports = __webpack_require__("iANj").Symbol;


/***/ }),

/***/ "tfRM":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("5I/1");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "tpC5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tyYZ":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("evKR"),
    listCacheDelete = __webpack_require__("WqOw"),
    listCacheGet = __webpack_require__("DndO"),
    listCacheHas = __webpack_require__("/OXf"),
    listCacheSet = __webpack_require__("meRA");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "tz60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("0Lvz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("4dmN")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "uDOi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWbD":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("LNGb"),
    overRest = __webpack_require__("Yv2V"),
    setToString = __webpack_require__("Dysy");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "uZ73":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAZtJREFUaEPtmTFSxDAMRSWfgAPQxr4Fh4AjAC00LAwNDBT0UEJNy33sXGJPgBZnNjNh2SQkKymr2aTLJHH0/rdl2UYwfqHx+GEGmNrB2YFDdcB57y+I6CYL4Jx7ijF+jhFjii7kQginRPQBAEc5aCIqy7L0FgCy8tcA8FAHbwngj/JrxZcAcJdSet9nB3LwV0T02FQeAJaIeBlj/Ppx5XtfAbqUf04pvY4NPgNLD2Ix5Wu3JAFalUfEnDbfdlFeGkBceUkAFeWlANSUlwBQVZ4bQF15ToBJlOcCmEx5DgAMIZw1q8q6tuHM833lxeiJrCiKE0TMNfxx4yc71zZ9AW8+Hw3gvb8HgJeN4Nlm2P+CHC6A+S6UK1nTg3jdR02n0XqcmZ7ImhAiS8a+bDQ6C21peBInOAGqPSqpxXubE9wANcSvjSvJEkMCQNUJKQA1JyQBVJyQBhB3QgNA1AktgE4nAOA2pZS32wdfmgCtTlg6H9jqhDWACsJ7f05Ei+rG2BHT4H7e9YH2GGANPjc2A7BLOrDB2YGBgrG/vgLfFVdA0vyLLAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "uZMl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("SG5I");

__webpack_require__("wm8T");

/***/ }),

/***/ "vb1w":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("L1QY");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "wNex":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA9VJREFUWEe9l11oW2UYx3/PSTI3FUR0F4qou3BjTuw2T1ZUVIY3Xgh6U527GYJj0A9ZZ5N2uzHe1CWZzA9wxuJQpkwjgvPCCSoMYW7NSUER5sVEu7rdFMpa1qTbmpxH3+SsTT/SnpOMPnA4Ief/Pv//ec7z8b6CH1MV3kJ4E0VE/Szxi5FlgZl8hHHdi9AKlCi5HRxoHVt2nU/A8gKMo7SzB+Wjik/hGGXpos+e8MmxJMyfgOTZ+5DQMBACxoF24tHjKyfAMKWck8BzVVIdxbWi9NkjzYrwFwHDknQ6Ed4DLE/EEYpWDwm72IwI/wIODrYgVhZhvUdYBOkhbh9ZGQHp329Dr38OvFhDOIKsihJrGW1UhGASLOIqsqbA3s0TS9Z5Or8T1S/mkR0nEm6ne4tJzsAmpJ2jwAaUvxA3Qaz1n7peDuXvxtV/gdU1mAmULnqjxwKzV6o65XQAh4EIcILi5A4S26/WdZZyskDbvOdjlMM2+7eYUg1kQiq3Gaws6ENAGaGDgj1AQtxFPSVzryKS8QTPQlQGuH3NPjo2TQZRIGSzIS6sexelc6bGhS4eGP6Gc226QEhyaCPimig8Mo9oCqSXuP1BMAEGfTD3BJacrln4N8JvKGbwmEi4oGVEXFzCwDMI9ywkkkuo+z1CCWEaV0rAdGWGWEyj3m90HNEfTb7N9oGU8yvweBD1TWLHULpnBaTzr6NqktHrdE2697Vch2ojkATivtbdPFCxKiCrIYbz54F1N8+3L0+nqgLSzgso39YsuQjyE6IWKiFUQwjmMngLxQbuX4SiDOS8ahIQg6+5VFCxkEq5/4lIv/D++Vu4djmDyi7P4ThCD7HoJwsIzNbs8Jk7KUVMO/ZG8xzUD2h5d+WfsCVMW1K9X6veS5aAZREulWH1KLGWgpB0tiHyFeiD1UYk+yhc+ZDEdlNCCy3lPGk+GnDv3IdyDpcd9Nl/+Aq+BzKtuNt8BG+3c4Ki7Fxyxldbt9kXmN1RrXVSnMzUFV5HlWBaqyUbceUKYfdT3thmhk19S+V+AXmqBmCa1Uli9vON7Jj9b0gMY//gXYSti/Om4QjCLmLRU0FCfwMbTMCh/Gu4OjDn7VXaiT+WaeTtjR//Aky1XL18FP7PkVkbRFY9a7K5kbcPJiA99ChamYIbPLILSOgVYlvPNEoeUEDuJVQ+m/n+SoKpW98msen6yghIOV8CL1fJ9Cx3WE+zxzajtinzlwPmfDihl4C1lUOJym56o981xTzTiPx4eWdwPWWrvzILXP2ZqcLHQRtOPRp/EbhxPH/4a6GtzW205BYT8R8RXUbfQHa9TAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "wXdB":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "wYgl":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("b+bF"),
    isObjectLike = __webpack_require__("XUab");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "wiaE":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("NZra");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "wm8T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Eif7"), __esModule: true };

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "x//u":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "xVc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("qs+f");
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
var toObject = __webpack_require__("wXdB");
var IObject = __webpack_require__("wiaE");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("zyKz")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "y1vT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "yRnQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("97gm");
var bind = __webpack_require__("+jwL");
var Axios = __webpack_require__("F3T6");
var defaults = __webpack_require__("nCfu");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("59gI");
axios.CancelToken = __webpack_require__("ITLE");
axios.isCancel = __webpack_require__("WKQ7");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pMKr");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "yU3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_button_style_css__ = __webpack_require__("mkdO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_button__ = __webpack_require__("Zp9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__("63og");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);



var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Btn = function (_PureComponent) {
  _inherits(Btn, _PureComponent);

  function Btn() {
    _classCallCheck(this, Btn);

    return _possibleConstructorReturn(this, (Btn.__proto__ || Object.getPrototypeOf(Btn)).apply(this, arguments));
  }

  _createClass(Btn, [{
    key: 'render',


    // componentWillReceiveProps(nextProps, nextContext) {
    //   const { disabled, text } = nextProps;
    //   this.setState({
    //     disabled,
    //     text,
    //   });
    // }

    value: function render() {
      var _props = this.props,
          className = _props.className,
          onClick = _props.onClick,
          key = _props.key,
          text = _props.text,
          style = _props.style,
          disabled = _props.disabled;

      return _jsx(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_button___default.a, {
        style: style,
        activeStyle: { background: '#ccc' },
        className: 'button ' + (className || ''),
        onClick: onClick,
        disabled: disabled
      }, key, text);
    }
  }]);

  return Btn;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Btn.defaultProps = {
  style: {}
};


/* harmony default export */ __webpack_exports__["default"] = (Btn);

/***/ }),

/***/ "yYxz":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "ygug":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"check-circle\" ><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zM13.1 23.2l-2.2 2.1 10 9.9L38.1 15l-2.2-2-15.2 17.8-7.6-7.6z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "check-circle");

/***/ }),

/***/ "ymMP":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("K+tY"),
    cloneBuffer = __webpack_require__("re1T"),
    cloneTypedArray = __webpack_require__("E32k"),
    copyArray = __webpack_require__("TVqP"),
    initCloneObject = __webpack_require__("WO/L"),
    isArguments = __webpack_require__("6+fr"),
    isArray = __webpack_require__("cW2c"),
    isArrayLikeObject = __webpack_require__("wYgl"),
    isBuffer = __webpack_require__("Fq9N"),
    isFunction = __webpack_require__("sTRE"),
    isObject = __webpack_require__("fAzg"),
    isPlainObject = __webpack_require__("RVTP"),
    isTypedArray = __webpack_require__("d7ze"),
    safeGet = __webpack_require__("CglM"),
    toPlainObject = __webpack_require__("tUq7");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "ytCb":
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__("BiZS");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"down\" ><title>Operation Icons Copy 4</title><path d=\"M22.355 28.237l-11.483-10.9c-.607-.576-1.714-.396-2.48.41l.674-.71c-.763.802-.73 2.071-.282 2.496l11.37 10.793-.04.039 2.088 2.196 1.098-1.043 12.308-11.682c.447-.425.48-1.694-.282-2.496l.674.71c-.766-.806-1.873-.986-2.48-.41L22.355 28.237z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "down");

/***/ }),

/***/ "zDzn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("yRnQ");

/***/ }),

/***/ "zMcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: delegated ./node_modules/react/index.js from dll-reference vendor_library
var reactfrom_dll_reference_vendor_library = __webpack_require__("GiK3");
var reactfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor_library);

// EXTERNAL MODULE: delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
var react_domfrom_dll_reference_vendor_library = __webpack_require__("O27J");
var react_domfrom_dll_reference_vendor_library_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor_library);

// CONCATENATED MODULE: ./node_modules/rc-touchable/es/PressEvent.js

function PressEvent(nativeEvent) {
    var _this = this;

    this.nativeEvent = nativeEvent;
    ['type', 'currentTarget', 'target', 'touches', 'changedTouches'].forEach(function (m) {
        _this[m] = nativeEvent[m];
    });
    if (!nativeEvent.$pressSeq) {
        nativeEvent.$pressSeq = 1;
    } else {
        nativeEvent.$pressSeq += 1;
    }
    this.$pressSeq = nativeEvent.$pressSeq;
}
PressEvent.prototype = extends_default()({}, PressEvent.prototype, {
    preventDefault: function preventDefault() {
        this.nativeEvent.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        var nativeEvent = this.nativeEvent,
            $pressSeq = this.$pressSeq;

        if (nativeEvent.$stopPressSeq) {
            return;
        }
        nativeEvent.$stopPressSeq = $pressSeq;
    }
});
function shouldFirePress(e) {
    var nativeEvent = e.nativeEvent,
        $pressSeq = e.$pressSeq;

    if (!nativeEvent.$stopPressSeq) {
        return true;
    }
    return nativeEvent.$stopPressSeq >= $pressSeq;
}
/* harmony default export */ var es_PressEvent = (PressEvent);
// CONCATENATED MODULE: ./node_modules/rc-touchable/es/index.js





// inspired by react-native



function keyMirror(obj) {
    Object.keys(obj).forEach(function (k) {
        return obj[k] = k;
    });
    return obj;
}
function copy(from, list) {
    var to = {};
    list.forEach(function (k) {
        to[k] = from[k];
    });
    return to;
}
function extractSingleTouch(_nativeEvent) {
    var nativeEvent = _nativeEvent;
    if (nativeEvent.nativeEvent) {
        nativeEvent = nativeEvent.nativeEvent;
    }
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;
    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
}
/**
 * Touchable states.
 */
var States = keyMirror({
    NOT_RESPONDER: null,
    RESPONDER_INACTIVE_PRESS_IN: null,
    RESPONDER_INACTIVE_PRESS_OUT: null,
    RESPONDER_ACTIVE_PRESS_IN: null,
    RESPONDER_ACTIVE_PRESS_OUT: null,
    RESPONDER_ACTIVE_LONG_PRESS_IN: null,
    RESPONDER_ACTIVE_LONG_PRESS_OUT: null,
    ERROR: null
});
/**
 * Quick lookup map for states that are considered to be "active"
 */
var IsActive = {
    RESPONDER_ACTIVE_PRESS_OUT: true,
    RESPONDER_ACTIVE_PRESS_IN: true
};
/**
 * Quick lookup for states that are considered to be "pressing" and are
 * therefore eligible to result in a "selection" if the press stops.
 */
var IsPressingIn = {
    RESPONDER_INACTIVE_PRESS_IN: true,
    RESPONDER_ACTIVE_PRESS_IN: true,
    RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
var IsLongPressingIn = {
    RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
/**
 * Inputs to the state machine.
 */
var Signals = keyMirror({
    DELAY: null,
    RESPONDER_GRANT: null,
    RESPONDER_RELEASE: null,
    RESPONDER_TERMINATED: null,
    ENTER_PRESS_RECT: null,
    LEAVE_PRESS_RECT: null,
    LONG_PRESS_DETECTED: null
});
/**
 * Mapping from States x Signals => States
 */
var Transitions = {
    NOT_RESPONDER: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
        RESPONDER_RELEASE: States.ERROR,
        RESPONDER_TERMINATED: States.ERROR,
        ENTER_PRESS_RECT: States.ERROR,
        LEAVE_PRESS_RECT: States.ERROR,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_INACTIVE_PRESS_IN: {
        DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_INACTIVE_PRESS_OUT: {
        DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_ACTIVE_PRESS_IN: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
    },
    RESPONDER_ACTIVE_PRESS_OUT: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_ACTIVE_LONG_PRESS_IN: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
        LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
    },
    RESPONDER_ACTIVE_LONG_PRESS_OUT: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    error: {
        DELAY: States.NOT_RESPONDER,
        RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.NOT_RESPONDER,
        LEAVE_PRESS_RECT: States.NOT_RESPONDER,
        LONG_PRESS_DETECTED: States.NOT_RESPONDER
    }
};
// ==== Typical Constants for integrating into UI components ====
// const HIT_EXPAND_PX = 20;
// const HIT_VERT_OFFSET_PX = 10;
var HIGHLIGHT_DELAY_MS = 130;
var PRESS_EXPAND_PX = 20;
var LONG_PRESS_THRESHOLD = 500;
var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
var LONG_PRESS_ALLOWED_MOVEMENT = 10;
var lastClickTime = 0;
var pressDelay = 200;
function isAllowPress() {
    // avoid click penetration
    return Date.now() - lastClickTime >= pressDelay;
}

var es_Touchable = function (_React$Component) {
    inherits_default()(Touchable, _React$Component);

    function Touchable() {
        classCallCheck_default()(this, Touchable);

        var _this = possibleConstructorReturn_default()(this, (Touchable.__proto__ || Object.getPrototypeOf(Touchable)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.callChildEvent('onTouchStart', e);
            _this.lockMouse = true;
            if (_this.releaseLockTimer) {
                clearTimeout(_this.releaseLockTimer);
            }
            _this.touchableHandleResponderGrant(e.nativeEvent);
        };
        _this.onTouchMove = function (e) {
            _this.callChildEvent('onTouchMove', e);
            _this.touchableHandleResponderMove(e.nativeEvent);
        };
        _this.onTouchEnd = function (e) {
            _this.callChildEvent('onTouchEnd', e);
            _this.releaseLockTimer = setTimeout(function () {
                _this.lockMouse = false;
            }, 300);
            _this.touchableHandleResponderRelease(new es_PressEvent(e.nativeEvent));
        };
        _this.onTouchCancel = function (e) {
            _this.callChildEvent('onTouchCancel', e);
            _this.releaseLockTimer = setTimeout(function () {
                _this.lockMouse = false;
            }, 300);
            _this.touchableHandleResponderTerminate(e.nativeEvent);
        };
        _this.onMouseDown = function (e) {
            _this.callChildEvent('onMouseDown', e);
            if (_this.lockMouse) {
                return;
            }
            _this.touchableHandleResponderGrant(e.nativeEvent);
            document.addEventListener('mousemove', _this.touchableHandleResponderMove, false);
            document.addEventListener('mouseup', _this.onMouseUp, false);
        };
        _this.onMouseUp = function (e) {
            document.removeEventListener('mousemove', _this.touchableHandleResponderMove, false);
            document.removeEventListener('mouseup', _this.onMouseUp, false);
            _this.touchableHandleResponderRelease(new es_PressEvent(e));
        };
        _this.touchableHandleResponderMove = function (e) {
            if (!_this.touchable.startMouse) {
                return;
            }
            // Measurement may not have returned yet.
            if (!_this.touchable.dimensionsOnActivate || _this.touchable.touchState === States.NOT_RESPONDER) {
                return;
            }
            // Not enough time elapsed yet, wait for highlight -
            // this is just a perf optimization.
            if (_this.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
                return;
            }
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            if (_this.pressInLocation) {
                var movedDistance = _this._getDistanceBetweenPoints(pageX, pageY, _this.pressInLocation.pageX, _this.pressInLocation.pageY);
                if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
                    _this._cancelLongPressDelayTimeout();
                }
            }
            if (_this.checkTouchWithinActive(e)) {
                _this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
                var curState = _this.touchable.touchState;
                if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
                    _this._cancelLongPressDelayTimeout();
                }
            } else {
                _this._cancelLongPressDelayTimeout();
                _this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
            }
        };
        return _this;
    }

    createClass_default()(Touchable, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.touchable = { touchState: undefined };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.root = react_domfrom_dll_reference_vendor_library_default.a.findDOMNode(this);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.root = react_domfrom_dll_reference_vendor_library_default.a.findDOMNode(this);
            // disabled auto clear active state
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.releaseLockTimer) {
                clearTimeout(this.releaseLockTimer);
            }
            if (this.touchableDelayTimeout) {
                clearTimeout(this.touchableDelayTimeout);
            }
            if (this.longPressDelayTimeout) {
                clearTimeout(this.longPressDelayTimeout);
            }
            if (this.pressOutDelayTimeout) {
                clearTimeout(this.pressOutDelayTimeout);
            }
        }
    }, {
        key: 'callChildEvent',
        value: function callChildEvent(event, e) {
            var childHandle = reactfrom_dll_reference_vendor_library_default.a.Children.only(this.props.children).props[event];
            if (childHandle) {
                childHandle(e);
            }
        }
    }, {
        key: '_remeasureMetricsOnInit',
        value: function _remeasureMetricsOnInit(e) {
            var root = this.root;

            var touch = extractSingleTouch(e);
            var boundingRect = root.getBoundingClientRect();
            this.touchable = {
                touchState: this.touchable.touchState,
                startMouse: {
                    pageX: touch.pageX,
                    pageY: touch.pageY
                },
                positionOnGrant: {
                    left: boundingRect.left + window.pageXOffset,
                    top: boundingRect.top + window.pageYOffset,
                    width: boundingRect.width,
                    height: boundingRect.height,
                    clientLeft: boundingRect.left,
                    clientTop: boundingRect.top
                }
            };
        }
    }, {
        key: 'touchableHandleResponderGrant',
        value: function touchableHandleResponderGrant(e) {
            var _this2 = this;

            this.touchable.touchState = States.NOT_RESPONDER;
            if (this.pressOutDelayTimeout) {
                clearTimeout(this.pressOutDelayTimeout);
                this.pressOutDelayTimeout = null;
            }
            if (this.props.fixClickPenetration && !isAllowPress()) {
                return;
            }
            this._remeasureMetricsOnInit(e);
            this._receiveSignal(Signals.RESPONDER_GRANT, e);
            var _props = this.props,
                delayMS = _props.delayPressIn,
                longDelayMS = _props.delayLongPress;

            if (delayMS) {
                this.touchableDelayTimeout = setTimeout(function () {
                    _this2._handleDelay(e);
                }, delayMS);
            } else {
                this._handleDelay(e);
            }
            var longPressEvent = new es_PressEvent(e);
            this.longPressDelayTimeout = setTimeout(function () {
                _this2._handleLongDelay(longPressEvent);
            }, longDelayMS + delayMS);
        }
    }, {
        key: 'checkScroll',
        value: function checkScroll(e) {
            var positionOnGrant = this.touchable.positionOnGrant;
            // container or window scroll
            var boundingRect = this.root.getBoundingClientRect();
            if (boundingRect.left !== positionOnGrant.clientLeft || boundingRect.top !== positionOnGrant.clientTop) {
                this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
                return false;
            }
        }
    }, {
        key: 'touchableHandleResponderRelease',
        value: function touchableHandleResponderRelease(e) {
            if (!this.touchable.startMouse) {
                return;
            }
            var touch = extractSingleTouch(e);
            if (Math.abs(touch.pageX - this.touchable.startMouse.pageX) > 30 || Math.abs(touch.pageY - this.touchable.startMouse.pageY) > 30) {
                this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
                return;
            }
            if (this.checkScroll(e) === false) {
                return;
            }
            this._receiveSignal(Signals.RESPONDER_RELEASE, e);
        }
    }, {
        key: 'touchableHandleResponderTerminate',
        value: function touchableHandleResponderTerminate(e) {
            if (!this.touchable.startMouse) {
                return;
            }
            this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
        }
    }, {
        key: 'checkTouchWithinActive',
        value: function checkTouchWithinActive(e) {
            var positionOnGrant = this.touchable.positionOnGrant;
            var _props2 = this.props,
                _props2$pressRetentio = _props2.pressRetentionOffset,
                pressRetentionOffset = _props2$pressRetentio === undefined ? {} : _props2$pressRetentio,
                hitSlop = _props2.hitSlop;

            var pressExpandLeft = pressRetentionOffset.left;
            var pressExpandTop = pressRetentionOffset.top;
            var pressExpandRight = pressRetentionOffset.right;
            var pressExpandBottom = pressRetentionOffset.bottom;
            if (hitSlop) {
                pressExpandLeft += hitSlop.left;
                pressExpandTop += hitSlop.top;
                pressExpandRight += hitSlop.right;
                pressExpandBottom += hitSlop.bottom;
            }
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            return pageX > positionOnGrant.left - pressExpandLeft && pageY > positionOnGrant.top - pressExpandTop && pageX < positionOnGrant.left + positionOnGrant.width + pressExpandRight && pageY < positionOnGrant.top + positionOnGrant.height + pressExpandBottom;
        }
    }, {
        key: 'callProp',
        value: function callProp(name, e) {
            if (this.props[name] && !this.props.disabled) {
                this.props[name](e);
            }
        }
    }, {
        key: 'touchableHandleActivePressIn',
        value: function touchableHandleActivePressIn(e) {
            this.setActive(true);
            this.callProp('onPressIn', e);
        }
    }, {
        key: 'touchableHandleActivePressOut',
        value: function touchableHandleActivePressOut(e) {
            this.setActive(false);
            this.callProp('onPressOut', e);
        }
    }, {
        key: 'touchableHandlePress',
        value: function touchableHandlePress(e) {
            if (shouldFirePress(e)) {
                this.callProp('onPress', e);
            }
            lastClickTime = Date.now();
        }
    }, {
        key: 'touchableHandleLongPress',
        value: function touchableHandleLongPress(e) {
            if (shouldFirePress(e)) {
                this.callProp('onLongPress', e);
            }
        }
    }, {
        key: 'setActive',
        value: function setActive(active) {
            if (this.props.activeClassName || this.props.activeStyle) {
                this.setState({
                    active: active
                });
            }
        }
    }, {
        key: '_remeasureMetricsOnActivation',
        value: function _remeasureMetricsOnActivation() {
            this.touchable.dimensionsOnActivate = this.touchable.positionOnGrant;
        }
    }, {
        key: '_handleDelay',
        value: function _handleDelay(e) {
            this.touchableDelayTimeout = null;
            this._receiveSignal(Signals.DELAY, e);
        }
    }, {
        key: '_handleLongDelay',
        value: function _handleLongDelay(e) {
            this.longPressDelayTimeout = null;
            var curState = this.touchable.touchState;
            if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
                console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
            } else {
                this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
            }
        }
    }, {
        key: '_receiveSignal',
        value: function _receiveSignal(signal, e) {
            var curState = this.touchable.touchState;
            var nextState = Transitions[curState] && Transitions[curState][signal];
            if (!nextState) {
                return;
            }
            if (nextState === States.ERROR) {
                return;
            }
            if (curState !== nextState) {
                this._performSideEffectsForTransition(curState, nextState, signal, e);
                this.touchable.touchState = nextState;
            }
        }
    }, {
        key: '_cancelLongPressDelayTimeout',
        value: function _cancelLongPressDelayTimeout() {
            if (this.longPressDelayTimeout) {
                clearTimeout(this.longPressDelayTimeout);
                this.longPressDelayTimeout = null;
            }
        }
    }, {
        key: '_isHighlight',
        value: function _isHighlight(state) {
            return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
        }
    }, {
        key: '_savePressInLocation',
        value: function _savePressInLocation(e) {
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            this.pressInLocation = { pageX: pageX, pageY: pageY };
        }
    }, {
        key: '_getDistanceBetweenPoints',
        value: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
            var deltaX = aX - bX;
            var deltaY = aY - bY;
            return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        }
    }, {
        key: '_performSideEffectsForTransition',
        value: function _performSideEffectsForTransition(curState, nextState, signal, e) {
            var curIsHighlight = this._isHighlight(curState);
            var newIsHighlight = this._isHighlight(nextState);
            var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;
            if (isFinalSignal) {
                this._cancelLongPressDelayTimeout();
            }
            if (!IsActive[curState] && IsActive[nextState]) {
                this._remeasureMetricsOnActivation();
            }
            if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
                this.touchableHandleLongPress(e);
            }
            if (newIsHighlight && !curIsHighlight) {
                this._startHighlight(e);
            } else if (!newIsHighlight && curIsHighlight) {
                this._endHighlight(e);
            }
            if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
                var hasLongPressHandler = !!this.props.onLongPress;
                var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && (!hasLongPressHandler || !this.props.longPressCancelsPress // or we're told to ignore it.
                );
                var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
                if (shouldInvokePress) {
                    if (!newIsHighlight && !curIsHighlight) {
                        // we never highlighted because of delay, but we should highlight now
                        this._startHighlight(e);
                        this._endHighlight(e);
                    }
                    this.touchableHandlePress(e);
                }
            }
            if (this.touchableDelayTimeout) {
                clearTimeout(this.touchableDelayTimeout);
                this.touchableDelayTimeout = null;
            }
        }
    }, {
        key: '_startHighlight',
        value: function _startHighlight(e) {
            this._savePressInLocation(e);
            this.touchableHandleActivePressIn(e);
        }
    }, {
        key: '_endHighlight',
        value: function _endHighlight(e) {
            var _this3 = this;

            if (this.props.delayPressOut) {
                this.pressOutDelayTimeout = setTimeout(function () {
                    _this3.touchableHandleActivePressOut(e);
                }, this.props.delayPressOut);
            } else {
                this.touchableHandleActivePressOut(e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                children = _props3.children,
                disabled = _props3.disabled,
                activeStyle = _props3.activeStyle,
                activeClassName = _props3.activeClassName;

            var events = disabled ? undefined : copy(this, ['onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel', 'onMouseDown']);
            var child = reactfrom_dll_reference_vendor_library_default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle) {
                    style = extends_default()({}, style, activeStyle);
                }
                if (activeClassName) {
                    if (className) {
                        className += ' ' + activeClassName;
                    } else {
                        className = activeClassName;
                    }
                }
                return reactfrom_dll_reference_vendor_library_default.a.cloneElement(child, extends_default()({ className: className,
                    style: style }, events));
            }
            return reactfrom_dll_reference_vendor_library_default.a.cloneElement(child, events);
        }
    }]);

    return Touchable;
}(reactfrom_dll_reference_vendor_library_default.a.Component);

/* harmony default export */ var es = __webpack_exports__["default"] = (es_Touchable);

es_Touchable.defaultProps = {
    fixClickPenetration: false,
    disabled: false,
    delayPressIn: HIGHLIGHT_DELAY_MS,
    delayLongPress: LONG_PRESS_DELAY_MS,
    delayPressOut: 100,
    pressRetentionOffset: {
        left: PRESS_EXPAND_PX,
        right: PRESS_EXPAND_PX,
        top: PRESS_EXPAND_PX,
        bottom: PRESS_EXPAND_PX
    },
    hitSlop: undefined,
    longPressCancelsPress: true
};

/***/ }),

/***/ "zbne":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__("Ngpj");

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),

/***/ "zwoO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "zyKz":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ })

},[3]);


// WEBPACK FOOTER //
// static/js/commons.a847dc1c.js